//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Aanleiding voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return OK
     */
    aanleiding_van_adviesdossier_ophalen(vestigingId: string, adviesdossierId: string): Promise<AanleidingenOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Aanleiding";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAanleiding_van_adviesdossier_ophalen(_response);
        });
    }

    protected processAanleiding_van_adviesdossier_ophalen(response: Response): Promise<AanleidingenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AanleidingenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AanleidingenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AanleidingenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AanleidingenOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Aanleiding voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param body (optional) De inhoud van het Adviesbox-form Aanleiding
     * @return No Content
     */
    aanleiding_van_adviesdossier_wijzigen(vestigingId: string, adviesdossierId: string, body: Aanleiding | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Aanleiding";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAanleiding_van_adviesdossier_wijzigen(_response);
        });
    }

    protected processAanleiding_van_adviesdossier_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de waarschuwingen voor het verwerken van de inhoud van het Adviesbox-form Aanleiding voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param body (optional) De inhoud van het Adviesbox-form Aanleiding
     * @return OK
     */
    waarschuwingen_bij_aanleiding_wijzigen(vestigingId: string, adviesdossierId: string, body: Aanleiding | null | undefined): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Aanleiding/Waarschuwingen";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWaarschuwingen_bij_aanleiding_wijzigen(_response);
        });
    }

    protected processWaarschuwingen_bij_aanleiding_wijzigen(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Aanvraag voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @return OK
     */
    aanvraag_van_voorstel_ophalen(vestigingId: string, voorstelId: string): Promise<AanvragenOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Aanvraag";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAanvraag_van_voorstel_ophalen(_response);
        });
    }

    protected processAanvraag_van_voorstel_ophalen(response: Response): Promise<AanvragenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AanvragenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AanvragenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AanvragenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AanvragenOutput>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Acceptatie voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @return OK
     */
    acceptatie_van_voorstel_ophalen(vestigingId: string, voorstelId: string): Promise<AcceptatieOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Acceptatie";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAcceptatie_van_voorstel_ophalen(_response);
        });
    }

    protected processAcceptatie_van_voorstel_ophalen(response: Response): Promise<AcceptatieOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AcceptatieOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AcceptatieOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AcceptatieOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AcceptatieOutput>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form AOV voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @return OK
     */
    aOVs_van_voorstel_ophalen(vestigingId: string, voorstelId: string): Promise<AovOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Aov";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAOVs_van_voorstel_ophalen(_response);
        });
    }

    protected processAOVs_van_voorstel_ophalen(response: Response): Promise<AovOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AovOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AovOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AovOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AovOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form AOV voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param body (optional) De inhoud van het Adviesbox-form AOV
     * @return No Content
     */
    aOVs_van_voorstel_wijzigen(vestigingId: string, voorstelId: string, body: Aov | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Aov";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAOVs_van_voorstel_wijzigen(_response);
        });
    }

    protected processAOVs_van_voorstel_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Bereken de AOV voor Adviesbox-form AOV voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param body (optional) De inhoud van het Adviesbox-form AOV
     * @return OK
     */
    aOVs_van_voorstel_berekenen(vestigingId: string, voorstelId: string, body: AovBerekening | null | undefined): Promise<AovResultaat> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Aov";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAOVs_van_voorstel_berekenen(_response);
        });
    }

    protected processAOVs_van_voorstel_berekenen(response: Response): Promise<AovResultaat> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AovResultaat;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AovResultaat;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AovResultaat;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AovResultaat;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AovResultaat>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form AOV voor de huidige situatie.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return OK
     */
    aOVs_van_huidige_situatie_ophalen(vestigingId: string, adviesdossierId: string): Promise<AovOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Aov";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAOVs_van_huidige_situatie_ophalen(_response);
        });
    }

    protected processAOVs_van_huidige_situatie_ophalen(response: Response): Promise<AovOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AovOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AovOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AovOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AovOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form AOV voor de huidige situatie.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param body (optional) De inhoud van het Adviesbox-form AOV
     * @return No Content
     */
    aOVs_van_huidige_situatie_wijzigen(vestigingId: string, adviesdossierId: string, body: Aov | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Aov";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAOVs_van_huidige_situatie_wijzigen(_response);
        });
    }

    protected processAOVs_van_huidige_situatie_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Aanvraag/Bankgarantie voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return OK
     */
    bankgarantie_van_adviesdossier_ophalen(vestigingId: string, adviesdossierId: string): Promise<BankgarantieOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Bankgarantie";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBankgarantie_van_adviesdossier_ophalen(_response);
        });
    }

    protected processBankgarantie_van_adviesdossier_ophalen(response: Response): Promise<BankgarantieOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankgarantieOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankgarantieOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankgarantieOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankgarantieOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Aanvraag/Bankgarantie voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param body (optional) De inhoud van het Adviesbox-form Aanvraag/Bankgarantie
     * @return No Content
     */
    bankgarantie_van_adviesdossier_verwerken(vestigingId: string, adviesdossierId: string, body: Bankgarantie | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Bankgarantie";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBankgarantie_van_adviesdossier_verwerken(_response);
        });
    }

    protected processBankgarantie_van_adviesdossier_verwerken(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verstuurt een bankgarantieaanvraag naar de betreffende partij.
     * @param body (optional) 
     * @return OK
     */
    verstuurt_een_aanvraag_van_een_bankgarantie_naar_de_bankgarantieverstrekker(vestigingId: string, adviesdossierId: string, body: Bankgarantie | null | undefined): Promise<BankgarantieAanvraagOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/BankgarantieAanvraag";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerstuurt_een_aanvraag_van_een_bankgarantie_naar_de_bankgarantieverstrekker(_response);
        });
    }

    protected processVerstuurt_een_aanvraag_van_een_bankgarantie_naar_de_bankgarantieverstrekker(response: Response): Promise<BankgarantieAanvraagOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankgarantieAanvraagOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankgarantieAanvraagOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankgarantieAanvraagOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankgarantieAanvraagOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankgarantieAanvraagOutput>(null as any);
    }

    /**
     * Geeft de bij Nwb bekende geldverstrekkers.
     * @return OK
     */
    nwb_Geldverstrekkers_ophalen(vestigingId: string): Promise<NwbGeldverstrekkersOutput> {
        let url_ = this.baseUrl + "/GetGeldverstrekker";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processNwb_Geldverstrekkers_ophalen(_response);
        });
    }

    protected processNwb_Geldverstrekkers_ophalen(response: Response): Promise<NwbGeldverstrekkersOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NwbGeldverstrekkersOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NwbGeldverstrekkersOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NwbGeldverstrekkersOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NwbGeldverstrekkersOutput>(null as any);
    }

    /**
     * Geeft de producten.
     * @return OK
     */
    nwb_producten_ophalen(vestigingId: string): Promise<NwbProductenOutput> {
        let url_ = this.baseUrl + "/GetProducten";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processNwb_producten_ophalen(_response);
        });
    }

    protected processNwb_producten_ophalen(response: Response): Promise<NwbProductenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NwbProductenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NwbProductenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NwbProductenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NwbProductenOutput>(null as any);
    }

    /**
     * Geeft de arrangementen voor een bepaald product.
     * @param productId (optional) 
     * @return OK
     */
    nwb_arrangementen_ophalen(vestigingId: string, productId: number | null | undefined): Promise<NwbArrangementenOutput> {
        let url_ = this.baseUrl + "/GetArrangementen?";
        if (productId !== undefined && productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processNwb_arrangementen_ophalen(_response);
        });
    }

    protected processNwb_arrangementen_ophalen(response: Response): Promise<NwbArrangementenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NwbArrangementenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NwbArrangementenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NwbArrangementenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NwbArrangementenOutput>(null as any);
    }

    /**
     * Clean cache (tijdelijk)
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param voorstelId Identificatie van voorstel
     * @return OK
     */
    dashboard_cache_legen(vestigingId: string, adviesdossierId: string, voorstelId: string): Promise<DashboardOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Voorstellen/{voorstelId}/Dashboard/Clean";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDashboard_cache_legen(_response);
        });
    }

    protected processDashboard_cache_legen(response: Response): Promise<DashboardOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardOutput>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Dashboard voor het gegeven adviesdossier per onderdeel.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param onderdeel Onderdeel van het dashboard dat gewenst is
     * @param berekenTekort Property om aan te geven of tekorten berekend moeten worden
     * @return OK
     */
    dashboard_van_adviesdossier_ophalen_per_onderdeel(vestigingId: string, adviesdossierId: string, onderdeel: Onderdeel, berekenTekort: boolean): Promise<DashboardOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Dashboard/{onderdeel}?";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        if (onderdeel === undefined || onderdeel === null)
            throw new Error("The parameter 'onderdeel' must be defined.");
        url_ = url_.replace("{onderdeel}", encodeURIComponent("" + onderdeel));
        if (berekenTekort === undefined || berekenTekort === null)
            throw new Error("The parameter 'berekenTekort' must be defined and cannot be null.");
        else
            url_ += "berekenTekort=" + encodeURIComponent("" + berekenTekort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDashboard_van_adviesdossier_ophalen_per_onderdeel(_response);
        });
    }

    protected processDashboard_van_adviesdossier_ophalen_per_onderdeel(response: Response): Promise<DashboardOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Dashboard voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param onderdeel Onderdeel van het dashboard waarvan de gegevens opgeslagen moeten worden
     * @param body (optional) De inhoud van het Adviesbox-form Dashboard
     * @return No Content
     */
    dashboard_van_voorstel_wijzigen(vestigingId: string, adviesdossierId: string, onderdeel: Onderdeel2, body: Dashboard | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Dashboard/{onderdeel}";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        if (onderdeel === undefined || onderdeel === null)
            throw new Error("The parameter 'onderdeel' must be defined.");
        url_ = url_.replace("{onderdeel}", encodeURIComponent("" + onderdeel));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDashboard_van_voorstel_wijzigen(_response);
        });
    }

    protected processDashboard_van_voorstel_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Dashboard voor het gegeven voorstel per onderdeel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param onderdeel Onderdeel van het dashboard dat gewenst is
     * @param berekenTekort Property om aan te geven of tekorten berekend moeten worden
     * @return OK
     */
    dashboard_van_voorstel_ophalen_per_onderdeel(vestigingId: string, voorstelId: string, onderdeel: Onderdeel3, berekenTekort: boolean): Promise<DashboardOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Dashboard/{onderdeel}?";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        if (onderdeel === undefined || onderdeel === null)
            throw new Error("The parameter 'onderdeel' must be defined.");
        url_ = url_.replace("{onderdeel}", encodeURIComponent("" + onderdeel));
        if (berekenTekort === undefined || berekenTekort === null)
            throw new Error("The parameter 'berekenTekort' must be defined and cannot be null.");
        else
            url_ += "berekenTekort=" + encodeURIComponent("" + berekenTekort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDashboard_van_voorstel_ophalen_per_onderdeel(_response);
        });
    }

    protected processDashboard_van_voorstel_ophalen_per_onderdeel(response: Response): Promise<DashboardOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardOutput>(null as any);
    }

    /**
     * Geeft alle inhoud van het Adviesbox-form Dashboard voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return OK
     */
    dashboard_van_adviesdossier_ophalen(vestigingId: string, adviesdossierId: string): Promise<DashboardOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Dashboard";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDashboard_van_adviesdossier_ophalen(_response);
        });
    }

    protected processDashboard_van_adviesdossier_ophalen(response: Response): Promise<DashboardOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardOutput>(null as any);
    }

    /**
     * Geeft alle inhoud van het Adviesbox-form Dashboard voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @return OK
     */
    dashboard_van_van_het_voorstel_ophalen(vestigingId: string, voorstelId: string): Promise<DashboardOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Dashboard";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDashboard_van_van_het_voorstel_ophalen(_response);
        });
    }

    protected processDashboard_van_van_het_voorstel_ophalen(response: Response): Promise<DashboardOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardOutput>(null as any);
    }

    /**
     * Geeft alle geselecteerde motivering onderwerpen voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return OK
     */
    geselecteerde_motivering_onderwerpen_van_het_adviesdossier_ophalen(vestigingId: string, adviesdossierId: string): Promise<DashboardOnderwerpenOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Dashboard/Onderwerpen";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGeselecteerde_motivering_onderwerpen_van_het_adviesdossier_ophalen(_response);
        });
    }

    protected processGeselecteerde_motivering_onderwerpen_van_het_adviesdossier_ophalen(response: Response): Promise<DashboardOnderwerpenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardOnderwerpenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardOnderwerpenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardOnderwerpenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardOnderwerpenOutput>(null as any);
    }

    /**
     * Geeft de dekkingen van een adviesdossier.
     * @param vestigingId De identificatie van de vestiging.
     * @param adviesdossierId De identificatie van het adviesdossier.
     * @return OK
     */
    dekkingen_van_adviesdossier_ophalen(vestigingId: string, adviesdossierId: string): Promise<DekkingenOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Dekking";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDekkingen_van_adviesdossier_ophalen(_response);
        });
    }

    protected processDekkingen_van_adviesdossier_ophalen(response: Response): Promise<DekkingenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DekkingenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DekkingenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DekkingenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DekkingenOutput>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Financieringsbehoefte voor het gegeven voorstel (analyse).
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @return OK
     */
    financieringsbehoefte_van_voorstel_ophalen(vestigingId: string, voorstelId: string): Promise<FinancieringsbehoeftenOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Financieringsbehoefte";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFinancieringsbehoefte_van_voorstel_ophalen(_response);
        });
    }

    protected processFinancieringsbehoefte_van_voorstel_ophalen(response: Response): Promise<FinancieringsbehoeftenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FinancieringsbehoeftenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FinancieringsbehoeftenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FinancieringsbehoeftenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FinancieringsbehoeftenOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Financieringsbehoefte voor het gegeven voorstel (analyse).
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param body (optional) De inhoud van het Adviesbox-form Financieringsbehoefte
     * @return No Content
     */
    financieringsbehoefte_van_voorstel_wijzigen(vestigingId: string, voorstelId: string, body: Financieringsbehoefte | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Financieringsbehoefte";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFinancieringsbehoefte_van_voorstel_wijzigen(_response);
        });
    }

    protected processFinancieringsbehoefte_van_voorstel_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de waarschuwingen voor het verwerken van de inhoud van het Adviesbox-form Financieringsbehoefte voor het gegeven voorstel (analyse).
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param body (optional) De inhoud van het Adviesbox-form Financieringsbehoefte
     * @return OK
     */
    waarschuwingen_bij_financieringsbehoefte_wijzigen(vestigingId: string, voorstelId: string, body: Financieringsbehoefte | null | undefined): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Financieringsbehoefte/Waarschuwingen";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWaarschuwingen_bij_financieringsbehoefte_wijzigen(_response);
        });
    }

    protected processWaarschuwingen_bij_financieringsbehoefte_wijzigen(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Berekent de eigenwoningschuld met de gegeven input voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param body (optional) De input voor de berekening
     * @return OK
     */
    eigenwoningschuld(vestigingId: string, voorstelId: string, body: EwsInput | null | undefined): Promise<EwsOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Financieringsbehoefte/Eigenwoningschuld";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEigenwoningschuld(_response);
        });
    }

    protected processEigenwoningschuld(response: Response): Promise<EwsOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EwsOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EwsOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EwsOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EwsOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EwsOutput>(null as any);
    }

    /**
     * Berekent de rentelasten van het overbruggingskrediet met de gegeven input voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param body (optional) De input voor de berekening
     * @return OK
     */
    overbruggingskrediet(vestigingId: string, voorstelId: string, body: OverbruggingskredietInput | null | undefined): Promise<OverbruggingskredietOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Financieringsbehoefte/Overbruggingskrediet";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOverbruggingskrediet(_response);
        });
    }

    protected processOverbruggingskrediet(response: Response): Promise<OverbruggingskredietOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverbruggingskredietOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverbruggingskredietOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverbruggingskredietOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverbruggingskredietOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OverbruggingskredietOutput>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Hypotheek voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @return OK
     */
    hypotheek_van_voorstel_ophalen(vestigingId: string, voorstelId: string): Promise<HypotheekVoorstelOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Hypotheek";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheek_van_voorstel_ophalen(_response);
        });
    }

    protected processHypotheek_van_voorstel_ophalen(response: Response): Promise<HypotheekVoorstelOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekVoorstelOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekVoorstelOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekVoorstelOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HypotheekVoorstelOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Hypotheek voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param body (optional) De inhoud van het Adviesbox-form Hypotheek
     * @return No Content
     */
    hypotheek_van_voorstel_wijzigen(vestigingId: string, voorstelId: string, body: HypotheekVoorstel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Hypotheek";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheek_van_voorstel_wijzigen(_response);
        });
    }

    protected processHypotheek_van_voorstel_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Hypotheek voor de huidige situatie.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return OK
     */
    hypotheek_van_huidige_situatie_ophalen(vestigingId: string, adviesdossierId: string): Promise<HypotheekHuidigeSituatieOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Hypotheek";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheek_van_huidige_situatie_ophalen(_response);
        });
    }

    protected processHypotheek_van_huidige_situatie_ophalen(response: Response): Promise<HypotheekHuidigeSituatieOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekHuidigeSituatieOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekHuidigeSituatieOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekHuidigeSituatieOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HypotheekHuidigeSituatieOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Hypotheek voor de huidige situatie.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het voorstel
     * @param body (optional) De inhoud van het Adviesbox-form Hypotheek
     * @return No Content
     */
    hypotheek_van_huidige_situatie_wijzigen(vestigingId: string, adviesdossierId: string, body: HypotheekHuidigeSituatie | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Hypotheek";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheek_van_huidige_situatie_wijzigen(_response);
        });
    }

    protected processHypotheek_van_huidige_situatie_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Berekent de periodieke aflossing van een leningdeel met de gegeven input.
     * @param vestigingId De identificatie van de vestiging
     * @param body (optional) De input voor de berekening
     * @return OK
     */
    periodieke_aflossing(vestigingId: string, body: PeriodiekeAflossingInput | null | undefined): Promise<PeriodiekeAflossingOutput> {
        let url_ = this.baseUrl + "/Hypotheek/Periodieke aflossing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPeriodieke_aflossing(_response);
        });
    }

    protected processPeriodieke_aflossing(response: Response): Promise<PeriodiekeAflossingOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PeriodiekeAflossingOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PeriodiekeAflossingOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PeriodiekeAflossingOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PeriodiekeAflossingOutput>(null as any);
    }

    /**
     * Berekent de waarde van een premiedepot met de gegeven input.
     * @param vestigingId De identificatie van de vestiging
     * @param body (optional) De input voor de berekening
     * @return OK
     */
    premiedepot(vestigingId: string, body: PremiedepotInput | null | undefined): Promise<PremiedepotOutput> {
        let url_ = this.baseUrl + "/Hypotheek/Premiedepot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPremiedepot(_response);
        });
    }

    protected processPremiedepot(response: Response): Promise<PremiedepotOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PremiedepotOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PremiedepotOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PremiedepotOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PremiedepotOutput>(null as any);
    }

    /**
     * Geeft de hypotheekrente van het Adviesbox-form Hypotheek voor het gegeven voorstel met de gegeven input.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param body (optional) De input voor de bepaling van het rentepercentage
     * @return OK
     */
    hypotheekrente_ophalen(vestigingId: string, voorstelId: string, body: RentepercentageInput | null | undefined): Promise<RentepercentageOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Hypotheek/Hypotheekrente";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheekrente_ophalen(_response);
        });
    }

    protected processHypotheekrente_ophalen(response: Response): Promise<RentepercentageOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RentepercentageOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RentepercentageOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RentepercentageOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RentepercentageOutput>(null as any);
    }

    /**
     * Geeft de personeelskorting van het Adviesbox-form Hypotheek voor het gegeven voorstel met de gegeven input.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param body (optional) De input voor de bepaling van de personeelskorting
     * @return OK
     */
    personeelskorting_ophalen(vestigingId: string, voorstelId: string, body: PersoneelskortingInput | null | undefined): Promise<PersoneelskortingOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Hypotheek/Personeelskorting";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPersoneelskorting_ophalen(_response);
        });
    }

    protected processPersoneelskorting_ophalen(response: Response): Promise<PersoneelskortingOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersoneelskortingOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersoneelskortingOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersoneelskortingOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersoneelskortingOutput>(null as any);
    }

    /**
     * Genereert een hypotheeksamenstelling voor het gegeven voorstel met de gegeven input.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param body (optional) De input voor de genereren van de hypotheeksamenstelling
     * @return OK
     */
    hypotheeksamenstelling_genereren(vestigingId: string, voorstelId: string, body: HypotheeksamenstellingInput | null | undefined): Promise<HypotheeksamenstellingOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Hypotheek/Hypotheeksamenstelling";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheeksamenstelling_genereren(_response);
        });
    }

    protected processHypotheeksamenstelling_genereren(response: Response): Promise<HypotheeksamenstellingOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheeksamenstellingOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheeksamenstellingOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheeksamenstellingOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HypotheeksamenstellingOutput>(null as any);
    }

    /**
     * Bereken de opbouwpremie voor Adviesbox-form Hypotheek voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param body (optional) De inhoud van het Adviesbox-form Hypotheek
     * @return OK
     */
    premie_van_opbouwproduct_voor_opgegeven_voorstel_berekenen(vestigingId: string, voorstelId: string, body: OpbouwBerekening | null | undefined): Promise<SpaarHypotheekOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Hypotheek/OpbouwPremie";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPremie_van_opbouwproduct_voor_opgegeven_voorstel_berekenen(_response);
        });
    }

    protected processPremie_van_opbouwproduct_voor_opgegeven_voorstel_berekenen(response: Response): Promise<SpaarHypotheekOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SpaarHypotheekOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SpaarHypotheekOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SpaarHypotheekOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SpaarHypotheekOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpaarHypotheekOutput>(null as any);
    }

    /**
     * Geeft de hypotheekvormen die matchen met de gegeven leningdelen in de input, indien men zou wijzigen naar de nieuwe geldverstrekker en hypotheeklabel.
     * @param vestigingId De identificatie van de vestiging
     * @param body (optional) De input voor de bepaling van de hypotheekvormen
     * @return OK
     */
    wijzig_geldverstrekker_met_behoud_van_leningdelen(vestigingId: string, body: WijzigGeldverstrekkerInput | null | undefined): Promise<WijzigGeldverstrekkerOutput> {
        let url_ = this.baseUrl + "/Hypotheek/WijzigGeldverstrekker";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWijzig_geldverstrekker_met_behoud_van_leningdelen(_response);
        });
    }

    protected processWijzig_geldverstrekker_met_behoud_van_leningdelen(response: Response): Promise<WijzigGeldverstrekkerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WijzigGeldverstrekkerOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WijzigGeldverstrekkerOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WijzigGeldverstrekkerOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WijzigGeldverstrekkerOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WijzigGeldverstrekkerOutput>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Hypotheek oversluiten voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @return OK
     */
    hypotheek_oversluiten_van_voorstel_ophalen(vestigingId: string, voorstelId: string): Promise<HypotheekOversluitenOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/HypotheekOversluiten";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheek_oversluiten_van_voorstel_ophalen(_response);
        });
    }

    protected processHypotheek_oversluiten_van_voorstel_ophalen(response: Response): Promise<HypotheekOversluitenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekOversluitenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekOversluitenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekOversluitenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HypotheekOversluitenOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Hypotheek oversluiten voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param body (optional) De inhoud van het Adviesbox-form Hypotheek oversluiten
     * @return No Content
     */
    hypotheek_oversluiten_van_voorstel_wijzigen(vestigingId: string, voorstelId: string, body: HypotheekOversluiten | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/HypotheekOversluiten";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheek_oversluiten_van_voorstel_wijzigen(_response);
        });
    }

    protected processHypotheek_oversluiten_van_voorstel_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Voer de berekening Hypotheek Oversluiten uit per maatschappij.
     * @param body (optional) 
     * @return OK
     */
    hypotheek_oversluiten_berekenen(vestigingId: string, voorstelId: string, body: HypotheekOversluiten | null | undefined): Promise<HypotheekOversluitenResultaat> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/HypotheekOversluiten";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheek_oversluiten_berekenen(_response);
        });
    }

    protected processHypotheek_oversluiten_berekenen(response: Response): Promise<HypotheekOversluitenResultaat> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekOversluitenResultaat;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekOversluitenResultaat;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekOversluitenResultaat;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekOversluitenResultaat;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HypotheekOversluitenResultaat>(null as any);
    }

    /**
     * Geeft het resultaat van de pricetool aanroep
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param body (optional) De input voor de berekening
     * @return OK
     */
    pricetool_aanroepen(vestigingId: string, voorstelId: string, body: IngPriceInput | null | undefined): Promise<IngPriceOutput> {
        let url_ = this.baseUrl + "/PostPricetoolResult?";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined and cannot be null.");
        else
            url_ += "voorstelId=" + encodeURIComponent("" + voorstelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPricetool_aanroepen(_response);
        });
    }

    protected processPricetool_aanroepen(response: Response): Promise<IngPriceOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IngPriceOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IngPriceOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IngPriceOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IngPriceOutput>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Inkomen en Fiscus voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return OK
     */
    inkomenFiscus_van_adviesdossier_ophalen(vestigingId: string, adviesdossierId: string): Promise<InkomenFiscusOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/InkomenFiscus";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInkomenFiscus_van_adviesdossier_ophalen(_response);
        });
    }

    protected processInkomenFiscus_van_adviesdossier_ophalen(response: Response): Promise<InkomenFiscusOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InkomenFiscusOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InkomenFiscusOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InkomenFiscusOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InkomenFiscusOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Inkomen en Fiscus voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param body (optional) De inhoud van het Adviesbox-form Inkomen en Fiscus
     * @return No Content
     */
    inkomenFiscus_van_adviesdossier_wijzigen(vestigingId: string, adviesdossierId: string, body: InkomenFiscus | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/InkomenFiscus";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInkomenFiscus_van_adviesdossier_wijzigen(_response);
        });
    }

    protected processInkomenFiscus_van_adviesdossier_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Berekent het periodeinkomen op basis van het jaarinkomen, de periode en overige parameters.
     * @param inkomenPeriodeCode InkomenPeriode Geen = 0, PerJaar = 1, PerMaand = 12, Per4Weken = 13, PerWeek = 52
     * @param body (optional) 
     * @return OK
     */
    jaarinkomen_naar_periodeinkomen_berekening(vestigingId: string, jaarinkomenBedrag: number, inkomenPeriodeCode: InkomenPeriodeCode, body: InkomenLoondienstInput | null | undefined): Promise<InkomenOutput> {
        let url_ = this.baseUrl + "/InkomenFiscus/JaarNaarPeriode/{jaarinkomenBedrag}/{inkomenPeriodeCode}";
        if (jaarinkomenBedrag === undefined || jaarinkomenBedrag === null)
            throw new Error("The parameter 'jaarinkomenBedrag' must be defined.");
        url_ = url_.replace("{jaarinkomenBedrag}", encodeURIComponent("" + jaarinkomenBedrag));
        if (inkomenPeriodeCode === undefined || inkomenPeriodeCode === null)
            throw new Error("The parameter 'inkomenPeriodeCode' must be defined.");
        url_ = url_.replace("{inkomenPeriodeCode}", encodeURIComponent("" + inkomenPeriodeCode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processJaarinkomen_naar_periodeinkomen_berekening(_response);
        });
    }

    protected processJaarinkomen_naar_periodeinkomen_berekening(response: Response): Promise<InkomenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InkomenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InkomenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InkomenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InkomenOutput>(null as any);
    }

    /**
     * Berekent het jaarinkomen op basis van het periodeinkomen, de periode en overige parameters.
     * @param inkomenPeriodeCode InkomenPeriode Geen = 0, PerJaar = 1, PerMaand = 12, Per4Weken = 13, PerWeek = 52
     * @param body (optional) 
     * @return OK
     */
    periodeinkomen_naar_jaarinkomen_berekening(vestigingId: string, periodeinkomenBedrag: number, inkomenPeriodeCode: InkomenPeriodeCode2, body: InkomenLoondienstInput | null | undefined): Promise<InkomenOutput> {
        let url_ = this.baseUrl + "/InkomenFiscus/PeriodeNaarJaar/{periodeinkomenBedrag}/{inkomenPeriodeCode}";
        if (periodeinkomenBedrag === undefined || periodeinkomenBedrag === null)
            throw new Error("The parameter 'periodeinkomenBedrag' must be defined.");
        url_ = url_.replace("{periodeinkomenBedrag}", encodeURIComponent("" + periodeinkomenBedrag));
        if (inkomenPeriodeCode === undefined || inkomenPeriodeCode === null)
            throw new Error("The parameter 'inkomenPeriodeCode' must be defined.");
        url_ = url_.replace("{inkomenPeriodeCode}", encodeURIComponent("" + inkomenPeriodeCode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPeriodeinkomen_naar_jaarinkomen_berekening(_response);
        });
    }

    protected processPeriodeinkomen_naar_jaarinkomen_berekening(response: Response): Promise<InkomenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InkomenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InkomenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InkomenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InkomenOutput>(null as any);
    }

    /**
     * Berekent het gemiddelde inkomen over de afgelopen 3 jaar.
     * @param inkomenJ0 (optional) 
     * @param inkomenJ1 (optional) 
     * @param inkomenJ2 (optional) 
     * @return OK
     */
    berekening_gemiddelde_inkomen_afgelopen_3_jaar(vestigingId: string, inkomenJ0: number | null | undefined, inkomenJ1: number | null | undefined, inkomenJ2: number | null | undefined): Promise<GemiddeldInkomenOutput> {
        let url_ = this.baseUrl + "/InkomenFiscus/GemiddeldJaarinkomen?";
        if (inkomenJ0 !== undefined && inkomenJ0 !== null)
            url_ += "inkomenJ0=" + encodeURIComponent("" + inkomenJ0) + "&";
        if (inkomenJ1 !== undefined && inkomenJ1 !== null)
            url_ += "inkomenJ1=" + encodeURIComponent("" + inkomenJ1) + "&";
        if (inkomenJ2 !== undefined && inkomenJ2 !== null)
            url_ += "inkomenJ2=" + encodeURIComponent("" + inkomenJ2) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBerekening_gemiddelde_inkomen_afgelopen_3_jaar(_response);
        });
    }

    protected processBerekening_gemiddelde_inkomen_afgelopen_3_jaar(response: Response): Promise<GemiddeldInkomenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GemiddeldInkomenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GemiddeldInkomenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GemiddeldInkomenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GemiddeldInkomenOutput>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Kapitaalverzekering voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @return OK
     */
    kapitaalverzekeringen_van_voorstel_ophalen(vestigingId: string, voorstelId: string): Promise<KapitaalverzekeringOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Kapitaalverzekering";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKapitaalverzekeringen_van_voorstel_ophalen(_response);
        });
    }

    protected processKapitaalverzekeringen_van_voorstel_ophalen(response: Response): Promise<KapitaalverzekeringOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KapitaalverzekeringOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KapitaalverzekeringOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KapitaalverzekeringOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KapitaalverzekeringOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Kapitaalverzekering voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param body (optional) De inhoud van het Adviesbox-form Kapitaalverzekering
     * @return No Content
     */
    kapitaalverzekeringen_van_voorstel_wijzigen(vestigingId: string, voorstelId: string, body: Kapitaalverzekering | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Kapitaalverzekering";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKapitaalverzekeringen_van_voorstel_wijzigen(_response);
        });
    }

    protected processKapitaalverzekeringen_van_voorstel_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Kapitaalverzekering voor de huidige situatie.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return OK
     */
    kapitaalverzekeringen_van_huidige_situatie_ophalen(vestigingId: string, adviesdossierId: string): Promise<KapitaalverzekeringOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Kapitaalverzekering";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKapitaalverzekeringen_van_huidige_situatie_ophalen(_response);
        });
    }

    protected processKapitaalverzekeringen_van_huidige_situatie_ophalen(response: Response): Promise<KapitaalverzekeringOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KapitaalverzekeringOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KapitaalverzekeringOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KapitaalverzekeringOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KapitaalverzekeringOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Kapitaalverzekering voor de huidige situatie.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param body (optional) De inhoud van het Adviesbox-form Kapitaalverzekering
     * @return No Content
     */
    kapitaalverzekeringen_van_huidige_situatie_wijzigen(vestigingId: string, adviesdossierId: string, body: Kapitaalverzekering | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Kapitaalverzekering";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKapitaalverzekeringen_van_huidige_situatie_wijzigen(_response);
        });
    }

    protected processKapitaalverzekeringen_van_huidige_situatie_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Berekent de resultaten het Adviesbox-form Kapitaalverzekering voor het gegeven product.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param body (optional) De inhoud van het kapitaalverzekering-product
     * @return OK
     */
    kapitaalverzekering_berekenen(vestigingId: string, adviesdossierId: string, body: KapitaalverzekeringBerekeningInput | null | undefined): Promise<KapitaalverzekeringBerekeningOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Kapitaalverzekering";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKapitaalverzekering_berekenen(_response);
        });
    }

    protected processKapitaalverzekering_berekenen(response: Response): Promise<KapitaalverzekeringBerekeningOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KapitaalverzekeringBerekeningOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KapitaalverzekeringBerekeningOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KapitaalverzekeringBerekeningOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KapitaalverzekeringBerekeningOutput>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Klantprofiel voor het adviesdossier voor het gegeven onderwerp.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param onderwerp Het klantprofiel-onderwerp
     * @return OK
     */
    klantprofiel_van_adviesdossier_ophalen(vestigingId: string, adviesdossierId: string, onderwerp: Onderwerp): Promise<KlantprofielOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Klantprofiel/{onderwerp}";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        if (onderwerp === undefined || onderwerp === null)
            throw new Error("The parameter 'onderwerp' must be defined.");
        url_ = url_.replace("{onderwerp}", encodeURIComponent("" + onderwerp));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKlantprofiel_van_adviesdossier_ophalen(_response);
        });
    }

    protected processKlantprofiel_van_adviesdossier_ophalen(response: Response): Promise<KlantprofielOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KlantprofielOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KlantprofielOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KlantprofielOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KlantprofielOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Klantprofiel voor het adviesdossier voor het gegeven onderwerp.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param onderwerp Het klantprofiel-onderwerp
     * @param body (optional) De inhoud van het Adviesbox-form Klantprofiel
     * @return No Content
     */
    klantprofiel_van_adviesdossier_wijzigen(vestigingId: string, adviesdossierId: string, onderwerp: Onderwerp2, body: Klantprofiel | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Klantprofiel/{onderwerp}";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        if (onderwerp === undefined || onderwerp === null)
            throw new Error("The parameter 'onderwerp' must be defined.");
        url_ = url_.replace("{onderwerp}", encodeURIComponent("" + onderwerp));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKlantprofiel_van_adviesdossier_wijzigen(_response);
        });
    }

    protected processKlantprofiel_van_adviesdossier_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox Classic Klantprofiel voor het adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return OK
     */
    adviesbox_Classic_klantprofiel_van_adviesdossier_ophalen(vestigingId: string, adviesdossierId: string): Promise<KlantprofielAbcOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Klantprofiel/abc";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdviesbox_Classic_klantprofiel_van_adviesdossier_ophalen(_response);
        });
    }

    protected processAdviesbox_Classic_klantprofiel_van_adviesdossier_ophalen(response: Response): Promise<KlantprofielAbcOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KlantprofielAbcOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KlantprofielOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KlantprofielOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KlantprofielAbcOutput>(null as any);
    }

    /**
     * Bepaalt het risicoprofiel t.b.v. het Adviesbox-form Klantprofiel voor het onderwerp Risicoprofiel.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param body (optional) De input voor de bepaling van het risicoprofiel
     * @return OK
     */
    risicoprofiel_bepalen(vestigingId: string, adviesdossierId: string, body: RisicoprofielInput | null | undefined): Promise<RisicoprofielOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Klantprofiel/Risicoprofiel";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRisicoprofiel_bepalen(_response);
        });
    }

    protected processRisicoprofiel_bepalen(response: Response): Promise<RisicoprofielOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RisicoprofielOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RisicoprofielOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RisicoprofielOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RisicoprofielOutput>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Krediet voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @return OK
     */
    kredieten_van_voorstel_ophalen(vestigingId: string, voorstelId: string): Promise<KredietOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Krediet";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKredieten_van_voorstel_ophalen(_response);
        });
    }

    protected processKredieten_van_voorstel_ophalen(response: Response): Promise<KredietOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KredietOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KredietOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KredietOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KredietOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Krediet voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param body (optional) De inhoud van het Adviesbox-form Krediet
     * @return No Content
     */
    kredieten_van_voorstel_wijzigen(vestigingId: string, voorstelId: string, body: Krediet | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Krediet";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKredieten_van_voorstel_wijzigen(_response);
        });
    }

    protected processKredieten_van_voorstel_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Krediet voor de huidige situatie.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return OK
     */
    kredieten_van_huidige_situatie_ophalen(vestigingId: string, adviesdossierId: string): Promise<KredietOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Krediet";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKredieten_van_huidige_situatie_ophalen(_response);
        });
    }

    protected processKredieten_van_huidige_situatie_ophalen(response: Response): Promise<KredietOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KredietOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KredietOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KredietOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KredietOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Krediet voor de huidige situatie.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param body (optional) De inhoud van het Adviesbox-form Krediet
     * @return No Content
     */
    kredieten_van_huidige_situatie_wijzigen(vestigingId: string, adviesdossierId: string, body: Krediet | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Krediet";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKredieten_van_huidige_situatie_wijzigen(_response);
        });
    }

    protected processKredieten_van_huidige_situatie_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Aanvraag/Lening voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return OK
     */
    lening_van_adviesdossier_ophalen(vestigingId: string, adviesdossierId: string): Promise<LeningOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Lening";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLening_van_adviesdossier_ophalen(_response);
        });
    }

    protected processLening_van_adviesdossier_ophalen(response: Response): Promise<LeningOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeningOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeningOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeningOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LeningOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Aanvraag/Lening voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param body (optional) De inhoud van het Adviesbox-form Aanvraag/Lening
     * @return No Content
     */
    lening_van_adviesdossier_wijzigen(vestigingId: string, adviesdossierId: string, body: Lening | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Lening";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLening_van_adviesdossier_wijzigen(_response);
        });
    }

    protected processLening_van_adviesdossier_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Uitkerende lijfrente voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @return OK
     */
    lijfrente_producten_van_voorstel_ophalen(vestigingId: string, voorstelId: string): Promise<LijfrenteOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Lijfrente";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLijfrente_producten_van_voorstel_ophalen(_response);
        });
    }

    protected processLijfrente_producten_van_voorstel_ophalen(response: Response): Promise<LijfrenteOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LijfrenteOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LijfrenteOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LijfrenteOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LijfrenteOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Uitkerende lijfrente voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param body (optional) De inhoud van het Adviesbox-form Uitkerende lijfrente
     * @return No Content
     */
    lijfrente_producten_van_voorstel_wijzigen(vestigingId: string, voorstelId: string, body: Lijfrente | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Lijfrente";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLijfrente_producten_van_voorstel_wijzigen(_response);
        });
    }

    protected processLijfrente_producten_van_voorstel_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Uitkerende lijfrente voor de huidige situatie.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return OK
     */
    lijfrente_producten_van_huidige_situatie_ophalen(vestigingId: string, adviesdossierId: string): Promise<LijfrenteOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Lijfrente";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLijfrente_producten_van_huidige_situatie_ophalen(_response);
        });
    }

    protected processLijfrente_producten_van_huidige_situatie_ophalen(response: Response): Promise<LijfrenteOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LijfrenteOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LijfrenteOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LijfrenteOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LijfrenteOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Uitkerende lijfrente voor de huidige situatie.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param body (optional) De inhoud van het Adviesbox-form Uitkerende lijfrente
     * @return No Content
     */
    lijfrente_producten_van_huidige_situatie_wijzigen(vestigingId: string, adviesdossierId: string, body: Lijfrente | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Lijfrente";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLijfrente_producten_van_huidige_situatie_wijzigen(_response);
        });
    }

    protected processLijfrente_producten_van_huidige_situatie_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Maximale hypotheek voor het gegeven voorstel (analyse).
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @return OK
     */
    maximale_hypotheek_van_voorstel_ophalen(vestigingId: string, voorstelId: string): Promise<MaximaleHypotheekOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/MaximaleHypotheek";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMaximale_hypotheek_van_voorstel_ophalen(_response);
        });
    }

    protected processMaximale_hypotheek_van_voorstel_ophalen(response: Response): Promise<MaximaleHypotheekOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaximaleHypotheekOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaximaleHypotheekOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaximaleHypotheekOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MaximaleHypotheekOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Maximale hypotheek voor het gegeven voorstel (analyse).
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param body (optional) De inhoud van het Adviesbox-form Maximale hypotheek
     * @return No Content
     */
    maximale_hypotheek_van_voorstel_wijzigen(vestigingId: string, voorstelId: string, body: MaximaleHypotheek | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/MaximaleHypotheek";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMaximale_hypotheek_van_voorstel_wijzigen(_response);
        });
    }

    protected processMaximale_hypotheek_van_voorstel_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Berekent de maximale hypotheek met de gegeven input voor het gegeven voorstel (analyse).
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param body (optional) De input voor de berekening
     * @return OK
     */
    maximale_hypotheek_van_voorstel_berekenen(vestigingId: string, voorstelId: string, body: MaximaleHypotheek | null | undefined): Promise<MaximaleHypotheekUitkomstOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/MaximaleHypotheek";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMaximale_hypotheek_van_voorstel_berekenen(_response);
        });
    }

    protected processMaximale_hypotheek_van_voorstel_berekenen(response: Response): Promise<MaximaleHypotheekUitkomstOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaximaleHypotheekUitkomstOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaximaleHypotheekUitkomstOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaximaleHypotheekUitkomstOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaximaleHypotheekUitkomstOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MaximaleHypotheekUitkomstOutput>(null as any);
    }

    /**
     * Geeft de informatie die nodig is om het menu samen te stellen.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return OK
     */
    geeft_de_informatie_die_nodig_is_om_het_menu_samen_te_stellen(vestigingId: string, adviesdossierId: string): Promise<MenuOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Menu";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGeeft_de_informatie_die_nodig_is_om_het_menu_samen_te_stellen(_response);
        });
    }

    protected processGeeft_de_informatie_die_nodig_is_om_het_menu_samen_te_stellen(response: Response): Promise<MenuOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MenuOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MenuOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MenuOutput>(null as any);
    }

    /**
     * Sluit het adviesdossier
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return No Content
     */
    sluit_het_adviesddossier(vestigingId: string, adviesdossierId: string): Promise<void> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Sluiten";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSluit_het_adviesddossier(_response);
        });
    }

    protected processSluit_het_adviesddossier(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de informatie voor de dossierbalk
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return OK
     */
    geeft_de_informatie_voor_de_dossierbalk(vestigingId: string, adviesdossierId: string): Promise<DossierbalkOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Dossierbalk";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGeeft_de_informatie_voor_de_dossierbalk(_response);
        });
    }

    protected processGeeft_de_informatie_voor_de_dossierbalk(response: Response): Promise<DossierbalkOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DossierbalkOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DossierbalkOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DossierbalkOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van de dossierbalk
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param body (optional) De inhoud van de dossierbalk
     * @return No Content
     */
    dossierbalk_informatie_wijzigen(vestigingId: string, adviesdossierId: string, body: DossierbalkInfo | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Dossierbalk";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDossierbalk_informatie_wijzigen(_response);
        });
    }

    protected processDossierbalk_informatie_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de status van een adviesdossier
     * @param vestigingId De unieke identificatie van de huidige vestiging
     * @param adviesdossierId De unieke identificatie van het adviesdossier
     * @return OK
     */
    status_ophalen(vestigingId: string, adviesdossierId: string): Promise<AdviesdossierStatus> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Status";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStatus_ophalen(_response);
        });
    }

    protected processStatus_ophalen(response: Response): Promise<AdviesdossierStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdviesdossierStatus;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdviesdossierStatus;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdviesdossierStatus;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdviesdossierStatus;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdviesdossierStatus>(null as any);
    }

    /**
     * Wijzigt de status van een adviesdossier.
     * @param vestigingId De unieke identificatie van de vestiging
     * @param adviesdossierId De unieke identificatie van het adviesdossier
     * @param body (optional) De nieuwe status
     * @return No Content
     */
    status_wijzigen(vestigingId: string, adviesdossierId: string, body: AdviesdossierStatus | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Status";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStatus_wijzigen(_response);
        });
    }

    protected processStatus_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdviesdossierStatus;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdviesdossierStatus;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdviesdossierStatus;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Wijzigt de naam van een voorstel.
     * @param vestigingId De unieke identificatie van de vestiging
     * @param voorstelId De unieke identificatie van het adviesdossier
     * @param body (optional) De nieuwe naam van het voorstel
     * @return No Content
     */
    naam_voorstel_wijzigen(vestigingId: string, voorstelId: string, body: VoorstelNaam | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Naam";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processNaam_voorstel_wijzigen(_response);
        });
    }

    protected processNaam_voorstel_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft een export van het het adviesdossier terug als abox-bestand.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param anoniem (optional) Geeft aan of de export anoniem gemaakt moet worden
     * @return OK
     */
    adviesdossier_exporteren_naar_abox(vestigingId: string, adviesdossierId: string, anoniem: boolean | null | undefined): Promise<AboxExportOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Export/Abox?";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        if (anoniem !== undefined && anoniem !== null)
            url_ += "anoniem=" + encodeURIComponent("" + anoniem) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdviesdossier_exporteren_naar_abox(_response);
        });
    }

    protected processAdviesdossier_exporteren_naar_abox(response: Response): Promise<AboxExportOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AboxExportOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AboxExportOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AboxExportOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AboxExportOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AboxExportOutput>(null as any);
    }

    /**
     * Geeft een export van het het adviesdossier terug als hbx-bestand.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return OK
     */
    adviesdossier_exporteren_naar_hbx(vestigingId: string, adviesdossierId: string): Promise<HbxExportOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Export/Hbx";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdviesdossier_exporteren_naar_hbx(_response);
        });
    }

    protected processAdviesdossier_exporteren_naar_hbx(response: Response): Promise<HbxExportOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HbxExportOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HbxExportOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HbxExportOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HbxExportOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HbxExportOutput>(null as any);
    }

    /**
     * Neemt het gegeven voorstel (analyse) in beheer en geeft als resultaat de ID van het nieuwe adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel (analyse)
     * @return Created
     */
    voorstel_in_beheer_nemen(vestigingId: string, voorstelId: string): Promise<NewOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/InBeheerNemen";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVoorstel_in_beheer_nemen(_response);
        });
    }

    protected processVoorstel_in_beheer_nemen(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Motivering voor het adviesdossier voor het gegeven soort onderwerp en eventueel de klant.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param onderwerpsoort Het soort onderwerp
     * @return OK
     */
    motivering_van_adviesdossier_ophalen(vestigingId: string, adviesdossierId: string, onderwerpsoort: Onderwerpsoort): Promise<MotiveringOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Motivering/{onderwerpsoort}";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        if (onderwerpsoort === undefined || onderwerpsoort === null)
            throw new Error("The parameter 'onderwerpsoort' must be defined.");
        url_ = url_.replace("{onderwerpsoort}", encodeURIComponent("" + onderwerpsoort));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMotivering_van_adviesdossier_ophalen(_response);
        });
    }

    protected processMotivering_van_adviesdossier_ophalen(response: Response): Promise<MotiveringOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MotiveringOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MotiveringOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MotiveringOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MotiveringOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Motivering voor het adviesdossier voor het gegeven soort onderwerp en eventueel de klant.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param onderwerpsoort Het soort onderwerp
     * @param body (optional) De inhoud van het Adviesbox-form Motivering
     * @return No Content
     */
    motivering_vanadviesdossier_wijzigen(vestigingId: string, adviesdossierId: string, onderwerpsoort: Onderwerpsoort2, body: Motivering | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Motivering/{onderwerpsoort}";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        if (onderwerpsoort === undefined || onderwerpsoort === null)
            throw new Error("The parameter 'onderwerpsoort' must be defined.");
        url_ = url_.replace("{onderwerpsoort}", encodeURIComponent("" + onderwerpsoort));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMotivering_vanadviesdossier_wijzigen(_response);
        });
    }

    protected processMotivering_vanadviesdossier_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Haalt de ongelezen notificaties van een adviseur op.
     * @param vestigingId De identificatie van de vestiging
     * @return OK
     */
    haalt_de_ongelezen_notificaties_van_een_adviseur_op(vestigingId: string): Promise<NotificatieOutput> {
        let url_ = this.baseUrl + "/Notificatie";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHaalt_de_ongelezen_notificaties_van_een_adviseur_op(_response);
        });
    }

    protected processHaalt_de_ongelezen_notificaties_van_een_adviseur_op(response: Response): Promise<NotificatieOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotificatieOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotificatieOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotificatieOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificatieOutput>(null as any);
    }

    /**
     * Zet een notificatie op gelezen.
     * @param vestigingId De identificatie van de vestiging
     * @param uniqueIdentification (optional) Unieke identificatie van een notificatie
     * @return OK
     */
    toggled_of_een_notificatie_is_gelezen(vestigingId: string, uniqueIdentification: string | null | undefined): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Notificatie?";
        if (uniqueIdentification !== undefined && uniqueIdentification !== null)
            url_ += "uniqueIdentification=" + encodeURIComponent("" + uniqueIdentification) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processToggled_of_een_notificatie_is_gelezen(_response);
        });
    }

    protected processToggled_of_een_notificatie_is_gelezen(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Verwijderd notificatie uit de lijst
     * @param vestigingId De identificatie van de vestiging
     * @param uniqueIdentification (optional) Unieke identificatie van een notificatie
     * @return OK
     */
    verwijderd_notificatie_uit_de_lijst(vestigingId: string, uniqueIdentification: string | null | undefined): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Notificatie?";
        if (uniqueIdentification !== undefined && uniqueIdentification !== null)
            url_ += "uniqueIdentification=" + encodeURIComponent("" + uniqueIdentification) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerwijderd_notificatie_uit_de_lijst(_response);
        });
    }

    protected processVerwijderd_notificatie_uit_de_lijst(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Stuurt een concept aanvraag naar Nwb
     * @param body (optional) 
     * @return OK
     */
    nwb_concept_aanvraag_posten(body: NwbConceptAanvraag | null | undefined): Promise<NwbConceptOutput> {
        let url_ = this.baseUrl + "/PostConcept";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processNwb_concept_aanvraag_posten(_response);
        });
    }

    protected processNwb_concept_aanvraag_posten(response: Response): Promise<NwbConceptOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NwbConceptOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NwbConceptOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NwbConceptOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NwbConceptOutput>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form ORV voor het gegeven voorstel (analyse).
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @return OK
     */
    oRVs_van_voorstel_ophalen(vestigingId: string, voorstelId: string): Promise<OrvOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Orv";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processORVs_van_voorstel_ophalen(_response);
        });
    }

    protected processORVs_van_voorstel_ophalen(response: Response): Promise<OrvOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrvOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrvOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrvOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrvOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form ORV voor het gegeven voorstel (analyse).
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param body (optional) De inhoud van het Adviesbox-form ORV
     * @return No Content
     */
    oRVs_van_voorstel_wijzigen(vestigingId: string, voorstelId: string, body: Orv | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Orv";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processORVs_van_voorstel_wijzigen(_response);
        });
    }

    protected processORVs_van_voorstel_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Bereken de ORV voor Adviesbox-form ORV voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param body (optional) De inhoud van het Adviesbox-form ORV
     * @return OK
     */
    oRVs_van_voorstel_berekenen(vestigingId: string, voorstelId: string, body: OrvBerekening | null | undefined): Promise<OrvResultaat> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Orv";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processORVs_van_voorstel_berekenen(_response);
        });
    }

    protected processORVs_van_voorstel_berekenen(response: Response): Promise<OrvResultaat> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrvResultaat;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrvResultaat;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrvResultaat;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrvResultaat;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrvResultaat>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form ORV voor de huidige situatie.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return OK
     */
    oRVs_van_huidige_situatie_ophalen(vestigingId: string, adviesdossierId: string): Promise<OrvOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Orv";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processORVs_van_huidige_situatie_ophalen(_response);
        });
    }

    protected processORVs_van_huidige_situatie_ophalen(response: Response): Promise<OrvOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrvOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrvOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrvOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrvOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form ORV voor de huidige situatie.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param body (optional) De inhoud van het Adviesbox-form Hypotheek
     * @return No Content
     */
    oRVs_van_huidige_situatie_wijzigen(vestigingId: string, adviesdossierId: string, body: Orv | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Orv";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processORVs_van_huidige_situatie_wijzigen(_response);
        });
    }

    protected processORVs_van_huidige_situatie_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Berekent de duur in maanden van de inkomensaanvulling.
     * @param vestigingId De identificatie van de vestiging
     * @param body (optional) De parameters waarmee de berekening uitgevoerd moet worden
     * @return OK
     */
    duur_in_maanden_van_inkomensaanvulling_berekenen(vestigingId: string, body: InkomensaanvullingDuurInMaandenInput | null | undefined): Promise<InkomensaanvullingDuurInMaandenOutput> {
        let url_ = this.baseUrl + "/Orv/Inkomensaanvulling/DuurInMaanden";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuur_in_maanden_van_inkomensaanvulling_berekenen(_response);
        });
    }

    protected processDuur_in_maanden_van_inkomensaanvulling_berekenen(response: Response): Promise<InkomensaanvullingDuurInMaandenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InkomensaanvullingDuurInMaandenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InkomensaanvullingDuurInMaandenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InkomensaanvullingDuurInMaandenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InkomensaanvullingDuurInMaandenOutput>(null as any);
    }

    /**
     * Voert de ORV premievergelijker uit voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param body (optional) De input voor de berekening
     * @return OK
     */
    oRV_premievergelijker_uitvoeren(vestigingId: string, adviesdossierId: string, body: OrvVergelijkerInput | null | undefined): Promise<OrvVergelijkerOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/OrvVergelijker";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processORV_premievergelijker_uitvoeren(_response);
        });
    }

    protected processORV_premievergelijker_uitvoeren(response: Response): Promise<OrvVergelijkerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrvVergelijkerOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrvVergelijkerOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrvVergelijkerOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrvVergelijkerOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrvVergelijkerOutput>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Overig voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @return OK
     */
    overige_producten_van_voorstel_ophalen(vestigingId: string, voorstelId: string): Promise<OverigOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Overig";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOverige_producten_van_voorstel_ophalen(_response);
        });
    }

    protected processOverige_producten_van_voorstel_ophalen(response: Response): Promise<OverigOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverigOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverigOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverigOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OverigOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Overig voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het advies
     * @param body (optional) De inhoud van het Adviesbox-form Overig
     * @return No Content
     */
    overige_producten_van_voorstel_wijzigen(vestigingId: string, voorstelId: string, body: Overig | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Overig";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOverige_producten_van_voorstel_wijzigen(_response);
        });
    }

    protected processOverige_producten_van_voorstel_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Overig voor de huidige situatie.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return OK
     */
    overige_producten_van_huidige_situatie_ophalen(vestigingId: string, adviesdossierId: string): Promise<OverigOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Overig";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOverige_producten_van_huidige_situatie_ophalen(_response);
        });
    }

    protected processOverige_producten_van_huidige_situatie_ophalen(response: Response): Promise<OverigOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverigOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverigOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverigOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OverigOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Overig voor de huidige situatie.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het voorstel
     * @param body (optional) De inhoud van het Adviesbox-form Overig
     * @return No Content
     */
    overige_producten_van_huidige_situatie_wijzigen(vestigingId: string, adviesdossierId: string, body: Overig | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Overig";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOverige_producten_van_huidige_situatie_wijzigen(_response);
        });
    }

    protected processOverige_producten_van_huidige_situatie_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Pensioen voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return OK
     */
    pensioen_van_adviesdossier_ophalen(vestigingId: string, adviesdossierId: string): Promise<PensioenOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Pensioen";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPensioen_van_adviesdossier_ophalen(_response);
        });
    }

    protected processPensioen_van_adviesdossier_ophalen(response: Response): Promise<PensioenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PensioenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PensioenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PensioenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PensioenOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Pensioen voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param body (optional) De inhoud van het Adviesbox-form Pensioen
     * @return No Content
     */
    pensioen_van_adviesdossier_wijzigen(vestigingId: string, adviesdossierId: string, body: Pensioen | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Pensioen";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPensioen_van_adviesdossier_wijzigen(_response);
        });
    }

    protected processPensioen_van_adviesdossier_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Personalia voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return OK
     */
    personalia_van_adviesdossier_ophalen(vestigingId: string, adviesdossierId: string): Promise<PersonaliaOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Personalia";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPersonalia_van_adviesdossier_ophalen(_response);
        });
    }

    protected processPersonalia_van_adviesdossier_ophalen(response: Response): Promise<PersonaliaOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonaliaOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonaliaOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonaliaOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonaliaOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Personalia voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param body (optional) De inhoud van het Adviesbox-form Personalia
     * @return No Content
     */
    personalia_van_adviesdossier_wijzigen(vestigingId: string, adviesdossierId: string, body: Personalia | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Personalia";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPersonalia_van_adviesdossier_wijzigen(_response);
        });
    }

    protected processPersonalia_van_adviesdossier_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de waarschuwingen voor het verwerken van de inhoud van het Adviesbox-form Personalia voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param body (optional) De inhoud van het Adviesbox-form Personalia
     * @return OK
     */
    waarschuwingen_bij_personalia_wijzigen(vestigingId: string, adviesdossierId: string, body: Personalia | null | undefined): Promise<PersonaliaWaarschuwingenOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Personalia/Waarschuwingen";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWaarschuwingen_bij_personalia_wijzigen(_response);
        });
    }

    protected processWaarschuwingen_bij_personalia_wijzigen(response: Response): Promise<PersonaliaWaarschuwingenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonaliaWaarschuwingenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonaliaWaarschuwingenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonaliaWaarschuwingenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonaliaWaarschuwingenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonaliaWaarschuwingenOutput>(null as any);
    }

    /**
     * Geeft de rapportage-structuur met de gegeven ID voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param structuurId De identificatie van de rapportage-structuur
     * @return OK
     */
    rapportage_structuur_van_voorstel_ophalen(vestigingId: string, voorstelId: string, structuurId: string): Promise<RapportSamenstellenStructuurOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/RapportSamenstellen/Structuren/{structuurId}";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        if (structuurId === undefined || structuurId === null)
            throw new Error("The parameter 'structuurId' must be defined.");
        url_ = url_.replace("{structuurId}", encodeURIComponent("" + structuurId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRapportage_structuur_van_voorstel_ophalen(_response);
        });
    }

    protected processRapportage_structuur_van_voorstel_ophalen(response: Response): Promise<RapportSamenstellenStructuurOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RapportSamenstellenStructuurOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RapportSamenstellenStructuurOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RapportSamenstellenStructuurOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RapportSamenstellenStructuurOutput>(null as any);
    }

    /**
     * Geeft de rapportage-structuur met de gegeven ID voor de huidige situatie het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param structuurId De identificatie van de rapportage-structuur
     * @return OK
     */
    rapportage_structuur_van_huidige_situatie_ophalen(vestigingId: string, adviesdossierId: string, structuurId: string): Promise<RapportSamenstellenStructuurOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/RapportSamenstellen/Structuren/{structuurId}";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        if (structuurId === undefined || structuurId === null)
            throw new Error("The parameter 'structuurId' must be defined.");
        url_ = url_.replace("{structuurId}", encodeURIComponent("" + structuurId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRapportage_structuur_van_huidige_situatie_ophalen(_response);
        });
    }

    protected processRapportage_structuur_van_huidige_situatie_ophalen(response: Response): Promise<RapportSamenstellenStructuurOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RapportSamenstellenStructuurOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RapportSamenstellenStructuurOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RapportSamenstellenStructuurOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RapportSamenstellenStructuurOutput>(null as any);
    }

    /**
     * Verwerkt de rapportage-structuur voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param body (optional) De rapportage-structuur
     * @return No Content
     */
    rapportage_structuur_van_adviesdossier_wijzigen(vestigingId: string, adviesdossierId: string, structuurId: string, body: RapportSamenstellenStructuur | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/RapportSamenstellen/Structuren/{structuurId}";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        if (structuurId === undefined || structuurId === null)
            throw new Error("The parameter 'structuurId' must be defined.");
        url_ = url_.replace("{structuurId}", encodeURIComponent("" + structuurId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRapportage_structuur_van_adviesdossier_wijzigen(_response);
        });
    }

    protected processRapportage_structuur_van_adviesdossier_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Zoekt een adviesdossier op basis van een zoekopdracht
     * @param vestigingId Het id van de vestiging waar de gebruiker werkt
     * @param body (optional) Criteria en zoektermen waarop gezocht moet worden
     * @return OK
     */
    zoek_een_adviesdossier(vestigingId: string, body: ZoekDossierInput | null | undefined): Promise<ZoekresultaatOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/Zoeken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processZoek_een_adviesdossier(_response);
        });
    }

    protected processZoek_een_adviesdossier(response: Response): Promise<ZoekresultaatOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ZoekresultaatOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ZoekresultaatOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ZoekresultaatOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ZoekresultaatOutput>(null as any);
    }

    /**
     * logt het laatst geopende adviesdossier
     * @param vestigingId Het id van de vestiging waar de gebruiker werkt
     * @param klantdossierId klant dossier behorend bij dit adviesdossier
     * @return OK
     */
    voegt_een_laatst_geopende_adviesdossiers_toe(vestigingId: string, adviesdossierId: string, klantdossierId: string): Promise<RecentGeopendOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Recent/{klantdossierId}";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        if (klantdossierId === undefined || klantdossierId === null)
            throw new Error("The parameter 'klantdossierId' must be defined.");
        url_ = url_.replace("{klantdossierId}", encodeURIComponent("" + klantdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVoegt_een_laatst_geopende_adviesdossiers_toe(_response);
        });
    }

    protected processVoegt_een_laatst_geopende_adviesdossiers_toe(response: Response): Promise<RecentGeopendOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RecentGeopendOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RecentGeopendOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecentGeopendOutput>(null as any);
    }

    /**
     * Zoekt de laatst geopende adviesdossiers
     * @param vestigingId Het id van de vestiging waar de gebruiker werkt
     * @param aantal (optional) Het (maximum) aantal adviesdossiers dat geleverd moet worden
     * @return OK
     */
    zoekt_de_laatst_geopende_adviesdossiers(vestigingId: string, aantal: number | null | undefined): Promise<RecentGeopendOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/Recent?";
        if (aantal !== undefined && aantal !== null)
            url_ += "aantal=" + encodeURIComponent("" + aantal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processZoekt_de_laatst_geopende_adviesdossiers(_response);
        });
    }

    protected processZoekt_de_laatst_geopende_adviesdossiers(response: Response): Promise<RecentGeopendOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RecentGeopendOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RecentGeopendOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecentGeopendOutput>(null as any);
    }

    /**
     * Zoekt de laatst geopende documentdossiers
     * @param vestigingId Het id van de vestiging waar de gebruiker werkt
     * @param aantal (optional) Het (maximum) aantal documentdossiers dat geleverd moet worden
     * @return OK
     */
    zoekt_de_laatst_geopende_documentdossiers(vestigingId: string, aantal: number | null | undefined): Promise<RecentGeopendOutput> {
        let url_ = this.baseUrl + "/Documentdossiers/Recent?";
        if (aantal !== undefined && aantal !== null)
            url_ += "aantal=" + encodeURIComponent("" + aantal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processZoekt_de_laatst_geopende_documentdossiers(_response);
        });
    }

    protected processZoekt_de_laatst_geopende_documentdossiers(response: Response): Promise<RecentGeopendOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RecentGeopendOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RecentGeopendOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecentGeopendOutput>(null as any);
    }

    /**
     * Geeft de inhoud van het adviesdossier met name de korte en lange omschrijving.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return OK
     */
    inhoud_van_adviesdossier_ophalen(vestigingId: string, adviesdossierId: string): Promise<AdviesdossierOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInhoud_van_adviesdossier_ophalen(_response);
        });
    }

    protected processInhoud_van_adviesdossier_ophalen(response: Response): Promise<AdviesdossierOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdviesdossierOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdviesdossierOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdviesdossierOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdviesdossierOutput>(null as any);
    }

    /**
     * Verwijder een adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De unieke identificatie van het adviesdossier
     * @return No Content
     */
    verwijder_een_adviesdossier_(vestigingId: string, adviesdossierId: string): Promise<void> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerwijder_een_adviesdossier_(_response);
        });
    }

    protected processVerwijder_een_adviesdossier_(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NieuwKlantdossierOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Maakt een adviesdossier aan op basis van een ander adviesdossier binnen dezelfde klantsamenstelling.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier dat als voorbeeld dient voor het nieuwe adviesdossier
     * @param body (optional) De input voor de kopie, dit zijn de korte en lange omschrijving
     * @return Created
     */
    kopie_van_adviesdossier_maken(vestigingId: string, adviesdossierId: string, body: NieuwAdviesdossierInput | null | undefined): Promise<NieuwAdviesdossierOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Kopie";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKopie_van_adviesdossier_maken(_response);
        });
    }

    protected processKopie_van_adviesdossier_maken(response: Response): Promise<NieuwAdviesdossierOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NieuwAdviesdossierOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NieuwAdviesdossierOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NieuwAdviesdossierOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NieuwAdviesdossierOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NieuwAdviesdossierOutput>(null as any);
    }

    /**
     * Maakt een adviesdossier aan voor een klantdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param klantdossierId De identificatie van het klantdossier waarvoor het adviesdossier aangemaakt moet worden
     * @return Created
     */
    maakt_een_adviesdossier_aan_voor_een_klantdossier(vestigingId: string, klantdossierId: string): Promise<NieuwAdviesdossierOutput> {
        let url_ = this.baseUrl + "/Klantdossiers/{klantdossierId}/NieuwAdviesdossier";
        if (klantdossierId === undefined || klantdossierId === null)
            throw new Error("The parameter 'klantdossierId' must be defined.");
        url_ = url_.replace("{klantdossierId}", encodeURIComponent("" + klantdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMaakt_een_adviesdossier_aan_voor_een_klantdossier(_response);
        });
    }

    protected processMaakt_een_adviesdossier_aan_voor_een_klantdossier(response: Response): Promise<NieuwAdviesdossierOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NieuwAdviesdossierOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NieuwAdviesdossierOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NieuwAdviesdossierOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NieuwAdviesdossierOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NieuwAdviesdossierOutput>(null as any);
    }

    /**
     * Maakt een nieuw klantdossier aan (en maakt voor deze een klant en adviesdossier).
     * @param vestigingId De identificatie van de vestiging
     * @param body (optional) Gegevens van het nieuwe klantdossier
     * @return Created
     */
    maakt_een_nieuw_klantdossier_aan(vestigingId: string, body: NieuwKlantdossierInput | null | undefined): Promise<NieuwKlantdossierOutput> {
        let url_ = this.baseUrl + "/Klantdossiers/NieuwKlantdossier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMaakt_een_nieuw_klantdossier_aan(_response);
        });
    }

    protected processMaakt_een_nieuw_klantdossier_aan(response: Response): Promise<NieuwKlantdossierOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NieuwKlantdossierOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NieuwKlantdossierOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NieuwKlantdossierOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NieuwKlantdossierOutput>(null as any);
    }

    /**
     * Verwijder een klantdossier met onderliggende adviesdossier(s).
     * @param vestigingId De identificatie van de vestiging
     * @param klantdossierId De unieke identificatie van het klantdossier
     * @return No Content
     */
    verwijder_een_klantdossier_met_onderliggende_adviesdossiers_(vestigingId: string, klantdossierId: string): Promise<void> {
        let url_ = this.baseUrl + "/Klantdossiers/{klantdossierId}";
        if (klantdossierId === undefined || klantdossierId === null)
            throw new Error("The parameter 'klantdossierId' must be defined.");
        url_ = url_.replace("{klantdossierId}", encodeURIComponent("" + klantdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerwijder_een_klantdossier_met_onderliggende_adviesdossiers_(_response);
        });
    }

    protected processVerwijder_een_klantdossier_met_onderliggende_adviesdossiers_(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verwijder alle klantdossier met onderliggende adviesdossier(s) van een vestiging.
     * @param vestigingId De identificatie van de vestiging
     * @return OK
     */
    verwijder_alle_klantdossier_met_onderliggende_adviesdossiers_van_een_vestiging_(vestigingId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Klantdossiers/alle";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerwijder_alle_klantdossier_met_onderliggende_adviesdossiers_van_een_vestiging_(_response);
        });
    }

    protected processVerwijder_alle_klantdossier_met_onderliggende_adviesdossiers_van_een_vestiging_(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Geeft de adviseurs van de ingelogde gebruiker.
     * @param vestigingId De identificatie van de vestiging
     * @return OK
     */
    adviseurs_gekoppeld_aan_de_ingelogde_gebruiker(vestigingId: string): Promise<AdviseurOutput> {
        let url_ = this.baseUrl + "/Adviseurs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdviseurs_gekoppeld_aan_de_ingelogde_gebruiker(_response);
        });
    }

    protected processAdviseurs_gekoppeld_aan_de_ingelogde_gebruiker(response: Response): Promise<AdviseurOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdviseurOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdviseurOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdviseurOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdviseurOutput>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Aanvraag/Taxatie voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return OK
     */
    taxatie_van_adviesdossier_ophalen(vestigingId: string, adviesdossierId: string): Promise<TaxatieOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Taxatie";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTaxatie_van_adviesdossier_ophalen(_response);
        });
    }

    protected processTaxatie_van_adviesdossier_ophalen(response: Response): Promise<TaxatieOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaxatieOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaxatieOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaxatieOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaxatieOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Aanvraag/Taxatie voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param body (optional) De inhoud van het Adviesbox-form Aanvraag/Taxatie
     * @return No Content
     */
    taxatie_van_adviesdossier_verwerken(vestigingId: string, adviesdossierId: string, body: Taxatie | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Taxatie";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTaxatie_van_adviesdossier_verwerken(_response);
        });
    }

    protected processTaxatie_van_adviesdossier_verwerken(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Slaat de gegevens op en verstuurt een taxatieaanvraag naar de betreffende partij.
     * @param body (optional) 
     * @return OK
     */
    verstuurt_een_aanvraag_van_een_taxatie_naar_het_taxatiebureau(vestigingId: string, adviesdossierId: string, body: Taxatie | null | undefined): Promise<TaxatieAanvraagOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Aanvraag";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerstuurt_een_aanvraag_van_een_taxatie_naar_het_taxatiebureau(_response);
        });
    }

    protected processVerstuurt_een_aanvraag_van_een_taxatie_naar_het_taxatiebureau(response: Response): Promise<TaxatieAanvraagOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaxatieAanvraagOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaxatieAanvraagOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaxatieAanvraagOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaxatieAanvraagOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaxatieAanvraagOutput>(null as any);
    }

    /**
     * Geeft de geldverstrekkers volgens NWWI.
     * @param vestigingId Unieke identificatie van de vestiging
     * @param agentnummer (optional) Agentnummer
     * @param taxatiedoel Taxatiedoel (niet alle doelen zijn toegestaan bij NWWI)
     * @param postcode (optional) Postcode van het object
     * @return OK
     */
    geeft_de_geldverstrekkers_volgens_NWWI(vestigingId: string, agentnummer: number | null | undefined, taxatiedoel: Taxatiedoel, postcode: string | null | undefined): Promise<TaxatieNwwiGeldverstrekkersOutput> {
        let url_ = this.baseUrl + "/Taxatie/NWWI/Geldverstrekkers?";
        if (agentnummer !== undefined && agentnummer !== null)
            url_ += "agentnummer=" + encodeURIComponent("" + agentnummer) + "&";
        if (taxatiedoel === undefined || taxatiedoel === null)
            throw new Error("The parameter 'taxatiedoel' must be defined and cannot be null.");
        else
            url_ += "taxatiedoel=" + encodeURIComponent("" + taxatiedoel) + "&";
        if (postcode !== undefined && postcode !== null)
            url_ += "postcode=" + encodeURIComponent("" + postcode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGeeft_de_geldverstrekkers_volgens_NWWI(_response);
        });
    }

    protected processGeeft_de_geldverstrekkers_volgens_NWWI(response: Response): Promise<TaxatieNwwiGeldverstrekkersOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaxatieNwwiGeldverstrekkersOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaxatieNwwiGeldverstrekkersOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaxatieNwwiGeldverstrekkersOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaxatieNwwiGeldverstrekkersOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaxatieNwwiGeldverstrekkersOutput>(null as any);
    }

    /**
     * Geeft de taxatiebureaus volgens NWWI.
     * @param vestigingId Unieke identificatie van de vestiging
     * @param postcode (optional) Postcode van het object
     * @param huisnummer (optional) Huisnummer van het object
     * @param contractId (optional) ContractId van de geldverstrekker
     * @return OK
     */
    geeft_de_taxatiebureaus_volgens_NWWI(vestigingId: string, postcode: string | null | undefined, huisnummer: number | null | undefined, contractId: number | null | undefined): Promise<TaxatieNwwiTaxatiebureausOutput> {
        let url_ = this.baseUrl + "/Taxatie/NWWI/Taxatiebureaus?";
        if (postcode !== undefined && postcode !== null)
            url_ += "postcode=" + encodeURIComponent("" + postcode) + "&";
        if (huisnummer !== undefined && huisnummer !== null)
            url_ += "huisnummer=" + encodeURIComponent("" + huisnummer) + "&";
        if (contractId !== undefined && contractId !== null)
            url_ += "contractId=" + encodeURIComponent("" + contractId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGeeft_de_taxatiebureaus_volgens_NWWI(_response);
        });
    }

    protected processGeeft_de_taxatiebureaus_volgens_NWWI(response: Response): Promise<TaxatieNwwiTaxatiebureausOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaxatieNwwiTaxatiebureausOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaxatieNwwiTaxatiebureausOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaxatieNwwiTaxatiebureausOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaxatieNwwiTaxatiebureausOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaxatieNwwiTaxatiebureausOutput>(null as any);
    }

    /**
     * Haalt de adviseur eigenaar gegevens op voor een adviesdossier.
     * @return OK
     */
    eigenaarAdviesdossierOpvragen(vestigingId: string, adviesdossierId: string): Promise<AdviesEigenaarOutput> {
        let url_ = this.baseUrl + "/Adviesdossier/Eigenaar/{adviesdossierId}";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEigenaarAdviesdossierOpvragen(_response);
        });
    }

    protected processEigenaarAdviesdossierOpvragen(response: Response): Promise<AdviesEigenaarOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdviesEigenaarOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdviesEigenaarOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdviesEigenaarOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdviesEigenaarOutput>(null as any);
    }

    /**
     * Wijzigt de eigenaar van een adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param huidigAdviseurId (optional) bestaande adviesdossier eigenaar
     * @param adviesdossierId (optional) adviesdossier id
     * @param licentiesMedewerkerId (optional) id van de licentie medewerker (vertalen we later naar adviseur)
     * @return OK
     */
    wijzigenEigenaarAdviesdossier(vestigingId: string, huidigAdviseurId: string | null | undefined, adviesdossierId: string | null | undefined, licentiesMedewerkerId: string | null | undefined): Promise<AdviesdossierWijzigenEigenaar> {
        let url_ = this.baseUrl + "/Adviesdossier/WijzigEigenaar?";
        if (huidigAdviseurId !== undefined && huidigAdviseurId !== null)
            url_ += "huidigAdviseurId=" + encodeURIComponent("" + huidigAdviseurId) + "&";
        if (adviesdossierId !== undefined && adviesdossierId !== null)
            url_ += "adviesdossierId=" + encodeURIComponent("" + adviesdossierId) + "&";
        if (licentiesMedewerkerId !== undefined && licentiesMedewerkerId !== null)
            url_ += "licentiesMedewerkerId=" + encodeURIComponent("" + licentiesMedewerkerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWijzigenEigenaarAdviesdossier(_response);
        });
    }

    protected processWijzigenEigenaarAdviesdossier(response: Response): Promise<AdviesdossierWijzigenEigenaar> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdviesdossierWijzigenEigenaar;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdviesdossierWijzigenEigenaar;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdviesdossierWijzigenEigenaar;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdviesdossierWijzigenEigenaar>(null as any);
    }

    /**
     * Geeft aan of de ingelogde gebruiker het adviesdossier mag openen / lezen.
     * @param vestigingId De identificatie van de vestiging
     * @param body (optional) De adviesdossier waarvoor we leesrechten op willen vragen
     * @return OK
     */
    toegang_Tot_Adviesdossier(vestigingId: string, body: { [key: string]: string; } | null | undefined): Promise<AdviesdossierRechtenOutput> {
        let url_ = this.baseUrl + "/Adviesdossier/Leesrechten";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processToegang_Tot_Adviesdossier(_response);
        });
    }

    protected processToegang_Tot_Adviesdossier(response: Response): Promise<AdviesdossierRechtenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdviesdossierRechtenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdviesdossierRechtenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdviesdossierRechtenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdviesdossierRechtenOutput>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Vergoedingenoverzicht voor het gegeven voorstel (analyse).
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel (analyse)
     * @return OK
     */
    vergoedingenoverzicht_van_voorstel_ophalen(vestigingId: string, voorstelId: string): Promise<VergoedingenoverzichtenOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Vergoedingenoverzicht";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVergoedingenoverzicht_van_voorstel_ophalen(_response);
        });
    }

    protected processVergoedingenoverzicht_van_voorstel_ophalen(response: Response): Promise<VergoedingenoverzichtenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VergoedingenoverzichtenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VergoedingenoverzichtenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VergoedingenoverzichtenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VergoedingenoverzichtenOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Vergoedingenoverzicht voor het gegeven voorstel (analyse).
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel (analyse)
     * @param body (optional) De inhoud van het Adviesbox-form Vergoedingenoverzicht
     * @return No Content
     */
    vergoedingenoverzicht_van_voorstel_wijzigen(vestigingId: string, voorstelId: string, body: Vergoedingenoverzicht | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Vergoedingenoverzicht";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVergoedingenoverzicht_van_voorstel_wijzigen(_response);
        });
    }

    protected processVergoedingenoverzicht_van_voorstel_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de waarschuwingen voor het verwerken van de inhoud van het Adviesbox-form Vergoedingenoverzicht voor het gegeven voorstel (analyse).
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param body (optional) De inhoud van het Adviesbox-form Vergoedingenoverzicht
     * @return OK
     */
    waarschuwingen_bij_vergoedingenoverzicht_wijzigen(vestigingId: string, voorstelId: string, body: Vergoedingenoverzicht | null | undefined): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Vergoedingenoverzicht/Waarschuwingen";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWaarschuwingen_bij_vergoedingenoverzicht_wijzigen(_response);
        });
    }

    protected processWaarschuwingen_bij_vergoedingenoverzicht_wijzigen(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Vermogen voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @return OK
     */
    vermogenen_van_voorstel_ophalen(vestigingId: string, voorstelId: string): Promise<VermogenOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Vermogen";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVermogenen_van_voorstel_ophalen(_response);
        });
    }

    protected processVermogenen_van_voorstel_ophalen(response: Response): Promise<VermogenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VermogenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VermogenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VermogenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VermogenOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Vermogen voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param body (optional) De inhoud van het Adviesbox-form Vermogen
     * @return No Content
     */
    vermogen_van_voorstel_wijzigen(vestigingId: string, voorstelId: string, body: Vermogen | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Vermogen";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVermogen_van_voorstel_wijzigen(_response);
        });
    }

    protected processVermogen_van_voorstel_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Vermogen voor de huidige situatie.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return OK
     */
    vermogen_van_huidige_situatie_ophalen(vestigingId: string, adviesdossierId: string): Promise<VermogenOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Vermogen";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVermogen_van_huidige_situatie_ophalen(_response);
        });
    }

    protected processVermogen_van_huidige_situatie_ophalen(response: Response): Promise<VermogenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VermogenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VermogenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VermogenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VermogenOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Vermogen voor de huidige situatie.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param body (optional) De inhoud van het Adviesbox-form Vermogen
     * @return No Content
     */
    vermogen_van_huidige_situatie_wijzigen(vestigingId: string, adviesdossierId: string, body: Vermogen | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Vermogen";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVermogen_van_huidige_situatie_wijzigen(_response);
        });
    }

    protected processVermogen_van_huidige_situatie_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Berekent de inhoud van de pop-up 'Opname uit beleggingen' t.b.v. het Adviesbox-form Vermogen voor het gegeven (Onafhankelijk) product.
     * @param vestigingId De identificatie van de vestiging
     * @param body (optional) De inhoud van het (Onafhankelijk) vermogensproduct
     * @return OK
     */
    vermogen_berekenen(vestigingId: string, adviesdossierId: string, body: VermogenBerekeningInput | null | undefined): Promise<VermogenBerekeningOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Vermogen";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVermogen_berekenen(_response);
        });
    }

    protected processVermogen_berekenen(response: Response): Promise<VermogenBerekeningOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VermogenBerekeningOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VermogenBerekeningOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VermogenBerekeningOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VermogenBerekeningOutput>(null as any);
    }

    /**
     * Berekent de inhoud van de pop-up 'Opname uit beleggingen' t.b.v. het Adviesbox-form Vermogen voor het gegeven (Onafhankelijk) product.
     * @param vestigingId De identificatie van de vestiging
     * @param body (optional) De inhoud van het (Onafhankelijk) vermogensproduct
     * @return OK
     */
    opname_uit_beleggingen_berekenen(vestigingId: string, body: VermogenBerekeningInput | null | undefined): Promise<OpnameBerekeningOutput> {
        let url_ = this.baseUrl + "/Vermogen/Opname";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOpname_uit_beleggingen_berekenen(_response);
        });
    }

    protected processOpname_uit_beleggingen_berekenen(response: Response): Promise<OpnameBerekeningOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpnameBerekeningOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpnameBerekeningOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpnameBerekeningOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OpnameBerekeningOutput>(null as any);
    }

    /**
     * @return OK
     */
    getVersionInfo(): Promise<VersionInfo> {
        let url_ = this.baseUrl + "/VersionInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVersionInfo(_response);
        });
    }

    protected processGetVersionInfo(response: Response): Promise<VersionInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VersionInfo;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BadRequestResult;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VersionInfo>(null as any);
    }

    /**
     * @return OK
     */
    getFoutcodes(): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/VersionInfo/FoutCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFoutcodes(_response);
        });
    }

    protected processGetFoutcodes(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Woning voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return OK
     */
    woning_van_adviesdossier_ophalen(vestigingId: string, adviesdossierId: string): Promise<WoningenOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Woning";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWoning_van_adviesdossier_ophalen(_response);
        });
    }

    protected processWoning_van_adviesdossier_ophalen(response: Response): Promise<WoningenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WoningenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WoningenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WoningenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WoningenOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Woning voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param body (optional) De inhoud van het Adviesbox-form Woning
     * @return No Content
     */
    woning_van_adviesdossier_wijzigen(vestigingId: string, adviesdossierId: string, body: Woning | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Woning";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWoning_van_adviesdossier_wijzigen(_response);
        });
    }

    protected processWoning_van_adviesdossier_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Upload een foto van de woning en werk hiermee de woninggegevens bij
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param fotoWoningBestand (optional) De te uploaden foto
     * @return Created
     */
    foto_woning_uploaden(vestigingId: string, adviesdossierId: string, fotoWoningBestand: FileParameter | null | undefined): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Woning/UploadFotoWoning?";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined and cannot be null.");
        else
            url_ += "adviesdossierId=" + encodeURIComponent("" + adviesdossierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fotoWoningBestand !== null && fotoWoningBestand !== undefined)
            content_.append("fotoWoningBestand", fotoWoningBestand.data, fotoWoningBestand.fileName ? fotoWoningBestand.fileName : "fotoWoningBestand");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFoto_woning_uploaden(_response);
        });
    }

    protected processFoto_woning_uploaden(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Woonsituatie voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return OK
     */
    woonsituatie_van_adviesdossier_ophalen(vestigingId: string, adviesdossierId: string): Promise<WoonsituatieOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Woonsituatie";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWoonsituatie_van_adviesdossier_ophalen(_response);
        });
    }

    protected processWoonsituatie_van_adviesdossier_ophalen(response: Response): Promise<WoonsituatieOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WoonsituatieOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WoonsituatieOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WoonsituatieOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WoonsituatieOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Woonsituatie voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param body (optional) De inhoud van het Adviesbox-form Woonsituatie
     * @return No Content
     */
    woonsituatie_van_adviesdossier_wijzigen(vestigingId: string, adviesdossierId: string, body: Woonsituatie | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Woonsituatie";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWoonsituatie_van_adviesdossier_wijzigen(_response);
        });
    }

    protected processWoonsituatie_van_adviesdossier_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

/** Bevat de inhoud van het Adviesbox-form Aanleiding. */
export interface Aanleiding {
    aanvrager1: KlantnaamReadOnly | null;
    aanvrager2: KlantnaamReadOnly | null;
    financiering: FinancieringOptions;
    /** Tweede woning (box 3) */
    tweedeWoning: boolean | null;
    /** Indicatie dat er huidige woningen in eigendom aanwezig zijn in het adviesdossier */
    huidigeWoningenInEigendomAanwezig: boolean;
    /** Geselecteerde keuzes onder 'Financiële planning' */
    financielePlanningKeuzes: FinancielePlanningKeuze[] | null;
    /** Geselecteerde keuzes onder 'Aanleiding gesprek' */
    aanleidingen: AanleidingBasis[] | null;
    /** Voorstellen (maximaal 3) */
    voorstellen: AanleidingVoorstel[] | null;
}

/** Bevat basisgegevens van een aanleiding voor het adviesgesprek. */
export interface AanleidingBasis {
    aanleidingGesprek: AanleidingGesprekOptions | null;
    /** Omschrijving van aanleiding, indien gekozen is voor AanleidingGesprek 'overig' */
    omschrijving: string | null;
}

/** AanleidingGesprekOptions Geen = 0, Verbouwing = 1, AfkoopErfpacht = 2, ExtraAflossen = 3, Echtscheiding = 4, EindeRentevastperiode = 5, AflossingsvormAanpassen = 6, MaandlastenVerlichting = 7, Risicoscan = 8, Vermogensadvies = 9, Controlegesprek = 10, FinancieringWoning = 11, Overig = 99 */
export enum AanleidingGesprekOptions {
    Geen = "Geen",
    Verbouwing = "Verbouwing",
    AfkoopErfpacht = "AfkoopErfpacht",
    ExtraAflossen = "ExtraAflossen",
    Echtscheiding = "Echtscheiding",
    EindeRentevastperiode = "EindeRentevastperiode",
    AflossingsvormAanpassen = "AflossingsvormAanpassen",
    MaandlastenVerlichting = "MaandlastenVerlichting",
    Risicoscan = "Risicoscan",
    Vermogensadvies = "Vermogensadvies",
    Controlegesprek = "Controlegesprek",
    FinancieringWoning = "FinancieringWoning",
    Overig = "Overig",
}

/** Bevat de gegevens van een voorstel in het scherm Aanleiding. */
export interface AanleidingVoorstel {
    /** Unieke identificatie van het voorstel (analyse). */
    voorstelId: string | null;
    /** Unieke identificatie van het voorstel (analyse) waarvan een kopie moet worden gemaakt */
    kopieVanVoorstelId: string | null;
    /** Naam van het voorstel */
    omschrijving: string | null;
    /** Volgnummer van het voorstel */
    readonly volgnummer: number | null;
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Aanleiding. */
export interface AanleidingenOutput {
    /** Lijst met de inhoud van het Adviesbox-form Aanleiding per adviesdossier. */
    aanleidingen: { [key: string]: Aanleiding; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** AanpassingRenteOptions DirectBijLagereLtv = 1, NaEindeRentevastperiode = 3 */
export enum AanpassingRenteOptions {
    DirectBijLagereLtv = "DirectBijLagereLtv",
    NaEindeRentevastperiode = "NaEindeRentevastperiode",
}

export interface Aanvraag {
    hypotheek: AanvraagHypotheek | null;
    orv: AanvraagVerzekering[] | null;
    aov: AanvraagVerzekering[] | null;
    bankgarantie: AanvraagBankgarantie | null;
    taxatie: AanvraagTaxatie | null;
    readonly serviceproviders: ServiceproviderReadOnly[] | null;
    readonly softwareKoppelingen: SoftwareKoppelingReadOnly[] | null;
    readonly voorstellen: AanvraagVoorstel[] | null;
    externeReferentie: string | null;
}

export interface AanvraagBankgarantie {
    readonly hoofdsom: number | null;
    hdnNummer: number | null;
    readonly partijcode: string | null;
    readonly hdnOntvangerCode: string | null;
    readonly partijnaam: string | null;
    productcode: number;
    readonly productnaam: string | null;
    productId: string;
    voorstel: number;
    versie: number;
    meenemenNaarBemiddeling: boolean | null;
    aanvraagVerzonden: boolean;
}

export interface AanvraagHypotheek {
    looptijdMaanden: number;
    readonly leningdelen: AanvraagLeningdeel[] | null;
    aanvraagNaarPartij: boolean | null;
    aanvraagNaarServiceproviderId: string | null;
    hdnNummer: number | null;
    aanvraagNaarSoftwareKoppelingId: string | null;
    readonly partijcode: string | null;
    readonly hdnOntvangerCode: string | null;
    readonly partijnaam: string | null;
    productcode: number;
    readonly productnaam: string | null;
    productId: string;
    voorstel: number;
    versie: number;
    meenemenNaarBemiddeling: boolean | null;
    aanvraagVerzonden: boolean;
}

export interface AanvraagLeningdeel {
    aflossingsvorm: AflossingsVormType;
    productcode: number;
    readonly productnaam: string | null;
    readonly hoofdsom: number | null;
}

export interface AanvraagTaxatie {
    hdnNummer: number | null;
    readonly partijcode: string | null;
    readonly hdnOntvangerCode: string | null;
    readonly partijnaam: string | null;
    productcode: number;
    readonly productnaam: string | null;
    productId: string;
    voorstel: number;
    versie: number;
    meenemenNaarBemiddeling: boolean | null;
    aanvraagVerzonden: boolean;
}

export interface AanvraagVerzekerde {
    persoonId: string;
    volgnummer: number;
    readonly naamVerzekerde: string | null;
}

export interface AanvraagVerzekering {
    readonly premie: number | null;
    readonly verzekerden: AanvraagVerzekerde[] | null;
    aanvraagNaarPartij: boolean | null;
    aanvraagNaarServiceproviderId: string | null;
    hdnNummer: number | null;
    aanvraagNaarSoftwareKoppelingId: string | null;
    readonly partijcode: string | null;
    readonly hdnOntvangerCode: string | null;
    readonly partijnaam: string | null;
    productcode: number;
    readonly productnaam: string | null;
    productId: string;
    voorstel: number;
    versie: number;
    meenemenNaarBemiddeling: boolean | null;
    aanvraagVerzonden: boolean;
}

export interface AanvraagVoorstel {
    readonly voorstelNaam: string | null;
    readonly voorstelId: string | null;
    readonly geselecteerd: boolean | null;
}

export interface AanvragenOutput {
    aanvragen: { [key: string]: Aanvraag; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de uitvoer van het exporteren van een adviesdossier naar abox. */
export interface AboxExportOutput {
    /** Het gegenereerde abox-bestand */
    resultaat: string | null;
    /** De (default) bestandsnaam */
    filename: string | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de inhoud van het Adviesbox-form Acceptatie. */
export interface Acceptatie {
    hypotheek: AcceptatieHypotheek | null;
    zuiverNhg: AcceptatieHypotheek | null;
    indicatie: AcceptatieIndicatie | null;
    aanvrager1: AcceptatieAanvrager | null;
    aanvrager2: AcceptatieAanvrager | null;
    /** De naam van de geldverstrekker die in het Form Hypotheek geselecteerd is. */
    readonly geldverstrekkerNaam: string | null;
}

/** Bevat gegevens van de aanvrager (klant). */
export interface AcceptatieAanvrager {
    /** Toetsinkomen van aanvrager */
    readonly brutoInkomenBedrag: number | null;
    /** Hinttekst bij Bruto inkomen */
    readonly hintTekst: string | null;
    klantId: string;
    readonly achternaam: string | null;
    readonly voorvoegsel: string | null;
    readonly voorletters: string | null;
    readonly voornamen: string | null;
    geslacht: GeslachtOpties | null;
    readonly roker: boolean | null;
    readonly geboortedatum: string | null;
    readonly aowdatum: string | null;
}

/** Bevat de gegevens van de (verplichte) extra aflossing voor een bepaalde periode. */
export interface AcceptatieExtraAflossingPeriode {
    /** Periode (van t/m maand) */
    readonly periode: string | null;
    /** Verplichte extra aflossing */
    verplichteAflossingBedrag: number;
    /** Mogelijke extra aflossing */
    mogelijkeAflossingBedrag: number;
    /** Looptijd (mnd) */
    looptijdInMaanden: number;
    /** Rente */
    rentePercentage: number;
}

/** Bevat gegevens van 'Hypotheek bij...'. */
export interface AcceptatieHypotheek {
    /** Krediet toetslast per jaar */
    readonly kredietToetslastBedrag: number | null;
    /** Marktwaarde */
    readonly marktwaardeBedrag: number | null;
    /** Erfpachtcanon */
    erfpachtBedrag: number;
    /** Doorlopende hypotheken */
    doorlopendeHypothekenBedrag: number;
    /** Gewenste hypotheek */
    readonly gewensteHypotheekBedrag: number | null;
    /** Totaal gevraagde hypotheek */
    readonly totaalGevraagdeHypotheekBedrag: number | null;
    /** Indicatie meer/minder lenen (contante waarde) */
    readonly indicatieMeerLenenBedrag: number | null;
    /** Toetsrente */
    readonly toetsrentePercentage: number | null;
    /** Woonquote */
    readonly woonquotePercentage: number | null;
    /** Fictieve jaarlast */
    readonly fictieveJaarlastBedrag: number | null;
    /** Toegestane jaarlast */
    readonly toegestaneJaarlastBedrag: number | null;
    /** Maximale hypotheek o.b.v. inkomen en lasten */
    readonly maximaleHypotheekInkomenBedrag: number | null;
    /** Indicatie of "Maximale hypotheek o.b.v. inkomen en lasten" goedgekeurd is */
    maximaleHypotheekInkomenIndicatie: boolean;
    /** Maximale hypotheek o.b.v. onderpand en lening */
    readonly maximaleHypotheekOnderpandBedrag: number | null;
    /** Indicatie of "Maximale hypotheek o.b.v. onderpand en lening" goedgekeurd is */
    maximaleHypotheekOnderpandIndicatie: boolean;
    /** Maximale hypotheek o.b.v. NHG voorwaarden */
    readonly maximaleHypotheekNhgBedrag: number | null;
    /** Indicatie of "Maximale hypotheek o.b.v. NHG voorwaarden" goedgekeurd is */
    maximaleHypotheekNhgIndicatie: boolean;
    /** Uitwerking meer/minder lenen (periodes) */
    readonly meerLenenPeriodes: AcceptatieMeerLenenPeriode[] | null;
    /** Specificatie extra aflossing */
    readonly extraAflossingPeriodes: AcceptatieExtraAflossingPeriode[] | null;
}

/** Bevat indicatie-gegevens van 'Acceptatie'. */
export interface AcceptatieIndicatie {
    indicatie: IndicatieOptions | null;
    /** Indicatie of er een waarschuwing getoond moet worden dat de maximale hypotheek o.b.v. inkomen en lasten
gelijk is aan de maximale hypotheek in box 3. */
    toonWaarschuwingMaxHypotheekIsMaxHypotheekBox3: boolean;
    /** Toelichting (regels) */
    readonly toelichtingRegels: AcceptatieToelichtingRegel[] | null;
    /** Voetnoten (regels) */
    readonly voetnoten: AcceptatieVoetnoot[] | null;
}

/** Bevat de gegevens van de indicatie meer/minder lenen voor een bepaalde periode. */
export interface AcceptatieMeerLenenPeriode {
    /** Periode (van t/m maand) */
    readonly periode: string | null;
    /** Toegestane maandlast */
    toegestaneMaandlastBedrag: number;
    /** Ink. aanvrager */
    inkomenAanvrager1Bedrag: number;
    /** Ink. partner */
    inkomenAanvrager2Bedrag: number;
    /** Vrij te besteden vermogen */
    vrijVermogenBedrag: number;
    /** Toetsrente */
    toetsrentePercentage: number;
    /** Woonquote (vervallen) */
    woonquotePercentage: number;
    /** Woonquote box 1 */
    woonquoteBox1Percentage: number;
    /** Woonquote box 3 */
    woonquoteBox3Percentage: number;
    /** Maandlast uit voorstel box 1 */
    maandlastVoorstelBox1Bedrag: number;
    /** Maandlast uit voorstel box 3 */
    maandlastVoorstelBox3Bedrag: number;
    /** Beschikbare ruimte */
    ruimteBedrag: number;
    /** Beschikbare ruimte */
    werkelijkeMaandlast: number;
    /** Aaanvang datum periode */
    readonly startDatum: string | null;
    /** Einddatum periode */
    readonly eindDatum: string | null;
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Acceptatie. */
export interface AcceptatieOutput {
    /** Lijst met de inhoud van het Adviesbox-form Acceptatie per voorstel. */
    acceptaties: { [key: string]: Acceptatie; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat een toelichtingsregel van de indicatie. */
export interface AcceptatieToelichtingRegel {
    /** Tekst van de toelichting */
    readonly toelichting: string | null;
}

/** Bevat een voetnoot ter onderbouwing van de acceptatie-uitslag. */
export interface AcceptatieVoetnoot {
    /** Tekst van de voetnoot */
    readonly voetnoot: string | null;
}

/** Bevat adresgegevens. */
export interface Adres {
    /** Straatnaam */
    straat: string | null;
    /** Huisnummer (het numerieke deel van het huisnummer) */
    huisnummer: number | null;
    /** Huisnummer toevoeging (het niet-numerieke deel van het huisnummer) */
    toevoeging: string | null;
    /** Postcode */
    postcode: string | null;
    /** De locatieaanduiding. Wordt veelal gebuikt bij bedrijfscomplexen (bijv. toren II). */
    locatie: string | null;
    /** Plaatsnaam */
    plaats: string | null;
    /** Land (identificatie) */
    landCode: string | null;
}

/** De gegevens van een adres (niet te wijzigen) */
export interface AdresReadOnly {
    /** Straatnaam */
    readonly straat: string | null;
    /** Huisnummer (het numerieke deel van het huisnummer) */
    readonly huisnummer: number | null;
    /** Huisnummer toevoeging (het niet-numerieke deel van het huisnummer) */
    readonly toevoeging: string | null;
    /** Postcode */
    readonly postcode: string | null;
    /** De locatieaanduiding. Wordt veelal gebuikt bij bedrijfscomplexen (bijv. toren II). */
    readonly locatie: string | null;
    /** Plaatsnaam */
    readonly plaats: string | null;
    /** Land (identificatie) */
    readonly landCode: string | null;
}

/** Advies eigenaar output model */
export interface AdviesEigenaarOutput {
    /** Id van de adviseur */
    adviseurId: string;
    /** Persoonsgegevens van de adviseur */
    naam: string | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface AdviesNotificatie {
    rapportId: string;
    adviesDossierId: string | null;
    readonly uniqueIdentification: string | null;
    adviseurId: string;
    vestigingId: string;
    content: string | null;
    aanmaakdatum: string | null;
    isGelezen: boolean;
    redirectPagina: string | null;
}

/** Gegevens van een adviesdossier. Alleen de korte en lange omschrijving zijn nodig. */
export interface AdviesdossierOmschrijvingen {
    /** Korte omschrijving van het advies */
    korteOmschrijving: string | null;
    /** Lange/uitgebreide omschrijving van het advies */
    langeOmschrijving: string | null;
}

/** Gegevens van een adviesdossier. */
export interface AdviesdossierOutput {
    adviesdossier: AdviesdossierOmschrijvingen | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Output voor Toegang : AdviesdossierRechten */
export interface AdviesdossierRechtenOutput {
    /** Wel of geen toegang */
    adviesdossierIds: string[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Gegevens voor het bijwerken van de status van een adviesdossier */
export interface AdviesdossierStatus {
    status: AdviesdossierStatusOptions;
}

/** AdviesdossierStatusOptions Nieuw = 0, InBehandeling = 1, Afgerond = 2, Vervallen = 3 */
export enum AdviesdossierStatusOptions {
    Nieuw = "Nieuw",
    InBehandeling = "InBehandeling",
    Afgerond = "Afgerond",
    Vervallen = "Vervallen",
}

/** Output voor Toegang : Wijzigen eigenaar adviesdossier */
export interface AdviesdossierWijzigenEigenaar {
    /** Overzetten naar nieuwe eigenaar succesvol? */
    overgezet: boolean;
    /** Heeft vorige eigenaar nog toegang? */
    voorgaandeEigenaarUitsluiten: boolean;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Gegevens van de adviseur */
export interface AdviseurOutput {
    /** Lijst met adviseurs en gekoppelde vestigingen */
    adviseurs: AdviseurVestiging[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Adviseur met gekoppelde vestiging */
export interface AdviseurVestiging {
    /** ID van de adviseur */
    adviseurId: string;
    /** ID van de gekoppelde vestiging */
    vestigingId: string;
}

export interface Aflosproduct {
    soortAflosproduct: SoortAflosproductOptions;
    productId: string;
    volgnummer: number;
    readonly omschrijving: string | null;
    aflossen: boolean;
    prioriteit: number | null;
    readonly ingangsdatum: string | null;
    readonly looptijdInMaanden: number | null;
    readonly doorlopend: boolean | null;
}

/** AflossingsVormType Geen = 0, Annuïteit = 1, Lineair = 2, Levensverzekering = 3, Spaar = 4, Aflosvrij = 5, Krediet = 9, Belegging = 10, Hybride = 11, UnitLinked = 12, Spaarrekening = 13, AnnuïteitUitgesteld = 20, AnnuïteitBlok = 21, KredietNoPay = 22 */
export enum AflossingsVormType {
    Geen = "Geen",
    Annuïteit = "Annuïteit",
    Lineair = "Lineair",
    Levensverzekering = "Levensverzekering",
    Spaar = "Spaar",
    Aflosvrij = "Aflosvrij",
    Krediet = "Krediet",
    Belegging = "Belegging",
    Hybride = "Hybride",
    UnitLinked = "UnitLinked",
    Spaarrekening = "Spaarrekening",
    AnnuïteitUitgesteld = "AnnuïteitUitgesteld",
    AnnuïteitBlok = "AnnuïteitBlok",
    KredietNoPay = "KredietNoPay",
}

/** AoBeoordelingscriterium Geen = 0, PassendeArbeid = 1, GangbareArbeid = 2, Beroeps = 3 */
export enum AoBeoordelingscriterium {
    Geen = "Geen",
    PassendeArbeid = "PassendeArbeid",
    GangbareArbeid = "GangbareArbeid",
    Beroeps = "Beroeps",
}

/** Ao-dekking */
export interface AoDekkingBedragen {
    /** Collectie van verzekerde bedragen per jaar */
    readonly verzekerdeBedragen: VerzekerdBedrag[] | null;
}

export interface AoIndexering {
    volgnummer: number;
    ondergrensPercentage: number | null;
    bovengrensPercentage: number | null;
    uitkeringPercentage: number | null;
}

export interface AoUitkering {
    minimaalAoPercentage: number | null;
    totAoPercentage: number | null;
    gedeeltelijkeUitkeringObv: GedeeltelijkeUitkeringAoOpties | null;
    rvcAfwijkingCode: RvcAfwijkingsoort | null;
    rvcAfwijkingPercentage: number | null;
    isAfwijkendBijRestVerdienCapaciteit: boolean | null;
    rvcUitkeringPercentage: number | null;
    aoIndexeringen: AoIndexering[] | null;
}

/** Bevat de gegevens van Adviesbox Form AOV. */
export interface Aov {
    /** De producten op het scherm */
    producten: AovProduct[];
    aanvrager1: AovAanvrager | null;
    aanvrager2: AovAanvrager | null;
    /** De af te lossen leningdelen van het voorstel. */
    readonly leningdelen: LeningdeelReadOnly[] | null;
    /** De af te lossen kredieten van het voorstel. */
    readonly kredieten: KredietReadOnly[] | null;
    /** Ingangsdatum van het voorstel (of: 'Passeerdatum' wanneer er een hypotheek geadviseerd wordt) */
    readonly ingangsdatumVoorstel: string | null;
    /** Marktwaarde van het pand */
    readonly marktwaardeBedrag: number | null;
    /** Gewenste hypotheek op het pand */
    readonly gewensteHypotheekBedrag: number | null;
}

/** De aanvraaggegevens van een AOV-product. */
export interface AovAanvraag {
    /** Is aanvrager 1 in aanraking (geweest) met politie of justitie, vanwege het (mede)plegen van een strafbaar feit */
    strafrechtelijkVerledenAanvrager1: boolean | null;
    /** Is aanvrager 2 in aanraking (geweest) met politie of justitie, vanwege het (mede)plegen van een strafbaar feit */
    strafrechtelijkVerledenAanvrager2: boolean | null;
    /** Verwacht aanvrager 1 een ontslag */
    verwachtingOntslagAanvrager1: boolean | null;
    /** Verwacht aanvrager 2 een ontslag */
    verwachtingOntslagAanvrager2: boolean | null;
    /** Heeft de werkgever van aanvrager 1 plannen bekend gemaakt over en/of is werkgever van aanvrager 1 bezig met een werktijdverkorting, een uitstel van betaling en/of faillissement */
    financieleProblemenWerkgeverAanvrager1: boolean | null;
    /** Heeft de werkgever van aanvrager 2 plannen bekend gemaakt over en/of is werkgever van aanvrager 2 bezig met een werktijdverkorting, een uitstel van betaling en/of faillissement */
    financieleProblemenWerkgeverAanvrager2: boolean | null;
    /** Heeft de werkgever van aanvrager 1 plannen bekend gemaakt over en/of is werkgever van aanvrager 1 bezig met een reorganisatie */
    reorganisatieWerkgeverAanvrager1: boolean | null;
    /** Heeft de werkgever van aanvrager 2 plannen bekend gemaakt over en/of is werkgever van aanvrager 2 bezig met een reorganisatie */
    reorganisatieWerkgeverAanvrager2: boolean | null;
    /** Verwacht de verzekerde veranderingen in zijn/haar werkomgeving */
    verwachtingWerkomgeving: boolean | null;
    /** Verwacht de verzekerde een beeindiging van het dienstverband */
    verwachtingEindeDienstverband: boolean | null;
    /** Geeft aan of de toelichting is gelezen en slotverklaring akkoord is. */
    toelichtingGelezenAkkoordMetSlotverklaring: boolean | null;
    /** Marktwaarde */
    readonly marktwaardeBedrag: number | null;
    /** Hypotheekbedrag */
    readonly hypotheekbedrag: number | null;
    /** TOP-verzekering */
    topVerzekering: boolean | null;
    /** Indexatie tijdens uitkering */
    indexatieTijdensUitkering: boolean | null;
    verzekerdBedragScenario: BedragScenario | null;
    /** Het opgegeven maandinkomen */
    maandinkomen: number | null;
    /** Het berekende netto maandinkomen */
    nettoMaandinkomen: number | null;
    /** Maandinkomen overnemen uit inkomen uit arbeid van de aanvrager */
    maandinkomenOvernemen: boolean | null;
    /** Gewenste gegerandeerde maandinkomen */
    maandinkomenGegarandeerd: number | null;
}

/** Gegevens van de aanvrager van een AOV-verzekering */
export interface AovAanvrager {
    /** Het bruto jaarinkomen van de aanvrager. */
    readonly brutoJaarinkomen: number | null;
    /** Indicatief maandinkomen van de aanvrager van deze dekking */
    readonly indicatiefMaandinkomenBedrag: number | null;
    /** Indicatief jaarinkomen van de aanvrager van deze dekking */
    readonly indicatiefJaarinkomenBedrag: number | null;
    klantId: string;
    readonly achternaam: string | null;
    readonly voorvoegsel: string | null;
    readonly voorletters: string | null;
    readonly voornamen: string | null;
    geslacht: GeslachtOpties | null;
    readonly roker: boolean | null;
    readonly geboortedatum: string | null;
    readonly aowdatum: string | null;
}

/** Invoer voor een AOV-berekening. */
export interface AovBerekening {
    aovProduct: AovProduct;
}

/** AovBetalingMiddelsOptions Koopsom = 0, Maandpremie = 1, Combinatie = 2 */
export enum AovBetalingMiddelsOptions {
    Koopsom = "Koopsom",
    Maandpremie = "Maandpremie",
    Combinatie = "Combinatie",
}

/** Gegevens van een dekking van een AOV-verzekering. */
export interface AovDekking {
    voornaamsteInkomstenbron: AovVoornaamsteInkomstenbronOptions | null;
    verzekerdeDekkingen: AovVerzekerdeDekkingenOptions | null;
    dekkingAo: AovDekkingArbeidsongeschiktheid | null;
    dekkingWw: AovDekkingWerkloosheid | null;
    dekkingEa: AovDekkingBasis | null;
    /** Geeft aan of de WGA-gat-verzekering aanvult tot het uitkeringspercentage van het laatst verdiende loon */
    uitgebreid: boolean | null;
    keuzeDekking: AovKeuzeDekkingOptions | null;
    /** Het vaste bedrag dat uitgekeerd wordt bij een WIA-excedent-verzekering */
    vastBedrag: number | null;
    /** Het percentage van het inkomen uit arbeid boven het maximum dagloon dat wordt verzekerd door WIA-excedent-verzekering */
    percentageBovenMaxDagloon: number | null;
    rubriekA: AovDekkingRubriekA | null;
    rubriekB: AovDekkingRubriekB | null;
    beoordelingscriterium: AoBeoordelingscriterium | null;
}

/** Gegevens van onderdeel arbeidsongeschiktheid van de dekking */
export interface AovDekkingArbeidsongeschiktheid {
    /** Uitkeringsduur in maanden */
    uitkeringsduurInMaandenAo: number | null;
    uitkeringsduurInMaanden: AovUitkeringsduurOptions | null;
    /** Geeft het beroep van de verzekerde aan (alleen bij TAF MLBZ van toepassing) */
    beroep: string | null;
    eigenRisico: AovEigenRisicoOptions | null;
    uitkeringGedeeltelijkAo: UitkeringAoSoort | null;
    aoUitkering: AoUitkering | null;
    /** AnnuiteitsPercentage van de dekking */
    annuiteitsPercentage: number | null;
    /** Verzekerd maandbedrag of verzekerd kapitaal gedeeltelijk AO */
    verzekerdBedragGedeeltelijkAo: number | null;
    /** Verzekerd maandbedrag of verzekerd kapitaal */
    verzekerdBedrag: number | null;
    /** Looptijd in maanden */
    looptijdInMaanden: number | null;
}

/** Basisgegevens van de dekking. */
export interface AovDekkingBasis {
    /** Verzekerd maandbedrag of verzekerd kapitaal */
    verzekerdBedrag: number | null;
    /** Looptijd in maanden */
    looptijdInMaanden: number | null;
}

/** Gegevens van Rubriek A van een arbeidsongeschiktheidsverzekering */
export interface AovDekkingRubriekA {
    /** Jaarlijkse indexatie */
    jaarlijkseIndexatiePercentage: number | null;
    soortJaarlijkseIndexering: Indexatiesoort | null;
    /** Duur eigen risico in maanden */
    eigenRisicoInMaanden: number | null;
    uitkeringGedeeltelijkAo: UitkeringAoSoort | null;
    aoUitkering: AoUitkering | null;
    /** Het verzekerd bedrag */
    verzekerdBedrag: number | null;
    beoordelingscriterium: AoBeoordelingscriterium | null;
}

/** Gegevens van Rubriek B van een arbeidsongeschiktheidsverzekering */
export interface AovDekkingRubriekB {
    /** Eindleeftijd van de uitkering */
    eindleeftijd: number | null;
    /** Het verzekerd bedrag */
    verzekerdBedrag: number | null;
    beoordelingscriterium: AoBeoordelingscriterium | null;
}

/** Gegevens van onderdeel werkloosheid van de dekking */
export interface AovDekkingWerkloosheid {
    /** Uitkeringsduur in maanden */
    uitkeringsduurInMaanden: number | null;
    /** Verzekerd maandbedrag of verzekerd kapitaal */
    verzekerdBedrag: number | null;
    /** Looptijd in maanden */
    looptijdInMaanden: number | null;
}

/** AovEigenRisicoOptions Dagen30 = 0, Dagen90 = 1, Dagen180 = 2, Dagen365 = 3, Dagen730 = 4 */
export enum AovEigenRisicoOptions {
    Dagen30 = "Dagen30",
    Dagen90 = "Dagen90",
    Dagen180 = "Dagen180",
    Dagen365 = "Dagen365",
    Dagen730 = "Dagen730",
}

/** AovKeuzeDekkingOptions VastBedrag = 0, Percentage = 1 */
export enum AovKeuzeDekkingOptions {
    VastBedrag = "VastBedrag",
    Percentage = "Percentage",
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form AOV (zowel huidige situatie als voorstel). */
export interface AovOutput {
    /** Lijst met AOV-producten per adviesdossier (huidige situatie) of voorstel. */
    aovs: { [key: string]: Aov; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Gegevens van een AOV-polis. */
export interface AovPolis {
    productnummer: string | null;
    maatschappijCode: string | null;
    maatschappijOmschrijving: string | null;
    maatschappijCodeHdn: string | null;
    productnaam: string | null;
    productcode: number;
    ingangsdatum: string;
    looptijdInMaanden: number | null;
    uwBemiddeling: boolean;
}

/** Premiegegevens van de AOV-verzekering */
export interface AovPremie {
    betalingMiddels: AovBetalingMiddelsOptions | null;
    /** Koopsomperiode in aantal maanden indien gekozen is voor BetalingMiddels 'Combinatie' */
    koopsomperiodeInMaanden: number | null;
    /** Koopsom indien gekozen is voor BetalingMiddels 'Combinatie' of 'Koopsom' */
    koopsomBedrag: number | null;
    /** Aftrekbaar gedeelte van de koopsom indien gekozen is voor BetalingMiddels 'Combinatie' of 'Koopsom' */
    koopsomAftrekbaarBedrag: number | null;
    /** Premie of vervolgpremie */
    premieBedrag: number | null;
    /** Premie AO Dekking */
    premieBedragAo: number | null;
    /** Premie WW Dekking */
    premieBedragWw: number | null;
    /** Premie TOP Dekking */
    premieBedragTop: number | null;
    /** Premie EA Dekking */
    premieBedragEa: number | null;
    /** Aftrekbaar gedeelte van de premie */
    premieAftrekbaarBedrag: number | null;
    /** Geeft aan of de premie (en eventuele koopsom) aftrekbaar is */
    premieAftrekbaar: boolean | null;
    betalingstermijn: BetalingsTermijnType | null;
    /** Geeft aan of de premie collectief betaald wordt */
    collectief: boolean | null;
    /** Jaarlijkse indexatie van de termijnpremie bij de Arbeidsongeschiktheidsverzekering. */
    jaarlijksIndexatiePercentage: number | null;
}

/** Bevat de gegevens van het Aov-product. */
export interface AovProduct {
    soortProduct: AovSoortProductOptions;
    /** Geeft het beroep van de verzekerde aan (alleen bij TAF MLBZ van toepassing) */
    beroep: string | null;
    /** Geeft de risicoklasse van het beroep van de verzekerde aan
(alleen bij TAF MLBZ van toepassing) */
    risicoklasseberoep: string | null;
    /** Geeft aan of de einddatum gelijk is aan de aowdatum van de verzekerde
(alleen bij TAF MLBZ van toepassing) */
    einddatumIsAowLeeftijd: boolean;
    /** Geeft aan of het om een doorlopend product gaat. */
    readonly doorlopend: boolean | null;
    polis: AovPolis;
    /** Unieke identificaties van de klanten die als verzekerde geselecteerd zijn. */
    verzekerdeKlantIds: string[];
    dekkingVerzekerde1: AovDekking;
    dekkingVerzekerde2: AovDekking | null;
    premie: AovPremie;
    verpanding: Verpanding | null;
    aanvraag: AovAanvraag | null;
    /** Indicatie dat indien er doorlopende leningdelen gewijzigd zijn, deze opnieuw overgenomen moeten worden naar de voorstellen */
    wijzigingenInDoorlopendeProductenOvernemen: boolean;
    /** 10% van Hypotheeksom met max. 75.000 en min. 2.500 */
    verzekerdeKredietsom: number | null;
    productId: string | null;
    meenemen: boolean;
}

/** Het resultaat van een AOV-berekening. */
export interface AovResultaat {
    /** Ingangsdatum */
    readonly ingangsdatum: string | null;
    /** De berekende premie. */
    readonly premies: AovResultaatPremie[] | null;
    /** De berekende gegevens voor een verzekerde.
Deze wordt alleen door Dazure GoedIdee Inkomensbeschermer gebruikt */
    readonly verzekerden: AovResultaatVerzekerde[] | null;
    aoDekking: AoDekkingBedragen | null;
    wwDekking: WwDekkingBedragen | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Een berekende AOV-premie. */
export interface AovResultaatPremie {
    /** Premiebedrag */
    readonly bedrag: number | null;
    /** Het AO-gedeelte van het premiebedrag */
    readonly aoBedrag: number | null;
    /** Het WW-gedeelte van het premiebedrag */
    readonly wwBedrag: number | null;
    /** Het IGP-gedeelte van het premiebedrag */
    readonly igpBedrag: number | null;
    /** Looptijd in maanden */
    readonly looptijdInMaanden: number | null;
}

/** Een berekende AOV-verzekerde. */
export interface AovResultaatVerzekerde {
    /** Netto inkomen, maandbedrag */
    readonly nettoInkomen: number | null;
    /** VerzekerdBedragGedeeltelijkeAo */
    readonly verzekerdBedragGedeeltelijkeAo: number | null;
    /** VerzekerdBedragVolledigeAo */
    readonly verzekerdBedragVolledigeAo: number | null;
}

/** AovSoortProductOptions Woonlastenverzekering = 0, WgaGatVerzekering = 1, WiaExcedentVerzekering = 2, Arbeidsongeschiktheidverzekering = 3, Hypotheekaflosverzekering = 4, Inkomensgarantieverzekering = 5, Product = 6 */
export enum AovSoortProductOptions {
    Woonlastenverzekering = "Woonlastenverzekering",
    WgaGatVerzekering = "WgaGatVerzekering",
    WiaExcedentVerzekering = "WiaExcedentVerzekering",
    Arbeidsongeschiktheidverzekering = "Arbeidsongeschiktheidverzekering",
    Hypotheekaflosverzekering = "Hypotheekaflosverzekering",
    Inkomensgarantieverzekering = "Inkomensgarantieverzekering",
    Product = "Product",
}

/** AovUitkeringsduurOptions Jaren2 = 0, Jaren5 = 1, Jaren10 = 2, EindeLooptijd = 3 */
export enum AovUitkeringsduurOptions {
    Jaren2 = "Jaren2",
    Jaren5 = "Jaren5",
    Jaren10 = "Jaren10",
    EindeLooptijd = "EindeLooptijd",
}

/** AovVerzekerdeDekkingenOptions Ao = 0, Ww = 1, Ea = 2, AoWw = 3, AoEa = 4, AoWwEa = 5 */
export enum AovVerzekerdeDekkingenOptions {
    Ao = "Ao",
    Ww = "Ww",
    Ea = "Ea",
    AoWw = "AoWw",
    AoEa = "AoEa",
    AoWwEa = "AoWwEa",
}

/** AovVoornaamsteInkomstenbronOptions Loondienst = 0, Zelfstandige = 1 */
export enum AovVoornaamsteInkomstenbronOptions {
    Loondienst = "Loondienst",
    Zelfstandige = "Zelfstandige",
}

/** Bevat gegevens over de AOW-uitkering. */
export interface AowData {
    /** Indicatieveld of AOW datum berekend wordt */
    aowDatumOvernemen: boolean;
    /** Datum AOW */
    aowDatum: string;
    /** Duur korting AOW */
    duurkortingAowInJaren: number;
    /** AOW-bedrag (berekend) */
    aowBedrag: number;
    /** AOW-datum, zoals die bepaald is op basis van de geboortedatum. */
    berekendeAowDatum: string;
}

/** Gegevens van 1 arrangement. */
export interface Arrangement {
    /** De arrangements identifier. */
    id: string | null;
    /** Arrangements omschrijving. */
    omschrijving: string | null;
    /** Indicatie inkomen koper(s) verplicht. */
    inkomenKopersVerplicht: boolean;
    /** Indicatie financieringsinformatie verplicht. */
    financieringsinformatieVerplicht: boolean;
    /** Indicating direct. */
    isDirect: boolean;
    gekoppeldeGeldverstrekker: Geldverstrekker | null;
    /** De verlengingskosten. */
    verlengingskosten: number;
    /** Indicating digitale nota. */
    digitaleNota: boolean;
}

export interface BadRequestResult {
    statusCode: number;
}

/** Bevat de inhoud van het Adviesbox-form Aanvraag/Bankgarantie. */
export interface Bankgarantie {
    algemeen: BankgarantieAlgemeen;
    onroerendeZaak: BankgarantieOnroerendeZaak | null;
    notaris: BankgarantieNotaris | null;
    verkopers: BankgarantieVerkopers | null;
    pand: BankgarantiePand | null;
    garantie: BankgarantieGarantie | null;
    aanvrager1: KlantnaamReadOnly | null;
    aanvrager2: KlantnaamReadOnly | null;
    soortFinanciering: Financieringsoort | null;
}

/** Uitvoer voor een Bankgarantie aanvraag */
export interface BankgarantieAanvraagOutput {
    bnpAanvraag: BankgarantieBnpAanvraagOutput | null;
    nwbAanvraag: BankgarantieBnpAanvraagOutput | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat gegevens van het gekozen voorstel (de gewenste hypotheek). */
export interface BankgarantieAlgemeen {
    /** Gets or sets de product identifier. (intern) */
    productId: string | null;
    /** Gets or sets de arrangement identifier. */
    arrangementId: string | null;
    /** Gets or sets uw kenmerk. */
    uwKenmerk: string | null;
    /** De code van de bankgarantieinstelling uit de Producten Web API */
    instellingMaatschappijCode: string | null;
    /** De code van het gekozen arrangement uit de Nationale Waarborg API */
    aanvraagViaArrangementId: string | null;
    /** Nummer van tussenpersoon zoals bekend bij nat. waarborg */
    tussenpersoonnummer: string | null;
    /** Het agentnummer. */
    agentnummer: string | null;
    /** De arrangementsnaam. */
    arrangementsnaam: string | null;
    productkeuze: ProductkeuzeOptions | null;
    /** Gets or sets het offertenummer. */
    offertenummer: string | null;
}

/** Uitvoer voor een BNP aanvraag */
export interface BankgarantieBnpAanvraagOutput {
    /** Id van de maatschappij */
    readonly id: string | null;
    /** Status van de aanvraag */
    readonly status: string | null;
    /** Url van de aanvraag */
    readonly url: string | null;
    /** Token om de url uit te kunnen voeren */
    readonly token: string | null;
    /** Naam van de token parameter in de querystring */
    readonly tokenName: string | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de gegevens van de afgegeven garantie. */
export interface BankgarantieGarantie {
    /** Afgiftedatum bankgarantie */
    afgiftedatum: string | null;
    /** Datum ondertekening koopakte */
    ondertekeningKoopakteDatum: string | null;
    /** Passeerdatum/einddatum van de bankgarantie */
    passeerdatum: string | null;
    /** Standaard passeerdatum, zoals ingevuld op het Form Vergoedingenoverzicht */
    passeerdatumStandaard: string | null;
    /** Indicatie dat de standaard passeerdatum overgenomen moet worden */
    passeerdatumOvernemen: boolean | null;
    /** Code van de gekozen vergoeding uit de API van Nationale Waarborg */
    vergoedingCode: string | null;
    /** Indicatie of er sprake is van 'Verzekerde bankgarantie' */
    verzekerdeBankgarantie: boolean | null;
    /** Totale bankgarantiekosten */
    bankgarantiekostenBedrag: number | null;
    /** Geeft aan of het bankgarantiekostenbedrag eigen invoer is */
    bankgarantiekostenEigenInvoer: boolean;
    /** Bankgarantie premiebedrag */
    premieBedrag: number | null;
    /** Ingangsdatum van de bankgarantie */
    ingangsdatum: string | null;
    /** Einddatum van de bankgarantie */
    einddatum: string | null;
}

/** Bevat gegevens van een notaris. */
export interface BankgarantieNotaris {
    /** Unieke identificatie van het gekozen notariskantoor uit de instellingen */
    gekozenNotariskantoorId: string | null;
    /** Naam notariskantoor */
    kantoornaam: string | null;
    adres: Adres | null;
    typeNotaris: NotarisType;
    /** Telefoonnummer notaris */
    telefoonNummer: string | null;
}

/** Bevat de gegevens van de afgegeven onroerende zaak. */
export interface BankgarantieOnroerendeZaak {
    adres: Adres | null;
    nieuwWoonadres: AdresReadOnly | null;
    /** De naam van het nieuwbouw project */
    projectnaam: string | null;
    /** Bouwnummer van het nieuwbouw project */
    bouwnummer: string | null;
    /** Omschrijving van het nieuwbouwproject */
    omschrijving: string | null;
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Aanvraag/Bankgarantie. */
export interface BankgarantieOutput {
    /** Lijst met de inhoud van het Adviesbox-form Aanvraag/Bankgarantie per adviesdossier. */
    bankgaranties: { [key: string]: Bankgarantie; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de gegevens van het aan te kopen pand. */
export interface BankgarantiePand {
    /** Aankoopprijs */
    aankoopprijsBedrag: number | null;
    /** Hypotheekbedrag */
    hypotheekbedrag: number | null;
    /** Gehanteerde marktwaarde */
    marktwaardeBedrag: number | null;
    /** De naam van de geldverstrekker die in het Form Hypotheek geselecteerd is. */
    geldverstrekkerNaam: string | null;
    /** Indicatie dat NHG-garantie van toepassing is op de nieuwe financiering */
    nhg: boolean | null;
    /** Garantiebedrag */
    garantiebedrag: number | null;
    /** Indicatie dat het garantiebedrag berekend moet worden */
    garantieOvernemen: boolean | null;
    /** Bedrag aan eigen middelen */
    eigenMiddelenBedrag: number | null;
    /** Bedrag van overbrugging */
    overbruggingBedrag: number | null;
    /** Betreft starterslening */
    starterslening: boolean | null;
}

/** Bevat gegevens van een verkoper. */
export interface BankgarantieVerkoper {
    /** Achternaam */
    achternaam: string | null;
    /** Voorvoegsel */
    voorvoegsel: string | null;
    /** Voorletters */
    voorletters: string | null;
    /** Roepnaam */
    woonplaats: string | null;
}

/** Bevat gegevens van de verkopers. */
export interface BankgarantieVerkopers {
    /** Bedrijfsnaam */
    bedrijfsnaam: string | null;
    verkoper1: BankgarantieVerkoper | null;
    verkoper2: BankgarantieVerkoper | null;
}

/** BasisdekkingOptions Geen = 1, PercentageOpgebouwdeWaarde = 2, SomBetaaldePremies = 3 */
export enum BasisdekkingOptions {
    Geen = "Geen",
    PercentageOpgebouwdeWaarde = "PercentageOpgebouwdeWaarde",
    SomBetaaldePremies = "SomBetaaldePremies",
}

export interface BedragIndexering {
    bedrag: number | null;
    volgnummer: number;
    ingangsmaand: number | null;
}

export interface BedragScenario {
    waarde: number | null;
    indexeringen: BedragIndexering[] | null;
    omschrijving: string | null;
}

/** Begunstigingsoort Geen = 0, Standaard = 1, Afwijkend = 2 */
export enum Begunstigingsoort {
    Geen = "Geen",
    Standaard = "Standaard",
    Afwijkend = "Afwijkend",
}

/** BelastingBoxOptions Box1 = 0, Box3 = 1 */
export enum BelastingBoxOptions {
    Box1 = "Box1",
    Box3 = "Box3",
}

/** Belastingbox Geen = 0, Box1 = 1, Box2 = 2, Box3 = 3 */
export enum Belastingbox {
    Geen = "Geen",
    Box1 = "Box1",
    Box2 = "Box2",
    Box3 = "Box3",
}

/** BeleggersprofielOptions ZeerDefensief = 1, Defensief = 2, Gematigd = 3, Neutraal = 4, GematigdOffensief = 5, Offensief = 6, ZeerOffensief = 7 */
export enum BeleggersprofielOptions {
    ZeerDefensief = "ZeerDefensief",
    Defensief = "Defensief",
    Gematigd = "Gematigd",
    Neutraal = "Neutraal",
    GematigdOffensief = "GematigdOffensief",
    Offensief = "Offensief",
    ZeerOffensief = "ZeerOffensief",
}

/** Het resultaat van een gemiddeld jaarinkomen-berekening. */
export interface BerekendGemiddeldInkomen {
    /** Het berekende gemiddelde jaarinkomen. */
    gemiddeldInkomen: number | null;
}

/** Bevat het resultaat van de inkomensperiode-berekening. */
export interface BerekendResultaat {
    /** Het bruto salarisbedrag per periode. */
    brutoSalarisBedrag: number | null;
    /** Het bruto salarisbedrag per jaar. */
    brutoSalarisJaarBedrag: number | null;
    /** Het bedrag aan vakantietoeslag. */
    vakantietoeslagBedrag: number | null;
    /** Het bedrag 13e maand waarmee gerekend is. */
    maand13Bedrag: number | null;
    /** Het totaal bruto salarisbedrag per jaar */
    totaalBrutoJaarsalarisBedrag: number | null;
}

/** Berekeningsoort Geen = 0, Kapitaal = 1, Premie = 2, Rendement = 3, EigenInvoer = 4, Aanvangsstorting = 5, Onttrekking = 6, LijfrenteUitkering = 7, UitgesteldeInleg = 8, Garantiekapitaal = 9, PremieObvGarantiekapitaal = 10 */
export enum Berekeningsoort {
    Geen = "Geen",
    Kapitaal = "Kapitaal",
    Premie = "Premie",
    Rendement = "Rendement",
    EigenInvoer = "EigenInvoer",
    Aanvangsstorting = "Aanvangsstorting",
    Onttrekking = "Onttrekking",
    LijfrenteUitkering = "LijfrenteUitkering",
    UitgesteldeInleg = "UitgesteldeInleg",
    Garantiekapitaal = "Garantiekapitaal",
    PremieObvGarantiekapitaal = "PremieObvGarantiekapitaal",
}

/** BetaalwijzeAdvieskostenOptions MeefinancierenInHypotheek = 1, VoldoenUitEigenMiddelen = 2 */
export enum BetaalwijzeAdvieskostenOptions {
    MeefinancierenInHypotheek = "MeefinancierenInHypotheek",
    VoldoenUitEigenMiddelen = "VoldoenUitEigenMiddelen",
}

/** BetalenUitPremiedepot Geen = 0, Aanvangsstorting = 1, Premie = 2, PremieHoog = 4, Spaarpremie = 8, SpaarpremieHoog = 16, Risicopremie = 32, RisicopremieHoog = 64, Inleg = 128, Storting = 256 */
export enum BetalenUitPremiedepot {
    Geen = "Geen",
    Aanvangsstorting = "Aanvangsstorting",
    Premie = "Premie",
    PremieHoog = "PremieHoog",
    Spaarpremie = "Spaarpremie",
    SpaarpremieHoog = "SpaarpremieHoog",
    Risicopremie = "Risicopremie",
    RisicopremieHoog = "RisicopremieHoog",
    Inleg = "Inleg",
    Storting = "Storting",
}

/** BetalingVia Geen = 0, Notaris = 1, AcceptGiro = 2, AutoIncasso = 3, Geldverstrekker = 4, Anders = 99 */
export enum BetalingVia {
    Geen = "Geen",
    Notaris = "Notaris",
    AcceptGiro = "AcceptGiro",
    AutoIncasso = "AutoIncasso",
    Geldverstrekker = "Geldverstrekker",
    Anders = "Anders",
}

/** BetalingsTermijnType Geen = 0, Maand = 1, TweeMaanden = 2, Kwartaal = 3, HalfJaar = 6, Jaar = 12, Eenmalig = 99, Week = -7, Dag = -1 */
export enum BetalingsTermijnType {
    Geen = "Geen",
    Maand = "Maand",
    TweeMaanden = "TweeMaanden",
    Kwartaal = "Kwartaal",
    HalfJaar = "HalfJaar",
    Jaar = "Jaar",
    Eenmalig = "Eenmalig",
    Week = "Week",
    Dag = "Dag",
}

/** BewonersOpties Aanvrager1 = 1, Aanvrager2 = 2, Beiden = 3 */
export enum BewonersOpties {
    Aanvrager1 = "Aanvrager1",
    Aanvrager2 = "Aanvrager2",
    Beiden = "Beiden",
}

/** BijtellingAutovdZaakOpties _0Procent = 0, _4Procent = 4, _7Procent = 7, _8Procent = 8, _12Procent = 12, _14Procent = 14, _15Procent = 15, _16Procent = 16, _20Procent = 20, _21Procent = 21, _22Procent = 22, _25Procent = 25 */
export enum BijtellingAutovdZaakOpties {
    _0Procent = "_0Procent",
    _4Procent = "_4Procent",
    _7Procent = "_7Procent",
    _8Procent = "_8Procent",
    _12Procent = "_12Procent",
    _14Procent = "_14Procent",
    _15Procent = "_15Procent",
    _16Procent = "_16Procent",
    _20Procent = "_20Procent",
    _21Procent = "_21Procent",
    _22Procent = "_22Procent",
    _25Procent = "_25Procent",
}

/** BoeterenteBerekeningswijzeOpties Contant = 3, EigenInvoer = 7 */
export enum BoeterenteBerekeningswijzeOpties {
    Contant = "Contant",
    EigenInvoer = "EigenInvoer",
}

/** BurgerlijkeStaatType Geen = 0, GehuwdGemeenschapVanGoederen = 1, GehuwdMetHuwelijkseVoorwaarden = 2, Alleenstaand = 3, SamenwonendMetSamenlevingscontract = 4, SamenwonendZonderSamenlevingscontract = 5, PartnerregistratieInGemeenschapVanGoederen = 6, PartnerregistratieOnderRegistratievoorwaarden = 7, GehuwdVolgensBuitenlandsRecht = 8, GehuwdInBeperkteGemeenschapVanGoederen = 9, PartnerregistratieInBeperkteGemeenschapVanGoederen = 10 */
export enum BurgerlijkeStaatType {
    Geen = "Geen",
    GehuwdGemeenschapVanGoederen = "GehuwdGemeenschapVanGoederen",
    GehuwdMetHuwelijkseVoorwaarden = "GehuwdMetHuwelijkseVoorwaarden",
    Alleenstaand = "Alleenstaand",
    SamenwonendMetSamenlevingscontract = "SamenwonendMetSamenlevingscontract",
    SamenwonendZonderSamenlevingscontract = "SamenwonendZonderSamenlevingscontract",
    PartnerregistratieInGemeenschapVanGoederen = "PartnerregistratieInGemeenschapVanGoederen",
    PartnerregistratieOnderRegistratievoorwaarden = "PartnerregistratieOnderRegistratievoorwaarden",
    GehuwdVolgensBuitenlandsRecht = "GehuwdVolgensBuitenlandsRecht",
    GehuwdInBeperkteGemeenschapVanGoederen = "GehuwdInBeperkteGemeenschapVanGoederen",
    PartnerregistratieInBeperkteGemeenschapVanGoederen = "PartnerregistratieInBeperkteGemeenschapVanGoederen",
}

/** ConceptAdres. */
export interface ConceptAdres {
    /** Gets or sets straat. */
    straat: string | null;
    /** Gets or sets plaats. */
    plaats: string | null;
    /** Gets or sets postcode. */
    postcode: string | null;
    /** Gets or sets huisnummer. */
    huisnummer: number | null;
    /** Gets or sets toevoeging (optioneel). */
    huisnummerToevoeging: string | null;
}

/** Gegevens bedrijfsmatige verkoper. */
export interface ConceptBedrijfVerkoper {
    /** Gets or sets de bedrijfsnaam. */
    bedrijfsnaam: string | null;
    /** Gets or sets vestigingsplaats. */
    plaats: string | null;
}

/** ConceptKoper gegevens. */
export interface ConceptKoper {
    /** Gets or sets voorletters. */
    voorletters: string | null;
    /** Gets or sets achternaam. */
    achternaam: string | null;
    /** Gets or sets emailadres. */
    emailAdres: string | null;
    /** Gets or sets geslacht. */
    geslacht: string | null;
    /** Gets or sets geboortedatum. */
    geboortedatum: string | null;
    /** Gets or sets inkomen. */
    inkomen: number | null;
    /** Gets or sets nationaliteitIso3166Alpha3 Landcode 3 tekens ISO. */
    nationaliteitIso3166Alpha3: string | null;
    adres: ConceptAdres | null;
}

/** Gegevens nieuwubouw. */
export interface ConceptNieuwbouwgegevens {
    /** Gets or sets straat / projectnaam. */
    straatOfProject: string | null;
    /** Gets or sets bouw/Kavel nummer. */
    bouwOfKavelnummer: string | null;
    /** Gets or sets postcode */
    postcode: string | null;
    /** Gets or sets plaatsnaam. */
    plaats: string | null;
}

/** ConceptNotaris. */
export interface ConceptNotaris {
    /** Gets or sets naam notariskantoor. */
    naamKantoor: string | null;
    adres: ConceptAdres | null;
}

/** Gegevens pariculiere verkoper. */
export interface ConceptParticuliereVerkoper {
    /** Gets or sets voorletters. */
    voorletters: string | null;
    /** Gets or sets achternaam. */
    achternaam: string | null;
    /** Gets or sets plaats. */
    plaats: string | null;
}

/** De verschillend mogelijk verkoperstypen. */
export interface ConceptVerkopers {
    /** Gets or sets gegevens particuliere verkopers. */
    particuliereVerkopers: ConceptParticuliereVerkoper[] | null;
    /** Gets or sets gegevens bedrijfsmatige verkopers. */
    bedrijfVerkopers: ConceptBedrijfVerkoper[] | null;
    /** Gets or sets gegevens eventuele ander verkoper(s) (alleen
omschrijving). */
    anderVerkoperOmschrijving: string[] | null;
}

/** ControleGewenstInkomenOptions Nbi = 1, BrutoInkomenswens = 2, Geen = 3 */
export enum ControleGewenstInkomenOptions {
    Nbi = "Nbi",
    BrutoInkomenswens = "BrutoInkomenswens",
    Geen = "Geen",
}

/** ControleGewenstNbiOptions BehoudenHuidigNbi = 0, MargeHuidigNbi = 1, VastBedrag = 2, PercentageHuidigNbi = 3 */
export enum ControleGewenstNbiOptions {
    BehoudenHuidigNbi = "BehoudenHuidigNbi",
    MargeHuidigNbi = "MargeHuidigNbi",
    VastBedrag = "VastBedrag",
    PercentageHuidigNbi = "PercentageHuidigNbi",
}

/** ControleMaandlastOptions BenodigdInkomen = 1, WerkelijkeLast = 2 */
export enum ControleMaandlastOptions {
    BenodigdInkomen = "BenodigdInkomen",
    WerkelijkeLast = "WerkelijkeLast",
}

/** Bevat de inhoud van het Adviesbox-form Dashboard. */
export interface Dashboard {
    werkloosheid: DashboardScenarioWerkloosheid | null;
    arbeidsongeschiktheid: DashboardScenarioArbeidsongeschiktheid | null;
    overlijden: DashboardScenarioOverlijden | null;
    pensioen: DashboardScenarioPensioen | null;
    aanvrager1: KlantnaamReadOnly | null;
    aanvrager2: KlantnaamReadOnly | null;
}

/** DashboardOnderdeelOptions HypotheekAcceptatie = 0, Snelinzicht = 1, Overlijden = 2, Arbeidsongeschiktheid = 3, Werkloosheid = 4, Pensioen = 5, VerantwoordeWoonlasten = 6, Aflossingsvorm = 7, Rentevastperiode = 8, OpbouwDoelvermogen = 9 */
export enum DashboardOnderdeelOptions {
    HypotheekAcceptatie = "HypotheekAcceptatie",
    Snelinzicht = "Snelinzicht",
    Overlijden = "Overlijden",
    Arbeidsongeschiktheid = "Arbeidsongeschiktheid",
    Werkloosheid = "Werkloosheid",
    Pensioen = "Pensioen",
    VerantwoordeWoonlasten = "VerantwoordeWoonlasten",
    Aflossingsvorm = "Aflossingsvorm",
    Rentevastperiode = "Rentevastperiode",
    OpbouwDoelvermogen = "OpbouwDoelvermogen",
}

/** Geeft de geselecteerde onderwerpen voor het dashboard */
export interface DashboardOnderwerpen {
    /** Werkloosheid onderwerp geselecteerd ja/nee */
    werkloosheid: boolean | null;
    /** Arbeidsongeschiktheid onderwerp geselecteerd ja/nee */
    arbeidsongeschiktheid: boolean | null;
    /** Overlijden onderwerp geselecteerd ja/nee */
    overlijden: boolean | null;
    /** Pensioen onderwerp geselecteerd ja/nee */
    pensioen: boolean | null;
}

/** Geeft de geselecteerde onderwerpen voor het dashboard */
export interface DashboardOnderwerpenOutput {
    onderwerpen: DashboardOnderwerpen | null;
    code: string | null;
    target: string | null;
    message: string | null;
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Dashboard. */
export interface DashboardOutput {
    /** Lijst met Dashboards per adviesdossier of voorstel. */
    dashboards: { [key: string]: Dashboard; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de gegevens van 'Arbeidsongeschiktheid' t.b.v. het Adviesbox-form Dashboard */
export interface DashboardScenarioArbeidsongeschiktheid {
    uitgangspunten: DashboardUitgangspuntenArbeidsongeschiktheid | null;
    tekort: DashboardTekort | null;
}

/** Bevat de gegevens van 'Overlijden' t.b.v. het Adviesbox-form Dashboard. */
export interface DashboardScenarioOverlijden {
    uitgangspunten: DashboardUitgangspuntenOverlijden | null;
    tekort: DashboardTekort | null;
}

/** Bevat de gegevens van 'Pensioen' t.b.v. het Adviesbox-form Dashboard. */
export interface DashboardScenarioPensioen {
    uitgangspunten: DashboardUitgangspuntenPensioen | null;
    tekort: DashboardTekort | null;
}

/** Bevat de gegevens van 'Werkloosheid' t.b.v. het Adviesbox-form Dashboard */
export interface DashboardScenarioWerkloosheid {
    uitgangspunten: DashboardUitgangspuntenWerkloosheid | null;
    tekort: DashboardTekort | null;
}

/** Bevat het tekort/overschot van een scenario t.b.v. het Adviesbox-form Dashboard. */
export interface DashboardTekort {
    /** Tekort t.o.v. de maximale hypotheek bij toepassing van het scenario op aanvrager 1 */
    readonly tekortHypotheek1Bedrag: number | null;
    /** Tekort t.o.v. de maximale hypotheek bij toepassing van het scenario op aanvrager 2 */
    readonly tekortHypotheek2Bedrag: number | null;
    /** Tekort t.o.v. de maximale hypotheek bij toepassing van het scenario beide aanvragers */
    readonly tekortHypotheekBeideBedrag: number | null;
    /** Tekort aan inkomen o.b.v. maand/jaarlast bij toepassing van het scenario op aanvrager 1 */
    readonly tekortInkomen1Bedrag: number | null;
    /** Tekort aan inkomen o.b.v. maand/jaarlast bij toepassing van het scenario op aanvrager 2 */
    readonly tekortInkomen2Bedrag: number | null;
    /** Tekort aan inkomen o.b.v. maand/jaarlast bij toepassing van het scenario op beide aanvragers */
    readonly tekortInkomenBeideBedrag: number | null;
}

/** Bevat de uitgangspunten voor de berekeningen van 'Arbeidsongeschiktheid' t.b.v. het Adviesbox-form Dashboard. */
export interface DashboardUitgangspuntenArbeidsongeschiktheid {
    /** Unieke identificaties van de klanten die geselecteerd zijn bij 'Scenario van'. */
    scenarioVanKlantIds: string[];
    /** Indicatieveld of het vinkje van 'Beide' is aangevinkt wel of niet */
    overzichtBeideTonen: boolean | null;
    scenarioDoorrekeningExtra1: boolean | null;
    scenarioDoorrekeningExtra2: boolean | null;
    arbeidsongeschiktheidStandaardPercentage: number | null;
    arbeidsongeschiktheidExtra1Percentage: number | null;
    arbeidsongeschiktheidExtra2Percentage: number | null;
    duurzaamArbeidsongeschiktStandaard: boolean | null;
    duurzaamArbeidsongeschiktExtra1: boolean | null;
    duurzaamArbeidsongeschiktExtra2: boolean | null;
    benuttingVerdiencapaciteitStandaardPercentage: number | null;
    benuttingVerdiencapaciteitExtra1Percentage: number | null;
    benuttingVerdiencapaciteitExtra2Percentage: number | null;
    readonly toetsjaar: number | null;
    controleHypotheeknorm: MotiveringControleHypotheeknorm | null;
    controleGewenstInkomen: MotiveringControleGewenstInkomen | null;
    readonly voorstellen: MotiveringVoorstel[] | null;
    motiveringVoorVoorstelId: string | null;
}

/** Bevat de uitgangspunten voor de berekeningen van 'Overlijden' t.b.v. het Adviesbox-form Dashboard. */
export interface DashboardUitgangspuntenOverlijden {
    /** Unieke identificaties van de klanten die geselecteerd zijn bij 'Scenario van'. */
    scenarioVanKlantIds: string[];
    /** Indicatieveld of het vinkje van 'Beide' is aangevinkt wel of niet */
    overzichtBeideTonen: boolean | null;
    werkenNaOverlijdenPartnerAanvrager1Percentage: number | null;
    werkenNaOverlijdenPartnerAanvrager2Percentage: number | null;
    duurOverzicht: DuurOverzichtOptions | null;
    overzichtDuurInJaren: number | null;
    overzichtTotLeeftijdInMaanden: number | null;
    controleHypotheeknorm: MotiveringControleHypotheeknorm | null;
    controleGewenstInkomen: MotiveringControleGewenstInkomen | null;
    readonly voorstellen: MotiveringVoorstel[] | null;
    motiveringVoorVoorstelId: string | null;
}

/** Bevat de uitgangspunten voor de berekeningen van 'Pensioen' t.b.v. het Adviesbox-form Dashboard. */
export interface DashboardUitgangspuntenPensioen {
    /** Unieke identificaties van de klanten die geselecteerd zijn bij 'Scenario van'. */
    scenarioVanKlantIds: string[];
    /** Indicatieveld of het vinkje van 'Beide' is aangevinkt wel of niet */
    overzichtBeideTonen: boolean | null;
    beschikbareJaarruimteAanvrager1: MotiveringBeschikbareJaarruimte | null;
    beschikbareJaarruimteAanvrager2: MotiveringBeschikbareJaarruimte | null;
    controleHypotheeknorm: MotiveringControleHypotheeknorm | null;
    controleGewenstInkomen: MotiveringControleGewenstInkomen | null;
    readonly voorstellen: MotiveringVoorstel[] | null;
    motiveringVoorVoorstelId: string | null;
}

/** Bevat de uitgangspunten voor de berekeningen van 'Werkloosheid' t.b.v. het Adviesbox-form Dashboard. */
export interface DashboardUitgangspuntenWerkloosheid {
    /** Unieke identificaties van de klanten die geselecteerd zijn bij 'Scenario van'. */
    scenarioVanKlantIds: string[];
    /** Indicatieveld of het vinkje van 'Beide' is aangevinkt wel of niet */
    overzichtBeideTonen: boolean | null;
    controleHypotheeknorm: MotiveringControleHypotheeknorm | null;
    controleGewenstInkomen: MotiveringControleGewenstInkomen | null;
    readonly voorstellen: MotiveringVoorstel[] | null;
    motiveringVoorVoorstelId: string | null;
}

export interface Dekking {
    volgnummer: number;
    huidigDekkingId: string | null;
    origineelDekkingId: string | null;
    pakketDekkingId: string | null;
    soortDekking: Dekkingsoort | null;
    soortLijfrenteclausule: Lijfrenteclausulesoort | null;
    aanvangsdatum: string | null;
    looptijdInMaanden: number | null;
    productnaam: string | null;
    productHost: ProductHostOpties | null;
    maatschappijCode: string | null;
    polisnummer: string | null;
    hoogLaagPercentage: number | null;
    hoogLaagAantalMaanden: number | null;
    premiesplitsing: boolean | null;
    premieBerekenen: boolean | null;
    productcode: number | null;
    collectief: boolean | null;
    rentevastPeriodeInJaren: number | null;
    optimalisatie: boolean | null;
    brutoBerekening: boolean | null;
    rendementPercentage: number | null;
    dekkingnaam: string | null;
    betalingKoopsom: number | null;
    maatschappijOmschrijving: string | null;
    leningAflossen: boolean | null;
    verpanden: boolean | null;
    royeren: boolean | null;
    soortBerekening: Berekeningsoort | null;
    poliswaardeBedrag: number | null;
    premiedemper: boolean | null;
    ingebrachteWaardeBedrag: number | null;
    poliswaardeDatum: string | null;
    subproductCode: number | null;
    extraGegevens: string | null;
    opgebouwdKapitaalBedrag: number | null;
    opgebouwdKapitaalDatum: string | null;
    stortingKostenPercentage: number | null;
    premiePeriode1Percentage: number | null;
    duurEerstePeriodeInMaanden: number | null;
    premieVervolgperiodePercentage: number | null;
    poliskostenEersteStortingBedrag: number | null;
    poliskostenPremiePeriode1Bedrag: number | null;
    risicocategorie: number | null;
    provisiePercentage: number | null;
    provisieBedrag: number | null;
    begunstiging: Begunstigingsoort | null;
    soortDepot: string | null;
    bestedingsdoel: string | null;
    portefeuille: number | null;
    betalingKoopsomAan: string | null;
    jaarlijkseIndexering: boolean | null;
    beleggingsprofielCodeHdn: string | null;
    productcodeHdn: string | null;
    bijzonderheden: string | null;
    nettoWaardeBedrag: number | null;
    betaalmethode: BetalingVia | null;
    productvariabelen: string | null;
    eenmaligeHogeStorting: boolean | null;
    hoogLaagConstructie: HoogLaagConstructie | null;
    provisie: string | null;
    hoogstePremieOoitBedrag: number | null;
    laagstePremieooitBedrag: number | null;
    premieLopendJaarBedrag: number | null;
    maatschappijCodeOrigineel: string | null;
    origineleAanvangsdatum: string | null;
    uitgebreid: boolean | null;
    premieverloop: Premieverloopsoort | null;
    maatschappijOmschrijvingOrigineel: string | null;
    uwBemiddeling: boolean | null;
    lxVerstuurd: boolean | null;
    origineleSoortDekking: Dekkingsoort | null;
    aanvangBox1Datum: string | null;
    eerdereUitkeringenBedrag: number | null;
    premieVervolgperiodeBedrag: number | null;
    wtvDatum: string | null;
    wtvVoorPercentage: number | null;
    wtvNaPercentage: number | null;
    maatschappijCodeAdn: string | null;
    maatschappijCodeOndergebrachtAdn: string | null;
    maatschappijOndergebrachtOmschrijving: string | null;
    contractVervaldatum: string | null;
    administratiekostenBedrag: number | null;
    administratiekostenEenmalig: boolean | null;
    maatschappijCodeEnergie: number | null;
    maatschappijCodeTelecom: number | null;
    verzekeringsmotief: Verzekeringsmotief | null;
    origineelDoelkapitaalBedrag: number | null;
    origineleEinddatum: string | null;
    fiscaleVoortzettingMuteerbaar: boolean | null;
    fiscaleVoortzetting: boolean | null;
    verkortePremieduur: boolean | null;
    beeindigenInSituatie: Situatiekeuze | null;
    premievrijMakenInSituatie: Situatiekeuze | null;
    lijfrenteclausuleOrigineel: boolean | null;
    premieInvoerSamenstellen: boolean | null;
    onttrekkingSamenstellen: boolean | null;
    boetevrijOpnemen: boolean | null;
    inbrengHypotheekBedrag: number | null;
    waardeInbrengenInSituatie: Situatiekeuze | null;
    hdnAanvraagversie: number | null;
    premiereserve: boolean | null;
    provisiekeuze: Provisiekeuze | null;
}

export interface DekkingReadOnly {
    dekkingId: string;
    readonly productnaam: string | null;
}

export interface DekkingenOutput {
    dekkingen: { [key: string]: Dekking; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Dekkingsoort Geen = 0, Leven = 1, Spaar = 2, Belegging = 3, Risico = 4, KapWoning = 5, Lijfrente = 6, Hybride = 7, Uitvaart = 8, Aansprakelijkheid = 9, Opstal = 10, Inboedel = 11, Ongevallen = 12, Rechtsbijstand = 13, Reis = 14, Caravan = 15, Kostbaarheden = 16, Motorrijtuig = 17, Motor = 18, Buitenshuis = 19, BromfietsScooter = 20, Auto = 21, Fiets = 22, Boot = 23, Annulering = 24, Glas = 25, Ziektekosten = 26, Abonnement = 27, OngevallenZiekte = 28, OngevallenInzittenden = 29, Aanhangwagen = 30, Brand = 31, OpstalAnboedel = 32, Huiselectronica = 33, AansprakelijkheidGewoon = 34, RechtsbijstandVerkeer = 35, RechtsbijstandGezin = 36, RechtsbijstandBedrijf = 37, Buitenlandreizen = 38, Recreatie = 39, Energie = 40, Telecom = 41, Vereniging = 42, GoedDoel = 43, Krant = 44, Tijdschrift = 45, Anders = 99, Pakket = 100, Bestelauto = 210 */
export enum Dekkingsoort {
    Geen = "Geen",
    Leven = "Leven",
    Spaar = "Spaar",
    Belegging = "Belegging",
    Risico = "Risico",
    KapWoning = "KapWoning",
    Lijfrente = "Lijfrente",
    Hybride = "Hybride",
    Uitvaart = "Uitvaart",
    Aansprakelijkheid = "Aansprakelijkheid",
    Opstal = "Opstal",
    Inboedel = "Inboedel",
    Ongevallen = "Ongevallen",
    Rechtsbijstand = "Rechtsbijstand",
    Reis = "Reis",
    Caravan = "Caravan",
    Kostbaarheden = "Kostbaarheden",
    Motorrijtuig = "Motorrijtuig",
    Motor = "Motor",
    Buitenshuis = "Buitenshuis",
    BromfietsScooter = "BromfietsScooter",
    Auto = "Auto",
    Fiets = "Fiets",
    Boot = "Boot",
    Annulering = "Annulering",
    Glas = "Glas",
    Ziektekosten = "Ziektekosten",
    Abonnement = "Abonnement",
    OngevallenZiekte = "OngevallenZiekte",
    OngevallenInzittenden = "OngevallenInzittenden",
    Aanhangwagen = "Aanhangwagen",
    Brand = "Brand",
    OpstalAnboedel = "OpstalAnboedel",
    Huiselectronica = "Huiselectronica",
    AansprakelijkheidGewoon = "AansprakelijkheidGewoon",
    RechtsbijstandVerkeer = "RechtsbijstandVerkeer",
    RechtsbijstandGezin = "RechtsbijstandGezin",
    RechtsbijstandBedrijf = "RechtsbijstandBedrijf",
    Buitenlandreizen = "Buitenlandreizen",
    Recreatie = "Recreatie",
    Energie = "Energie",
    Telecom = "Telecom",
    Vereniging = "Vereniging",
    GoedDoel = "GoedDoel",
    Krant = "Krant",
    Tijdschrift = "Tijdschrift",
    Anders = "Anders",
    Pakket = "Pakket",
    Bestelauto = "Bestelauto",
}

/** DoelVerzekeringOptions Hypotheek = 1, VerliesVanInkomen = 2, Compagnon = 3, KeymanKeywoman = 4, AfdekkingErfbelasting = 5, FiscaleClaimBijOverlijden = 6, FinancieringKredietverstrekking = 7, LijfrenteAanvullendPensioenopbouw = 8 */
export enum DoelVerzekeringOptions {
    Hypotheek = "Hypotheek",
    VerliesVanInkomen = "VerliesVanInkomen",
    Compagnon = "Compagnon",
    KeymanKeywoman = "KeymanKeywoman",
    AfdekkingErfbelasting = "AfdekkingErfbelasting",
    FiscaleClaimBijOverlijden = "FiscaleClaimBijOverlijden",
    FinancieringKredietverstrekking = "FinancieringKredietverstrekking",
    LijfrenteAanvullendPensioenopbouw = "LijfrenteAanvullendPensioenopbouw",
}

/** DoorlopendLeningdeelMeenemenOptions Rentemiddeling = 2, EenOpEen = 3 */
export enum DoorlopendLeningdeelMeenemenOptions {
    Rentemiddeling = "Rentemiddeling",
    EenOpEen = "EenOpEen",
}

/** Bevat de informatie voor de dossierbalk van een adviesdossier. */
export interface DossierbalkInfo {
    /** Korte omschrijving van het advies */
    korteOmschrijving: string | null;
    /** Uitgebreide omschrijving van het advies */
    uitgebreideOmschrijving: string | null;
    /** Externe identificatie van het advies */
    externeIdentificatie: string | null;
    aanvrager1: KlantnaamReadOnly | null;
    aanvrager2: KlantnaamReadOnly | null;
}

/** Output voor het opvragen van de dossierbalk-informatie. */
export interface DossierbalkOutput {
    /** De informatie in de dossierbalk. */
    readonly dossierbalkInfo: { [key: string]: DossierbalkInfo; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Dossierstatus Geen = 0, InBehandeling = 1, Actief = 2, NietActief = 3 */
export enum Dossierstatus {
    Geen = "Geen",
    InBehandeling = "InBehandeling",
    Actief = "Actief",
    NietActief = "NietActief",
}

/** DuurOverzichtOptions TotLeeftijd = 1, VasteDuurInJaren = 2, Levenslang = 3 */
export enum DuurOverzichtOptions {
    TotLeeftijd = "TotLeeftijd",
    VasteDuurInJaren = "VasteDuurInJaren",
    Levenslang = "Levenslang",
}

/** DuurPensioenuitkeringOptions TotLeeftijd = 1, Levenslang = 3 */
export enum DuurPensioenuitkeringOptions {
    TotLeeftijd = "TotLeeftijd",
    Levenslang = "Levenslang",
}

/** EnergieKlasseType Geen = 0, A__ = 1, A_ = 2, A = 3, B = 4, C = 5, D = 6, E = 7, F = 8, G = 9, A___ = 10, A____ = 11, EnergieNeutraal = 12, NulOpDeMeter = 13, A____EP = 14, GeenEnergielabelMogelijk = 90, GeenEnergielabelBeschikbaar = 91 */
export enum EnergieKlasseType {
    Geen = "Geen",
    A__ = "A__",
    A_ = "A_",
    A = "A",
    B = "B",
    C = "C",
    D = "D",
    E = "E",
    F = "F",
    G = "G",
    A___ = "A___",
    A____ = "A____",
    EnergieNeutraal = "EnergieNeutraal",
    NulOpDeMeter = "NulOpDeMeter",
    A____EP = "A____EP",
    GeenEnergielabelMogelijk = "GeenEnergielabelMogelijk",
    GeenEnergielabelBeschikbaar = "GeenEnergielabelBeschikbaar",
}

/** Extra gegevens van de erfpacht t.b.v. woning in eigendom */
export interface ErfpachtOpWoning {
    /** Bedrag jaarlijkse canon */
    erfpachtBedrag: number | null;
    /** Indicatieveld. Is er sprake van eeuwigdurende erfpacht? */
    erfpachtEeuwigdurend: boolean;
    /** Datum einde erfpacht */
    erfpachtEinddatum: string | null;
    /** Indicatie dat er sprake is van particuliere erfpacht */
    erfpachtParticulier: boolean;
}

/** Error object zoals gebruikt door ING */
export interface ErrorMessageType {
    /** Gets or sets veld met Error (uit de XML) */
    veld: string | null;
    /** Gets or sets ING error code */
    code: string | null;
    /** Gets or sets leesbare melding */
    message: string | null;
}

/** Bevat gegevens van bestaande eigenwoningreserve of -schuld. */
export interface EwrOfEws {
    /** Bedrag (bestaanden) Eigenwoning reserve */
    bestaandeEwrBedrag: number | null;
    /** Bedrag eigenwoningschuld (EWS) overgangsrecht */
    ewsOvergangsrechtBedrag: number | null;
    /** Bedrag eigenwoningschuld (EWS) met verplichte aflossing */
    ewsVerplichteAflossingBedrag: number | null;
    /** Collectie met renteaftrek voor EwsOvergangsrecht */
    ewsOvergangsrechtRenteaftrekken: WoonsituatieRenteaftrek[] | null;
    /** Collectie met renteaftrek voor verplichte aflossing */
    ewsVerplichteAflossingRenteaftrekken: WoonsituatieRenteaftrek[] | null;
}

export interface EwsInput {
    koopsomBedrag: number | null;
    bouwrenteVoorAankoopBedrag: number | null;
    verbouwingBedrag: number | null;
    meerwerkBedrag: number | null;
    overdrachtsbelastingBedrag: number | null;
    courtageBedrag: number | null;
    transportakteBedrag: number | null;
    erfpachtAfkoopBedrag: number | null;
    vergoedingPartnerBedrag: number | null;
    readonly doorlopendeLeningdelenBox1Bedrag: number | null;
    afsluitkostenBedrag: number | null;
    readonly advieskostenBedrag: number | null;
    readonly bemiddelingsvergoedingGeldleningBedrag: number | null;
    readonly dossiervergoedingBedrag: number | null;
    gespreidBetalen: boolean | null;
    gespreidBetalenDuurInMaanden: number | null;
    advieskostenGespreidBedrag: number | null;
    bemiddelingsvergoedingGeldleningGespreidBedrag: number | null;
    nhgBedrag: number | null;
    hypotheekakteBedrag: number | null;
    taxatiekostenBedrag: number | null;
    startersleningAfsluitprovisieBedrag: number | null;
    afsluitkostenOverbruggingskredietBedrag: number | null;
    bereidstellingsprovisieBedrag: number | null;
    kostenOmzettingBedrag: number | null;
    overigeKosten1Bedrag: number | null;
    overigeKosten2Bedrag: number | null;
    overigeKosten3Bedrag: number | null;
    royementskostenBedrag: number | null;
    bouwkundigeKeuringBedrag: number | null;
    gewensteHypotheekBedrag: number | null;
    financieringskostenAftrekbaarPercentage: number | null;
    financieringskostenAftrekbaarOvernemen: boolean;
    arbeidskostenNotarisBedrag: number | null;
}

export interface EwsOutput {
    resultaat: EwsResultaat | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface EwsResultaat {
    investeringBedrag: number | null;
    financieringskostenAftrekbaarPercentage: number | null;
    financieringskostenAftrekbaarBedrag: number | null;
    financieringskostenBedrag: number | null;
    maximaalTeFinancierenBox1Bedrag: number | null;
    ewsBedrag: number | null;
    ewrBedrag: number | null;
    advieskostenAftrekbaarBedrag: number | null;
    ewsAflossingBedrag: number | null;
}

/** Bevat een keuze voor 'Financiële planning'. */
export interface FinancielePlanningKeuze {
    keuze: FinancielePlanningOptions;
}

/** FinancielePlanningOptions Overlijden = 1, Arbeidsongeschiktheid = 2, Werkloosheid = 3, Pensioen = 4, Vermogensopbouw = 5 */
export enum FinancielePlanningOptions {
    Overlijden = "Overlijden",
    Arbeidsongeschiktheid = "Arbeidsongeschiktheid",
    Werkloosheid = "Werkloosheid",
    Pensioen = "Pensioen",
    Vermogensopbouw = "Vermogensopbouw",
}

/** FinancieringOptions AankoopNieuwbouw = 1, AankoopBestaandeBouw = 2, HuidigeHypotheekWijzigen = 3, GeenFinanciering = 4 */
export enum FinancieringOptions {
    AankoopNieuwbouw = "AankoopNieuwbouw",
    AankoopBestaandeBouw = "AankoopBestaandeBouw",
    HuidigeHypotheekWijzigen = "HuidigeHypotheekWijzigen",
    GeenFinanciering = "GeenFinanciering",
}

/** Bevat de gegevens van het scherm Financieringsbehoefte. */
export interface Financieringsbehoefte {
    /** Omschrijving van het eerste voorstel */
    readonly omschrijvingVoorstel1: string | null;
    hypotheekNorm: TarievenNorm | null;
    /** Wanneer partner aanwezig is, benodigd voor eigendomsverhouding */
    readonly heeftPartner: boolean | null;
    /** Restant schuld box 1 */
    readonly restantSchuldBox1Bedrag: number | null;
    /** Restant schuld box 3 */
    readonly restantSchuldBox3Bedrag: number | null;
    /** Bedrag vrij vermogen */
    vrijVermogenBedrag: number | null;
    /** Berekend bedrag vrij vermogen */
    vrijVermogenBerekendBedrag: number | null;
    /** Indicatie dat het berekende vrij vermogen van de huidige situatie overgenomen moet worden */
    vrijVermogenOvernemen: boolean | null;
    /** Overwaarde t.b.v. de vermogenspositie */
    readonly overwaardeVermogenBedrag: number | null;
    /** Af te lossen bestaande overige lening(en) (kredieten) */
    readonly afTeLossenOverigeLeningenBedrag: number | null;
    /** Totaal van de huidige leningdelen */
    readonly totaalHuidigeLeningdelen: number | null;
    /** Het gewenste hypotheekbedrag */
    gewensteHypotheekBedrag: number | null;
    /** Vaste kosten die de adviseur in rekening brengt voor het adviseren */
    readonly advieskostenBedrag: number | null;
    /** Vaste kosten die de adviseur in rekening brengt voor het bemiddelen van de geldlening */
    readonly bemiddelingsvergoedingGeldleningBedrag: number | null;
    /** Overige vaste bemiddelingsvergoeding die de adviseur in rekening brengt voor het adviseren */
    readonly overigeBemiddelingsvergoedingBedrag: number | null;
    /** Vaste kosten die de adviseur in rekening brengt voor het beheer van het dossier t.b.v. de geldlening. */
    readonly dossiervergoedingBedrag: number | null;
    /** Indicatie dat de advieskosten gespreid betaald moeten worden */
    gespreidBetalen: boolean | null;
    /** Aantal maanden waarover het bedrag aan advieskosten gespreid wordt */
    gespreidBetalenDuurInMaanden: number | null;
    /** Vaste kosten die de adviseur in rekening brengt voor het adviseren */
    advieskostenGespreidBedrag: number | null;
    /** Indicatie dat het bedrag van de te spreiden advieskosten automatisch bepaald wordt */
    advieskostenGespreidOvernemen: boolean | null;
    /** Vaste kosten die de adviseur in rekening brengt voor het bemiddelen van de geldlening */
    bemiddelingsvergoedingGeldleningGespreidBedrag: number | null;
    /** Indicatie dat het bedrag van de te spreiden bemiddelingsvergoeding automatisch bepaald wordt */
    bemiddelingsvergoedingGeldleningGespreidOvernemen: boolean | null;
    /** Overige vaste bemiddelingsvergoeding die de adviseur in rekening brengt voor het adviseren */
    overigeBemiddelingsvergoedingGespreidBedrag: number | null;
    /** Indicatie dat het bedrag van de te spreiden overige bemiddelingsvergoeding automatisch bepaald wordt */
    overigeBemiddelingsvergoedingGespreidOvernemen: boolean | null;
    /** Passeerdatum van de hypotheek */
    readonly passeerdatum: string | null;
    /** Volgnummer van het voorstel waar de financieringsbehoefte onder valt */
    volgnummerVoorstel: number;
    /** Naam van het voorstel */
    readonly omschrijving: string | null;
    /** Percentage aftrekbare afsluitkosten indien door gebruiker zelf ingevuld */
    financieringskostenAftrekbaarPercentage: number | null;
    /** Indicatie dat het aftrekbaar percentage van de afsluitkosten berekend moet worden */
    financieringskostenAftrekbaarOvernemen: boolean;
    /** Bedrag hypothecaire inschrijving */
    inschrijvingBedrag: number | null;
    /** Indicatie dat de hypothecaire inschrijving automatisch bepaald (overgenomen) moet worden */
    inschrijvingOvernemen: boolean | null;
    /** Het berekende bevoorschottingspercentage (verhouding tussen marktwaarden en gewenste hypotheek) */
    readonly bevoorschottingspercentage: number | null;
    /** Het berekende maximale  bevoorschottingspercentage */
    readonly maxBevoorschottingspercentage: number | null;
    /** Indicatie of NHG mogelijk is */
    readonly nhgMogelijk: boolean | null;
    /** Maximale hypotheek op basis van de koopsom. */
    readonly maximaleHypotheekKoopsom: number | null;
    /** Saldo in box 1 van de huidige leningdelen die doorlopen van verkochte panden */
    doorlopendeLeningdelenBox1Bedrag: number | null;
    financieringsopzet: FinancieringsbehoefteFinancieringsopzet;
    pand: FinancieringsbehoeftePand;
    /** De specificatie van de netto verkoopopbrengst. */
    readonly specificatiesNettoVerkoopopbrengst: SpecificatieNettoVerkoopopbrengst[] | null;
    /** De specificatie van (extra) werkzaamheden die gedaan moeten worden */
    specificatiesVerbouwingVerbetering: FinancieringsbehoefteVerbouwing[] | null;
    /** Uitbetalingen per maand van de bouw. */
    uitbetalingen: Uitbetaling[] | null;
    /** Lijst met te beeindigen leningdelen, nodig voor de berekening van de boeterente */
    teBeeindigenLeningdelen: TeBeeindigenLeningdeel[] | null;
    /** Indicatie dat overbruggingskrediet mogelijk is */
    overbruggingskredietMogelijk: boolean;
    overbruggingskrediet: FinancieringsbehoefteOverbrugging | null;
    rentelastenOverbruggingskrediet: RentelastenOverbrugging | null;
    ewsResultaat: EwsResultaat | null;
    aanvrager1: KlantnaamReadOnly | null;
    aanvrager2: KlantnaamReadOnly | null;
    /** Geeft aan of de financieringsbehoefte eerder opgeslagen is of niet. */
    eerderOpslagen: boolean;
    nhgMogelijkResultaat: NhgMogelijkOutput | null;
}

/** Gegevens van een financieringsopzet */
export interface FinancieringsbehoefteFinancieringsopzet {
    /** Bedrag bankgarantie */
    bankgarantieBedrag: number | null;
    /** Bedrag bankgarantiekosten */
    kostenBankgarantieBedrag: number | null;
    /** Indicatieveld. Is er sprake van taxatiekosten */
    taxatiekosten: boolean | null;
    /** Bedrag taxatiekosten */
    taxatiekostenBedrag: number | null;
    /** Indicatieveld. Is er sprake van kosten opmaken hypotheekakte */
    hypotheekakte: boolean | null;
    /** Bedrag opmaken hypotheekakte */
    hypotheekakteBedrag: number | null;
    /** Bedrag arbeidskosten Notaris */
    arbeidskostenNotarisBedrag: number | null;
    /** Indicatieveld. Is er sprake van inbreng eigen geld */
    inbrengEigenGeld: boolean | null;
    /** Bedrag inbreng eigen geld */
    inbrengEigenGeldBedrag: number | null;
    /** Bedrag boeterente aflossing */
    boeterenteBedrag: number | null;
    /** Omschrijving inbreng eigen geld */
    eigenGeldOmschrijving1: string | null;
    /** EigenGeldOmschrijving2 */
    eigenGeldOmschrijving2: string | null;
    /** Bedrag inbreng eigen geld */
    eigenGeldBedrag1: number | null;
    /** Bedrag inbreng eigen geld */
    eigenGeldBedrag2: number | null;
    /** Bedrag gewenst consumptief te besteden bedrag */
    gewenstConsumptiefBedrag: number | null;
    /** Bedrag van de huidige leningdelen die doorlopen (berekend) */
    readonly doorlopendeLeningdelenBedrag: number | null;
    /** Geeft aan of er doorlopende leningdelen zijn in de situatie */
    readonly heeftDoorlopendeLeningdelen: boolean | null;
    /** Geeft aan of er in het voorstel leningdelen bestaan */
    readonly analyseHeeftLeningdelen: boolean | null;
    /** Vergoeding aan partner conform akte van verdeling */
    vergoedingPartnerBedrag: number | null;
    soortFinanciering: Financieringsoort | null;
    /** Indicatie dat de aanvrager gebruik wil maken van een Starterslening */
    starterslening: boolean | null;
    /** Bedrag Starterslening */
    startersleningBedrag: number | null;
    /** Afsluitprovisie berekend over de SVn Starterslening */
    startersleningAfsluitprovisieBedrag: number | null;
    /** Bedrag restschuld huidige woning */
    restschuldTotaalBedrag: number | null;
    /** Indicatie of de restschuld berekend moet worden aan de hand van de verkoopgegevens van de huidige woning */
    restschuldOvernemen: boolean | null;
    /** Berekend bedrag restschuld huidige woning */
    restschuldTotaalBerekendBedrag: number | null;
    /** Bedrag van de administratiekosten die de maatschappij rekent voor het omzetten van een of meerdere leningdelen */
    kostenOmzettingBedrag: number | null;
    /** Inbreng eigen middelen uit overwaarde */
    eigenGeldOverwaardeBedrag: number | null;
    /** Bereidstellingsprovisie (kosten om de geldigheidstermijn van de offerte te verlengen) */
    bereidstellingsprovisieBedrag: number | null;
    /** Bedrag van de extra aflossing als onderdeel van inbreng eigen geld */
    eigenGeldExtraAflossing: number | null;
    /** Bedrag extra kosten huidige hypotheek */
    extraKostenHuidigBedrag: number | null;
    /** Bedrag bijkomende kosten restschuld */
    restschuldBijkomendeKosten: number | null;
    /** Bedrag inbreng eigen geld voor verlagen restschuld */
    eigenGeldRestschuldBedrag: number | null;
    /** Bedrag inbreng kortlopende lening / krediet */
    inbrengKredietBedrag: number | null;
    /** Overige financiering 1 */
    overigeFinanciering1Omschrijving: string | null;
    /** Overige financiering 2 */
    overigeFinanciering2Omschrijving: string | null;
    /** Bedrag overige financiering 1 */
    overigeFinanciering1Bedrag: number | null;
    /** Bedrag overige financiering 1 */
    overigeFinanciering2Bedrag: number | null;
    /** Bankgarantie aanvragen */
    bankgarantieAanvragen: boolean | null;
    /** Bedrag voor de NHG */
    nhgBedrag: number | null;
    /** Bestaand NHG bedrag. */
    readonly bestaandNhgBedrag: number | null;
    /** Som doorlopende leningdelen zonder NHG. */
    readonly doorlopendZonderNhgBedrag: number | null;
    /** Indicatieveld. Is er sprake van een leveringsakte/transportakte? */
    transportakte: boolean | null;
    /** Bedrag kosten transportakte */
    transportakteBedrag: number | null;
    /** Bedrag overige mee te financieren kosten */
    overigeKosten1Bedrag: number | null;
    /** Indicatieveld. Is er sprake van overdrachtbelasting? */
    overdrachtsbelasting: boolean | null;
    /** Bedrag overdrachtsbelasting */
    overdrachtsbelastingBedrag: number | null;
    /** Percentage overdrachtsbelasting */
    overdrachtsbelastingPercentage: number | null;
    /** Indicatieveld. Is er sprake van makelaarscourtage? */
    courtage: boolean | null;
    /** Bedrag makelaarscourtage */
    courtageBedrag: number | null;
    /** Bedrag koopsom woning */
    koopsomBedrag: number | null;
    /** Indicatieveld. Is er sprake van kosten koper? */
    kostenKoper: boolean | null;
    /** Bedrag kosten grond */
    kostenGrondBedrag: number | null;
    /** Stichtingskosten bij nieuwbouw */
    stichtingskostenBedrag: number | null;
    /** Grond reeds in bezit */
    grondReedsInBezit: boolean | null;
    /** Bedrag renteverlies tijdens de bouw */
    renteverliesTijdensBouwBedrag: number | null;
    /** Bedrag meerwerk */
    meerwerkBedrag: number | null;
    /** Bedrag verbouwing/verbetering */
    verbouwingBedrag: number | null;
    /** Omschrijving overige kosten */
    overigeKosten1Omschrijving: string | null;
    /** Bedrag afkoop erfpacht */
    erfpachtAfkoopBedrag: number | null;
    /** Datum erfpacht afgekocht */
    erfpachtAfgekochtTotDatum: string | null;
    /** Bedrag koopsom roerende zaken */
    roerendeZakenBedrag: number | null;
    /** Bedrag bouwrente over de periode voor aankoop */
    bouwrenteVoorAankoopBedrag: number | null;
    /** Bedrag bouwrente over de periode voor aankoop */
    bouwrenteNaAankoopBedrag: number | null;
    /** Omschrijving overige kosten 2 */
    overigeKosten2Omschrijving: string | null;
    /** Bedrag overige mee te financieren kosten 2 */
    overigeKosten2Bedrag: number | null;
    overigeKosten1Box: Belastingbox | null;
    overigeKosten2Box: Belastingbox | null;
    /** Bedrag verbouwing/verbetering niet waardevermeerderen */
    meerwerkWaardeloosBedrag: number | null;
    /** Percentage hypotheekrente t.b.v. renteverlies tijdens de bouw */
    renteverliesHypotheekrentePercentage: number | null;
    /** Percentage depotvergoeding */
    depotvergoedingPercentage: number | null;
    /** Bedrag aan energiebesparende maatregelen */
    energiebesparendeMaatregelenBedrag: number | null;
    /** Bedrag waarvan in energiebespaarbudget */
    energiebespaarbudgetBedrag: number | null;
    /** Bedrag achterstallig onderhoud bij verbouwing/verbetering */
    achterstalligOnderhoudBedrag: number | null;
    /** Indicatie of de overige kostenpost eenmalig aftrekbaar is in het jaar van betaling */
    overigeKosten1EenmaligAftrekbaar: boolean | null;
    /** Indicatie of de 2e overige kostenpost eenmalig aftrekbaar is in het jaar van betaling */
    overigeKosten2EenmaligAftrekbaar: boolean | null;
    /** Indicatie dat de NHG-kosten berekend zijn */
    nhgKostenOvernemen: boolean | null;
    /** Overwaarde gebruiken als eigen geld */
    eigenGeldOverwaarde: boolean | null;
    /** Bedrag af te lossen bestaande hypotheken */
    hypotheekAflossingBedrag: number | null;
    /** Indicatie dat het 'bedrag af te lossen bestaande hypotheken' overgenomen moet worden */
    hypotheekAflossingOvernemen: boolean | null;
    /** Berekend bedrag af te lossen bestaande hypotheken */
    readonly hypotheekAflossingBerekendBedrag: number | null;
    /** Omschrijving overige kosten 3 */
    overigeKosten3Omschrijving: string | null;
    /** Bedrag overige mee te financieren kosten 3 */
    overigeKosten3Bedrag: number | null;
    overigeKosten3Box: Belastingbox | null;
    /** Indicatie of de 3e overige kostenpost eenmalig aftrekbaar is in het jaar van betaling */
    overigeKosten3EenmaligAftrekbaar: boolean | null;
    /** Indicatie dat de berekende overwaarde bij inbreng eigen geld overgenomen moet worden */
    eigenGeldOverwaardeOvernemen: boolean | null;
    /** Indicatie dat de eigenwoningschuld berekend moet worden */
    eigenwoningschuldOvernemen: boolean | null;
    /** Bedrag eigenwoningschuld indien deze niet berekend maar door de gebruiker zelf ingevoerd is */
    eigenwoningschuldBedrag: number | null;
    /** Bedrag berekende inbreng eigen geld uit opgebouwde waarde (berekend) */
    readonly eigenGeldInbrengBedrag: number | null;
    /** Bedrag inbreng eigen geld uit inbreng polis/rekening met vrije invoer */
    eigenGeldInbrengOverig1Bedrag: number | null;
    /** Bedrag inbreng eigen geld uit opgebouwde waarde ter verlaging van restschuld */
    eigenGeldInbrengRestschuldBedrag: number | null;
    /** Indicatie dat de inbreng eigen geld uit opgebouwde waarde ter verlaging van restschuld berekend moet worden */
    eigenGeldInbrengRestschuldOvernemen: boolean | null;
    /** Omschrijving inbreng eigen geld uit inbreng polis/rekening met vrije invoer */
    eigenGeldInbrengOverig1Omschrijving: string | null;
    /** Soort nieuwbouw conform de HDN keuzelijst SoortNieuwbouwType */
    soortNieuwbouw: number | null;
    /** Soort zelfbouw conform de HDN keuzelijst SoortZelfbouwType */
    soortZelfbouw: number | null;
    /** Royementskosten die meegefinancierd moeten worden */
    royementskostenBedrag: number | null;
    /** Het bedrag dat betaald is aan de bouwkundige keuring */
    bouwkundigeKeuringBedrag: number | null;
    bouwkundigeKeuringBox: Belastingbox | null;
    /** Geeft aan of de kosten voor de bouwkundige keuring eenmalig aftrekbaar zijn. */
    bouwkundigeKeuringEenmaligAftrekbaar: boolean | null;
    /** Geeft de toekomstige energie (label) klasse in welke de woning gaat vallen na de verbouwing volgens de HDN keuzelijst EnergieKlasseType */
    energieklasseToekomstig: number | null;
}

/** Gegevens van een overbrugging */
export interface FinancieringsbehoefteOverbrugging {
    /** De hoogte van het overbruggingskrediet */
    overbruggingBedrag: number | null;
    /** De bij het overbruggingskrediet behorende afsluitkosten (provisie) */
    afsluitkostenBedrag: number | null;
    /** Het gedeelte van de overbrugging dat in box 1 valt (box 3 wordt hiervan afgeleid) */
    box1Bedrag: number | null;
    /** Indicatie dat de overwaarde default overgenomen moet worden */
    overwaardeMeenemen: boolean | null;
    /** Indicatie dat de einddatum default overgenomen moet worden van de verkoopdatum van een te verkopen pand */
    einddatumMeenemen: boolean | null;
    /** De einddatum van het overbruggingskrediet */
    einddatum: string | null;
    /** Aantal maanden rentevastperiode */
    rentevastAantalMaanden: number | null;
    /** De rente van het overbruggingskrediet */
    rentePercentage: number | null;
    /** De ingangsdatum van het overbruggingskrediet (gelijk aan passeerdatum) */
    aanvangsdatum: string | null;
    /** Het gedeelte van de overwaarde dat meegenomen moet worden in het overbruggingskrediet */
    meenemenInOverbruggingBedrag: number | null;
}

/** Gegevens van een pand */
export interface FinancieringsbehoeftePand {
    /** Indicatieveld. Is er sprake van erfpacht? */
    erfpacht: boolean | null;
    /** Indicatieveld. Is de erfpacht afgekocht? */
    erfpachtAfgekocht: boolean | null;
    /** Indicatieveld. Is er sprake van eeuwigdurende erfpacht? */
    erfpachtEeuwigdurend: boolean | null;
    /** Datum einde erfpacht */
    erfpachtEinddatum: string | null;
    /** Bedrag jaarlijkse canon */
    erfpachtBedrag: number | null;
    /** Bedrag WOZ-waarde */
    wozWaarde: number | null;
    /** Bedrag eigenwoningforfait */
    eigenWoningForfaitBedrag: number | null;
    /** Bedrag getaxeerde marktwaarde */
    taxatieBedrag: number | null;
    /** Bedrag marktwaarde na verbouw */
    marktwaardeNaVerbouwingBedrag: number | null;
    /** Aantal maanden duur van de bouw */
    duurBouwInMaanden: number | null;
    /** Eigendomsverhouding aanvrager 1 */
    eigendom1Percentage: number | null;
    /** Eigendomsverhouding aanvrager 2 */
    eigendom2Percentage: number | null;
    gebruikPand: GebruikPandSoort | null;
    /** Indicatie dat er sprake is van particuliere erfpacht */
    erfpachtParticulier: boolean | null;
    adres: AdresReadOnly | null;
}

/** Bevat gegevens van de verbouwing van een taxatie. */
export interface FinancieringsbehoefteVerbouwing {
    /** De unieke identificatie van een verbouwing. */
    verbouwingId: string | null;
    /** Volgnummer van de verbouwing binnen een pand */
    volgnummer: number;
    /** Omschrijving werkzaamheden */
    werkzaamheden: string | null;
    /** Bedrag werkzaamheden */
    werkzaamhedenBedrag: number | null;
    /** Code veld. Bevat waarde uit ENUM_TAUVerbouwType */
    typeVerbouwing: string | null;
    /** Omschrijving werkzaamheden */
    omschrijving: string | null;
    /** Indicatieveld. Verbouwing in eigen beheer */
    verbouwingInEigenBeheer: boolean | null;
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Financieringsbehoefte. */
export interface FinancieringsbehoeftenOutput {
    /** Lijst met de inhoud van scherm Financieringsbehoefte per Voorstel. */
    financieringsbehoeften: { [key: string]: Financieringsbehoefte; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Financieringsoort Geen = 0, AankoopBestaandeBouw = 1, AankoopNieuwbouw = 2, Oversluiten = 3, Heropname = 4, _2eHypotheek = 5, _3eHypotheek = 6, _4eHypotheek = 7, Omzetting = 8, _1eHypotheek = 9 */
export enum Financieringsoort {
    Geen = "Geen",
    AankoopBestaandeBouw = "AankoopBestaandeBouw",
    AankoopNieuwbouw = "AankoopNieuwbouw",
    Oversluiten = "Oversluiten",
    Heropname = "Heropname",
    _2eHypotheek = "_2eHypotheek",
    _3eHypotheek = "_3eHypotheek",
    _4eHypotheek = "_4eHypotheek",
    Omzetting = "Omzetting",
    _1eHypotheek = "_1eHypotheek",
}

/** FiscaalRegimeOptions PreBredeHerwaardering = 0, BredeHerwaardering = 1, Ib2001 = 2 */
export enum FiscaalRegimeOptions {
    PreBredeHerwaardering = "PreBredeHerwaardering",
    BredeHerwaardering = "BredeHerwaardering",
    Ib2001 = "Ib2001",
}

/** Bevat gegevens van fiscale aftrekposten. */
export interface FiscaleAftrekposten {
    /** Bedrag aan te betalen partneralimentatie */
    teBetalenPartnerAlimentatieBedrag: number;
    /** Einddatum van de betaling van de partneralimentatie */
    teBetalenPartnerAlimentatieEinddatum: string | null;
}

/** Bevat gegevens van fiscale bijtelposten. */
export interface FiscaleBijtelposten {
    /** Bedrag cataloguswaarde auto van de zaak */
    autovdZaakCataloguswaardeBedrag: number;
    bijtellingAutovdZaak: BijtellingAutovdZaakOpties;
    /** Eigen bijdrage t.b.v. de auto van de zaak */
    bijdrageAutovdZaakBedrag: number;
    /** Handmatig opgegeven bijtellingbedrag */
    autovdZaakBijtellingBedrag: number | null;
}

/** FiscalePlaatsingOrvOptions Box1 = 0, Box3 = 1 */
export enum FiscalePlaatsingOrvOptions {
    Box1 = "Box1",
    Box3 = "Box3",
}

/** FiscaleTyperingOptions Geen = 0, KapitaalverzekeringEigenWoningKew = 1, SpaarrekeningEigenWoningSew = 2, BeleggingsrekeningEigenWoningBew = 3, KapitaalverzekeringZonderEigenWoning = 4 */
export enum FiscaleTyperingOptions {
    Geen = "Geen",
    KapitaalverzekeringEigenWoningKew = "KapitaalverzekeringEigenWoningKew",
    SpaarrekeningEigenWoningSew = "SpaarrekeningEigenWoningSew",
    BeleggingsrekeningEigenWoningBew = "BeleggingsrekeningEigenWoningBew",
    KapitaalverzekeringZonderEigenWoning = "KapitaalverzekeringZonderEigenWoning",
}

export interface FiscaleVoortzettingKeuze {
    productId: string | null;
    omschrijving: string | null;
    productkenmerken: ProductKenmerken | null;
}

/** FiscaleVoortzettingOptions Geen = 0, VoortgezetProduct = 1, EigenInvoer = 2 */
export enum FiscaleVoortzettingOptions {
    Geen = "Geen",
    VoortgezetProduct = "VoortgezetProduct",
    EigenInvoer = "EigenInvoer",
}

/** Garantiesoort Geen = 0, Nhg = 1, Gemeente = 2 */
export enum Garantiesoort {
    Geen = "Geen",
    Nhg = "Nhg",
    Gemeente = "Gemeente",
}

/** GebruikPandSoort Geen = 0, PrimaireWoning = 1, TweedeWoning = 2, DeelsVerhuurd = 3, GeheelVerhuurd = 4 */
export enum GebruikPandSoort {
    Geen = "Geen",
    PrimaireWoning = "PrimaireWoning",
    TweedeWoning = "TweedeWoning",
    DeelsVerhuurd = "DeelsVerhuurd",
    GeheelVerhuurd = "GeheelVerhuurd",
}

/** GedeeltelijkeUitkeringAoOpties WerkelijkAoPercentage = 1, Staffel = 2 */
export enum GedeeltelijkeUitkeringAoOpties {
    WerkelijkAoPercentage = "WerkelijkAoPercentage",
    Staffel = "Staffel",
}

/** Geldverstrekker gegevens */
export interface Geldverstrekker {
    /** Code van de geldverstrekker (volgens nat. waarborg). */
    code: string | null;
    /** Naam geldverstrekker. */
    naam: string | null;
}

/** De uitvoer van de gemiddeld jaarinkomen-berekening. */
export interface GemiddeldInkomenOutput {
    resultaat: BerekendGemiddeldInkomen | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** GeslachtOpties Geen = 0, Man = 1, Vrouw = 2 */
export enum GeslachtOpties {
    Geen = "Geen",
    Man = "Man",
    Vrouw = "Vrouw",
}

/** Bevat de uitvoer van het exporteren van een adviesdossier naar hbx. */
export interface HbxExportOutput {
    /** Het gegenereerde hbx-bestand */
    resultaat: string | null;
    /** De (default) bestandsnaam */
    filename: string | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat gegevens van heffingskortingen. Alleen de beleggingskorting wordt momenteel gebruikt, de andere kortingen zijn daarom voorlopig verwijderd */
export interface Heffingskortingen {
    /** Beleggingskorting */
    beleggingskortingBedrag: number;
}

/** HoogLaagConstructie Onbekend = 0, HoogLaag = 1, LaagHoog = 2, Geen = 3, Eenmalig = 4 */
export enum HoogLaagConstructie {
    Onbekend = "Onbekend",
    HoogLaag = "HoogLaag",
    LaagHoog = "LaagHoog",
    Geen = "Geen",
    Eenmalig = "Eenmalig",
}

/** Extra gegevens van het huidige pand t.b.v. woning in eigendom */
export interface HuidigPand {
    /** Code van het type woning volgens de HDN keuzelijst CodeObjectType */
    typePand: number | null;
    /** Code van het gebruiksdoel van het betreffende object volgens de HDN keuzelijst ObjectSoortType */
    objectSoort: number | null;
    /** Code van het bijzondere gebruiksdoel van het betreffende object volgens de HDN keuzelijst BijzObjectSoortType */
    bijzonderObjectSoort: number | null;
    /** Indicatie dat er een garage aanwezig is */
    heeftGarage: boolean | null;
    /** Indicatie dat het object wordt gebruikt voor recreatieve bewoning */
    recreatieveBewoning: boolean | null;
    /** Geeft de energie (label) klasse in welke de woning valt volgens de HDN keuzelijst EnergieKlasseType */
    energieklasse: number | null;
    /** Indicatie dat het adres gelijk is het woonadres van de (1e) klant */
    gelijkAanWoonadres: boolean | null;
    adres: Adres | null;
    /** Bouwjaar */
    bouwjaar: number | null;
    /** Opleveringsdatum */
    opleverdatum: string | null;
    /** Bouwplan */
    bouwplan: string | null;
    /** Bouwnummer */
    bouwnummer: string | null;
    /** Kadastrale gemeente */
    kadasterGemeente: string | null;
    /** Kadastrale sectie */
    kadasterSectie: string | null;
    /** Kadastraal nummer */
    kadasterNummer: string | null;
    /** Indicatieveld. Is er sprake van een gedeeld perceel? */
    gedeeld: boolean;
    /** Indicatieveld. Is er sprake van appartementsrecht? */
    appartement: boolean;
    /** Servicekosten */
    servicekosten: number | null;
    /** Geeft de bouwaard van het object weer volgens de HDN keuzelijst BouwaardType */
    bouwaard: number | null;
    /** Staat van onderhoud volgens de HDN keuzelijst OnderhoudsToestandType */
    staatOnderhoud: number | null;
    /** Geeft aan dat op het object een voorwaarde bij verkoop van toepassing is */
    verkoopOnderVoorwaarden: boolean;
    /** Geeft aan welke voorwaarde bij verkoop van toepassing is (indien VerkoopOnderVoorwaarden = True) */
    verkoopOnderVoorwaardenConstructie: number | null;
    /** Omschrijving constructie verkoop onder voorwaarden */
    verkoopOnderVoorwaardenConstructieOmschrijving: string | null;
    /** Afbouwgarantie */
    afbouwgarantie: boolean;
    /** Taxatie aanwezig */
    taxatieAanwezig: boolean;
    /** Taxatiedatum */
    taxatiedatum: string | null;
    /** Datum ontbindende voorwaarden */
    ontbindendeVoorwaardenDatum: string | null;
    /** Geeft aan op welke datum de energie (label) klasse is afgegeven */
    energieklasseDatum: string | null;
    /** Wanneer de erfpacht- of kortingsconstructie nog niet is opgenomen in de waardelijst VerkoopOnderVoorwaardenConstructieType, kan hier 
           worden aangegeven om wat voor type constructie het gaat, zodat er rekening mee gehouden kan worden in de volledigheidstoets van NHG. */
    soortConstructieAnders: number | null;
    /** Met het Bag-ID kan verschillende brondata worden geraadpleegd zoals, EP-online, KadastraleKaart, WOZ-waardeloket. */
    bagId: string | null;
    /** Soort taxatie / bron waardebepaling */
    bronwaardebepaling: number | null;
}

/** Gegevens van de huidige woning */
export interface HuidigeWoning {
    /** Referentie naar pand in de huidige situatie */
    readonly pandId: string | null;
    /** Volgnummer van de woning op het scherm */
    readonly volgnummer: number | null;
    /** Bedrag marktwaarde */
    readonly marktwaardeBedrag: number | null;
    adres: AdresReadOnly | null;
}

/** Bevat gegevens van een huidige woonsituatie. */
export interface HuidigeWoonsituatie {
    /** Unieke identificatie van een huidige woonsituatie */
    woonsituatieId: string | null;
    /** Volgnummer van een woonsituatie binnen een situatie */
    volgnummer: number;
    soortWoonsituatie: Woonsituatiesoort;
    bewoners: BewonersOpties;
    ewrOfEws: EwrOfEws | null;
    huurwoning: Huurwoning | null;
    woningInEigendom: WoningInEigendom | null;
}

/** Extra gegevens van een huurwoning */
export interface Huurwoning {
    /** Huur per maand (bedrag) */
    huurPerMaandBedrag: number | null;
    /** Stijging (percentage) per jaar */
    stijgingPercentage: number | null;
}

export interface HypotheekAutomatischeRentedaling {
    aanpassingRente: AanpassingRenteOptions;
    renteopslagen: HypotheekRenteopslagMarktwaarde[];
    rentescenario: boolean;
    opslagNaRentevastperiodePercentage: number | null;
    marktwaardeRenteBedrag: number | null;
}

export interface HypotheekExtraAflossing {
    extraAflossingId: string | null;
    volgnummer: number;
    datum: string;
    bedrag: number;
    looptijdInMaanden: number;
    betalingstermijn: BetalingsTermijnType | null;
}

export interface HypotheekFiscaleRegeling {
    polisnummer: string | null;
    kapitaalopbouw: KapitaalopbouwOptions | null;
    productId: string | null;
    fiscaleVoortzetting: FiscaleVoortzettingOptions | null;
    originelePolisnummer: string | null;
    externeMaatschappijCode: string | null;
    externeMaatschappijOmschrijving: string | null;
    lijfrenteclausuleOrigineel: boolean | null;
    fiscaleTypering: FiscaleTyperingOptions | null;
    garantieverzekering: boolean | null;
    fiscaalRegime: FiscaalRegimeOptions | null;
    oorspronkelijkeIngangsdatum: string | null;
    ingangsdatumBox1: string | null;
    einddatum: string | null;
    doelkapitaalBedrag: number | null;
    laagstePremieooitBedrag: number | null;
    hoogstePremieOoitBedrag: number | null;
    huidigeJaarPremieBedrag: number | null;
    premieLopendJaarBedrag: number | null;
    eerdereUitkeringenBedrag: number | null;
    ingebrachteWaardeBedrag: number | null;
}

export interface HypotheekHuidigeSituatie {
    panden: HypotheekPand[] | null;
    aanvrager1: KlantnaamReadOnly | null;
    aanvrager2: KlantnaamReadOnly | null;
    leningdelen: HypotheekHuidigeSituatieLeningdeel[] | null;
    hypotheekAanwezig: boolean;
    readonly oorspronkelijkHypotheekbedragIngevuld: boolean | null;
    readonly administratiekostenBedrag: number | null;
    readonly maatschappijCode: string | null;
    readonly productnaam: string | null;
}

export interface HypotheekHuidigeSituatieLeningdeel {
    pandId: string;
    rangorde: number | null;
    klantIds: string[] | null;
    oorspronkelijkeHoofdsomBedrag: number | null;
    garantie: Garantiesoort | null;
    restantHoofdsomOvernemen: boolean | null;
    opgaveDatum: string | null;
    aanvangsdatum: string;
    wijzigingenInDoorlopendeProductenOvernemen: boolean;
    leningdeelId: string | null;
    volgnummer: number;
    meenemen: boolean;
    hypotheekvorm: Hypotheekvorm;
    maatschappijCodeHdn: string | null;
    maatschappijCode: string | null;
    maatschappijOmschrijving: string | null;
    productcode: number;
    leningdeelBedrag: number | null;
    aflossingBedrag: number | null;
    wijzeVanTerugbetaling: WijzeVanTerugbetalingType | null;
    rentevariant: RentevariantOptions;
    renteboxSoort: number | null;
    rentevastAantalMaanden: number | null;
    rentebedenktijdInMaanden: number | null;
    rentevastperiodeEinddatum: string | null;
    renteScenario: PercentageScenario | null;
    leningnummer: string | null;
    leningdeelnummer: string | null;
    looptijdInMaanden: number | null;
    uwBemiddeling: boolean;
    deelBox1Bedrag: number | null;
    consumptiefBedrag: number | null;
    automatischeRentedaling: HypotheekAutomatischeRentedaling | null;
    extraAflossingen: HypotheekExtraAflossing[] | null;
    renteaftrekken: HypotheekRenteaftrek[] | null;
}

export interface HypotheekHuidigeSituatieOutput {
    hypotheken: { [key: string]: HypotheekHuidigeSituatie; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface HypotheekHypotheeklabel {
    code: number;
    readonly omschrijving: string | null;
    maatschappijCode: string | null;
    maatschappijOmschrijving: string | null;
    hypotheekopties: Hypotheekoptie[] | null;
    hypotheekoptiesIngPriceTool: HypotheekoptiesIngPriceTool | null;
}

export interface HypotheekKapitaalopbouw {
    doelkapitaal1Bedrag: number | null;
    doelkapitaal2Bedrag: number | null;
    doelkapitaal1Overnemen: boolean | null;
    doelkapitaal2Overnemen: boolean | null;
    doelkapitaal1Percentage: number | null;
    doelkapitaal2Percentage: number | null;
    voorbeeldkapitaal1Bedrag: number | null;
    voorbeeldkapitaal2Bedrag: number | null;
    voorbeeldkapitaal1Percentage: number | null;
    voorbeeldkapitaal2Percentage: number | null;
}

/** Extra gegevens van de hypotheek op het huidige pand t.b.v. woning in eigendom */
export interface HypotheekOpWoning {
    /** Oorspronkelijke hypotheek op het pand */
    oorspronkelijkHypotheekbedrag: number | null;
    /** Bedrag hypothecaire inschrijving */
    inschrijvingBedrag: number | null;
    /** Indicatie dat de inschrijving berekend is/moet worden */
    inschrijvingOvernemen: boolean | null;
}

export interface HypotheekOverlijdensrisicodekking {
    verzekerdKapitaal1Bedrag: number | null;
    verzekerdKapitaal2Bedrag: number | null;
    premiesplitsing: boolean | null;
}

/** Bevat de inhoud van het Adviesbox-form Hypotheek oversluiten. */
export interface HypotheekOversluiten {
    /** De marktwaarde van het pand. */
    readonly marktwaardeBedrag: number | null;
    /** De gewenste nieuwe hypotheek op het pand. */
    readonly gewensteHypotheekBedrag: number | null;
    /** Het bedrag aan notariskosten dat betaald moet worden. */
    readonly notariskostenBedrag: number | null;
    /** Het bedrag aan taxatiekosten dat betaald moet worden. */
    readonly taxatiekostenBedrag: number | null;
    /** Het bedrag aan NHG kosten dat betaald moet worden indien NHG van toepassing. */
    readonly nhgkostenBedrag: number | null;
    /** Het bedrag aan advieskosten dat betaald moet worden. */
    readonly advieskostenBedrag: number | null;
    /** Het bedrag aan bemiddelingsvergoeding dat betaald moet worden. */
    readonly bemiddelingsvergoedingBedrag: number | null;
    /** Het bedrag aan dossiervergoeding dat betaald moet worden. */
    readonly dossiervergoedingBedrag: number | null;
    /** Het bedrag aan boeterente dat betaald moet worden op de oude hypotheek. */
    readonly boeterenteBedrag: number | null;
    /** De gewenste rentevastperiode op de nieuwe hypotheek. */
    gewensteRentevastperiodeInJaren: number | null;
    /** De totale bruto rentelast van de huidige situaties */
    totaleBrutoRentelast: number;
    /** Huidige situatie van leningdelen. */
    readonly huidigeSituatie: HypotheekOversluitenHuidigeHypotheek[] | null;
    aanvrager1: KlantnaamReadOnly | null;
    aanvrager2: KlantnaamReadOnly | null;
}

/** Gegevens van een huidig leningdeel. */
export interface HypotheekOversluitenHuidigeHypotheek {
    /** Naam van de maatschappij. */
    readonly maatschappij: string | null;
    /** Bedrag van het leningdeel. */
    readonly leningdeelBedrag: number | null;
    /** De rente van het leningdeel. */
    readonly rentepercentage: number | null;
    /** Het bedrag aan bruto rentelasten. */
    readonly brutoRentelastenBedrag: number | null;
    /** Het gecorrigeerde bedrag aan bruto rentelasten. */
    readonly gecorrigeerdeBrutoRentelastenBedrag: number | null;
    /** Rentevastperiode in maanden. */
    readonly rentevastperiodeInMaanden: number | null;
    /** Einddatum huidige rentevastperiode. */
    readonly eindeRentevastperiode: string | null;
}

/** Uitvoer van de Hypotheek oversluiten berekening voor een label. */
export interface HypotheekOversluitenHypotheekLabel {
    /** Code van de geldverstrekker. */
    readonly geldverstrekkerCode: string | null;
    /** Gets or sets verkorte naam van de geldverstrekker. */
    readonly geldverstrekkerNaam: string | null;
    /** Code van het hypotheeklabel binnen een geldverstrekker. */
    hypotheeklabelCode: number;
    /** Gets or sets naam van het hypotheeklabel binnen een geldverstrekker. */
    readonly hypotheeklabelNaam: string | null;
    /** Rentepercentage dat gebruikt is bij de berekening. */
    rentepercentage: number;
    /** De kosten van het oversluiten. */
    oversluitkostenBedrag: number;
    /** Bruto rentelast per maand */
    brutoRentelastPerMaand: number;
    /** Besparing op de bruto rentelast per maand */
    besparingPerMaand: number;
    /** Totale besparing binnen de rentevastperiode */
    besparingRvp: number;
    /** Terugverdienperiode in maanden */
    readonly terugverdienperiodeInMaanden: number | null;
    /** Terugverdienpercentage in nieuwe rentevastperiode */
    readonly terugverdienpercentage: number | null;
    uitslag: UitslagOptions;
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Hypotheek oversluiten. */
export interface HypotheekOversluitenOutput {
    /** Lijst met de inhoud van het Adviesbox-form Hypotheek oversluiten per voorstel. */
    hypotheekOversluiten: { [key: string]: HypotheekOversluiten; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Uitvoer van de Hypotheek oversluiten berekening. */
export interface HypotheekOversluitenResultaat {
    /** De resultaten per label. */
    readonly resultatenPerLabel: HypotheekOversluitenHypotheekLabel[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface HypotheekPand {
    pandId: string;
    readonly marktwaardeRenteBedrag: number | null;
    readonly bevoorschottingspercentage: number | null;
    marktwaardeLtvBedrag: number | null;
    readonly marktwaardeLtvBerekendBedrag: number | null;
    marktwaardeLtvOvernemen: boolean | null;
    gebruikPand: GebruikPandSoort | null;
    energieKlasse: EnergieKlasseType | null;
    readonly meerwerkEbvBedrag: number | null;
    readonly totaleHypotheekBedrag: number | null;
    bewoners: BewonersOpties | null;
}

export interface HypotheekPremie {
    premieduurInMaanden: number | null;
    readonly einddatumStortingen: string | null;
    premieduurHooglaagInMaanden: number | null;
    readonly einddatumStortingenHoogLaag: string | null;
    hooglaagVerhouding: number | null;
    betalingsTermijn: BetalingsTermijnType | null;
    premieBedrag: number | null;
    premieTotaalBedragLaag: number | null;
    premieTotaalBedragHoog: number | null;
    aanvangsstorting: number | null;
    premiedepot: HypotheekPremiedepot | null;
}

export interface HypotheekPremiedepot {
    uitgangspunt: PremiedepotUitgangspunt | null;
    opnameLagePremies: boolean | null;
    opnameHogePremies: boolean | null;
    opnameAanvangsstorting: boolean | null;
    opnameExtraStortingen: boolean | null;
    vergoeding: number | null;
    premiedepotBedrag: number | null;
    premiedepotDuurInMaanden: number | null;
}

export interface HypotheekProductwaarde {
    readonly waardeopbouwBedrag: number | null;
    waardeopbouwMaanden: WaardeopbouwInMaand[] | null;
}

export interface HypotheekRenteaftrek {
    renteaftrekId: string | null;
    volgnummer: number;
    bedrag: number | null;
    aanvangsdatum: string;
    einddatum: string;
}

export interface HypotheekRenteopslagMarktwaarde {
    marktwaardeTmPercentage: number;
    renteopslagPercentage: number | null;
}

export interface HypotheekVerklaringInkomen {
    werkgever: boolean;
    uwv: boolean;
    perspectief: boolean;
    accountantsverklaring: boolean;
    ibStukken: boolean;
}

export interface HypotheekVoorstel {
    hypotheeklabel: HypotheekHypotheeklabel | null;
    readonly totaleHypotheekBedrag: number | null;
    readonly gewensteHypotheekBedrag: number | null;
    readonly aanvangsdatum: string | null;
    soortFinanciering: Financieringsoort | null;
    readonly nhg: boolean | null;
    readonly eigenwoningschuldBedrag: number | null;
    readonly overbruggingBedrag: number | null;
    readonly kredietenBox1Bedrag: number | null;
    aanvrager1: KlantnaamReadOnly | null;
    aanvrager2: KlantnaamReadOnly | null;
    pand: HypotheekPand | null;
    fiscaleVoortzettingKeuzes: FiscaleVoortzettingKeuze[] | null;
    leningdelen: HypotheekVoorstelLeningdeel[] | null;
    verklaringInkomen: HypotheekVerklaringInkomen | null;
    readonly administratiekostenBedrag: number | null;
    readonly maatschappijCode: string | null;
    readonly productnaam: string | null;
}

export interface HypotheekVoorstelLeningdeel {
    doorlopend: boolean;
    readonly aanvangsdatum: string | null;
    readonly opgaveDatum: string | null;
    readonly klantIds: string[] | null;
    verzekeringnemerKlantIds: string[];
    verzekerdeKlantIds: string[];
    kapitaalopbouw: HypotheekKapitaalopbouw | null;
    overlijdensrisicoDekking: HypotheekOverlijdensrisicodekking | null;
    fiscaleRegeling: HypotheekFiscaleRegeling | null;
    premie: HypotheekPremie | null;
    hypotheekoptiesIngPriceTool: HypotheekoptiesIngLeningdeel | null;
    productwaarde: HypotheekProductwaarde | null;
    leningdeelId: string | null;
    volgnummer: number;
    meenemen: boolean;
    hypotheekvorm: Hypotheekvorm;
    maatschappijCodeHdn: string | null;
    maatschappijCode: string | null;
    maatschappijOmschrijving: string | null;
    productcode: number;
    leningdeelBedrag: number | null;
    aflossingBedrag: number | null;
    wijzeVanTerugbetaling: WijzeVanTerugbetalingType | null;
    rentevariant: RentevariantOptions;
    renteboxSoort: number | null;
    rentevastAantalMaanden: number | null;
    rentebedenktijdInMaanden: number | null;
    rentevastperiodeEinddatum: string | null;
    renteScenario: PercentageScenario | null;
    leningnummer: string | null;
    leningdeelnummer: string | null;
    looptijdInMaanden: number | null;
    uwBemiddeling: boolean;
    deelBox1Bedrag: number | null;
    consumptiefBedrag: number | null;
    automatischeRentedaling: HypotheekAutomatischeRentedaling | null;
    extraAflossingen: HypotheekExtraAflossing[] | null;
    renteaftrekken: HypotheekRenteaftrek[] | null;
}

export interface HypotheekVoorstelOutput {
    hypotheken: { [key: string]: HypotheekVoorstel; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface Hypotheekoptie {
    code: number;
    readonly omschrijving: string | null;
    readonly toelichting: string | null;
    readonly rentekortingPercentage: number | null;
    geselecteerd: boolean;
}

export interface HypotheekoptiesIngLeningdeel {
    readonly productnaam: string | null;
    doorlopendLeningdeelMeenemen: DoorlopendLeningdeelMeenemenOptions | null;
    loyaliteitsbonusBedrag: number | null;
    standaardRenteData: HypotheekoptiesIngRenteData | null;
    ltvData: HypotheekoptiesIngRenteData | null;
    dagrenteData: HypotheekoptiesIngRenteData | null;
    actieveBetaalrekeningData: HypotheekoptiesIngRenteData | null;
    loyaliteitsbonusData: HypotheekoptiesIngRenteData | null;
    teBetalenRenteData: HypotheekoptiesIngRenteData | null;
    optimalisatiemelding: string | null;
}

export interface HypotheekoptiesIngPriceTool {
    correlationId: string | null;
    dagrente: boolean;
    actieveBetaalrekening: boolean;
    loyaliteitsbonus: boolean;
    melding: string | null;
}

export interface HypotheekoptiesIngRenteData {
    percentage: number | null;
    melding: string | null;
}

export interface Hypotheeksamenstelling {
    leningdelen: HypotheeksamenstellingLeningdeel[] | null;
}

export interface HypotheeksamenstellingInput {
    maatschappijCode: string | null;
    hypotheeklabelCode: number;
}

export interface HypotheeksamenstellingLeningdeel {
    readonly matchHypotheekvormen: Hypotheekvorm[] | null;
    readonly nearMatchHypotheekvormen: Hypotheekvorm[] | null;
    huidigeHypotheekvorm: Hypotheekvorm | null;
    doorlopend: boolean;
    readonly aanvangsdatum: string | null;
    readonly opgaveDatum: string | null;
    readonly klantIds: string[] | null;
    verzekeringnemerKlantIds: string[];
    verzekerdeKlantIds: string[];
    kapitaalopbouw: HypotheekKapitaalopbouw | null;
    overlijdensrisicoDekking: HypotheekOverlijdensrisicodekking | null;
    fiscaleRegeling: HypotheekFiscaleRegeling | null;
    premie: HypotheekPremie | null;
    hypotheekoptiesIngPriceTool: HypotheekoptiesIngLeningdeel | null;
    productwaarde: HypotheekProductwaarde | null;
    leningdeelId: string | null;
    volgnummer: number;
    meenemen: boolean;
    hypotheekvorm: Hypotheekvorm;
    maatschappijCodeHdn: string | null;
    maatschappijCode: string | null;
    maatschappijOmschrijving: string | null;
    productcode: number;
    leningdeelBedrag: number | null;
    aflossingBedrag: number | null;
    wijzeVanTerugbetaling: WijzeVanTerugbetalingType | null;
    rentevariant: RentevariantOptions;
    renteboxSoort: number | null;
    rentevastAantalMaanden: number | null;
    rentebedenktijdInMaanden: number | null;
    rentevastperiodeEinddatum: string | null;
    renteScenario: PercentageScenario | null;
    leningnummer: string | null;
    leningdeelnummer: string | null;
    looptijdInMaanden: number | null;
    uwBemiddeling: boolean;
    deelBox1Bedrag: number | null;
    consumptiefBedrag: number | null;
    automatischeRentedaling: HypotheekAutomatischeRentedaling | null;
    extraAflossingen: HypotheekExtraAflossing[] | null;
    renteaftrekken: HypotheekRenteaftrek[] | null;
}

export interface HypotheeksamenstellingOutput {
    resultaat: Hypotheeksamenstelling | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface Hypotheekvorm {
    code: number;
    omschrijving: string | null;
    aflossingsvorm: AflossingsVormType | null;
    renteboxCode: number;
    starterslening: boolean;
    restschuldFinanciering: boolean;
    heeftLooptijdInMaanden: boolean;
}

/** Indexatiesoort Geen = 0, Uitkering = 1, VerzekerdBedrag = 2 */
export enum Indexatiesoort {
    Geen = "Geen",
    Uitkering = "Uitkering",
    VerzekerdBedrag = "VerzekerdBedrag",
}

/** IndicatieOptions Goedgekeurd = 1, Afgekeurd = 2, ValidatieNietMogelijk = 3 */
export enum IndicatieOptions {
    Goedgekeurd = "Goedgekeurd",
    Afgekeurd = "Afgekeurd",
    ValidatieNietMogelijk = "ValidatieNietMogelijk",
}

/** Inputmodel voor IgnPricetool */
export interface IngPriceInput {
    /** Dagrente optie. */
    dagrente: boolean;
    /** Actieve betaalrekening optie. */
    actieveBetaalrekening: boolean;
    /** Loyaliteitsbonus optie. */
    loyaliteitsbonus: boolean;
    /** Lijt met leningdeelgegevens */
    perLeningdelen: PerLeningdeel[] | null;
    /** Wel/geen NHG. */
    nhg: boolean;
    /** Marktwaarde bedrag */
    marktwaarde: number | null;
    /** Hypotheek bedrag. */
    hypotheekBedrag: number | null;
    /** Overbruggings bedrag. */
    overbruggingsBedrag: number | null;
}

/** Resultaat van de aanroep */
export interface IngPriceOutput {
    hypotheek: IngPricetoolHypotheek | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** IngPricetoll hypotheek gegevens */
export interface IngPricetoolHypotheek {
    /** Resultaat per leningdeel */
    leningdelenResult: LeningdelenResult[] | null;
    /** OverbruggingsRente */
    overbruggingsRente: string | null;
    /** Ongebruikt hoofdbedrag. */
    ongebruiktHoofdbedrag: string | null;
    errorMessages: ErrorMessageType[] | null;
}

/** Bevat de inhoud van het Adviesbox-form Inkomen & Fiscus. */
export interface InkomenFiscus {
    aanvrager1: InkomenFiscusAanvrager | null;
    aanvrager2: InkomenFiscusAanvrager | null;
    /** Indicatie dat sprake is van optimale fiscale verdeling */
    optimaleFiscaleVerdeling: boolean;
}

/** Bevat inkomensgegevens van de aanvrager (klant). */
export interface InkomenFiscusAanvrager {
    /** Unieke identificatie van de klant */
    klantId: string;
    aowData: AowData | null;
    fiscaleAftrekposten: FiscaleAftrekposten | null;
    fiscaleBijtelposten: FiscaleBijtelposten | null;
    heffingskortingen: Heffingskortingen | null;
    /** Geboortedatum */
    readonly geboortedatum: string | null;
    /** Percentage fiscale verdeling (alleen van belang wanneer de optimale fiscale verdeling niet berekend wordt) */
    fiscaleVerdelingPercentage: number | null;
    /** Indicatie dat aan de wekeneis (minstens 26 van de 36 weken gewerkt voor werkloosheid) is voldaan */
    wekenEis: boolean | null;
    /** Indicatieveld. Voldoet aan jareneis */
    jarenEis: boolean | null;
    /** Aantal jaar arbeidsverleden */
    arbeidsverledenInJaren: number | null;
    soortLoonverklaring: LoonverklaringOpties | null;
    /** Toetsinkomen UWV (bij Verklaring inkomen "UWV document")
Verdiencapaciteit (bij Verklaring inkomen "Arbeidmarktscan") */
    toetsinkomenUwv: number | null;
    /** Verdiencapaciteit score volgens de Arbeidsmarktscan */
    verdiencapaciteitScore: number | null;
    /** Rapportnummer van de arbeidsmarktscan */
    rapportnummer: string | null;
    /** De lijst met loondiensten (t.b.v. 'Bruto salaris uit dienstverband') */
    loondiensten: Loondienst[] | null;
    onderneming: Onderneming | null;
    overigeWerkzaamheden: Onderneming | null;
    aanmerkelijkBelang: Onderneming | null;
    teOntvangenAlimentatieExPartner: OverigeInkomstenBox1 | null;
    anwUitkering: OverigeInkomstenBox1 | null;
    wgaUitkering: OverigeInkomstenBox1 | null;
    ivaUitkering: OverigeInkomstenBox1 | null;
    wazUitkering: OverigeInkomstenBox1 | null;
    waoUitkeringTijdelijk: OverigeInkomstenBox1 | null;
    waoUitkeringBlijvend: OverigeInkomstenBox1 | null;
    wajongUitkering: OverigeInkomstenBox1 | null;
    wwUitkering: OverigeInkomstenBox1 | null;
    rwwUitkering: OverigeInkomstenBox1 | null;
    wachtgeld: OverigeInkomstenBox1 | null;
    /** Nabestaandenpensioen voor AOW */
    nabestaandenpensioenVooAow: number | null;
    /** Nabestaandenpensioen na AOW */
    nabestaandenpensioenNaAow: number | null;
    overigeInkomsten1: OverigeInkomstenBox1 | null;
    overigeInkomsten2: OverigeInkomstenBox1 | null;
    inkomstenBox3Verhuur: InkomstenBox3 | null;
    inkomstenBox3Beleggingen: InkomstenBox3 | null;
    /** Indicatie er één of meerdere loondiensten aanwezig zijn (t.b.v. 'Bruto salaris uit dienstverband') */
    heeftLoondienst: boolean;
    /** Indicatie er overige inkomsten box 1 aanwezig zijn */
    heeftOverigeInkomstenBox1: boolean;
    /** Indicatie er inkomsten box 3 aanwezig zijn */
    heeftInkomstenBox3: boolean;
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Inkomen & Fiscus. */
export interface InkomenFiscusOutput {
    /** Lijst met de inhoud van het scherm Inkomen & Fiscus per adviesdossier. */
    inkomenFiscusen: { [key: string]: InkomenFiscus; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface InkomenLoondienstInput {
    vebBedrag: number | null;
    provisieBedrag: number | null;
    onregelmatigheidstoeslagBedrag: number | null;
    vakantiegeldPercentage: number | null;
    maand13: boolean | null;
    gratificatieBedrag: number | null;
    overwerkBedrag: number | null;
    inkomstentoeslag: number | null;
    vastFlexibelBudgetBedrag: number | null;
}

/** De uitvoer van de inkomensperiode-berekening. */
export interface InkomenOutput {
    resultaat: BerekendResultaat | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** InkomenPeriode Geen = 0, PerJaar = 1, PerMaand = 12, Per4Weken = 13, PerWeek = 52 */
export enum InkomenPeriode {
    Geen = "Geen",
    PerJaar = "PerJaar",
    PerMaand = "PerMaand",
    Per4Weken = "Per4Weken",
    PerWeek = "PerWeek",
}

/** Gegevens van inkomensaanvulling bij overlijden. */
export interface InkomensaanvullingBijOverlijden {
    /** Het tarief dat gehanteerd wordt. */
    gehanteerdTariefPercentage: number | null;
    /** Het bedrag aan gewenste uitkering. */
    gewensteUitkeringBedrag: number | null;
    uitkeringstermijn: BetalingsTermijnType;
    /** Duur van de uitkering in maanden */
    readonly duurInMaanden: number | null;
}

/** Invoer voor de berekening van de duur in maanden van de inkomensaanvulling. */
export interface InkomensaanvullingDuurInMaandenInput {
    /** Het verzekerd bedrag */
    verzekerdBedrag: number;
    betalingsTermijn: BetalingsTermijnType;
    /** Het bedrag aan gewenste uitkering. */
    gewensteUitkeringBedrag: number | null;
    /** Het tarief dat gehanteerd wordt. */
    gehanteerdTariefPercentage: number | null;
}

/** Uitvoer van de berekening van de duur in maanden van de inkomensaanvulling. */
export interface InkomensaanvullingDuurInMaandenOutput {
    /** Berekende duur in maanden */
    readonly duurInMaanden: number | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** InkomenverklaringOpties Geen = 0, IbStukken = 1, Accountantsverklaring = 2 */
export enum InkomenverklaringOpties {
    Geen = "Geen",
    IbStukken = "IbStukken",
    Accountantsverklaring = "Accountantsverklaring",
}

/** Inkomsten box 3 van een persoon, voornamelijk uit verhuur en beleggingen. */
export interface InkomstenBox3 {
    /** Einddatum van de inkomsten */
    einddatum: string | null;
    /** Bedrag van de inkomsten */
    bedrag: number | null;
    /** Eindleeftijd wanneer de inkomsten overgaat op partner */
    overgangOpPartnerEindleeftijd: number | null;
    /** Datum per wanneer de inkomsten overgaat op partner */
    overgangOpPartnerEinddatum: string | null;
    /** Percentage van het bedrag dat overgaat op partner */
    overgangOpPartnerPercentage: number | null;
    /** Einde bij werkloosheid */
    eindeBijWw: boolean | null;
    /** Indicatie dat het resultaat bij arbeidsongeschiktheid afhankelijk is van de verdiencapaciteit */
    resultaatVdc: boolean | null;
    /** Einde bij arbeidsongeschiktheid */
    eindeBijAo: boolean | null;
    /** Indicatie dat de inkomsten bij overlijden overgaat op de partner */
    overgangOpPartner: boolean | null;
    /** Omschrijving inkomstenpost, soort OverigeInkomsten */
    omschrijving: string | null;
    /** Aantal maanden dat de inkomsten ontvangen worden */
    looptijdInMaanden: number | null;
    /** Bedrag bijtelling */
    fiscaalBedrag: number | null;
    soort: OverigeInkomstenBox3Soort;
    /** Volgnummer binnen de overige inkomsten van de klant. */
    volgnummer: number;
}

/** KapitaalopbouwOptions Box1 = 0, Box3 = 1, Box3TijdelijkVrijgesteld = 2 */
export enum KapitaalopbouwOptions {
    Box1 = "Box1",
    Box3 = "Box3",
    Box3TijdelijkVrijgesteld = "Box3TijdelijkVrijgesteld",
}

/** Bevat de gegevens van Adviesbox Form Kapitaalverzekering. */
export interface Kapitaalverzekering {
    /** De producten op het scherm */
    producten: KapitaalverzekeringProduct[];
    aanvrager1: KlantnaamReadOnly | null;
    aanvrager2: KlantnaamReadOnly | null;
    /** De af te lossen leningdelen van het voorstel. */
    readonly leningdelen: LeningdeelReadOnly[] | null;
    /** De af te lossen kredieten van het voorstel. */
    readonly kredieten: KredietReadOnly[] | null;
    /** De mogelijk fiscaal voort te zetten huidige dekkingen (kapitaalverzekeringen en vermogensrekeningen). */
    readonly dekkingen: DekkingReadOnly[] | null;
    /** De naam van de geldverstrekker die in het Form Hypotheek geselecteerd is. */
    readonly geldverstrekkerNaam: string | null;
    /** Ingangsdatum van het voorstel (of: 'Passeerdatum' wanneer er een hypotheek geadviseerd wordt) */
    readonly ingangsdatumVoorstel: string | null;
    /** Mogelijke keuzes indien er sprake is van fiscale voorzetting */
    readonly fiscaleVoortzettingKeuzes: FiscaleVoortzettingKeuze[] | null;
}

/** Invoer voor de berekening van een kapitaalverzekering. */
export interface KapitaalverzekeringBerekeningInput {
    kapitaalverzekeringProduct: KapitaalverzekeringProduct;
}

/** Het resultaat van de kapitaalverzekering-berekening. */
export interface KapitaalverzekeringBerekeningOutput {
    resultaat: KapitaalverzekeringBerekeningResultaat | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de berekende resultaten van de berekening. */
export interface KapitaalverzekeringBerekeningResultaat {
    /** Bedrag voor de (lage) beleggingsinleg of totaalpremie */
    readonly lagePremieBedrag: number | null;
    /** Bedrag voor de hoge beleggingsinleg of hoge totaalpremie */
    readonly hogePremieBedrag: number | null;
    /** Bedrag voor de aanvangsstorting (koopsom) */
    readonly aanvangsstortingBedrag: number | null;
    /** Rendement garantie- of voorbeeldkapitaal */
    readonly rendementPercentage: number | null;
    /** Waardeopbouw aan het einde van de dekking (ook wel: voorbeeldkapitaal) */
    readonly waardeopbouwBedrag: number | null;
    /** Waardeopbouw per jaar */
    readonly waardeopbouwJaren: WaardeopbouwInJaar[] | null;
    /** De berekende waardeopbouw per maand */
    readonly waardeopbouwMaanden: WaardeopbouwInMaand[] | null;
}

/** De gegevens van 'Extra premiestorting' voor een bepaald jaar. */
export interface KapitaalverzekeringExtraPremiestortingInJaar {
    jaar: number;
    bedrag: number;
}

/** Bevat gegevens van de fiscale regeling. */
export interface KapitaalverzekeringFiscaleRegeling {
    /** Polisnummer */
    polisnummer: string | null;
    orv: FiscalePlaatsingOrvOptions | null;
    /** Geeft aan of er sprake is van een lijfrenteclausule */
    lijfrenteclausule: boolean | null;
    kapitaalopbouw: KapitaalopbouwOptions | null;
    productId: string | null;
    fiscaleVoortzetting: FiscaleVoortzettingOptions | null;
    originelePolisnummer: string | null;
    externeMaatschappijCode: string | null;
    externeMaatschappijOmschrijving: string | null;
    lijfrenteclausuleOrigineel: boolean | null;
    fiscaleTypering: FiscaleTyperingOptions | null;
    garantieverzekering: boolean | null;
    fiscaalRegime: FiscaalRegimeOptions | null;
    oorspronkelijkeIngangsdatum: string | null;
    ingangsdatumBox1: string | null;
    einddatum: string | null;
    doelkapitaalBedrag: number | null;
    laagstePremieooitBedrag: number | null;
    hoogstePremieOoitBedrag: number | null;
    huidigeJaarPremieBedrag: number | null;
    premieLopendJaarBedrag: number | null;
    eerdereUitkeringenBedrag: number | null;
    ingebrachteWaardeBedrag: number | null;
}

/** Gegevens van 'Kapitaalopbouw'. */
export interface KapitaalverzekeringKapitaalopbouw {
    soortRekening: SoortKapitaalverzekeringsrekeningOptions | null;
    soortBerekening: SoortBerekeningOptionsKv | null;
    /** Doelkapitaal */
    doelkapitaalBedrag: number | null;
    /** Rendement doelkapitaal */
    doelrendementPercentage: number | null;
    /** Voorbeeldkapitaal */
    voorbeeldkapitaalBedrag: number | null;
    /** Rendement voorbeeldkapitaal */
    voorbeeldrendementPercentage: number | null;
    /** Garantiekapitaal / waarvan gegarandeerd */
    garantiekapitaalBedrag: number | null;
    /** Rendement garantiekapitaal / waarvan gegarandeerd */
    garantierendementPercentage: number | null;
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Kapitaalverzekering (zowel huidige situatie als voorstel). */
export interface KapitaalverzekeringOutput {
    /** Lijst met in houd van het scherm Kapitaalverzekering per adviesdossier (huidige situatie) of voorstel. */
    kapitaalverzekeringen: { [key: string]: Kapitaalverzekering; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Gegevens van 'Overlijdensrisicodekking'. */
export interface KapitaalverzekeringOverlijdensrisicodekking {
    basisdekking: BasisdekkingOptions;
    /** Verzekerd kapitaal */
    verzekerdKapitaalBedrag: number | null;
    soortRisicodekking: OrvUitkeringssoortOptions | null;
    /** Het annuïteitspercentage */
    annuiteitsPercentage: number | null;
    /** Dekking daalt tot */
    dekkingDaaltTotBedrag: number | null;
    /** Duur daling in jaren */
    duurdalingInJaren: number | null;
    /** Percentage waarde */
    waardePercentage: number | null;
    partnerrente: KapitaalverzekeringPartnerrente | null;
}

/** Bevat gegevens van Partnerrente. */
export interface KapitaalverzekeringPartnerrente {
    /** Partnerrente per jaar */
    partnerrentePerJaarBedrag: number;
    /** Levenslang */
    levenslang: boolean;
    /** Maximale duur rente in jaren */
    maxDuurInJaren: number | null;
    /** Direct ingaande rente */
    directIngaandeRente: boolean;
    /** Uitsteldatum */
    uitsteldatum: string | null;
}

/** Gegevens van een Kapitaalverzekering-polis. */
export interface KapitaalverzekeringPolis {
    productnummer: string | null;
    maatschappijCode: string | null;
    maatschappijOmschrijving: string | null;
    maatschappijCodeHdn: string | null;
    productnaam: string | null;
    productcode: number;
    ingangsdatum: string;
    looptijdInMaanden: number | null;
    uwBemiddeling: boolean;
}

/** Gegevens van 'Poliswaarde'. */
export interface KapitaalverzekeringPoliswaarde {
    /** Reeds opgebouwd */
    reedsOpgebouwdBedrag: number | null;
    /** Reeds opgebouwd per datum */
    reedsOpgebouwdDatum: string | null;
    /** Afkoopwaarde */
    afkoopwaardeBedrag: number | null;
    /** Afkoopwaarde per datum */
    afkoopwaardeDatum: string | null;
    /** Waardeopbouw (na x jaar) */
    readonly waardeopbouwBedrag: number | null;
    /** Waardeopbouw per jaar */
    readonly waardeopbouwJaren: WaardeopbouwInJaar[] | null;
    /** De berekende waardeopbouw per maand */
    waardeopbouwMaanden: WaardeopbouwInMaand[] | null;
}

/** De premiegegevens van een premie-/inlegdepot */
export interface KapitaalverzekeringPremiedepot {
    uitgangspunt: PremiedepotUitgangspunt | null;
    opnameLagePremies: boolean | null;
    opnameHogePremies: boolean | null;
    opnameAanvangsstorting: boolean | null;
    opnameExtraStortingen: boolean | null;
    vergoeding: number | null;
    premiedepotBedrag: number | null;
    premiedepotDuurInMaanden: number | null;
}

/** Gegevens van 'Premiegegevens'. */
export interface KapitaalverzekeringPremiegegevens {
    /** Het aantal maanden dat inleg betaald moet worden */
    duurInMaanden: number | null;
    /** Het aantal maanden dat inleg betaald moet worden in de hooglaag-constructie */
    duurHooglaagInMaanden: number | null;
    /** Hoog/laag verhouding 1: ... */
    hooglaagVerhouding: number | null;
    betalingstermijn: BetalingsTermijnType | null;
    /** Bedrag voor de (lage) beleggingsinleg */
    beleggingsinlegBedrag: number | null;
    /** Bedrag voor de hoge beleggingsinleg */
    hogeBeleggingsinlegBedrag: number | null;
    /** Bedrag voor de (lage) risicopremie */
    risicopremieBedrag: number | null;
    /** Bedrag voor de hoge risicopremie */
    hogeRisicopremieBedrag: number | null;
    /** Bedrag voor de (lage) totaalpremie */
    totaalPremieBedrag: number | null;
    /** Bedrag voor de hoge totaalpremie */
    hogeTotaalPremieBedrag: number | null;
    /** Bedrag voor de aanvangsstorting */
    aanvangsstortingBedrag: number | null;
    /** Het aftrekbare deel van de premie */
    premieAftrekbaarBedrag: number | null;
    /** Het aftrekbare deel van de aanvangsstorting */
    aanvangsstortingAftrekbaarBedrag: number | null;
    /** Extra premiestorting per jaar */
    extraPremiestortingJaren: KapitaalverzekeringExtraPremiestortingInJaar[] | null;
    premiedepot: KapitaalverzekeringPremiedepot | null;
}

/** Bevat de gegevens van het Kapitaalverzekering-product. */
export interface KapitaalverzekeringProduct {
    soortProduct: SoortKapitaalverzekeringProductOptions;
    /** Geeft aan of het om een doorlopend product gaat */
    readonly doorlopend: boolean | null;
    polis: KapitaalverzekeringPolis;
    /** Unieke identificaties van de klanten die als verzekeringnemer geselecteerd zijn */
    verzekeringnemerKlantIds: string[];
    /** Unieke identificaties van de klanten die als verzekerde geselecteerd zijn */
    verzekerdeKlantIds: string[];
    /** Geeft aan of er gebruik gemaakt wordt van premiesplitsing. */
    premiesplitsing: boolean | null;
    poliswaarde: KapitaalverzekeringPoliswaarde | null;
    premiegegevens: KapitaalverzekeringPremiegegevens | null;
    kapitaalopbouw: KapitaalverzekeringKapitaalopbouw | null;
    verzekerde1Overlijdensrisicodekking: KapitaalverzekeringOverlijdensrisicodekking | null;
    verzekerde2Overlijdensrisicodekking: KapitaalverzekeringOverlijdensrisicodekking | null;
    fiscaleRegeling: KapitaalverzekeringFiscaleRegeling | null;
    verpanding: KapitaalverzekeringVerpanding | null;
    /** Indicatie dat indien het doorlopende product gewijzigd is, deze opnieuw overgenomen moet worden naar de voorstellen */
    wijzigingenInDoorlopendeProductenOvernemen: boolean;
    productId: string | null;
    meenemen: boolean;
}

/** De verpanding van een Kapitaalverzekeringsproduct. */
export interface KapitaalverzekeringVerpanding {
    uitkerendeFase: UitkerendeFase | null;
    verpandAanGeldverstrekker: boolean | null;
    bedoeldVoorAflossing: boolean | null;
    aflosproducten: Aflosproduct[] | null;
}

/** Bevat gegevens van een klant. */
export interface KlantDetails {
    /** Volgnummer van de klant binnen de klantsamenstelling. */
    volgnummer: number;
    /** Indicatie of klant gescheiden is */
    gescheiden: boolean;
    /** Datum gescheiden */
    gescheidenPerDatum: string | null;
    /** Legitimatiebewijs code volgens de HDN keuzelijst LegitimatieSoortType */
    legitimatiebewijsSoort: string | null;
    /** Nummer legitimatiebewijs */
    legitimatiebewijsNummer: string | null;
    /** Geldigheidsdatum legitimatiebewijs */
    legitimatiebewijsGeldTotDatum: string | null;
    /** Indicatieveld. Is aanvrager hoofdelijk aansprakelijk */
    hoofdelijkAansprakelijk: boolean;
    /** Hoogst genoten opleiding van de aanvrager volgens de HDN Keuzelijst OpleidingsNiveauType */
    opleidingsNiveau: number | null;
    /** Datum afgifte legitimatiebewijs */
    legitimatiebewijsAfgiftedatum: string | null;
    /** Plaats afgifte legitimatiebewijs */
    legitimatiebewijsAfgifteplaats: string | null;
    /** Geldigheidsdatum verblijfsvergunning */
    verblijfsvergunningGeldigTotDatum: string | null;
    /** Nummer verblijfsvergunning */
    verblijfsvergunningNummer: string | null;
    verblijfsvergunningCode: VerblijfsVergunningType | null;
    /** HDN code van de voortitel die een klant evt. heeft volgens de HDN keuzelijst VoortitelType */
    titel: number | null;
    /** Roker */
    roken: boolean;
    /** Code burgerlijke staat volgens de HDN keuzelijst BurgerlijkeStaatType */
    burgerlijkeStaat: number;
    /** Legitimatie land (code) */
    legitimatieLandCode: string | null;
    /** Code van het soort partnerschap dat ontbonden is bij een scheiding */
    gescheidenPartnerschap: number | null;
    /** Fiscale woonstaat (code) */
    fiscaleWoonstaatCode: string | null;
}

export interface KlantgegevensReadOnly {
    readonly straat: string | null;
    readonly huisnummer: number | null;
    readonly toevoeging: string | null;
    readonly postcode: string | null;
    readonly plaats: string | null;
    readonly telefoonWerk: string | null;
    readonly telefoonMobiel: string | null;
    readonly telefoonPrive: string | null;
    readonly email: string | null;
    klantId: string;
    readonly achternaam: string | null;
    readonly voorvoegsel: string | null;
    readonly voorletters: string | null;
    readonly voornamen: string | null;
    geslacht: GeslachtOpties | null;
    readonly roker: boolean | null;
    readonly geboortedatum: string | null;
    readonly aowdatum: string | null;
}

export interface KlantnaamReadOnly {
    klantId: string;
    readonly achternaam: string | null;
    readonly voorvoegsel: string | null;
    readonly voorletters: string | null;
    readonly voornamen: string | null;
    geslacht: GeslachtOpties | null;
    readonly roker: boolean | null;
    readonly geboortedatum: string | null;
    readonly aowdatum: string | null;
}

/** Bevat de inhoud van het Adviesbox-form Klantprofiel (onderwerp). */
export interface Klantprofiel {
    /** De vragen van het gevraagde klantprofiel-onderwerp */
    vragen: KlantprofielVraag[];
    aanvrager1: KlantnaamReadOnly | null;
    aanvrager2: KlantnaamReadOnly | null;
    /** Indicatie dat er in het adviesdossier een Adviesbox Classic klantprofiel opgeslagen is */
    heeftKlantprofielAbc: boolean;
}

/** Bevat de inhoud van het Adviesbox Classic klantprofiel. */
export interface KlantprofielAbc {
    /** De categorieën van het Adviesbox Classic klantprofiel (read-only) met onderliggende onderwerpen en vragen */
    readonly categorieen: KlantprofielCategorieAbc[] | null;
}

/** Output voor het opvragen van de inhoud van het Adviesbox Classic klantprofiel. */
export interface KlantprofielAbcOutput {
    /** Lijst met Adviesbox Classic klantprofielen per adviesdossier. */
    klantprofielen: { [key: string]: KlantprofielAbc; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de gegevens van een klantprofiel-antwoord t.b.v. het Adviesbox-form Klantprofiel. */
export interface KlantprofielAntwoord {
    /** Code van het klantprofiel-antwoord */
    code: number;
    /** Omschrijving van de klantprofiel-antwoord */
    readonly omschrijving: string | null;
    /** Waarde van het (1e deel van het) antwoord */
    waarde1: any | null;
    /** Waarde van het 2e deel van het antwoord, indien van toepassing */
    waarde2: any | null;
    /** Waarde van het 3e deel van het antwoord, indien van toepassing */
    waarde3: any | null;
}

/** Bevat de gegevens van een ABC klantprofiel-antwoord t.b.v. het Adviesbox-form Klantprofiel. */
export interface KlantprofielAntwoordAbc {
    /** Code van het klantprofiel-antwoord */
    code: number;
    /** Omschrijving van het klantprofiel-antwoord */
    readonly omschrijving: string | null;
}

/** Bevat de inhoud van een Adviesbox Classic klantprofiel-categorie. */
export interface KlantprofielCategorieAbc {
    /** Code van de klantprofiel-categorie */
    code: number;
    /** Omschrijving van de categorie */
    omschrijving: string | null;
    /** Lijst met onderwerpen (read-only) behorend bij de klantprofiel-categorie */
    readonly onderwerpen: KlantprofielOnderwerpAbc[] | null;
}

/** Bevat de inhoud van een Adviesbox Classic klantprofiel-onderwerp. */
export interface KlantprofielOnderwerpAbc {
    /** Code van het klantprofiel-onderwerp */
    code: number;
    /** Omschrijving van het onderwerp */
    readonly omschrijving: string | null;
    /** Lijst met vragen (read-only) en bijbehorende antwoorden behorend bij het klantprofiel-onderwerp. */
    readonly vragen: KlantprofielVraagAbc[] | null;
    /** Toelichting (indien van toepassing) */
    readonly toelichting: string | null;
}

/** KlantprofielOnderwerpOptions AlgemeenDoelstelling = 1, AlgemeenToekomstperspectief = 2, AlgemeenRisicoEnKennis = 3, HypotheekAlgemeen = 4, HypotheekVerduurzaming = 5, HypotheekVerantwoordeWoonlasten = 6, HypotheekEigenGeld = 7, HypotheekDubbeleWoonlasten = 8, HypotheekFiscaal = 9, HypotheekHypotheekvorm = 10, HypotheekRentevastperiode = 11, HypotheekGeldverstrekker = 12, RisicosOverlijden = 13, RisicosArbeidsongeschiktheid = 14, RisicosWerkloosheid = 15, RisicosPensioen = 16, VermogensopbouwOpbouwDoelvermogen = 17, VermogensopbouwRisicoprofiel = 18 */
export enum KlantprofielOnderwerpOptions {
    AlgemeenDoelstelling = "AlgemeenDoelstelling",
    AlgemeenToekomstperspectief = "AlgemeenToekomstperspectief",
    AlgemeenRisicoEnKennis = "AlgemeenRisicoEnKennis",
    HypotheekAlgemeen = "HypotheekAlgemeen",
    HypotheekVerduurzaming = "HypotheekVerduurzaming",
    HypotheekVerantwoordeWoonlasten = "HypotheekVerantwoordeWoonlasten",
    HypotheekEigenGeld = "HypotheekEigenGeld",
    HypotheekDubbeleWoonlasten = "HypotheekDubbeleWoonlasten",
    HypotheekFiscaal = "HypotheekFiscaal",
    HypotheekHypotheekvorm = "HypotheekHypotheekvorm",
    HypotheekRentevastperiode = "HypotheekRentevastperiode",
    HypotheekGeldverstrekker = "HypotheekGeldverstrekker",
    RisicosOverlijden = "RisicosOverlijden",
    RisicosArbeidsongeschiktheid = "RisicosArbeidsongeschiktheid",
    RisicosWerkloosheid = "RisicosWerkloosheid",
    RisicosPensioen = "RisicosPensioen",
    VermogensopbouwOpbouwDoelvermogen = "VermogensopbouwOpbouwDoelvermogen",
    VermogensopbouwRisicoprofiel = "VermogensopbouwRisicoprofiel",
}

/** KlantprofielOnderwerpStatusOptions NietIngevuld = 1, Onvolledig = 2, Volledig = 3 */
export enum KlantprofielOnderwerpStatusOptions {
    NietIngevuld = "NietIngevuld",
    Onvolledig = "Onvolledig",
    Volledig = "Volledig",
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Klantprofiel (onderwerp). */
export interface KlantprofielOutput {
    /** Lijst met klantprofielen per adviesdossier. */
    klantprofielen: { [key: string]: Klantprofiel; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de gegevens van een klantprofiel-vraag t.b.v. het Adviesbox-form Klantprofiel. */
export interface KlantprofielVraag {
    code: KlantprofielVraagOptions;
    /** Omschrijving van de klantprofiel-vraag */
    readonly omschrijving: string | null;
    /** De antwoorden/het antwoord bij de klantprofiel-vraag */
    antwoorden: KlantprofielAntwoord[];
    /** Toelichting (indien van toepassing) */
    toelichting: string | null;
}

/** Bevat de gegevens van een ABC klantprofiel-vraag t.b.v. het Adviesbox-form Klantprofiel. */
export interface KlantprofielVraagAbc {
    /** Code van de klantprofiel-vraag */
    code: number;
    /** Omschrijving van de klantprofiel-vraag */
    readonly omschrijving: string | null;
    /** Lijst met antwoorden (read-only) behorend bij de klantprofiel-vraag. */
    readonly antwoorden: KlantprofielAntwoordAbc[] | null;
}

/** KlantprofielVraagOptions FinancieleDoelen = 101, VerwachteInkomensontwikkelingAanvrager1 = 201, VerwachteInkomensontwikkelingAanvrager2 = 202, WaaromZalInkomenStijgenAanvrager1 = 203, WaaromZalInkomenStijgenAanvrager2 = 204, WaaromZalInkomenDalenAanvrager1 = 205, WaaromZalInkomenDalenAanvrager2 = 206, WanneerStoppenMetWerkenAanvrager1 = 207, WanneerStoppenMetWerkenAanvrager2 = 208, WijzigingGezinssituatieVerwacht = 209, HoelangBlijvenWonen = 210, FinancieleMeevallerVerwacht = 211, GroteUitgavenVerwacht = 212, KennisFinancieelEnErvaring = 301, KennisFinancieleProducten = 302, KennisFiscaleSocialeWetgeving = 303, KennisFinancieelAdvies = 304, WelkeMateFinancieleRisicos = 305, GeldVoorFinancieleTegenvallers = 306, HoeveelGeldVoorFinancieleTegenvallers = 307, WatSpreektMeesteAanRisico = 308, WensenDoelstellingenHypotheek = 401, KennisHypothekenAlgemeen = 402, KennisHypothekenHypotheekvormen = 403, KennisHypothekenNhg = 404, KennisHypothekenFiscaliteit = 405, KennisRisicosRestschuld = 406, KennisRentewijzigingen = 407, KennisInkomstendaling = 408, KennisDubbeleWoonlasten = 409, KennisHypothekenVerduurzaming = 501, KennisHypothekenEnergiebesparendeMaatregelen = 502, KennisHypothekenBesparingen = 503, KennisHypothekenFinancieringsmogelijkheden = 504, InteresseVerduurzamenWoning = 505, VoornaamsteRedenVerduurzamenWoning = 506, FinancierenVerduurzamenWoning = 507, WensenMbtVerantwoordeWoonlasten = 601, HoeveelSparenPerMaand = 602, HoeveelEigenGeldBeschikbaar = 701, HoeveelEigenGeldInbrengen = 702, HoeveelGeldOverhouden = 703, WaarvoorEigenGeldGebruiken = 704, KrijgtTeMakenDubbeleWoonlasten = 801, HoeLangDubbeleWoonlasten = 802, HoeDubbeleWoonlastenBetalen = 803, WensFiscaleAftrekHypotheek = 901, WensAflossenHypotheek = 1001, VanPlanTussentijdsAflossen = 1002, DoelExtraAflossen = 1003, BereidRisicoRentestijging = 1101, HoelangVastzettenHypotheekrente = 1102, VoornaamsteRedenVastzettenHypotheekrente = 1103, HoeStijgingMaandlastenOpvangen = 1104, VoorkeurGeldverstrekker = 1201, GeldverstrekkerVoorwaardenBelangrijk = 1202, KennisInkomenssituatieNaOvl = 1301, KennisOrv = 1302, KennisNabestaandenvoorzieningPensioenregeling = 1303, KennisNabestaandenvoorzieningAnw = 1304, KennisNabestaandenvoorzieningUitkering = 1305, WensMaatregelenOvlAanvrager1 = 1306, WensMaatregelenOvlAanvrager2 = 1307, VerzorgdAchterlaten = 1308, MaatregelenFinancieleGevolgenOvl = 1309, NabestaandenUitgavenBeperken = 1310, WelkeUitgavenBeperkenOvl = 1311, KennisInkomenssituatieNaAo = 1401, KennisAoVerzekeringen = 1402, KennisAoVoorzieningWerkgever = 1403, KennisAoVoorzieningWia = 1404, WensMaatregelenAoAanvrager1 = 1405, WensMaatregelenAoAanvrager2 = 1406, WaarvoorInkomensaanvullingAo = 1407, HoelangInkomensaanvullingAo = 1408, MaatregelenFinancieleGevolgenAo = 1409, UitgavenBeperkenAo = 1410, WelkeUitgavenBeperkenAo = 1411, KennisInkomenssituatieNaWw = 1501, KennisWwVerzekeringen = 1502, KennisWwVoorziening = 1503, WensMaatregelenWwAanvrager1 = 1504, WensMaatregelenWwAanvrager2 = 1505, WaarvoorInkomensaanvullingWw = 1506, HoelangInkomensaanvullingWw = 1507, HoeveelTijdNieuweBaanAanvrager1 = 1508, HoeveelTijdNieuweBaanAanvrager2 = 1509, MaatregelenFinancieleGevolgenWw = 1510, UitgavenBeperkenWw = 1511, WelkeUitgavenBeperkenWw = 1512, KennisInkomenssituatiePensioen = 1601, KennisPensioenWerkgever = 1602, KennisPensioenAow = 1603, KennisPensioenLijfrente = 1604, KennisPensioenVermogen = 1605, MaatregelenPensioenAanvrager1 = 1606, MaatregelenPensioenAanvrager2 = 1607, MaatregelenGevolgenPensioenBeperken = 1608, UitgavenLagerPensioenInkomenBeperken = 1609, WelkeUitgavenBeperkenPensioen = 1610, WaarvoorInkomenVermogenOpzijZetten = 1611, KennisSparenBeleggenAlgemeen = 1701, KennisOntwikkelingenFinancieleMarkt = 1702, KennisBeleggingsfondsen = 1703, KennisZelfHandelen = 1704, KennisVermogensbeheer = 1705, KennisSparenSpaarrekening = 1706, KennisSparenVerzekering = 1707, BelangrijksteSpaarBeleggingsdoel = 1708, BereidRisicoLagerDoelvermogen = 1709, HoeDoelvermogenBereiken = 1710, BelangrijksteBronInkomen = 1801, LevensonderhoudReguliereInkomsten = 1802, WelkDeelVermogenBeleggen = 1803, ErvaringBeleggenAandelenObligaties = 1804, KennisBeleggenAandelenObligaties = 1805, BeleggingsgedragVolgensStelling = 1806, AlsWaardeVermogenAanzienlijkDaalt = 1807, RisicoLopenVermogensopbouw = 1808, HoeBelangrijkBereikenDoel = 1809 */
export enum KlantprofielVraagOptions {
    FinancieleDoelen = "FinancieleDoelen",
    VerwachteInkomensontwikkelingAanvrager1 = "VerwachteInkomensontwikkelingAanvrager1",
    VerwachteInkomensontwikkelingAanvrager2 = "VerwachteInkomensontwikkelingAanvrager2",
    WaaromZalInkomenStijgenAanvrager1 = "WaaromZalInkomenStijgenAanvrager1",
    WaaromZalInkomenStijgenAanvrager2 = "WaaromZalInkomenStijgenAanvrager2",
    WaaromZalInkomenDalenAanvrager1 = "WaaromZalInkomenDalenAanvrager1",
    WaaromZalInkomenDalenAanvrager2 = "WaaromZalInkomenDalenAanvrager2",
    WanneerStoppenMetWerkenAanvrager1 = "WanneerStoppenMetWerkenAanvrager1",
    WanneerStoppenMetWerkenAanvrager2 = "WanneerStoppenMetWerkenAanvrager2",
    WijzigingGezinssituatieVerwacht = "WijzigingGezinssituatieVerwacht",
    HoelangBlijvenWonen = "HoelangBlijvenWonen",
    FinancieleMeevallerVerwacht = "FinancieleMeevallerVerwacht",
    GroteUitgavenVerwacht = "GroteUitgavenVerwacht",
    KennisFinancieelEnErvaring = "KennisFinancieelEnErvaring",
    KennisFinancieleProducten = "KennisFinancieleProducten",
    KennisFiscaleSocialeWetgeving = "KennisFiscaleSocialeWetgeving",
    KennisFinancieelAdvies = "KennisFinancieelAdvies",
    WelkeMateFinancieleRisicos = "WelkeMateFinancieleRisicos",
    GeldVoorFinancieleTegenvallers = "GeldVoorFinancieleTegenvallers",
    HoeveelGeldVoorFinancieleTegenvallers = "HoeveelGeldVoorFinancieleTegenvallers",
    WatSpreektMeesteAanRisico = "WatSpreektMeesteAanRisico",
    WensenDoelstellingenHypotheek = "WensenDoelstellingenHypotheek",
    KennisHypothekenAlgemeen = "KennisHypothekenAlgemeen",
    KennisHypothekenHypotheekvormen = "KennisHypothekenHypotheekvormen",
    KennisHypothekenNhg = "KennisHypothekenNhg",
    KennisHypothekenFiscaliteit = "KennisHypothekenFiscaliteit",
    KennisRisicosRestschuld = "KennisRisicosRestschuld",
    KennisRentewijzigingen = "KennisRentewijzigingen",
    KennisInkomstendaling = "KennisInkomstendaling",
    KennisDubbeleWoonlasten = "KennisDubbeleWoonlasten",
    KennisHypothekenVerduurzaming = "KennisHypothekenVerduurzaming",
    KennisHypothekenEnergiebesparendeMaatregelen = "KennisHypothekenEnergiebesparendeMaatregelen",
    KennisHypothekenBesparingen = "KennisHypothekenBesparingen",
    KennisHypothekenFinancieringsmogelijkheden = "KennisHypothekenFinancieringsmogelijkheden",
    InteresseVerduurzamenWoning = "InteresseVerduurzamenWoning",
    VoornaamsteRedenVerduurzamenWoning = "VoornaamsteRedenVerduurzamenWoning",
    FinancierenVerduurzamenWoning = "FinancierenVerduurzamenWoning",
    WensenMbtVerantwoordeWoonlasten = "WensenMbtVerantwoordeWoonlasten",
    HoeveelSparenPerMaand = "HoeveelSparenPerMaand",
    HoeveelEigenGeldBeschikbaar = "HoeveelEigenGeldBeschikbaar",
    HoeveelEigenGeldInbrengen = "HoeveelEigenGeldInbrengen",
    HoeveelGeldOverhouden = "HoeveelGeldOverhouden",
    WaarvoorEigenGeldGebruiken = "WaarvoorEigenGeldGebruiken",
    KrijgtTeMakenDubbeleWoonlasten = "KrijgtTeMakenDubbeleWoonlasten",
    HoeLangDubbeleWoonlasten = "HoeLangDubbeleWoonlasten",
    HoeDubbeleWoonlastenBetalen = "HoeDubbeleWoonlastenBetalen",
    WensFiscaleAftrekHypotheek = "WensFiscaleAftrekHypotheek",
    WensAflossenHypotheek = "WensAflossenHypotheek",
    VanPlanTussentijdsAflossen = "VanPlanTussentijdsAflossen",
    DoelExtraAflossen = "DoelExtraAflossen",
    BereidRisicoRentestijging = "BereidRisicoRentestijging",
    HoelangVastzettenHypotheekrente = "HoelangVastzettenHypotheekrente",
    VoornaamsteRedenVastzettenHypotheekrente = "VoornaamsteRedenVastzettenHypotheekrente",
    HoeStijgingMaandlastenOpvangen = "HoeStijgingMaandlastenOpvangen",
    VoorkeurGeldverstrekker = "VoorkeurGeldverstrekker",
    GeldverstrekkerVoorwaardenBelangrijk = "GeldverstrekkerVoorwaardenBelangrijk",
    KennisInkomenssituatieNaOvl = "KennisInkomenssituatieNaOvl",
    KennisOrv = "KennisOrv",
    KennisNabestaandenvoorzieningPensioenregeling = "KennisNabestaandenvoorzieningPensioenregeling",
    KennisNabestaandenvoorzieningAnw = "KennisNabestaandenvoorzieningAnw",
    KennisNabestaandenvoorzieningUitkering = "KennisNabestaandenvoorzieningUitkering",
    WensMaatregelenOvlAanvrager1 = "WensMaatregelenOvlAanvrager1",
    WensMaatregelenOvlAanvrager2 = "WensMaatregelenOvlAanvrager2",
    VerzorgdAchterlaten = "VerzorgdAchterlaten",
    MaatregelenFinancieleGevolgenOvl = "MaatregelenFinancieleGevolgenOvl",
    NabestaandenUitgavenBeperken = "NabestaandenUitgavenBeperken",
    WelkeUitgavenBeperkenOvl = "WelkeUitgavenBeperkenOvl",
    KennisInkomenssituatieNaAo = "KennisInkomenssituatieNaAo",
    KennisAoVerzekeringen = "KennisAoVerzekeringen",
    KennisAoVoorzieningWerkgever = "KennisAoVoorzieningWerkgever",
    KennisAoVoorzieningWia = "KennisAoVoorzieningWia",
    WensMaatregelenAoAanvrager1 = "WensMaatregelenAoAanvrager1",
    WensMaatregelenAoAanvrager2 = "WensMaatregelenAoAanvrager2",
    WaarvoorInkomensaanvullingAo = "WaarvoorInkomensaanvullingAo",
    HoelangInkomensaanvullingAo = "HoelangInkomensaanvullingAo",
    MaatregelenFinancieleGevolgenAo = "MaatregelenFinancieleGevolgenAo",
    UitgavenBeperkenAo = "UitgavenBeperkenAo",
    WelkeUitgavenBeperkenAo = "WelkeUitgavenBeperkenAo",
    KennisInkomenssituatieNaWw = "KennisInkomenssituatieNaWw",
    KennisWwVerzekeringen = "KennisWwVerzekeringen",
    KennisWwVoorziening = "KennisWwVoorziening",
    WensMaatregelenWwAanvrager1 = "WensMaatregelenWwAanvrager1",
    WensMaatregelenWwAanvrager2 = "WensMaatregelenWwAanvrager2",
    WaarvoorInkomensaanvullingWw = "WaarvoorInkomensaanvullingWw",
    HoelangInkomensaanvullingWw = "HoelangInkomensaanvullingWw",
    HoeveelTijdNieuweBaanAanvrager1 = "HoeveelTijdNieuweBaanAanvrager1",
    HoeveelTijdNieuweBaanAanvrager2 = "HoeveelTijdNieuweBaanAanvrager2",
    MaatregelenFinancieleGevolgenWw = "MaatregelenFinancieleGevolgenWw",
    UitgavenBeperkenWw = "UitgavenBeperkenWw",
    WelkeUitgavenBeperkenWw = "WelkeUitgavenBeperkenWw",
    KennisInkomenssituatiePensioen = "KennisInkomenssituatiePensioen",
    KennisPensioenWerkgever = "KennisPensioenWerkgever",
    KennisPensioenAow = "KennisPensioenAow",
    KennisPensioenLijfrente = "KennisPensioenLijfrente",
    KennisPensioenVermogen = "KennisPensioenVermogen",
    MaatregelenPensioenAanvrager1 = "MaatregelenPensioenAanvrager1",
    MaatregelenPensioenAanvrager2 = "MaatregelenPensioenAanvrager2",
    MaatregelenGevolgenPensioenBeperken = "MaatregelenGevolgenPensioenBeperken",
    UitgavenLagerPensioenInkomenBeperken = "UitgavenLagerPensioenInkomenBeperken",
    WelkeUitgavenBeperkenPensioen = "WelkeUitgavenBeperkenPensioen",
    WaarvoorInkomenVermogenOpzijZetten = "WaarvoorInkomenVermogenOpzijZetten",
    KennisSparenBeleggenAlgemeen = "KennisSparenBeleggenAlgemeen",
    KennisOntwikkelingenFinancieleMarkt = "KennisOntwikkelingenFinancieleMarkt",
    KennisBeleggingsfondsen = "KennisBeleggingsfondsen",
    KennisZelfHandelen = "KennisZelfHandelen",
    KennisVermogensbeheer = "KennisVermogensbeheer",
    KennisSparenSpaarrekening = "KennisSparenSpaarrekening",
    KennisSparenVerzekering = "KennisSparenVerzekering",
    BelangrijksteSpaarBeleggingsdoel = "BelangrijksteSpaarBeleggingsdoel",
    BereidRisicoLagerDoelvermogen = "BereidRisicoLagerDoelvermogen",
    HoeDoelvermogenBereiken = "HoeDoelvermogenBereiken",
    BelangrijksteBronInkomen = "BelangrijksteBronInkomen",
    LevensonderhoudReguliereInkomsten = "LevensonderhoudReguliereInkomsten",
    WelkDeelVermogenBeleggen = "WelkDeelVermogenBeleggen",
    ErvaringBeleggenAandelenObligaties = "ErvaringBeleggenAandelenObligaties",
    KennisBeleggenAandelenObligaties = "KennisBeleggenAandelenObligaties",
    BeleggingsgedragVolgensStelling = "BeleggingsgedragVolgensStelling",
    AlsWaardeVermogenAanzienlijkDaalt = "AlsWaardeVermogenAanzienlijkDaalt",
    RisicoLopenVermogensopbouw = "RisicoLopenVermogensopbouw",
    HoeBelangrijkBereikenDoel = "HoeBelangrijkBereikenDoel",
}

/** Bevat de gegevens van Adviesbox Form Krediet. */
export interface Krediet {
    /** De producten op het scherm */
    producten: KredietProduct[];
    aanvrager1: KlantnaamReadOnly | null;
    aanvrager2: KlantnaamReadOnly | null;
    /** Ingangsdatum van het voorstel (of: 'Passeerdatum' wanneer er een hypotheek geadviseerd wordt) */
    readonly ingangsdatumVoorstel: string | null;
}

/** Gegevens van een dekking van een Krediet-verzekering. */
export interface KredietLeninggegevens {
    /** Hoofdsom */
    hoofdsomBedrag: number | null;
    /** Indicatie of het hoofdsombedrag overgenomen moet worden. */
    hoofdsomBedragOvernemen: boolean | null;
    /** Het berekende hoofdsombedrag dat gebruikt wordt als het hoofdsombedrag niet overgenomen wordt. */
    berekendHoofdsomBedrag: number | null;
    /** Restant hoofdsom */
    restantHoofdsomBedrag: number | null;
    /** Datum opgave restant hoofdsom */
    opgaveDatum: string | null;
    /** Slottermijn */
    slottermijnBedrag: number | null;
    /** Aflossingpercentage */
    aflossingPercentage: number | null;
    /** Rentepercentage per jaar */
    rentePercentage: number | null;
    /** Slottermijn */
    maandlastBedrag: number | null;
    /** Indicatie dat de berekende maandlast overgenomen moet worden. */
    maandlastOvernemen: boolean | null;
    garantie: Garantiesoort | null;
    /** HDN code  van het bestedingsdoel volgens de HDN-keuzelijst BestedingsDoelType (KX). */
    bestedingsdoelCode: number | null;
    /** Beschrijving bestedingsdoel */
    bestedingsdoelOmschrijving: string | null;
    /** Deel box 1 */
    deelBox1Bedrag: number | null;
    /** Einddatum renteaftrek */
    renteaftrekEinddatum: string | null;
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Krediet (zowel huidige situatie als voorstel). */
export interface KredietOutput {
    /** Lijst met Krediet-producten per adviesdossier (huidige situatie) of voorstel. */
    kredieten: { [key: string]: Krediet; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Gegevens van een Krediet-polis. */
export interface KredietPolis {
    productnummer: string | null;
    maatschappijCode: string | null;
    maatschappijOmschrijving: string | null;
    maatschappijCodeHdn: string | null;
    productnaam: string | null;
    productcode: number;
    ingangsdatum: string;
    looptijdInMaanden: number | null;
    uwBemiddeling: boolean;
}

/** Bevat de gegevens van het Krediet-product. */
export interface KredietProduct {
    soortProduct: SoortKredietProductOptions;
    /** Geeft aan of het om een doorlopend product gaat. */
    readonly doorlopend: boolean | null;
    polis: KredietPolis;
    /** Unieke identificaties van de klanten die als geldnemer geselecteerd zijn. */
    geldnemerKlantIds: string[];
    leninggegevens: KredietLeninggegevens;
    /** Indicatie dat indien het doorlopende product gewijzigd is, deze opnieuw overgenomen moet worden naar de voorstellen */
    wijzigingenInDoorlopendProductOvernemen: boolean | null;
    productId: string | null;
    meenemen: boolean;
}

export interface KredietReadOnly {
    kredietId: string;
    doorlopend: boolean;
    readonly productnaam: string | null;
}

/** Bevat de inhoud van het Adviesbox-form Aanvraag/Lening. */
export interface Lening {
    /** Voorstellen binnen het adviesdossier */
    voorstellen: LeningVoorstelReadOnly[] | null;
    algemeen: LeningAlgemeen;
    notaris: LeningNotaris | null;
    maatwerkoplossing: LeningMaatwerkoplossing | null;
    financiering: LeningFinanciering | null;
    erfpacht: LeningErfpacht | null;
    aanvullendeGegevens: LeningAanvullendeGegevens | null;
    dataLeverancier: LeningDataLeverancier | null;
    inventarisatieStudielening: LeningInventarisatieStudielening | null;
    aanvrager1: KlantnaamReadOnly | null;
    aanvrager2: KlantnaamReadOnly | null;
}

/** 'Aanvullende gegevens'. */
export interface LeningAanvullendeGegevens {
    /** Tekst van de aanvullende gegevens */
    toelichting: string | null;
}

/** Bevat gegevens van het gekozen voorstel (de gewenste hypotheek). */
export interface LeningAlgemeen {
    /** Unieke identificatie van het voorstel (analyse) van de gewenste hypotheek */
    gewensteHypotheekVoorstelId: string;
    /** Bespreekzaak */
    bespreekzaak: boolean;
    /** Verduurzaming besproken */
    verduurzamingBesproken: boolean;
    /** Soort advies conform de HDN keuzelijst 'AdviesTypeType' */
    soortAdvies: number;
    /** Netto advieskosten */
    nettoAdvieskostenBedrag: number | null;
    betaalwijzeAdvieskosten: BetaalwijzeAdvieskostenOptions | null;
}

/** Bevat gegevens van 'DataLeverancier'. */
export interface LeningDataLeverancier {
    /** Bevat selectie-gegevens van dataleveranciers. */
    dataLeveranciers: LeningDataLeverancierSelectie[];
}

/** Bevat selectie-gegevens van een dataleverancier. */
export interface LeningDataLeverancierSelectie {
    /** HDN code van de dataleverancier conform de HDN keuzelijst 'DataleverancierType' */
    hdnCode: number;
    /** Indicatie of de dataleverancier is geselecteerd. */
    geselecteerd: boolean;
}

/** Gegevens van 'Erfpacht'. */
export interface LeningErfpacht {
    /** Ingangsdatum erfpacht */
    ingangsdatum: string | null;
}

/** Bevat gegevens van 'Financiering'. */
export interface LeningFinanciering {
    /** Reden aanvraag conform de HDN keuzelijst 'MutatieType' */
    redenAanvraag: number | null;
    redenAankoop: RedenAankoopOptions;
    soortOversluiting: SoortOversluitingOptions | null;
    /** Senioren verhuisregeling */
    seniorenVerhuisregeling: boolean | null;
    aanleidingGesprek: AanleidingGesprekOptions | null;
    /** Bedrag verbouwing/verbetering */
    readonly verbouwingskosten: number | null;
}

/** Gegevens van 'Inventarisatie Studielening'. */
export interface LeningInventarisatieStudielening {
    /** HDN Code voor aanvrager 1 van de inventarisatie studielening conform de HDN keuzelijst StudieleningInventarisatieType */
    hdnCodeAanvrager1: number | null;
    /** HDN Code voor aanvrager 2 van de inventarisatie studielening conform de HDN keuzelijst StudieleningInventarisatieType */
    hdnCodeAanvrager2: number | null;
}

/** Bevat gegevens van een eventuele maatwerkoplossing. */
export interface LeningMaatwerkoplossing {
    /** Bevat maatwerkredenen van de maatwerkoplossing. */
    maatwerkredenen: LeningMaatwerkreden[];
}

/** Bevat gegevens van een maatwerkreden. */
export interface LeningMaatwerkreden {
    /** Unieke identificatie van de maatwerkreden */
    maatwerkRedenId: string | null;
    /** Volgnummer van de maatwerkreden voor weergave op het scherm */
    volgnummer: number;
    /** Unieke identificatie van de klant op wie de maatwerkoplossing betrekking heeft */
    betrekkingOpKlantId: string;
    /** Geeft de generieke explainreden weer conform HDN keuzelijst ExplainRedenType */
    redentypeCode: number;
    /** HDN-code van de maatwerkreden conform de HDN keuzelijst MaatwerkOplCodeMijType */
    reden: string | null;
    /** Toelichting op de maatwerkreden */
    toelichting: string | null;
}

/** Bevat gegevens van een notaris. */
export interface LeningNotaris {
    /** Unieke identificatie van het gekozen notariskantoor uit de instellingen */
    gekozenNotariskantoorId: string | null;
    /** Naam notariskantoor */
    kantoornaam: string | null;
    /** Rol notaris conform de HDN keuzelijst  'NotarisType' */
    typeNotaris: number;
    adres: Adres | null;
    contactpersoon: PersoonBasis | null;
    /** Telefoonnummer */
    telefoonnummer: string | null;
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Aanvraag/Lening. */
export interface LeningOutput {
    /** Lijst met de inhoud van het Adviesbox-form Aanvraag/Lening per adviesdossier. */
    leningen: { [key: string]: Lening; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de gegevens van een voorstel (niet te wijzigen). */
export interface LeningVoorstelReadOnly {
    /** Unieke identificatie van het voorstel (analyse) */
    voorstelId: string;
    /** Volgnummer voor weergave in het scherm */
    volgnummer: number;
    /** Naam van het voorstel */
    readonly omschrijving: string | null;
    /** Bedrag hypothecaire inschrijving */
    readonly inschrijvingBedrag: number | null;
    /** Code van de geldverstrekker uit de Producten API */
    readonly maatschappijCode: string | null;
    /** Hdn-ontvangercode uit de Producten API */
    readonly hdnOntvangerCode: string | null;
    /** Passeerdatum */
    passeerdatum: string;
    /** Indicatie dat NHG-garantie van toepassing is op de nieuwe financiering */
    readonly nhg: boolean | null;
    soortFinanciering: Financieringsoort | null;
    /** Indicatie dat er sprake is van erfpacht */
    readonly erfpacht: boolean | null;
    /** Indicatie dat het voorstel een nieuw leningdeel bevat */
    heeftNieuwLeningdeel: boolean;
    /** Indicatie dat het voorstel een meeneemhypotheek bevat */
    isMeeneemHypotheek: boolean;
}

/** Mee te nemen leningdeel */
export interface Leningdeel {
    /** Unieke identificatie van het leningdeel */
    leningdeelId: string | null;
    /** Referentie naar leningdeel in de huidige situatie (indien automatisch overgenomen) */
    huidigLeningdeelId: string | null;
    /** Bedrag leningdeel */
    leningdeelBedrag: number | null;
    aflossingsvorm: AflossingsVormType;
    /** Opgebouwde waarde */
    opgebouwdeWaardeBedrag: number | null;
    /** Het deel maanden van het restant van de looptijd */
    restantLooptijdInMaanden: number | null;
    /** Het gedeelte (als bedrag) van het hypotheekbedrag dat in box 3 zit */
    box3Bedrag: number | null;
}

export interface LeningdeelReadOnly {
    leningdeelId: string;
    doorlopend: boolean;
    readonly productnaam: string | null;
    readonly maatschappijCode: string | null;
    productcode: number;
    aanvangsdatum: string;
    looptijdInMaanden: number;
    volgnummer: number;
    leningdeelBedrag: number | null;
}

/** Result per leningdeel */
export interface LeningdelenResult {
    /** Standaard rente. */
    standaardRente: string | null;
    /** Gets or sets the Loan to value */
    ltv: string | null;
    /** Dagrente. */
    dagrente: string | null;
    /** Betaalrekening. */
    betaalrekening: string | null;
    /** Loyaliteit. */
    loyaliteit: string | null;
    /** leningdeel volgnummer. */
    volgnummer: number;
    /** Tooltip. */
    tooltip: string | null;
}

/** Bevat de gegevens van Adviesbox Form Uitkerende lijfrente. */
export interface Lijfrente {
    /** De producten op het scherm */
    producten: LijfrenteProduct[];
    aanvrager1: KlantnaamReadOnly | null;
    aanvrager2: KlantnaamReadOnly | null;
    /** Ingangsdatum van het voorstel (of: 'Passeerdatum' wanneer er een hypotheek geadviseerd wordt) */
    readonly ingangsdatumVoorstel: string | null;
}

/** Het kapitaal van een Uitkerende lijfrente-product. */
export interface LijfrenteKapitaal {
    uitgangspuntBerekening: LijfrenteUitgangspuntBerekeningOptions | null;
    /** Beschikbare koopsom */
    beschikbareKoopsomBedrag: number | null;
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Uitkerende lijfrente (zowel huidige situatie als voorstel). */
export interface LijfrenteOutput {
    /** Lijst met Uitkerende lijfrente-producten per adviesdossier (huidige situatie) of voorstel. */
    lijfrentes: { [key: string]: Lijfrente; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** De polisgegevens van een Uitkerende lijfrente-product. */
export interface LijfrentePolis {
    productnummer: string | null;
    maatschappijCode: string | null;
    maatschappijOmschrijving: string | null;
    maatschappijCodeHdn: string | null;
    productnaam: string | null;
    productcode: number;
    ingangsdatum: string;
    looptijdInMaanden: number | null;
    uwBemiddeling: boolean;
}

/** Basis Uitkerende lijfrente-product. */
export interface LijfrenteProduct {
    soortProduct: SoortLijfrenteProductOptions | null;
    /** Geeft aan of het om een doorlopend product gaat. */
    readonly doorlopend: boolean | null;
    polis: LijfrentePolis;
    /** Unieke identificaties van de klanten die als verzekeringnemer geselecteerd zijn */
    verzekeringnemerKlantIds: string[];
    /** Unieke identificaties van de klanten die als verzekerde geselecteerd zijn */
    verzekerdeKlantIds: string[];
    kapitaal: LijfrenteKapitaal;
    uitkerendeFase: LijfrenteUitkerendeFase;
    /** Indicatie dat indien er doorlopende producten gewijzigd zijn, deze opnieuw overgenomen moeten worden naar de voorstellen */
    wijzigingenInDoorlopendeProductenOvernemen: boolean;
    productId: string | null;
    meenemen: boolean;
}

/** LijfrenteUitgangspuntBerekeningOptions BeschikbareKoopsom = 0, Lijfrenteuitkering = 1 */
export enum LijfrenteUitgangspuntBerekeningOptions {
    BeschikbareKoopsom = "BeschikbareKoopsom",
    Lijfrenteuitkering = "Lijfrenteuitkering",
}

/** Bevat gegevens van de indicatieve uitkerende fase */
export interface LijfrenteUitkerendeFase {
    /** Indicatie dat het berekende lijfrente-uitkering overgenomen moet worden. */
    lijfrenteUitkeringOvernemen: boolean;
    belastingBox: BelastingBoxOptions | null;
    soortLijfrenteUitkering: SoortLijfrenteUitkeringOptions | null;
    duurUitkeringInMaanden: number | null;
    duurUitkeringHoogInMaanden: number | null;
    hooglaagVerhouding: number | null;
    lijfrenteTariefPercentage: number | null;
    overgangOp2eVerzekerde: boolean | null;
    overgangOp2eVerzekerdePercentage: number | null;
    lijfrenteUitkeringBedrag: number | null;
    termijn: BetalingsTermijnType | null;
}

/** Lijfrenteclausulesoort Geen = 0, Leven = 1, Overlijden = 2, LevenEnOverlijden = 3 */
export enum Lijfrenteclausulesoort {
    Geen = "Geen",
    Leven = "Leven",
    Overlijden = "Overlijden",
    LevenEnOverlijden = "LevenEnOverlijden",
}

/** Bevat de gegevens van een loondienst. */
export interface Loondienst {
    /** Unieke identificatie van de loondienst (null, indien loondienst toegevoegd moet worden) */
    loondienstId: string | null;
    /** Vergoeding voor Extra Beslaglegging */
    vebBedrag: number | null;
    /** Bedrag flexibel inkomen gemiddeld */
    inkomenFlexibelBedrag: number | null;
    /** Bedrag flexibel inkomen opgegeven jaar (Jr_InkomenFlexibel_Min_1) */
    inkomenFlexibelJaarBedrag: number | null;
    /** Bedrag flexibel inkomen 1 jaar voor opgegeven jaar */
    inkomenFlexibelJaarMin1Bedrag: number | null;
    /** Jaartal flexibel inkomen */
    inkomenFlexibelJaar: number | null;
    /** Bedrag flexibel inkomen 2 jaar voor opgegeven jaar */
    inkomenFlexibelJaarMin2Bedrag: number | null;
    /** Inkomsten uit toeslagen die structrureel mee kunnen tellen (bijv. diplomatoeslag, gevarentoeslag, oefeningtoeslag enz.) */
    inkomstenToeslagBedrag: number | null;
    /** Percentage loondoorbetaling bij AO jaar 1 */
    percentageLoondoorbetalingAoJaar1: number | null;
    /** Percentage loondoorbetaling bij AO jaar 2 */
    percentageLoondoorbetalingAoJaar2: number | null;
    /** Het aantal uren in de parttime arbeidsovereenkomst dat de persoon werkt */
    aantalContracturenPerWeek: number | null;
    /** Beroeptype (code) conform HDN keuzelijst BeroepType per HDN 16 */
    beroeptypeCode: number | null;
    inkomenScenario: BedragScenario | null;
    /** Bedrag jaarlijkse provisie */
    provisieBedrag: number | null;
    /** Indicatie of inkomen buitenlands is */
    buitenlandsInkomen: boolean | null;
    /** Bedrag onregelmatigheidstoeslag */
    onregelmatigheidstoeslagBedrag: number | null;
    /** Volgnummer van het werk binnen een klant */
    volgnummer: number;
    soortDienstBetrekking: SoortDienstBetrekkingType | null;
    /** Datum aanvang dienstverband */
    dienstverbandAanvangsdatum: string | null;
    /** Datum einde dienstverband */
    dienstverbandEinddatum: string | null;
    /** De datum waarop het inkomen uit overwerk van start is gegaan */
    overwerkAanvangsdatum: string | null;
    /** De datum waarop het inkomen uit overwerk wordt beÙindigd */
    overwerkEinddatum: string | null;
    /** De datum waarop het inkomen uit provisie van start is gegaan */
    provisieAanvangsdatum: string | null;
    /** De datum waarop het inkomen uit provisie wordt beeindigd */
    provisieEinddatum: string | null;
    /** Datum einde contract */
    contractEinddatum: string | null;
    /** Beschrijving beroep */
    beroepOmschrijving: string | null;
    /** Bedrag bruto salaris per periode. Periode beschreven in Anv_Cd_InkomenPeriode */
    inkomenPeriodeBedrag: number | null;
    inkomenPeriodeCode: InkomenPeriode | null;
    /** Percentage vakantiegeld */
    vakantiegeldPercentage: number | null;
    /** Bedrag vakantietoeslag */
    vakantiegeldBedrag: number | null;
    /** Bedrag 13e maand */
    maand13Bedrag: number | null;
    /** Bedrag vaste gratificatie / tantieme per jaar */
    gratificatieBedrag: number | null;
    /** Bedrag overwerk */
    overwerkBedrag: number | null;
    /** Indicatie dat de klant in dienst is bij familie */
    werkgeverIsFamilie: boolean | null;
    /** Werkgever-info van de klant */
    naamWerkgever: string | null;
    /** Geeft de fase waarin de uitzendkracht zich bevindt conform de HDN keuzelijst SoortUitzendcontractType */
    faseUitzendcontract: number | null;
    adresWerkgever: Adres | null;
    /** Toetsinkomen bij perspectiefverklaring */
    toetsinkomenPerspectiefverklaring: number | null;
    /** Inkomsten uit vast flexibel budget */
    vastFlexibelBudgetBedrag: number | null;
}

/** Aantal gegevens van een loondienst (niet te wijzigen). */
export interface LoondienstReadOnly {
    /** Uniek Id van de loondienst */
    loondienstId: string;
    /** Beroepsfunctie */
    readonly beroepsfunctie: string | null;
    /** Totaal bruto inkomen uit deze loondienst */
    readonly totaalBrutoInkomenBedrag: number | null;
    /** Datum tot wanneer deze loondienst meetelt (meestal de pensioen- of AOW datum) */
    readonly meetellenTotDatum: string | null;
}

/** LoonverklaringOpties Geen = 0, Werkgeververklaring = 1, UwvDocument = 2, Perspectiefverklaring = 3, Arbeidsmarktscan = 4 */
export enum LoonverklaringOpties {
    Geen = "Geen",
    Werkgeververklaring = "Werkgeververklaring",
    UwvDocument = "UwvDocument",
    Perspectiefverklaring = "Perspectiefverklaring",
    Arbeidsmarktscan = "Arbeidsmarktscan",
}

export interface MaxKoopsomOutput {
    success: boolean | null;
    readonly maxKoopsomBedrag: number | null;
}

export interface MaxKostenInEigendomOutput {
    success: boolean | null;
    readonly maxKostenInEigendomBedrag: number | null;
}

export interface MaxLeningOutput {
    success: boolean | null;
    readonly kostenInEigendomBedrag: number | null;
    readonly maxHypMarktwaardeBedrag: number | null;
}

/** Bevat de gegevens van Adviesbox Form Maximale Hypotheek */
export interface MaximaleHypotheek {
    /** Is er in de financieringsbehoefte gekozen voor Nhg */
    readonly nhg: boolean | null;
    /** Type woning volgens de HDN keuzelijst CodeObjectType. */
    readonly typePand: number | null;
    /** Code van het gebruiksdoel van het betreffende object volgens de HDN keuzelijst ObjectSoortType */
    readonly objectSoort: number | null;
    /** Indicatie dat het object wordt gebruikt voor recreatieve bewoning */
    readonly recreatieveBewoning: boolean | null;
    /** Gewenste looptijd van de hypotheek */
    hypotheekLooptijdInMaanden: number;
    /** Marktwaarde van het onderpand */
    readonly marktwaardeBedrag: number | null;
    /** Gewenste hypotheek volgens de financieringsbehoefte */
    readonly gewensteHypotheekBedrag: number | null;
    /** Andere financiering volgens de financieringsbehoefte */
    readonly andereFinancieringBedrag: number | null;
    toetsrenteBerekeningOpBasisVan: ToetsrenteBerekeningOptions;
    /** Specificatie toetsrente */
    specificatieToetsrentePercentage: number | null;
    /** Gewenste rentevastperiode */
    gewensteRentevastperiodeInMaanden: number | null;
    /** Vrij te besteden vermogen */
    vrijVermogenBedrag: number | null;
    /** De kredietjaarlast van beide aanvragers */
    kredietToetslastBedrag: number | null;
    /** Geeft aan of de krediettoetslast berekend (true) of opgegeven (not true) moet worden */
    kredietToetslastOvernemen: boolean | null;
    /** De berekende kredietjaarlast van beide aanvragers */
    readonly kredietToetslastBerekendBedrag: number | null;
    /** Geeft aan of leningdelen uit het verleden meegenomen moeten worden */
    leningdelenUitVerledenMeenemen: boolean | null;
    /** De leningdelen uit het verleden die meegenomen moeten worden */
    leningdelenUitVerleden: Leningdeel[] | null;
    /** Alle huidige leningdelen van alle huidige woonsituaties/hypotheken */
    readonly huidigeLeningdelen: Leningdeel[] | null;
    aanvrager1: MaximaleHypotheekAanvrager | null;
    aanvrager2: MaximaleHypotheekAanvrager | null;
}

/** Bevat gegevens van de aanvrager (klant). */
export interface MaximaleHypotheekAanvrager {
    aanvrager: KlantnaamReadOnly | null;
    /** Toetsinkomen van aanvrager */
    toetsinkomenBedrag: number | null;
    /** Geeft aan of het toetsinkomen van aanvrager berekend moet worden */
    toetsinkomenOvernemen: boolean | null;
    /** Het berekende toetsinkomen van aanvrager */
    readonly toetsinkomenBerekendBedrag: number | null;
    /** Pensioeninkomen van aanvrager */
    pensioeninkomenBedrag: number | null;
    /** Pensioeninkomen van aanvrager */
    readonly pensioeninkomenBerekendBedrag: number | null;
    /** Geeft aan of het pensioeninkomen van aanvrager berekend moet worden */
    pensioeninkomenOvernemen: boolean | null;
    /** De AOW leeftijd in maanden */
    readonly aowLeeftijdInMaanden: number | null;
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Maximale hypotheek. */
export interface MaximaleHypotheekOutput {
    /** Lijst met de inhoud van scherm Maximale hypotheek per Voorstel. */
    maximaleHypotheken: { [key: string]: MaximaleHypotheek; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** De uitkomsten van de maximale hypotheekberekening */
export interface MaximaleHypotheekUitkomst {
    /** Gets or sets code van het product zoals deze in de Adviesbox
producten-database is gedefinieerd. */
    productCode: number | null;
    /** Gets or sets productnaam. */
    productnaam: string | null;
    /** Gets or sets code van de maatschappij zoals deze in de Adviesbox
producten-database is gedefinieerd. */
    maatschappijCode: string | null;
    /** Gets or sets renteboxcode van de maatschappij zoals deze in de Adviesbox
producten-database is gedefinieerd. */
    renteboxMaatschappijCode: string | null;
    /** Gets or sets verkorte naam van de maatschappij. */
    maatschappijNaam: string | null;
    /** De toetsrente waarmee getoetst is / hypotheekrente */
    toetsrente: number | null;
    /** De maximale hypotheek op inkomen */
    maximaleHypotheek: number | null;
    /** De maximale hypotheek op het onderpand */
    maximaleHypotheekOnderpand: number | null;
    toetsinkomenVerklaringAanvrager1: ToetsinkomenVerklaring | null;
    toetsinkomenVerklaringAanvrager2: ToetsinkomenVerklaring | null;
    uitslag: UitslagOptions;
}

export interface MaximaleHypotheekUitkomstOutput {
    /** Lijst met de inhoud van scherm Maximale hypotheek per Voorstel. */
    maximaleHypotheken: { [key: string]: MaximaleHypotheekUitkomst; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Meeneemtype EenOpEen = 0, RenteBemiddeling = 1 */
export enum Meeneemtype {
    EenOpEen = "EenOpEen",
    RenteBemiddeling = "RenteBemiddeling",
}

/** Bevat de menu-informatie voor het menu van een adviesdossier. */
export interface MenuInfo {
    /** Unieke identificatie van het klantdossier. */
    klantdossierId: string;
    /** Gegevens van de voorstellen in het adviesdossier. */
    readonly voorstellen: MenuInfoVoorstel[] | null;
    /** Geeft aan of er woningen in eigendom zijn. */
    woningenInEigendom: boolean;
    financiering: FinancieringOptions;
    aanvrager1: KlantnaamReadOnly | null;
    aanvrager2: KlantnaamReadOnly | null;
    klantprofiel: MenuInfoKlantprofiel | null;
    motivering: MenuInfoMotivering | null;
    /** Laatste mutatiedatum van het adviesdossier. */
    readonly laatsteMutatieDatum: string | null;
    /** De ids van de adviseurs gekoppeld aan dit adviesdossier */
    adviseurIds: string[] | null;
    /** Keuzes m.b.t. rapportage-structuren uit de instellingen */
    structuurKeuzes: RapportSamenstellenStructuurKeuze[] | null;
}

/** Bevat gegevens van het menu-item Klantprofiel. */
export interface MenuInfoKlantprofiel {
    /** Gegevens van de onderwerpen van het klantprofiel */
    readonly onderwerpen: MenuInfoKlantprofielOnderwerp[] | null;
}

/** Bevat gegevens van een menu-item t.b.v. een klantprofiel-onderwerp. */
export interface MenuInfoKlantprofielOnderwerp {
    onderwerp: KlantprofielOnderwerpOptions;
    status: KlantprofielOnderwerpStatusOptions;
}

/** Bevat gegevens van het menu-item Motivering. */
export interface MenuInfoMotivering {
    /** Gegevens van de motivering-onderwerpen */
    readonly onderwerpen: MenuInfoMotiveringOnderwerp[] | null;
}

/** Bevat gegevens van een menu-item t.b.v. een motivering-onderwerp. */
export interface MenuInfoMotiveringOnderwerp {
    onderwerp: MotiveringOnderwerpsoort;
    status: MotiveringOnderwerpStatusOptions;
}

/** Gegevens van een voorstel voor een menu. */
export interface MenuInfoVoorstel {
    /** Het volgnummer van het voorstel. */
    volgnummer: number;
    /** Unieke identificatie van het voorstel. */
    id: string;
    /** Naam van het voorstel. */
    readonly naam: string | null;
    soortFinanciering: Financieringsoort | null;
    /** Geeft aan of er sprake is van een doorlopend leningdeel. */
    doorlopendeLeningdelen: boolean;
}

/** Output voor het opvragen van de menu-informatie. */
export interface MenuOutput {
    /** De menu-informatie van een adviesdossier. */
    readonly menuInfo: { [key: string]: MenuInfo; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface Motivering {
    onsAdvies: string | null;
    afwijkendeKeuze: string | null;
    onsAdvies2: string | null;
    afwijkendeKeuze2: string | null;
    readonly wensenAlgemeen: string[] | null;
    readonly wensenAanvrager1: string[] | null;
    readonly wensenAanvrager2: string[] | null;
    uitgangspuntenOverlijden: MotiveringUitgangspuntenOverlijden | null;
    uitgangspuntenArbeidsongeschiktheid: MotiveringUitgangspuntenArbeidsongeschiktheid | null;
    uitgangspuntenWerkloosheid: MotiveringUitgangspuntenWerkloosheid | null;
    uitgangspuntenPensioen: MotiveringUitgangspuntenPensioen | null;
    uitgangspuntenDubbeleWoonlasten: MotiveringUitgangspuntenDubbeleWoonlasten | null;
    uitgangspuntenHypotheek: MotiveringUitgangspuntenHypotheek | null;
    uitgangspuntenVermogen: MotiveringUitgangspunten | null;
    readonly tabellenResourceUrl: string | null;
    aanvrager1: KlantnaamReadOnly | null;
    aanvrager2: KlantnaamReadOnly | null;
}

export interface MotiveringBeschikbareJaarruimte {
    gewensteDuurPensioenUitkering: DuurPensioenuitkeringOptions | null;
    pensioenuitkeringTotLeeftijdInMaanden: number | null;
    winstBedrag: number | null;
    winstBerekendBedrag: number;
    winstOvernemen: boolean;
    tegenwoordigeDienstbetrekkingBedrag: number | null;
    tegenwoordigeDienstbetrekkingBerekendBedrag: number;
    tegenwoordigeDienstbetrekkingOvernemen: boolean;
    vroegereDienstbetrekkingBedrag: number | null;
    vroegereDienstbetrekkingBerekendBedrag: number;
    vroegereDienstbetrekkingOvernemen: boolean;
    buitenlandseInkomstenBedrag: number | null;
    reisaftrekBedrag: number;
    overigeWerkzaamhedenBedrag: number | null;
    overigeWerkzaamhedenBerekendBedrag: number;
    overigeWerkzaamhedenOvernemen: boolean;
    periodiekeUitkeringenBedrag: number | null;
    premiegrondslagBedrag: number;
    franchiseBedrag: number;
    subtotaalFranchise1Bedrag: number;
    premiegrondslagPercentage: number;
    subtotaalFranchise2Bedrag: number;
    pensioenaangroeiBedrag: number | null;
    readonly pensioenaangroeiPercentage: number | null;
    subtotaalPensioenaangroeiBedrag: number;
    toevoegingOdrBedrag: number | null;
    subtotaalToevoegingOdrBedrag: number;
    jaarruimteBedrag: number;
    benutteJaarruimteBedrag: number;
    benutteJaarruimteBerekendBedrag: number;
    benutteJaarruimteOvernemen: boolean;
    beschikbareJaarruimteBedrag: number;
    maxPremieGrondslag: number;
}

export interface MotiveringControleGewenstInkomen {
    controleGewenstInkomen: ControleGewenstInkomenOptions | null;
    brutoInkomenswensPercentage: number | null;
    controleGewenstNbi: ControleGewenstNbiOptions | null;
    margeOndergrensPercentage: number | null;
    margeBovengrensPercentage: number | null;
    vastBedrag: number | null;
    huidigNbiPercentage: number | null;
    gewijzigdeJarenTonen: boolean;
    benodigdKapitaalTonen: boolean;
}

export interface MotiveringControleHypotheeknorm {
    controleMaandlast: ControleMaandlastOptions | null;
    controleerMaximaleHypotheek: boolean;
}

/** MotiveringOnderwerpStatusOptions NietIngevuld = 1, Onvolledig = 2, Volledig = 3 */
export enum MotiveringOnderwerpStatusOptions {
    NietIngevuld = "NietIngevuld",
    Onvolledig = "Onvolledig",
    Volledig = "Volledig",
}

/** MotiveringOnderwerpsoort Geen = 0, Algemeen = 1, Rentevastperiode = 2, FiscaleAftrek = 3, InbrengEigenGeld = 4, OversluitenHypotheek = 5, VerantwoordeWoonlasten = 6, Box3Consumptief = 7, AfdekkenOverlijdensrisico = 8, AfdekkenAOWW = 9, Pensioenvoorziening = 10, HoogteOpbouwDoelvermogen = 11, WijzeOpbouwDoelvermogen = 12, Beleggingsproduct = 13, Beleggingsprofiel = 14, Fondskeuze = 15, OversluitenBeleggingspolis = 16, AfdekkenWW = 17, Kredieten = 18, DubbeleWoonlasten = 19, EerderStoppen = 20, Geldverstrekker = 21, HypotheekAflossen = 22, Schade = 23, Risicoprofiel = 24, Nazorg = 25, Energie = 26, Telecom = 27, Uitvaart = 28, Verduurzaming = 29, Alles = -1 */
export enum MotiveringOnderwerpsoort {
    Geen = "Geen",
    Algemeen = "Algemeen",
    Rentevastperiode = "Rentevastperiode",
    FiscaleAftrek = "FiscaleAftrek",
    InbrengEigenGeld = "InbrengEigenGeld",
    OversluitenHypotheek = "OversluitenHypotheek",
    VerantwoordeWoonlasten = "VerantwoordeWoonlasten",
    Box3Consumptief = "Box3Consumptief",
    AfdekkenOverlijdensrisico = "AfdekkenOverlijdensrisico",
    AfdekkenAOWW = "AfdekkenAOWW",
    Pensioenvoorziening = "Pensioenvoorziening",
    HoogteOpbouwDoelvermogen = "HoogteOpbouwDoelvermogen",
    WijzeOpbouwDoelvermogen = "WijzeOpbouwDoelvermogen",
    Beleggingsproduct = "Beleggingsproduct",
    Beleggingsprofiel = "Beleggingsprofiel",
    Fondskeuze = "Fondskeuze",
    OversluitenBeleggingspolis = "OversluitenBeleggingspolis",
    AfdekkenWW = "AfdekkenWW",
    Kredieten = "Kredieten",
    DubbeleWoonlasten = "DubbeleWoonlasten",
    EerderStoppen = "EerderStoppen",
    Geldverstrekker = "Geldverstrekker",
    HypotheekAflossen = "HypotheekAflossen",
    Schade = "Schade",
    Risicoprofiel = "Risicoprofiel",
    Nazorg = "Nazorg",
    Energie = "Energie",
    Telecom = "Telecom",
    Uitvaart = "Uitvaart",
    Verduurzaming = "Verduurzaming",
    Alles = "Alles",
}

export interface MotiveringOutput {
    motiveringen: { [key: string]: Motivering; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface MotiveringUitgangspunten {
    readonly voorstellen: MotiveringVoorstel[] | null;
    motiveringVoorVoorstelId: string | null;
}

export interface MotiveringUitgangspuntenArbeidsongeschiktheid {
    scenarioDoorrekeningExtra1: boolean | null;
    scenarioDoorrekeningExtra2: boolean | null;
    arbeidsongeschiktheidStandaardPercentage: number | null;
    arbeidsongeschiktheidExtra1Percentage: number | null;
    arbeidsongeschiktheidExtra2Percentage: number | null;
    duurzaamArbeidsongeschiktStandaard: boolean | null;
    duurzaamArbeidsongeschiktExtra1: boolean | null;
    duurzaamArbeidsongeschiktExtra2: boolean | null;
    benuttingVerdiencapaciteitStandaardPercentage: number | null;
    benuttingVerdiencapaciteitExtra1Percentage: number | null;
    benuttingVerdiencapaciteitExtra2Percentage: number | null;
    readonly toetsjaar: number | null;
    controleHypotheeknorm: MotiveringControleHypotheeknorm | null;
    controleGewenstInkomen: MotiveringControleGewenstInkomen | null;
    readonly scenarioVanKlantIds: string[] | null;
    readonly overzichtBeideTonen: boolean | null;
    readonly voorstellen: MotiveringVoorstel[] | null;
    motiveringVoorVoorstelId: string | null;
}

export interface MotiveringUitgangspuntenDubbeleWoonlasten {
    geschatteDuurOverbruggingInMaanden: number | null;
}

export interface MotiveringUitgangspuntenHypotheek {
    controleHypotheeknorm: MotiveringControleHypotheeknorm | null;
    controleGewenstInkomen: MotiveringControleGewenstInkomen | null;
    readonly scenarioVanKlantIds: string[] | null;
    readonly overzichtBeideTonen: boolean | null;
    readonly voorstellen: MotiveringVoorstel[] | null;
    motiveringVoorVoorstelId: string | null;
}

export interface MotiveringUitgangspuntenOverlijden {
    werkenNaOverlijdenPartnerAanvrager1Percentage: number | null;
    werkenNaOverlijdenPartnerAanvrager2Percentage: number | null;
    duurOverzicht: DuurOverzichtOptions | null;
    overzichtDuurInJaren: number | null;
    overzichtTotLeeftijdInMaanden: number | null;
    controleHypotheeknorm: MotiveringControleHypotheeknorm | null;
    controleGewenstInkomen: MotiveringControleGewenstInkomen | null;
    readonly scenarioVanKlantIds: string[] | null;
    readonly overzichtBeideTonen: boolean | null;
    readonly voorstellen: MotiveringVoorstel[] | null;
    motiveringVoorVoorstelId: string | null;
}

export interface MotiveringUitgangspuntenPensioen {
    beschikbareJaarruimteAanvrager1: MotiveringBeschikbareJaarruimte | null;
    beschikbareJaarruimteAanvrager2: MotiveringBeschikbareJaarruimte | null;
    controleHypotheeknorm: MotiveringControleHypotheeknorm | null;
    controleGewenstInkomen: MotiveringControleGewenstInkomen | null;
    readonly scenarioVanKlantIds: string[] | null;
    readonly overzichtBeideTonen: boolean | null;
    readonly voorstellen: MotiveringVoorstel[] | null;
    motiveringVoorVoorstelId: string | null;
}

export interface MotiveringUitgangspuntenWerkloosheid {
    controleHypotheeknorm: MotiveringControleHypotheeknorm | null;
    controleGewenstInkomen: MotiveringControleGewenstInkomen | null;
    readonly scenarioVanKlantIds: string[] | null;
    readonly overzichtBeideTonen: boolean | null;
    readonly voorstellen: MotiveringVoorstel[] | null;
    motiveringVoorVoorstelId: string | null;
}

export interface MotiveringVoorstel {
    voorstelId: string;
    readonly omschrijving: string | null;
    volgnummer: number;
}

export interface NewOutput {
    id: string | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface NhgMogelijkOutput {
    maxKoopsomResult: MaxKoopsomOutput | null;
    maxKostenInEigendomResult: MaxKostenInEigendomOutput | null;
    tweedeWoningNietMogelijkResult: TweedeWoningNietMogelijkOutput | null;
    maxLeningResult: MaxLeningOutput | null;
}

/** Gegevens van het nieuwe adviesdossier. */
export interface NieuwAdviesdossier {
    /** De unieke identificatie van het nieuwe adviesdossier. */
    adviesdossierId: string;
}

/** Gegevens van een nieuw adviesdossier. Opgegeven kunnen worden: korte en lange omschrijving. De overige gegevens van het dossier worden overgenomen van het opgegeven adviesdossier. */
export interface NieuwAdviesdossierInput {
    /** Korte omschrijving van het advies */
    korteOmschrijving: string | null;
    /** Lange/uitgebreide omschrijving van het advies */
    langeOmschrijving: string | null;
}

/** Het resultaat van het aanmaken van een nieuw adviesdossier. */
export interface NieuwAdviesdossierOutput {
    adviesdossier: NieuwAdviesdossier | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** De identificaties van dossiers en klanten. */
export interface NieuwKlantdossier {
    /** De unieke identificatie van het aangemaakte klantdossier. */
    klantdossierId: string;
    /** De unieke identificatie van het aangemaakte adviesdossier. */
    adviesdossierId: string;
    /** De unieke identificatie van de aangemaakte klant. */
    aanvrager1KlantId: string;
    /** Optioneel, de unieke identificatie van de aangemaakte partner. */
    readonly aanvrager2KlantId: string | null;
}

/** Gegevens van een nieuw klantdossier */
export interface NieuwKlantdossierInput {
    /** De achternaam van de klant. */
    achternaamAanvrager1: string;
    /** Het tussenvoegsel van de klant. */
    tussenvoegselAanvrager1: string | null;
    /** De roepnaam van de klant. */
    roepnaamAanvrager1: string | null;
    /** De geboortedatum van de klant. */
    geboortedatumAanvrager1: string;
    /** Geeft aan of er sprake is van een partner. */
    heeftAanvrager2: boolean;
    /** De achternaam van de partner. */
    achternaamAanvrager2: string | null;
    /** Het tussenvoegsel van de partner. */
    tussenvoegselAanvrager2: string | null;
    /** De roepnaam van de partner. */
    roepnaamAanvrager2: string | null;
    /** De geboortedatum van de partner. */
    geboortedatumAanvrager2: string | null;
}

/** Resultaat van het toevoegen van een nieuw klantdossier. */
export interface NieuwKlantdossierOutput {
    nieuwKlantdossier: NieuwKlantdossier | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** NotarisType Geen = 0, Passerend = 1, Transporterend = 2, OpstellerGarantieverklaring = 3 */
export enum NotarisType {
    Geen = "Geen",
    Passerend = "Passerend",
    Transporterend = "Transporterend",
    OpstellerGarantieverklaring = "OpstellerGarantieverklaring",
}

export interface NotificatieOutput {
    adviesNotificaties: AdviesNotificatie[] | null;
    systeemNotificatie: SysteemNotificatie[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Output voor het gevraagde arrangement. */
export interface NwbArrangementenOutput {
    /** Output voor het gevraagde arrangement. */
    arrangementen: Arrangement[] | null;
    /** Goed/Fout indicatie */
    isValid: boolean;
    /** Eventuele foutmelding */
    message: string | null;
}

/** Het model voor de concept methods. */
export interface NwbConceptAanvraag {
    /** Gets or sets de product identifier. (intern) */
    productId: string | null;
    /** Gets or sets de arrangement identifier. */
    arrangementId: string | null;
    /** Gets or sets uw kenmerk. */
    uwKenmerk: string | null;
    /** Gets or sets de kopers. */
    kopers: ConceptKoper[] | null;
    verkopers: ConceptVerkopers | null;
    adresOnroerendeZaak: ConceptAdres | null;
    nieuwbouwgegevens: ConceptNieuwbouwgegevens | null;
    /** Gets or sets de geldverstrekker. */
    geldverstrekker: string | null;
    /** Gets or sets het offertenummer. */
    offertenummer: string | null;
    /** Gets or sets het hypotheekbedrag. */
    hypotheekbedrag: number | null;
    /** Gets or sets bedrag aan eigenmiddelen. */
    eigenmiddelen: number | null;
    /** Gets or sets marktwaarde bedrag. */
    marktwaarde: number | null;
    /** Gets or sets het aankoopbedrag. */
    aankoopbedrag: number | null;
    /** Gets or sets het overbruggingsbedrag. */
    overbrugging: number | null;
    /** Gets or sets indicatie nationale hypotheekgarantie Ja/Nee. */
    nationaleHypotheekgarantie: boolean | null;
    /** Gets or sets de passeerdatum. */
    passeerdatum: string | null;
    /** Gets or sets de uiterste afgiftedatum. */
    uitersteAfgiftedatum: string | null;
    notaris: ConceptNotaris | null;
    /** Gets or sets indicatie verzekerd Ja/Nee. */
    isVerzekerd: boolean | null;
    /** Gets or sets eventuele opmerkingen. */
    opmerkingen: string | null;
}

/** Output model voor concept aanvraag */
export interface NwbConceptOutput {
    concept: NwbConceptAanvraag | null;
    /** Gets or sets bevat na de postconcept aanroep de URL naar de
aanvraag in het NWB portaal. De klkant kan deze gebruiken om direc,
zonder in te loggen naar de aanvraag te gaan. */
    aanvraagUrl: string | null;
    /** Gets or sets goed/Fout indicatie */
    isValid: boolean | null;
    /** Gets or sets eventuele foutmelding */
    message: string | null;
}

/** Ouput voor geldverstekkers method. */
export interface NwbGeldverstrekkersOutput {
    /** Lijst met geldverstekker gegevens. */
    geldverstrekkers: Geldverstrekker[] | null;
    /** Goed/Fout indicatie */
    isValid: boolean;
    /** Eventuele foutmelding */
    message: string | null;
}

/** Output voor de producten method. */
export interface NwbProductenOutput {
    /** Lijst met product elementen */
    producten: Product[] | null;
    /** Goed/Fout indicatie */
    isValid: boolean;
    /** Eventuele foutmelding */
    message: string | null;
}

/** Bevat gegevens van een onderneming. */
export interface Onderneming {
    /** Volgnummer van het inkomen binnen de ondernemingen van een klant */
    volgnummer: number;
    /** Bedrag inkomen vorig jaar */
    inkomenJaarMin1Bedrag: number | null;
    /** Bedrag inkomen 2 jaar geleden */
    inkomenJaarMin2Bedrag: number | null;
    /** Datum overgang op partner */
    overgangOpPartnerEinddatum: string | null;
    /** Datum einde onderneming */
    eindeOndernemingDatum: string | null;
    /** Indicatieveld. Einde bij arbeidsongeschiktheid */
    eindeBijAo: boolean | null;
    /** Indicatieveld. Is er sprake van dotatie FOR? */
    forDotatie: boolean | null;
    /** Indicatieveld. Is er sprake van meewerkaftrek? */
    meewerkaftrek: boolean | null;
    /** Indicatieveld. Is er sprake van overgang op partner bij overlijden? */
    overgangOpPartner: boolean | null;
    /** Indicatieveld. Is er sprake van zelfstandigenaftrek? */
    zelfstandigenaftrek: boolean | null;
    /** Boekjaar */
    boekjaar: number | null;
    /** Leeftijd overgang op partner */
    overgangOpPartnerEindleeftijd: number | null;
    /** Percentage overgang op partner */
    overgangOpPartnerPercentage: number | null;
    /** Indicatie dat men gebruik maakt van de MKB-Winstvrijstelling */
    mkbWinstvrijstelling: boolean | null;
    soortOndernemingHdn: SoortOndernemingType | null;
    rechtsVorm: RechtsVormType | null;
    /** Het nummer van de onderneming waarmee het bij de Kamer van Koophandel geregistreerd staat */
    kvkNummer: string | null;
    /** Het nummer van de vestiging waarmee het bij de Kamer van Koophandel geregistreerd staat */
    kvkVestigingsnummer: string | null;
    /** Indicatieveld. Einde bij werkloosheid */
    eindeBijWw: boolean | null;
    /** Indicatie dat het resultaat bij arbeidsongeschiktheid afhankelijk is van de verdiencapaciteit */
    resultaatVdc: boolean | null;
    /** Datum aanvang onderneming */
    ondernemingAanvangsdatum: string | null;
    inkomenScenario: BedragScenario | null;
    /** Indicatie dat het een DGA betreft */
    dga: boolean | null;
    /** Aandelenpercentage i.g.v. een DGA */
    aandelenPercentage: number | null;
    /** SBI-code */
    sbiCode: string | null;
    /** Rechtspersonen Samenwerkingsverbanden Informatie Nummer (RSIN) */
    rsin: string | null;
    soortInkomenverklaring: InkomenverklaringOpties | null;
    /** Toetsinkomen */
    toetsinkomen: number | null;
    /** Het aantal ondernemingen dat bijdraagt aan het opgegeven inkomen. */
    aantalOndernemingen: number | null;
    /** Kenmerk van de inkomensverklaring ondernemer waarmee deze bekend is binnen het accountancy domein. (BOI) */
    boi: string | null;
    /** Uitgiftedatum verklaring inkomen */
    uitgiftedatumVerklaringInkomen: string | null;
    /** Rekenexpert conform HDN keuzelijst RekenexpertType */
    rekenexperttypeCode: number | null;
    /** Kenmerk van de inkomensverklaring ondernemer waarmee deze bekend is binnen het accountancy domein (voorheen 'BOI'). */
    dossiernummer: string | null;
    /** Omschrijving soort overige inkomsten */
    soortOverigeInkomsten: string | null;
}

/** Invoer voor een Opbouw-berekening. */
export interface OpbouwBerekening {
    opbouwProduct: HypotheekVoorstelLeningdeel | null;
}

/** Het resultaat van de opnameberekening. */
export interface OpnameBerekeningOutput {
    /** De berekende resultaten van de opnameberekening. */
    readonly resultaat: OpnamePerJaarResultaat[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat het voorbeeldbedrag en de maximale opname van de vermogensrekening in een bepaald jaar. */
export interface OpnamePerJaarResultaat {
    /** Jaar van de vermogensrekening. */
    jaar: number;
    /** Voorbeeldkapitaal. */
    voorbeeldBedrag: number;
    /** Maximale opname. */
    maxOpnameBedrag: number;
}

/** Bevat de gegevens van Adviesbox Form Overlijdensrisicoverzekering. */
export interface Orv {
    /** De producten op het scherm */
    producten: OrvProduct[];
    aanvrager1: OrvAanvrager | null;
    aanvrager2: OrvAanvrager | null;
    /** De af te lossen leningdelen van het voorstel. */
    readonly leningdelen: LeningdeelReadOnly[] | null;
    /** De af te lossen kredieten van het voorstel. */
    readonly kredieten: KredietReadOnly[] | null;
    /** De naam van de geldverstrekker die in het Form Hypotheek geselecteerd is. */
    readonly geldverstrekkerNaam: string | null;
    /** Ingangsdatum van het voorstel (of: 'Passeerdatum' wanneer er een hypotheek geadviseerd wordt) */
    readonly ingangsdatumVoorstel: string | null;
}

/** De aanvraaggegevens van een ORV-product. */
export interface OrvAanvraag {
    /** Heeft aanvrager 1 een strafrechtelijk verleden. */
    strafrechtelijkVerledenAanvrager1: boolean | null;
    /** Heeft aanvrager 2 een strafrechtelijk verleden. */
    strafrechtelijkVerledenAanvrager2: boolean | null;
    /** Geeft aan of er sprake is van een voorlopige ingangsdatum. */
    voorlopigeIngangsdatum: boolean | null;
    /** Geeft aan of de communicatie digitaal verzonden mag worden. */
    akkoordMetDigitaleCommunicatie: boolean | null;
    /** Geeft aan of de polis digitaal opgestuurd mag worden. */
    akkoordMetDigitalePolis: boolean | null;
    /** Geeft aan of de toelichting is gelezen en slotverklaring akkoord is. */
    toelichtingGelezenAkkoordMetSlotverklaring: boolean | null;
    /** Geeft aan of er bij een andere verzeraar een nog een lopende aanvraag is. */
    eldersLopendeAanvraag: boolean | null;
    /** Indicatie dat men voldoet aan de acceptatiecriteria. */
    voldoetAanAcceptatiecriteria: boolean | null;
}

/** De gegevens van de aanvrager */
export interface OrvAanvrager {
    /** Indicatie of de aanvrager kinderen heeft */
    readonly heeftKinderen: boolean | null;
    klantId: string;
    readonly achternaam: string | null;
    readonly voorvoegsel: string | null;
    readonly voorletters: string | null;
    readonly voornamen: string | null;
    geslacht: GeslachtOpties | null;
    readonly roker: boolean | null;
    readonly geboortedatum: string | null;
    readonly aowdatum: string | null;
}

/** Invoer voor een ORV-berekening. */
export interface OrvBerekening {
    orvProduct: OrvProduct;
}

/** De dekking van een ORV-product. */
export interface OrvDekking {
    /** Het annuïteitspercentage. */
    annuiteits1Percentage: number | null;
    verzekeringsmotief: Verzekeringsmotief | null;
    doelVerzekering: DoelVerzekeringOptions | null;
    /** Verzekerd kapitaal van aanvrager 1 of van het product. */
    verzekerdKapitaal1Bedrag: number | null;
    /** Dekking daalt tot van aanvrager 1 of van het product. */
    dekkingDaaltTot1Bedrag: number | null;
    /** Dur van de daling in jaren voor aanvrager 1. */
    duurDalingInJaren1: number | null;
    /** Annuïteitspercentage aanvrager 2. */
    annuiteits2Percentage: number | null;
    /** Verzekerd kapitaal aanvrager 2. */
    verzekerdKapitaal2Bedrag: number | null;
    /** Dekking daalt tot van aanvrager 2. */
    dekkingDaaltTot2Bedrag: number | null;
    /** Dur van de daling in jaren voor aanvrager 2. */
    duurDalingInJaren2: number | null;
    /** Indicatie dat er sprake is van 'reservewaarde' (ook wel: 'premiereserve') */
    reservewaarde: boolean | null;
    basisdekking: Indexatiesoort | null;
    /** Het verzekerd maandbedrag. */
    verzekerdMaandbedrag: number | null;
    uitkeringBij: UitkeringBijOverlijdenSoort | null;
    /** Einddatum van de HAV-dekking. */
    einddatum: string | null;
    /** Leeftijd op de einddatum. */
    readonly eindleeftijd: number | null;
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form ORV (zowel huidige situatie als voorstel). */
export interface OrvOutput {
    /** Lijst met ORV-producten per adviesdossier (huidige situatie) of voorstel. */
    orvs: { [key: string]: Orv; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** De polisgegevens van een ORV-product. */
export interface OrvPolis {
    productnummer: string | null;
    maatschappijCode: string | null;
    maatschappijOmschrijving: string | null;
    maatschappijCodeHdn: string | null;
    productnaam: string | null;
    productcode: number;
    ingangsdatum: string;
    looptijdInMaanden: number | null;
    uwBemiddeling: boolean;
}

/** De premiegegevens van een ORV-product. */
export interface OrvPremie {
    /** Geeft aan of er sprake is van verkorte premieduur. */
    verkortePremieduur: boolean | null;
    /** Het aantal maanden dat premie betaald moet worden. */
    premieduurInMaanden: number | null;
    betalingsTermijn: BetalingsTermijnType | null;
    /** Premiebedrag. */
    premieBedrag: number | null;
    /** Specificatie van het verloop van de premie per jaar bij premieverloop 'Variabel'. */
    premiesPerJaar: PremiePerJaar[] | null;
    /** Geeft aan of de premie aftrekbaar is. */
    premieAftrekbaar: boolean | null;
}

/** Basis ORV-product. */
export interface OrvProduct {
    soortProduct: SoortOrvProductOptions;
    uitkeringssoort: OrvUitkeringssoortOptions | null;
    /** Geeft aan of het om een doorlopend product gaat. */
    readonly doorlopend: boolean | null;
    polis: OrvPolis;
    /** Unieke identificaties van de klanten die als verzekeringnemer geselecteerd zijn */
    verzekeringnemerKlantIds: string[];
    /** Unieke identificaties van de klanten die als verzekerde geselecteerd zijn */
    verzekerdeKlantIds: string[];
    /** Geeft aan of er gebruik gemaakt wordt van premiesplitsing. */
    premiesplitsing: boolean | null;
    dekking: OrvDekking;
    premie: OrvPremie;
    verpanding: OrvVerpanding | null;
    aanvraag: OrvAanvraag | null;
    /** Indicatie dat indien er doorlopende producten gewijzigd zijn, deze opnieuw overgenomen moeten worden naar de voorstellen */
    wijzigingenInDoorlopendeProductenOvernemen: boolean;
    premieverloop: PremieverloopOptions;
    productId: string | null;
    meenemen: boolean;
}

/** Het resultaat van een ORV-berekening. */
export interface OrvResultaat {
    /** De berekende premie. */
    readonly premies: OrvResultaatPremie[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Een berekende ORV-premie. */
export interface OrvResultaatPremie {
    /** Premiebedrag */
    readonly bedrag: number | null;
    /** Premie bedrag inclusief premievrijstelling bij arbeidsongeschiktheid */
    readonly bedragInclusiefPva: number | null;
    /** Premie bedrag exclusief premievrijstelling bij arbeidsongeschiktheid */
    readonly bedragExclusiefPva: number | null;
    /** Looptijd in maanden */
    readonly looptijdInMaanden: number | null;
}

/** OrvUitkeringssoortOptions LineairDalend = 1, AnnuïtairDalend = 2, Gelijkblijvend = 3 */
export enum OrvUitkeringssoortOptions {
    LineairDalend = "LineairDalend",
    AnnuïtairDalend = "AnnuïtairDalend",
    Gelijkblijvend = "Gelijkblijvend",
}

/** Bevat de invoergegevens van de ORV premievergelijker. */
export interface OrvVergelijkerInput {
    /** Unieke identificaties van de klanten die als verzekerde geselecteerd zijn */
    verzekerdeKlantIds: string[];
    /** Indicatie dat de eerste verzekerde rookt */
    verzekerde1Roker: boolean;
    /** Indicatie dat de tweede verzekerde (indien aanwezig) rookt */
    verzekerde2Roker: boolean | null;
    verzekeringsvorm: OrvUitkeringssoortOptions;
    /** Aanvangsdatum */
    aanvangsdatum: string;
    /** Duur */
    duurInJaren: number;
    /** Verzekerd kapitaal */
    verzekerdKapitaalBedrag: number;
    /** Het annuïteitspercentage */
    annuiteitsPercentage: number | null;
    /** Verpand */
    verpand: boolean;
}

/** Het resultaat van een ORV premievergelijker. */
export interface OrvVergelijkerOutput {
    /** De berekende resultaten. */
    readonly resultaten: OrvVergelijkerResultaat[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Een berekende ORV-premie. */
export interface OrvVergelijkerResultaat {
    /** De code van de verzekeringsmaatschappij uit de Producten Web API */
    readonly maatschappijCode: string | null;
    /** Maatschappij */
    readonly maatschappijOmschrijving: string | null;
    /** De code van het product uit de Producten Web API. */
    productcode: number;
    /** Product */
    readonly productnaam: string | null;
    /** Premieduur (in jaren) */
    premieduurInJaren: number;
    premieverloop: PremieverloopOptions;
    /** Totale premie */
    readonly totalePremieBedrag: number | null;
    /** Eerste premie */
    readonly eerstePremieBedrag: number | null;
    /** Reservewaarde true/false */
    readonly reservewaarde: boolean | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** De verpanding van een ORV-product. */
export interface OrvVerpanding {
    /** Geeft aan of het product bedoeld is als inkomensaanvulling. */
    inkomensaanvulling: boolean | null;
    inkomensaanvullingAanvrager1: InkomensaanvullingBijOverlijden | null;
    inkomensaanvullingAanvrager2: InkomensaanvullingBijOverlijden | null;
    verpandAanGeldverstrekker: boolean | null;
    bedoeldVoorAflossing: boolean | null;
    aflosproducten: Aflosproduct[] | null;
}

/** Bevat het bedrag van het ouderdomspensioen van een bepaalde ingangsdatum. */
export interface OuderdomspensioenIndexering {
    /** Volgnummer van de indexering binnen de AO-uitkering */
    volgnummer: number;
    /** Ingangsdatum */
    ingangsdatum: string | null;
    /** Bedrag */
    bedrag: number | null;
}

/** Bevat het verloop van het ouderdomspensioen. */
export interface OuderdomspensioenScenario {
    /** Bevat de bedragen per ingangsdata */
    indexeringen: OuderdomspensioenIndexering[] | null;
}

/** De invoer voor de overbruggingskrediet-berekening. */
export interface OverbruggingskredietInput {
    /** De hoogte van het overbruggingskrediet */
    overbruggingBedrag: number | null;
    /** De bij het overbruggingskrediet behorende afsluitkosten (provisie) */
    afsluitkostenBedrag: number | null;
    /** Het gedeelte van de overbrugging dat in box 1 valt (box 3 wordt hiervan afgeleid) */
    box1Bedrag: number | null;
    /** Indicatie dat de overwaarde default overgenomen moet worden */
    overwaardeMeenemen: boolean | null;
    /** Indicatie dat de einddatum default overgenomen moet worden van de verkoopdatum van een te verkopen pand */
    einddatumMeenemen: boolean | null;
    /** De einddatum van het overbruggingskrediet */
    einddatum: string | null;
    /** De rente van het overbruggingskrediet */
    rentePercentage: number | null;
    /** De ingangsdatum van het overbruggingskrediet (gelijk aan passeerdatum) */
    aanvangsdatum: string | null;
    /** Het gedeelte van de overwaarde dat meegenomen moet worden in het overbruggingskrediet */
    meenemenInOverbruggingBedrag: number | null;
    hypotheekNorm: TarievenNorm | null;
}

/** De uitvoer van de overbruggingskrediet-berekening. */
export interface OverbruggingskredietOutput {
    resultaat: OverbruggingskredietResultaat | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat het resultaat van de overbruggingskrediet-berekening. */
export interface OverbruggingskredietResultaat {
    /** Maandelijkse rentelast bruto. */
    rentelastMaandelijksBrutoBedrag: number | null;
    /** Maandelijkse rentelast netto. */
    rentelastMaandelijksNettoBedrag: number | null;
    /** Totale rentelast bruto. */
    rentelastTotaalBrutoBedrag: number | null;
    /** Totale rentelast netto. */
    rentelastTotaalNettoBedrag: number | null;
}

/** Bevat de gegevens van Adviesbox Form Overig. */
export interface Overig {
    /** De producten op het scherm */
    producten: OverigProduct[];
    aanvrager1: KlantnaamReadOnly | null;
    aanvrager2: KlantnaamReadOnly | null;
    /** Ingangsdatum van het voorstel (of: 'Passeerdatum' wanneer er een hypotheek geadviseerd wordt) */
    readonly ingangsdatumVoorstel: string | null;
}

/** Algemene gegevens van het product. */
export interface OverigAlgemeen {
    /** De naam van het product */
    productnaam: string | null;
    /** Omschrijving van het product */
    omschrijving: string | null;
    /** De ingangsdatum van het product. */
    aanvangsdatum: string;
    /** De looptijd van het product in maanden. */
    looptijdInMaanden: number;
    /** True indien de adviseur de nazorg op het product levert. */
    uwBemiddeling: boolean;
    /** Geeft aan doorlopend of nieuw */
    doorlopend: boolean | null;
}

/** Gegevens van het product. */
export interface OverigGegevens {
    correctieScenario: BedragScenario;
    betalingstermijn: BetalingsTermijnType;
    /** Geeft aan of er sprake is van inkomen uit arbeid. */
    inkomenUitArbeid: boolean | null;
    /** Geeft aan of de correctie onderdeel uitmaakt van het dagloon. */
    onderdeelDagloon: boolean | null;
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Overig (zowel huidige situatie als voorstel). */
export interface OverigOutput {
    /** Lijst met Overige-producten per adviesdossier (huidige situatie) of voorstel. */
    overigen: { [key: string]: Overig; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de gegevens van het overige product. */
export interface OverigProduct {
    /** Unieke identificatie van het product. */
    productId: string | null;
    /** Indicatie dat het product doorloopt in de nieuwe situatie */
    meenemen: boolean;
    algemeen: OverigAlgemeen;
    correctieLast: SoortCorrectieLastOptions | null;
    correctieFiscaal: SoortCorrectieFiscaalOptions | null;
    /** Unieke identificatie van de klant die als heffingspartij geselecteerd is. */
    heffingBijKlantId: string;
    gegevens: OverigGegevens;
    verrekenen: OverigVerrekenen;
    /** Indicatie dat indien er doorlopende producten gewijzigd zijn, deze opnieuw overgenomen moeten worden naar de voorstellen */
    wijzigingenInDoorlopendeProductenOvernemen: boolean;
}

/** Gegevens met betrekking tot de verrekening van het product. */
export interface OverigVerrekenen {
    /** Geeft aan of er sprake is van scenario Langleven. */
    langleven: boolean;
    /** Geeft aan of er sprake is van scenario Arbeidsongeschiktheid. */
    arbeidsongeschiktheid: boolean;
    /** Geeft aan of er sprake is van scenario Werkloosheid. */
    werkloosheid: boolean;
    /** Geeft aan of er sprake is van scenario Overlijden. */
    overlijden: boolean;
    /** Percentage overgang op partner */
    overgangOpPartnerPercentage: number | null;
    /** Datum overgang op partner */
    overgangOpPartnerEinddatum: string | null;
}

/** Bevat gegevens van overige inkomsten box 1. */
export interface OverigeInkomstenBox1 {
    /** Omschrijving (bij overige inkomsten) */
    omschrijving: string | null;
    /** Overige inkomsten (vrij invoerbaar) */
    bedrag: number;
    /** Einddatum overige inkomsten 2 */
    einddatum: string | null;
    /** Indicatie dat de einddatum gelijkgesteld moet worden aan de AOW-datum */
    einddatumOvernemen: boolean;
}

/** OverigeInkomstenBox3Soort BeleggingenInkomsten = 2, VerhuurInkomsten = 13 */
export enum OverigeInkomstenBox3Soort {
    BeleggingenInkomsten = "BeleggingenInkomsten",
    VerhuurInkomsten = "VerhuurInkomsten",
}

/** Bevat de inhoud van het Adviesbox-form Pensioen. */
export interface Pensioen {
    /** Bevat pensioenen */
    pensioenen: PensioenGegevens[] | null;
    aanvrager1: PensioenAanvrager | null;
    aanvrager2: PensioenAanvrager | null;
}

/** Bevat de naamgegevens en loondiensten van een aanvrager. */
export interface PensioenAanvrager {
    /** Collectie met loondiensten / inkomens uit dienstverband
Deze is benodigd om 'Dienstverband bij pensioen Huidige werkgever' te kunnen vullen
Loondienst bevat velden voor loondienstid, naam werkgever, totaal inkomen en de einddatum van het inkomen / pensioendatum */
    readonly loondiensten: LoondienstReadOnly[] | null;
    burgerlijkeStaat: BurgerlijkeStaatType | null;
    klantId: string;
    readonly achternaam: string | null;
    readonly voorvoegsel: string | null;
    readonly voorletters: string | null;
    readonly voornamen: string | null;
    geslacht: GeslachtOpties | null;
    readonly roker: boolean | null;
    readonly geboortedatum: string | null;
    readonly aowdatum: string | null;
}

/** Gegevens van een pensioen */
export interface PensioenGegevens {
    /** Unieke identificatie van het pensioen */
    pensioenId: string | null;
    /** Volgnummer van het pensioen binnen de pensioenen van de klant */
    volgnummer: number;
    /** Unieke identificatie van de klant; wordt gebruikt om de geselecteerde pensioendeelnemer bij te houden */
    klantId: string;
    /** Indicatieveld. Behoort pensioen bij huidige werkgever (True) of vorige (False) */
    pensioenBijHuidigeWerkgever: boolean;
    /** Naam pensioenuitvoerder */
    pensioenUitvoerder: string | null;
    /** Branche */
    branche: string | null;
    /** Unieke identificatie van dienstverband / loondienst; wordt gebruikt om de geselecteerde dienstverband / loondienst bij te houden */
    loondienstId: string | null;
    soortPensioenregeling: Pensioenregelingsoort | null;
    /** Percentage rekenrente opbouwfase */
    opbouwPercentage: number | null;
    /** Percentage rekenrente uitkeringsfase */
    uitkeringPercentage: number | null;
    /** Bedrag beschikbare premie (soort pensioen) */
    beschikbaarBedrag: number | null;
    /** Bedrag pensioengevend inkomen */
    pensioengevendInkomenBedrag: number | null;
    /** Bedrag pensioengevend inkomen overnemen uit berekening */
    pensioengevendInkomenOvernemen: boolean | null;
    /** Bedrag franchise */
    franchiseBedrag: number | null;
    /** Bedrag franchise overnemen uit berekening */
    franchiseOvernemen: boolean | null;
    /** Bedrag grondslag */
    grondslagBedrag: number | null;
    /** Bedrag grondslag overnemen uit berekening */
    grondslagOvernemen: boolean | null;
    /** Bedrag pensioen aangroei (factor A) */
    aangroeiBedrag: number | null;
    /** Bedrag Aangroei (factor A) overnemen uit berekening */
    aangroeiOvernemen: boolean | null;
    /** Huidig opgebouwd pensioenbedrag */
    opgebouwdBedrag: number | null;
    /** Datum overzicht */
    overzichtDatum: string | null;
    /** Bedrag doelvermogen */
    doelvermogenBedrag: number | null;
    /** Bedrag bijdrage prepensioen */
    bijdragePrePensioenBedrag: number | null;
    /** Bedrag bijdrage ouderdomspensioen */
    bijdrageOuderdomsPensioenBedrag: number | null;
    /** Indicatieveld. Sprake van ouderdomspensioen? */
    ouderdomspensioen: boolean | null;
    /** Bedrag ouderdomspensioen */
    ouderdomspensioenBedrag: number | null;
    /** Datum ouderdomspensioen */
    ouderdomspensioenDatum: string | null;
    ouderdomspensioenScenario: OuderdomspensioenScenario | null;
    /** Indicatieveld. Sprake van prepensioen? */
    prepensioen: boolean | null;
    /** Bedrag prepensioen */
    prepensioenBedrag: number | null;
    /** Datum prepensioen */
    prepensioenDatum: string | null;
    /** Is er sprake van partnerpensioen tot AOW bij overlijden voor AOW */
    partnerpensioenTotAowOverlijdenVoorAow: boolean | null;
    /** Percentage partnerpensioen tot AOW bij overlijden voor AOW van ouderdomspensioen */
    partnerpensioenTotAowOverlijdenVoorAowPercentage: number | null;
    /** Bedrag partnerpensioen tot AOW bij overlijden voor AOW van ouderdomspensioen */
    partnerpensioenTotAowOverlijdenVoorAowBedrag: number | null;
    /** Partnerpensioen na AOW bij overlijden voor AOW */
    partnerpensioenNaAowOverlijdenVoorAow: boolean | null;
    /** Percentage partnerpensioen na AOW bij overlijden voor AOW van ouderdomspensioen */
    partnerpensioenNaAowOverlijdenVoorAowPercentage: number | null;
    /** Bedrag partnerpensioen na AOW bij overlijden voor AOW van ouderdomspensioen */
    partnerpensioenNaAowOverlijdenVoorAowBedrag: number | null;
    /** Partnerpensioen tot AOW bij overlijden na AOW */
    partnerpensioenTotAowOverlijdenNaAow: boolean | null;
    /** Percentage partnerpensioen tot AOW bij overlijden na AOW van ouderdomspensioen */
    partnerpensioenTotAowOverlijdenNaAowPercentage: number | null;
    /** Bedrag partnerpensioen tot AOW bij overlijden na AOW van ouderdomspensioen */
    partnerpensioenTotAowOverlijdenNaAowBedrag: number | null;
    /** Partnerpensioen na AOW bij overlijden na AOW */
    partnerpensioenNaAowOverlijdenNaAow: boolean | null;
    /** Percentage partnerpensioen na AOW bij overlijden na AOW van ouderdomspensioen */
    partnerpensioenNaAowOverlijdenNaAowPercentage: number | null;
    /** Bedrag partnerpensioen na AOW bij overlijden na AOW van ouderdomspensioen */
    partnerpensioenNaAowOverlijdenNaAowBedrag: number | null;
    /** Indicatieveld. Sprake van ANW compensatie tot AOW jaar bij onvolledig ANW? */
    anwCompensatie: boolean | null;
    /** Bedrag ANW compensatie tot AOW jaar bij onvolledig ANW */
    anwCompensatieBedrag: number | null;
    /** Indicatieveld. Sprake van wezenpensioen? */
    wezenpensioen: boolean | null;
    /** Wezenpensioen bedrag */
    wezenpensioenBedrag: number | null;
    /** Percentage wezenpensioen (na AOW) van ouderdomspensioen */
    wezenpensioenPercentage: number | null;
    /** Eindleeftijd wezenpensioen */
    wezenpensioenEindleeftijd: number | null;
    /** Invaliditeitspensioen */
    invaliditeitspensioen: boolean | null;
    /** Bedrag bij invaliditeit */
    invaliditeitspensioenBedrag: number | null;
    /** Percentage invaliditeitspensioen (na AOW) van ouderdomspensioen */
    invaliditeitspensioenPercentage: number | null;
    invaliditeitspensioenUitkeringswijze: UitkeringAoSoort | null;
    aoUitkering: AoUitkering | null;
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Pensioen. */
export interface PensioenOutput {
    /** Lijst met de inhoud van het scherm Pensioen per adviesdossier. */
    pensioenen: { [key: string]: Pensioen; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Pensioenregelingsoort Geen = 0, Eindloon = 1, Middelloon = 2, BeschikbarePremie = 3 */
export enum Pensioenregelingsoort {
    Geen = "Geen",
    Eindloon = "Eindloon",
    Middelloon = "Middelloon",
    BeschikbarePremie = "BeschikbarePremie",
}

/** Gegevens van 1 leningdeel. */
export interface PerLeningdeel {
    /** Gets/sets het leningdeelbedrag. */
    leningdeelBedrag: number;
    meenemen: Meeneemtype | null;
    /** Gets/sets het loyaliteitsbedrag. */
    loyaliteitsbedrag: number | null;
    /** Volgnummer. */
    volgnummer: number;
    /** Afloscodevorm code HDN. */
    afloscodeHdn: string | null;
    /** Ingangsdatum leningdeel. */
    ingangsdatum: string | null;
    renteAfspraak: RenteAfspraakType;
    /** Gets/sets de rentevastperiode in maanden. */
    rentevastInMaanden: number;
    /** De huidige rente. */
    huidigeRente: number | null;
}

export interface PercentageIndexering {
    percentage: number | null;
    volgnummer: number;
    ingangsmaand: number | null;
}

export interface PercentageScenario {
    waarde: number | null;
    indexeringen: PercentageIndexering[] | null;
    omschrijving: string | null;
}

/** Bevat de input voor de periodieke aflossing-berekening. */
export interface PeriodiekeAflossingInput {
    aflossingsVorm: AflossingsVormType;
    /** Bedrag leningdeel (restant hoofdsom) */
    leningdeelBedrag: number | null;
    /** Datum aanvang van het leningdeel */
    aanvangsdatum: string;
    /** Aantal maanden looptijd */
    looptijdInMaanden: number | null;
    /** Datum opgave */
    opgaveDatum: string | null;
    /** RentePercentage */
    rentePercentage: number;
}

/** De uitvoer van de periodieke aflossing-berekening. */
export interface PeriodiekeAflossingOutput {
    resultaat: PeriodiekeAflossingResultaat | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat het resultaat van de aflossing-berekening. */
export interface PeriodiekeAflossingResultaat {
    /** De berekende periodieke aflossing */
    aflossingBedrag: number | null;
}

/** Bevat de gegevens van de Adviesbox form Personalia. */
export interface Personalia {
    /** Geeft aan of het advies met een mede-aanvrager gevraagd wordt */
    adviesMetMedeaanvrager: boolean;
    /** Geeft aan of aanvrager 2 een afwijkend adres heeft */
    aanvrager2HeeftAfwijkendAdres: boolean | null;
    aanvrager1: PersonaliaAanvrager;
    aanvrager2: PersonaliaAanvrager | null;
    /** De keuze die gemaakt is in het herberekeningscherm */
    herberekeningkeuze: number | null;
}

/** Gegevens van een aanvrager */
export interface PersonaliaAanvrager {
    /** Unieke identificatie van de klant */
    klantId: string | null;
    persoonsgegevens: PersoonDetails;
    klantgegevens: KlantDetails;
    woonadres: Adres | null;
    rekening: Rekening | null;
    /** Uitsluitingen van deze persoon */
    uitsluitingen: Uitsluiting[] | null;
    /** Weigeringen van deze persoon */
    weigeringen: Weigering[] | null;
    /** Kinderen van de aanvrager */
    kinderen: PersonaliaKind[] | null;
}

/** Gegevens van een kind */
export interface PersonaliaKind {
    /** Unieke identificatie van een Kind */
    kindId: string | null;
    /** Roepnaam */
    voornamen: string | null;
    /** Geboortedatum */
    geboortedatum: string;
    /** Indicatie dat het kind bij beide aanvragers hoort (indien van toepassing) */
    gezamenlijkKind: boolean | null;
    /** Indicatieveld. Is het kind inwonend? */
    inwonend: boolean;
    schooltype: Schooltype;
    /** Berekende kinderbijslag per kwartaal */
    readonly kinderbijslagPerKwartaal: number | null;
    /** Aantal keer kinderbijslag. Enkelvoudige of dubbele.. */
    aantalKeerKinderbijslag: number;
    /** Indicatieveld. Is er sprake van co-ouderschap? */
    coOuderschap: boolean;
    /** Berekende kinderbijslag per jaar */
    kinderbijslagPerJaar: number | null;
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Personalia. */
export interface PersonaliaOutput {
    /** Lijst met de inhoud van het Adviesbox-form Personalia per adviesdossier. */
    personalia: { [key: string]: Personalia; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Output voor het opvragen de waarschuwingen voor het Adviesbox-form Personalia. */
export interface PersonaliaWaarschuwingenOutput {
    /** Waarschuwingen voor herberekening optie 1. */
    herberekeningOptie1Waarschuwingen: ValidationResultModel[] | null;
    /** Waarschuwingen voor herberekening optie 2. */
    herberekeningOptie2Waarschuwingen: ValidationResultModel[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de input voor het bepalen van de personeelskorting. */
export interface PersoneelskortingInput {
    /** Code van het hypotheeklabel binnen een geldverstrekker uit de Producten API */
    hypotheeklabelCode: number;
    /** Code van de hypotheekvorm binnen een geldverstrekker */
    hypotheekvormCode: number;
    rentevariant: RentevariantOptions;
    /** Aantal maanden rentevastperiode */
    rentevastAantalMaanden: number | null;
    /** Aantal maanden rentebedenktijd */
    rentebedenktijdInMaanden: number | null;
    personeelskortingKeuze: PersoneelskortingKeuzeOptions;
}

/** PersoneelskortingKeuzeOptions Geen = 0, AmevCode30 = 30, AmevCode31 = 31, AsrCode50 = 50 */
export enum PersoneelskortingKeuzeOptions {
    Geen = "Geen",
    AmevCode30 = "AmevCode30",
    AmevCode31 = "AmevCode31",
    AsrCode50 = "AsrCode50",
}

/** De uitvoer van het bepalen van de personeelskorting. */
export interface PersoneelskortingOutput {
    resultaat: PersoneelskortingResultaat | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat het resultaat van de bepaling. */
export interface PersoneelskortingResultaat {
    /** Het bepaalde personeelskorting */
    personeelskortingPercentage: number | null;
}

export interface PersoonBasis {
    achternaam: string | null;
    voorvoegsel: string | null;
    voorletters: string | null;
    voornamen: string | null;
    geslacht: GeslachtOpties | null;
    geboortedatum: string | null;
    telefoonPrive: string | null;
    email: string | null;
}

/** Bevat detailleerde gegevens van een persoon. */
export interface PersoonDetails {
    /** Achternaam */
    achternaam: string | null;
    /** Voorvoegsel */
    voorvoegsel: string | null;
    /** Voorletters */
    voorletters: string | null;
    /** Roepnaam */
    roepnaam: string | null;
    geslacht: GeslachtOpties;
    /** Geboortedatum */
    geboortedatum: string;
    /** Telefoonnummer prive */
    telefoonPrive: string | null;
    /** E-mailadres */
    email: string | null;
    /** Burgerservicenummer (BSN) */
    bsn: string | null;
    /** Nationaliteit (code) */
    nationaliteitCode: string | null;
    /** Geboortenaam */
    geboortenaam: string | null;
    /** Geboortevoorvoegsel */
    geboorteVoorvoegsel: string | null;
    /** Geboorteplaats */
    geboorteplaats: string | null;
    /** Geboorteland (code) */
    geboortelandCode: string | null;
    /** Telefoonnummer werk */
    telefoonWerk: string | null;
    /** Telefoonnummer mobiel */
    telefoonMobiel: string | null;
    /** Geboortevoornamen */
    voornamen: string | null;
}

export interface Premie {
    volgnummer: number;
    soortPremie: Premiesoort | null;
    aanvangNaMaanden: number | null;
    looptijdInMaanden: number | null;
    premieBedrag: number | null;
    betalingstermijn: BetalingsTermijnType | null;
    uitPremiedepotBedrag: number | null;
    betalingAchteraf: boolean | null;
    premieUitEigenMiddelen: boolean | null;
    premieAftrekbaar: boolean | null;
    stijgingPercentage: number | null;
    stijgingDuurInMaanden: number | null;
    garantiePercentage: number | null;
    aftrekbaarBedrag: number | null;
    minimaalBedrag: number | null;
    optimaalBedrag: number | null;
    premieAlsBuitengewoneUitgave: boolean | null;
    soortRisicodekking: Risicodekkingen | null;
    uitPremiedepotDuurInMaanden: number | null;
    contraverzekeringBedrag: number | null;
}

/** Bevat de totale premie in een bepaald jaar in geval van variabele premie. */
export interface PremiePerJaar {
    /** Jaar van de looptijd van het product waarin de premie geldt. */
    jaar: number;
    /** Het totale premiebedrag in het gegeven jaar. */
    premieTotaalBedrag: number;
}

/** Bevat de input voor de premiedepot-berekening. */
export interface PremiedepotInput {
    uitgangspunt: PremiedepotUitgangspunt;
    uitgangspuntBetaling: BetalenUitPremiedepot | null;
    /** Bedrag depot storting */
    premiedepotBedrag: number | null;
    /** Percentage premiedepot */
    percentage: number | null;
    /** Aantal maanden looptijd */
    looptijdInMaanden: number | null;
    /** Aantal maanden looptijd */
    looptijdDekkingInMaanden: number | null;
    premies: Premie[] | null;
}

/** De uitvoer van de premiedepot-berekening. */
export interface PremiedepotOutput {
    resultaat: PremiedepotResultaat | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat het resultaat van de premiedepot-berekening. */
export interface PremiedepotResultaat {
    /** Het berekende premiedepot */
    premiedepotBedrag: number | null;
    /** Aantal maanden looptijd */
    looptijdInMaanden: number | null;
}

/** PremiedepotUitgangspunt Geen = 0, DuurDepot = 1, BedragDepot = 2, VolledigDepot = 3 */
export enum PremiedepotUitgangspunt {
    Geen = "Geen",
    DuurDepot = "DuurDepot",
    BedragDepot = "BedragDepot",
    VolledigDepot = "VolledigDepot",
}

/** Premiesoort Geen = 0, RisicoNormaal = 1, RisicoHoog = 2, TotaalNormaal = 3, TotaalHoog = 4, Storting = 5, Inleg = 6, Aanvangsstorting = 7, OnttrekkingRente = 8, OnttrekkingPremie = 9, OnttrekkingBelasting = 10, OnttrekkingOverig = 11 */
export enum Premiesoort {
    Geen = "Geen",
    RisicoNormaal = "RisicoNormaal",
    RisicoHoog = "RisicoHoog",
    TotaalNormaal = "TotaalNormaal",
    TotaalHoog = "TotaalHoog",
    Storting = "Storting",
    Inleg = "Inleg",
    Aanvangsstorting = "Aanvangsstorting",
    OnttrekkingRente = "OnttrekkingRente",
    OnttrekkingPremie = "OnttrekkingPremie",
    OnttrekkingBelasting = "OnttrekkingBelasting",
    OnttrekkingOverig = "OnttrekkingOverig",
}

/** PremieverloopOptions Gelijkblijvend = 0, Variabel = 1 */
export enum PremieverloopOptions {
    Gelijkblijvend = "Gelijkblijvend",
    Variabel = "Variabel",
}

/** Premieverloopsoort Geen = 0, Gelijkblijvend = 1, Jaarlijks = 2 */
export enum Premieverloopsoort {
    Geen = "Geen",
    Gelijkblijvend = "Gelijkblijvend",
    Jaarlijks = "Jaarlijks",
}

/** Product gegevens */
export interface Product {
    /** Id van de geldverstrekker (volgens nat. waarborg) */
    id: string | null;
    /** Naam geldverstrekker */
    naam: string | null;
}

/** ProductHostOpties Geen = 0, Leven = 1, Orv = 2, Aov = 3, Vermogen = 4, Lijfrente = 5, Uitvaart = 6, Schade = 7, Abonnement = 8, Krediet = 9, VrijeKolom = 10, Energie = 11, Telecom = 12, Hypotheek = 13 */
export enum ProductHostOpties {
    Geen = "Geen",
    Leven = "Leven",
    Orv = "Orv",
    Aov = "Aov",
    Vermogen = "Vermogen",
    Lijfrente = "Lijfrente",
    Uitvaart = "Uitvaart",
    Schade = "Schade",
    Abonnement = "Abonnement",
    Krediet = "Krediet",
    VrijeKolom = "VrijeKolom",
    Energie = "Energie",
    Telecom = "Telecom",
    Hypotheek = "Hypotheek",
}

export interface ProductKenmerken {
    readonly polisnummer: string | null;
    kapitaalopbouw: KapitaalopbouwOptions | null;
    readonly productId: string | null;
    readonly externeMaatschappijCode: string | null;
    readonly externeMaatschappijOmschrijving: string | null;
    readonly lijfrenteclausuleOrigineel: boolean | null;
    fiscaleTypering: FiscaleTyperingOptions | null;
    readonly garantieverzekering: boolean | null;
    fiscaalRegime: FiscaalRegimeOptions | null;
    readonly oorspronkelijkeIngangsdatum: string | null;
    readonly ingangsdatumBox1: string | null;
    readonly einddatum: string | null;
    readonly doelkapitaalBedrag: number | null;
    readonly laagstePremieooitBedrag: number | null;
    readonly hoogstePremieOoitBedrag: number | null;
    readonly huidigeJaarPremieBedrag: number | null;
    readonly premieLopendJaarBedrag: number | null;
    readonly eerdereUitkeringenBedrag: number | null;
    readonly ingebrachteWaardeBedrag: number | null;
}

/** ProductkeuzeOptions GS1218 = 1 */
export enum ProductkeuzeOptions {
    GS1218 = "GS1218",
}

export interface ProvisieItem {
    volgnummer: number;
    provisieCodeHdn: string | null;
    afwijkend: boolean | null;
    afsluitPercentage: number | null;
    doorloopPercentage: number | null;
    rentekortingPercentage: number | null;
    netto: boolean | null;
    premiesoort: ProvisiePremiesoort | null;
    percentage: number | null;
    code: string | null;
    soort: Provisiesoort | null;
    bedrag: number | null;
}

/** ProvisiePremiesoort Geen = 0, Termijnpremie = 1, Koopsom = 2, Hypotheek = 3 */
export enum ProvisiePremiesoort {
    Geen = "Geen",
    Termijnpremie = "Termijnpremie",
    Koopsom = "Koopsom",
    Hypotheek = "Hypotheek",
}

export interface Provisiekeuze {
    provisieItems: ProvisieItem[] | null;
}

/** Provisiesoort Geen = 0, Afsluitprovisie = 1, Doorlopendeprovisie = 2, Opbouw = 3, Inbouw = 4, Code = 5, Afsluitkorting = 6, Rentekorting = 7, ProvisieBedrag = 8, Prolongatie = 9, Incassovergoeding = 10 */
export enum Provisiesoort {
    Geen = "Geen",
    Afsluitprovisie = "Afsluitprovisie",
    Doorlopendeprovisie = "Doorlopendeprovisie",
    Opbouw = "Opbouw",
    Inbouw = "Inbouw",
    Code = "Code",
    Afsluitkorting = "Afsluitkorting",
    Rentekorting = "Rentekorting",
    ProvisieBedrag = "ProvisieBedrag",
    Prolongatie = "Prolongatie",
    Incassovergoeding = "Incassovergoeding",
}

export interface RapportSamenstellenElement {
    code: number;
    naam: string | null;
    soortElement: SoortElementOptions;
    volgnummer: number;
    inhoud: string | null;
    inhoudWijzigbaar: boolean;
    naamWeergevenAlsTitel: boolean;
    elementen: RapportSamenstellenElement[] | null;
    geselecteerd: boolean;
}

export interface RapportSamenstellenStructuur {
    elementen: RapportSamenstellenElement[];
    structuurId: string;
    volgnummer: number;
    naam: string | null;
}

/** Bevat gegevens van een rapportage-structuurkeuze t.b.v. rapportage-schermen. */
export interface RapportSamenstellenStructuurKeuze {
    /** Unieke identificatie van de rapportage structuur uit de instellingen */
    structuurId: string;
    /** Volgnummer voor weergave in het scherm */
    volgnummer: number;
    /** Naam */
    naam: string | null;
}

export interface RapportSamenstellenStructuurOutput {
    structuur: RapportSamenstellenStructuur | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Het resultaat van een zoekopdracht naar recent geopende adviesdossiers. */
export interface RecentGeopendOutput {
    /** De gevonden resultaten. */
    readonly zoekresultaten: ZoekenAdviesdossierMetKlantInfo[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** RechtsVormType Geen = 0, Eenmanszaak = 1, Maatschap = 2, VennootschapOnderFirma_Vof_ = 3, CommanditaireVennootschap_Cv_ = 4, BeslotenVennootschap_Bv_ = 5, NaamlozeVennootschap_Nv_ = 6, Stichting = 8 */
export enum RechtsVormType {
    Geen = "Geen",
    Eenmanszaak = "Eenmanszaak",
    Maatschap = "Maatschap",
    VennootschapOnderFirma_Vof_ = "VennootschapOnderFirma_Vof_",
    CommanditaireVennootschap_Cv_ = "CommanditaireVennootschap_Cv_",
    BeslotenVennootschap_Bv_ = "BeslotenVennootschap_Bv_",
    NaamlozeVennootschap_Nv_ = "NaamlozeVennootschap_Nv_",
    Stichting = "Stichting",
}

/** RedenAankoopOptions WoningEigenGebruik = 1, TweedeWoning = 2, DeelsVerhuurd = 3, GeheelVerhuurd = 4 */
export enum RedenAankoopOptions {
    WoningEigenGebruik = "WoningEigenGebruik",
    TweedeWoning = "TweedeWoning",
    DeelsVerhuurd = "DeelsVerhuurd",
    GeheelVerhuurd = "GeheelVerhuurd",
}

/** Bevat gegevens van een rekening. */
export interface Rekening {
    /** Unieke identificatie van een rekening */
    rekeningId: string | null;
    /** IBAN van de rekening */
    iban: string | null;
    /** Indicatie dat het een gezamenlijke rekening betreft */
    gezamenlijkeRekening: boolean;
}

/** RenteAfspraakType Geen = 0, Rentevast = 1, Rentedempend = 2, ContinuVariabel = 3, Correctie = 4, PlafondClick = 5, Samengesteld = 6, Orientatie = 9 */
export enum RenteAfspraakType {
    Geen = "Geen",
    Rentevast = "Rentevast",
    Rentedempend = "Rentedempend",
    ContinuVariabel = "ContinuVariabel",
    Correctie = "Correctie",
    PlafondClick = "PlafondClick",
    Samengesteld = "Samengesteld",
    Orientatie = "Orientatie",
}

/** Rentelasten bruto/netto, per maand/totaal van het overbruggingskrediet */
export interface RentelastenOverbrugging {
    /** Maandelijkse rentelast bruto. */
    rentelastMaandelijksBrutoBedrag: number | null;
    /** Maandelijkse rentelast netto. */
    rentelastMaandelijksNettoBedrag: number | null;
    /** Totale rentelast bruto. */
    rentelastTotaalBrutoBedrag: number | null;
    /** Totale rentelast netto. */
    rentelastTotaalNettoBedrag: number | null;
}

export interface RentepercentageInput {
    maatschappijCode: string | null;
    hypotheeklabelCode: number;
    hypotheekvormCode: number;
    rentevariant: RentevariantOptions;
    aflossingsVorm: AflossingsVormType;
    rentevastAantalMaanden: number | null;
    rentebedenktijdInMaanden: number | null;
    personeelskortingPercentage: number | null;
    hypotheekopties: Hypotheekoptie[] | null;
}

export interface RentepercentageOutput {
    resultaat: RentepercentageResultaat | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface RentepercentageResultaat {
    rentePercentage: number | null;
}

/** RentevariantOptions Rentevast = 1, Rentedempend = 2, Variabel = 3 */
export enum RentevariantOptions {
    Rentevast = "Rentevast",
    Rentedempend = "Rentedempend",
    Variabel = "Variabel",
}

/** Risicodekkingen Geen = 0, Ovl = 1, Ww = 2, Ea = 4, Anw = 8, Wga = 16, Wia = 32, WiaExcedent = 64, Zdg = 128, Schade = 256 */
export enum Risicodekkingen {
    Geen = "Geen",
    Ovl = "Ovl",
    Ww = "Ww",
    Ea = "Ea",
    Anw = "Anw",
    Wga = "Wga",
    Wia = "Wia",
    WiaExcedent = "WiaExcedent",
    Zdg = "Zdg",
    Schade = "Schade",
}

/** Invoer voor de bepaling van het risicoprofiel. */
export interface RisicoprofielInput {
    klantprofiel: Klantprofiel;
}

/** RisicoprofielOptions ZeerDefensief = 1, Defensief = 2, Neutraal = 3, Offensief = 4, ZeerOffensief = 5 */
export enum RisicoprofielOptions {
    ZeerDefensief = "ZeerDefensief",
    Defensief = "Defensief",
    Neutraal = "Neutraal",
    Offensief = "Offensief",
    ZeerOffensief = "ZeerOffensief",
}

/** Bevat de output van de bepaling van het risicoprofiel. */
export interface RisicoprofielOutput {
    resultaat: RisicoprofielResultaat | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat het resultaat van de bepaling van het risicoprofiel. */
export interface RisicoprofielResultaat {
    risicoprofiel: RisicoprofielOptions;
}

/** RvcAfwijkingsoort Geen = 0, Vanaf = 1, Tot = 2 */
export enum RvcAfwijkingsoort {
    Geen = "Geen",
    Vanaf = "Vanaf",
    Tot = "Tot",
}

/** Schooltype Geen = 0, GeenSchool = 1, Basisschool = 2, Mbo = 3, Hbo = 4, Wo = 5, NietErkendeOpleiding = 6, OnderbouwHavoVwo = 7, BovenbouwHavoVwo = 8, OnderbouwVmbo = 9, BovenbouwVmbo = 10 */
export enum Schooltype {
    Geen = "Geen",
    GeenSchool = "GeenSchool",
    Basisschool = "Basisschool",
    Mbo = "Mbo",
    Hbo = "Hbo",
    Wo = "Wo",
    NietErkendeOpleiding = "NietErkendeOpleiding",
    OnderbouwHavoVwo = "OnderbouwHavoVwo",
    BovenbouwHavoVwo = "BovenbouwHavoVwo",
    OnderbouwVmbo = "OnderbouwVmbo",
    BovenbouwVmbo = "BovenbouwVmbo",
}

export interface ServiceproviderReadOnly {
    serviceproviderId: string;
    naam: string | null;
    hdnNummer: string | null;
}

/** Situatiekeuze Geen = 0, Situatie1 = 1, Situatie2 = 2, Situatie3 = 4, HuidigeSituatie = 256 */
export enum Situatiekeuze {
    Geen = "Geen",
    Situatie1 = "Situatie1",
    Situatie2 = "Situatie2",
    Situatie3 = "Situatie3",
    HuidigeSituatie = "HuidigeSituatie",
}

export interface SoftwareKoppelingReadOnly {
    softwareKoppelingId: string;
    naam: string | null;
}

/** SoortAflosproductOptions Leningdeel = 0, Krediet = 1 */
export enum SoortAflosproductOptions {
    Leningdeel = "Leningdeel",
    Krediet = "Krediet",
}

/** SoortBerekeningOptions Inleg = 1, EersteInleg = 2, Onttrekking = 3, Voorbeeldkapitaal = 4, Voorbeeldrendement = 5, EigenInvoer = 6 */
export enum SoortBerekeningOptions {
    Inleg = "Inleg",
    EersteInleg = "EersteInleg",
    Onttrekking = "Onttrekking",
    Voorbeeldkapitaal = "Voorbeeldkapitaal",
    Voorbeeldrendement = "Voorbeeldrendement",
    EigenInvoer = "EigenInvoer",
}

/** SoortBerekeningOptionsKv Premie = 1, Voorbeeldkapitaal = 2, Voorbeeldrendement = 3, EigenInvoer = 4 */
export enum SoortBerekeningOptionsKv {
    Premie = "Premie",
    Voorbeeldkapitaal = "Voorbeeldkapitaal",
    Voorbeeldrendement = "Voorbeeldrendement",
    EigenInvoer = "EigenInvoer",
}

/** SoortCorrectieFiscaalOptions Aftrekpost = 0, Bijtelling = 1, Neutraal = 2 */
export enum SoortCorrectieFiscaalOptions {
    Aftrekpost = "Aftrekpost",
    Bijtelling = "Bijtelling",
    Neutraal = "Neutraal",
}

/** SoortCorrectieLastOptions Last = 0, Bijdrage = 1, Neutraal = 2 */
export enum SoortCorrectieLastOptions {
    Last = "Last",
    Bijdrage = "Bijdrage",
    Neutraal = "Neutraal",
}

/** SoortDepotOptions OpbouwDepot = 1, OpnameDepot = 2, VrijDepot = 3 */
export enum SoortDepotOptions {
    OpbouwDepot = "OpbouwDepot",
    OpnameDepot = "OpnameDepot",
    VrijDepot = "VrijDepot",
}

/** SoortDienstBetrekkingType Geen = 0, FlexibeleArbeidsrelatieMetPerspectiefverklaring = 8, FlexibeleArbeidsrelatieZonderPerspectiefverklaring = 9, LoondienstVast = 10, LoondienstTijdelijkMetIntentie = 11, LoondienstTijdelijkZonderIntentie = 12 */
export enum SoortDienstBetrekkingType {
    Geen = "Geen",
    FlexibeleArbeidsrelatieMetPerspectiefverklaring = "FlexibeleArbeidsrelatieMetPerspectiefverklaring",
    FlexibeleArbeidsrelatieZonderPerspectiefverklaring = "FlexibeleArbeidsrelatieZonderPerspectiefverklaring",
    LoondienstVast = "LoondienstVast",
    LoondienstTijdelijkMetIntentie = "LoondienstTijdelijkMetIntentie",
    LoondienstTijdelijkZonderIntentie = "LoondienstTijdelijkZonderIntentie",
}

/** SoortElementOptions Onderdeel = 1, Hoofdstuk = 2, Koptekst = 3, Tekstblok = 4, Grafiek = 5, Tabel = 6, Iteratie = 7 */
export enum SoortElementOptions {
    Onderdeel = "Onderdeel",
    Hoofdstuk = "Hoofdstuk",
    Koptekst = "Koptekst",
    Tekstblok = "Tekstblok",
    Grafiek = "Grafiek",
    Tabel = "Tabel",
    Iteratie = "Iteratie",
}

/** SoortKapitaalverzekeringProductOptions Levensverzekering = 1, UniversalLifePremie = 2, Product = 99 */
export enum SoortKapitaalverzekeringProductOptions {
    Levensverzekering = "Levensverzekering",
    UniversalLifePremie = "UniversalLifePremie",
    Product = "Product",
}

/** SoortKapitaalverzekeringsrekeningOptions Spaar = 1, Belegging = 2, Hybride = 3 */
export enum SoortKapitaalverzekeringsrekeningOptions {
    Spaar = "Spaar",
    Belegging = "Belegging",
    Hybride = "Hybride",
}

/** SoortKredietProductOptions AflopendKrediet = 1, DoorlopendKrediet = 2, Studielening = 3, Restschuldlening = 4, Werkgeverslening = 5, Privatelease = 6 */
export enum SoortKredietProductOptions {
    AflopendKrediet = "AflopendKrediet",
    DoorlopendKrediet = "DoorlopendKrediet",
    Studielening = "Studielening",
    Restschuldlening = "Restschuldlening",
    Werkgeverslening = "Werkgeverslening",
    Privatelease = "Privatelease",
}

/** SoortLijfrenteProductOptions BancaireLijfrente = 0, LijfrenteVerzekering = 1 */
export enum SoortLijfrenteProductOptions {
    BancaireLijfrente = "BancaireLijfrente",
    LijfrenteVerzekering = "LijfrenteVerzekering",
}

/** SoortLijfrenteUitkeringOptions Levenslang = 0, Tijdelijk = 1 */
export enum SoortLijfrenteUitkeringOptions {
    Levenslang = "Levenslang",
    Tijdelijk = "Tijdelijk",
}

/** SoortOndernemingType Geen = 0, ZelfstandigeZonderPersoneel_ZZP_ = 1, ZelfstandigeMetPersoneel = 3 */
export enum SoortOndernemingType {
    Geen = "Geen",
    ZelfstandigeZonderPersoneel_ZZP_ = "ZelfstandigeZonderPersoneel_ZZP_",
    ZelfstandigeMetPersoneel = "ZelfstandigeMetPersoneel",
}

/** SoortOrvProductOptions Orv = 0, AnwHiaatVerzekering = 1 */
export enum SoortOrvProductOptions {
    Orv = "Orv",
    AnwHiaatVerzekering = "AnwHiaatVerzekering",
}

/** SoortOversluitingOptions InterneOversluiting = 1, OversluitingAndereGeldgever = 2 */
export enum SoortOversluitingOptions {
    InterneOversluiting = "InterneOversluiting",
    OversluitingAndereGeldgever = "OversluitingAndereGeldgever",
}

/** SoortProductOptions Onbekend = 0, Hypotheek = 1, Kapitaalverzekering = 2, Overlijdensrisicoverzekering = 3, Woonlastenverzekering = 4, Vermogensrekening = 5, Krediet = 6, Lijfrente = 8, Overig = 9 */
export enum SoortProductOptions {
    Onbekend = "Onbekend",
    Hypotheek = "Hypotheek",
    Kapitaalverzekering = "Kapitaalverzekering",
    Overlijdensrisicoverzekering = "Overlijdensrisicoverzekering",
    Woonlastenverzekering = "Woonlastenverzekering",
    Vermogensrekening = "Vermogensrekening",
    Krediet = "Krediet",
    Lijfrente = "Lijfrente",
    Overig = "Overig",
}

/** SoortVermogenProductOptions Beleggingsdepot = 1, Spaarrekening = 2, Effectenlease = 3, Betaalrekening = 4, Product = 99 */
export enum SoortVermogenProductOptions {
    Beleggingsdepot = "Beleggingsdepot",
    Spaarrekening = "Spaarrekening",
    Effectenlease = "Effectenlease",
    Betaalrekening = "Betaalrekening",
    Product = "Product",
}

/** SoortVermogensrekeningOptions Spaar = 1, Belegging = 2, Hybride = 3 */
export enum SoortVermogensrekeningOptions {
    Spaar = "Spaar",
    Belegging = "Belegging",
    Hybride = "Hybride",
}

/** De uitvoer van de (bank)spaarpremie-berekening. */
export interface SpaarHypotheekOutput {
    resultaat: SpaarHypotheekResultaat | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat het resultaat van de (bank)spaarpremie-berekening. */
export interface SpaarHypotheekResultaat {
    /** Berekend Premiebedrag */
    premie: number;
    /** Berekende aanvangsstorting */
    aanvangsstorting: number;
    /** Berekend Premiebedrag hoog */
    premieHoog: number;
}

/** Specificatie van de netto verkoopopbrengst van een object */
export interface SpecificatieNettoVerkoopopbrengst {
    /** De identificatie van het pand waar het om gaat */
    pandId: string;
    adres: AdresReadOnly | null;
    /** De (geschatte) verkoopprijs van het object */
    readonly verkoopprijsBedrag: number | null;
    /** De (geschatte) verkoopkosten van het object */
    readonly verkoopkostenBedrag: number | null;
    /** Eigendomsverhouding aanvrager 1 */
    readonly eigendom1Percentage: number | null;
    /** Eigendomsverhouding aanvrager 2 */
    readonly eigendom2Percentage: number | null;
}

export interface SysteemNotificatie {
    isPinned: boolean;
    webUrl: string | null;
    readonly uniqueIdentification: string | null;
    adviseurId: string;
    vestigingId: string;
    content: string | null;
    aanmaakdatum: string | null;
    isGelezen: boolean;
    redirectPagina: string | null;
}

export interface TarievenNorm {
    jaar: number;
    maand: number;
}

/** Bevat de inhoud van het Adviesbox-form Aanvraag/Taxatie. */
export interface Taxatie {
    taxatiebureau: Taxatiebureau | null;
    opdrachtgever: TaxatiePersoon | null;
    partner: TaxatiePersoon | null;
    taxatieObject: TaxatieObject | null;
    bouwkundigeKeuring: TaxatieBouwkundigeKeuring | null;
    taxatieAlgemeen: TaxatieAlgemeen | null;
    contactpersoon: TaxatieContactpersoon | null;
    aanvullendeInformatie: TaxatieAanvullendeInformatie | null;
    aanvrager1: KlantgegevensReadOnly | null;
    aanvrager2: KlantgegevensReadOnly | null;
    taxatieObjectReadOnly: TaxatieObjectReadOnly | null;
    taxatieAlgemeenReadOnly: TaxatieAlgemeenReadOnly | null;
}

/** Uitvoer voor een Taxatie aanvraag */
export interface TaxatieAanvraagOutput {
    nwwiAanvraag: TaxatieNwwiAanvraagOutput | null;
    taxatheekAanvraag: TaxatieTaxatheekAanvraagOutput | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat aanvullende informatie. */
export interface TaxatieAanvullendeInformatie {
    /** Opmerkingen */
    opmerkingen: string | null;
    /** Spoed */
    spoed: boolean | null;
    /** Naam eigenaar */
    naamEigenaar: string | null;
    /** Telefoonnummer */
    telefoonnummer: string | null;
    /** Taxateurnummer */
    taxateurnummer: string | null;
    /** Geldverstrekker (ContractId uit de NWWI webservice) */
    geldverstrekker: number | null;
    /** Taxateur */
    taxateur: string | null;
    /** Opdrachtnummer */
    opdrachtnummer: string | null;
    /** Extern referentienummer */
    externReferentienummer: string | null;
    /** Tussenpersoon naam ten behoeve van een taxatie aanvraag */
    tussenpersoonNaam: string | null;
    /** Tussenpersoon nummer ten behoeve van een taxatie aanvraag */
    tussenpersoonNummer: string | null;
    /** Betaling via notaris */
    betalingViaNotaris: boolean | null;
}

/** Bevat gegevens voor de kaart taxatie. */
export interface TaxatieAlgemeen {
    doelTaxatie: TaxatieDoelOptions | null;
    /** De geldverstrekker */
    geldverstrekker: string | null;
    /** Referentie geldverstrekker */
    referentieGeldverstrekker: string | null;
    /** Indicatie of NHG van toepassing is */
    nhg: boolean | null;
    /** Indicatie of herbouwwaarde van toepassing is */
    herbouwwaarde: boolean | null;
    /** Indicatie NWWI aanvraag */
    nwwiAanvraag: boolean | null;
    /** Indicatie validatie verplicht */
    validatieVerplicht: boolean | null;
    /** Wel/geen Energie prestatie advies */
    energiePrestatieAdvies: boolean | null;
    /** Indicatie wel/geen bouwtechnische keuring */
    bouwtechnischeKeuring: boolean | null;
    /** Datum aanvraag */
    aanvraagdatum: string | null;
    /** Datum gereed */
    gereedDatum: string | null;
    /** Passeerdatum */
    passeerdatum: string | null;
    /** Inidicatie ja/nee voortaxatie gewenst */
    voortaxatieGewenst: boolean | null;
    /** Fax verstuurd */
    faxVerstuurd: boolean | null;
    /** Is recente verkoop */
    recenteVerkoop: boolean | null;
    /** Bemiddelings kosten */
    bemiddelingsKostenBedrag: number | null;
    /** Indicatie beinvloeding waarde */
    beinvloedingWaarde: boolean | null;
    /** Toelichting bij 'beinvloeding waarde' */
    toelichtingBeinvloedingWaarde: string | null;
    /** Indicatie of er een verbouwing plaats vindt */
    verbouwing: boolean | null;
    /** Verbouwingsbedrag uit financieringsopzet */
    readonly verbouwingBedrag: number | null;
    /** Lijst met specificaties van de verbouwing */
    verbouwingSpecificaties: TaxatieVerbouwingSpecificatie[] | null;
    /** Indicatie of de taxatie nodig is voor het verkrijgen van een lening */
    voorVerkrijgenLening: boolean | null;
    /** Betreft Aankoop */
    betreftAankoop: boolean | null;
}

/** Bevat (readonly) gegevens voor de kaart taxatie. */
export interface TaxatieAlgemeenReadOnly {
    /** De geldverstrekker */
    readonly geldverstrekker: string | null;
    /** Verbouwingsbedrag uit financieringsopzet */
    readonly verbouwingBedrag: number | null;
    /** Lijst met specificaties van de verbouwing */
    readonly verbouwingSpecificaties: TaxatieVerbouwingSpecificatie[] | null;
}

/** TaxatieBenodigdeKeuringOptions PlusKeuringMetNhgKeuring = 0, NhgKeuring = 1 */
export enum TaxatieBenodigdeKeuringOptions {
    PlusKeuringMetNhgKeuring = "PlusKeuringMetNhgKeuring",
    NhgKeuring = "NhgKeuring",
}

/** Bevat gegeven van 'Bouwkundige keuring'. */
export interface TaxatieBouwkundigeKeuring {
    /** Het bouwjaar */
    bouwjaar: number | null;
    inhoudwoning: TaxatieInhoudOptions | null;
    keuringTenBehoevenVan: TaxatieTenBehoevenVanOptions | null;
    /** De omschrijving voor keuze anders */
    keuringTenBehoevenVanAnders: string | null;
    benodigdeKeuring: TaxatieBenodigdeKeuringOptions | null;
    monument: TaxatieJaNeeOnbekendOptions | null;
    gestapeldeBouw: TaxatieGestapeldeBouwOptions | null;
    vve: TaxatieJaNeeOnbekendOptions | null;
    /** Inhoud */
    inhoud: number | null;
    /** Code van het soort woning conform de HDN keuzelijst CodeObjectType */
    soortWoning: number | null;
    /** Code van het gebruiksdoel van het betreffende object volgens de HDN keuzelijst ObjectSoortType */
    objectSoort: number | null;
}

/** TaxatieContactPersoonOptions Makelaar = 1, Eigenaar = 2, Opdrachtgever = 3, Anders = 4 */
export enum TaxatieContactPersoonOptions {
    Makelaar = "Makelaar",
    Eigenaar = "Eigenaar",
    Opdrachtgever = "Opdrachtgever",
    Anders = "Anders",
}

/** Contact persoon binnen de taxatie */
export interface TaxatieContactpersoon {
    typeContactpersoon: TaxatieContactPersoonOptions | null;
    /** Contactpersoon naam */
    naam: string | null;
    /** Naam makelaar */
    naamMakelaar: string | null;
    /** Telefoonnummer prive */
    telefoonPrive: string | null;
    /** Telefoonnummer werk */
    telefoonWerk: string | null;
    /** Telefoonnummer mobiel */
    telefoonMobiel: string | null;
    /** Woonplaats */
    woonplaats: string | null;
    /** Postcode */
    postcode: string | null;
    geslacht: GeslachtOpties | null;
    /** E-mailadres */
    email: string | null;
}

/** TaxatieDoelOptions HypothecaireFinancieringMetNhg = 1, HypothecaireFinancieringZonderNhg = 2, InzichtWaardeTenBehoeveBeslissing = 3, AanvraagHypothecaireGeldlening = 4, AankoopBeslissing = 5, AanvraagOverbruggingsfinanciering = 6, BijzonderBeheer = 7, BoedelSplitsing = 8, BrabantseVerkoopgarantie = 9, Hertaxatie = 10, MinnelijkeWaardering = 11, OntpandingVerzekeringspolis = 12, Uitwinning = 13, VerkoopBeslissing = 14, VerkrijgenFinanciering = 15, VerkrijgenFinancieringMetNhg = 16, VerkrijgenInzichtWaardeAankoopbeslissing = 17, VerkrijgenInzichtWaardeVerkoopbeslissing = 18, VerkrijgenInzichtTenBehoeveVanExecutorialeVerkoop = 20, WoningFinancieringMetValidatie = 21, WoningFinancieringNwwi = 22, BepalenPrijsBijVerkoop = 30, BepalenPrijsBijAankoop = 31, BepalenPrijsBijTerugkoop = 32, GedwongenVerkoop = 33, Anders = 99 */
export enum TaxatieDoelOptions {
    HypothecaireFinancieringMetNhg = "HypothecaireFinancieringMetNhg",
    HypothecaireFinancieringZonderNhg = "HypothecaireFinancieringZonderNhg",
    InzichtWaardeTenBehoeveBeslissing = "InzichtWaardeTenBehoeveBeslissing",
    AanvraagHypothecaireGeldlening = "AanvraagHypothecaireGeldlening",
    AankoopBeslissing = "AankoopBeslissing",
    AanvraagOverbruggingsfinanciering = "AanvraagOverbruggingsfinanciering",
    BijzonderBeheer = "BijzonderBeheer",
    BoedelSplitsing = "BoedelSplitsing",
    BrabantseVerkoopgarantie = "BrabantseVerkoopgarantie",
    Hertaxatie = "Hertaxatie",
    MinnelijkeWaardering = "MinnelijkeWaardering",
    OntpandingVerzekeringspolis = "OntpandingVerzekeringspolis",
    Uitwinning = "Uitwinning",
    VerkoopBeslissing = "VerkoopBeslissing",
    VerkrijgenFinanciering = "VerkrijgenFinanciering",
    VerkrijgenFinancieringMetNhg = "VerkrijgenFinancieringMetNhg",
    VerkrijgenInzichtWaardeAankoopbeslissing = "VerkrijgenInzichtWaardeAankoopbeslissing",
    VerkrijgenInzichtWaardeVerkoopbeslissing = "VerkrijgenInzichtWaardeVerkoopbeslissing",
    VerkrijgenInzichtTenBehoeveVanExecutorialeVerkoop = "VerkrijgenInzichtTenBehoeveVanExecutorialeVerkoop",
    WoningFinancieringMetValidatie = "WoningFinancieringMetValidatie",
    WoningFinancieringNwwi = "WoningFinancieringNwwi",
    BepalenPrijsBijVerkoop = "BepalenPrijsBijVerkoop",
    BepalenPrijsBijAankoop = "BepalenPrijsBijAankoop",
    BepalenPrijsBijTerugkoop = "BepalenPrijsBijTerugkoop",
    GedwongenVerkoop = "GedwongenVerkoop",
    Anders = "Anders",
}

/** TaxatieGebruikOptions Leegstaand = 7, VolledigBewoondDoorEigenaar = 8, DeelsBewoonDoorEigenaarAndereDeelDoorAnderen = 9, GeheelBewoondDoorAnderen = 10, GeheelVerhuurd = 11, PerKamerVerhuurd = 12, DeelsBewoondDeelsLeeg = 13, DeelsVerhuurdDeelsLeeg = 14, Onbekend = 15 */
export enum TaxatieGebruikOptions {
    Leegstaand = "Leegstaand",
    VolledigBewoondDoorEigenaar = "VolledigBewoondDoorEigenaar",
    DeelsBewoonDoorEigenaarAndereDeelDoorAnderen = "DeelsBewoonDoorEigenaarAndereDeelDoorAnderen",
    GeheelBewoondDoorAnderen = "GeheelBewoondDoorAnderen",
    GeheelVerhuurd = "GeheelVerhuurd",
    PerKamerVerhuurd = "PerKamerVerhuurd",
    DeelsBewoondDeelsLeeg = "DeelsBewoondDeelsLeeg",
    DeelsVerhuurdDeelsLeeg = "DeelsVerhuurdDeelsLeeg",
    Onbekend = "Onbekend",
}

/** TaxatieGestapeldeBouwOptions Anders = 0, Appartement = 4 */
export enum TaxatieGestapeldeBouwOptions {
    Anders = "Anders",
    Appartement = "Appartement",
}

/** TaxatieInhoudOptions Tot800 = 0, Groter800 = 1, Onbekend = 2 */
export enum TaxatieInhoudOptions {
    Tot800 = "Tot800",
    Groter800 = "Groter800",
    Onbekend = "Onbekend",
}

/** TaxatieJaNeeOnbekendOptions Ja = 0, Nee = 1, Onbekend = 2 */
export enum TaxatieJaNeeOnbekendOptions {
    Ja = "Ja",
    Nee = "Nee",
    Onbekend = "Onbekend",
}

/** Uitvoer voor een NWWI aanvraag */
export interface TaxatieNwwiAanvraagOutput {
    /** Gets rapportnummer behorende bij de aanvraag */
    readonly rapportNummer: string | null;
    /** Gets identificatie van de ingedeinde aanvraag */
    readonly aanvraagId: number | null;
}

/** Gegevens van de contactpersoon */
export interface TaxatieNwwiContactpersoon {
    /** Aanhef */
    aanhef: string | null;
    /** Achternaam */
    achternaam: string | null;
    /** Bedrijfsnaam */
    bedrijfsnaam: string | null;
    /** Volledige naam */
    contactpersoon: string | null;
    /** Titel */
    titel: string | null;
    /** Tussenvoegsels */
    tussenvoegsels: string | null;
    /** Voorletters */
    voorletters: string | null;
}

/** Gegevens van een geldverstrekker */
export interface TaxatieNwwiGeldverstrekkerOutput {
    contactpersoon: TaxatieNwwiContactpersoon | null;
    adres: AdresReadOnly | null;
    organisatie: TaxatieNwwiOrganisatie | null;
    bijzonderbeheeraanvragen: number | null;
    contractCode: any | null;
    contractId: number | null;
    contractType: string | null;
    eigenaar: string | null;
    opdrachtgeverAutomatischInvullen: number | null;
    relatieType: string | null;
}

/** Resultaat van de NWWI-opvraging Geldverstrekkers */
export interface TaxatieNwwiGeldverstrekkersOutput {
    /** De gevonden geldverstrekkers */
    readonly geldverstrekkers: TaxatieNwwiGeldverstrekkerOutput[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Gegevens van de organisatie */
export interface TaxatieNwwiOrganisatie {
    /** E-mailadres */
    readonly emailadres: string | null;
    /** Relatienummer */
    readonly relatienummer: number | null;
    /** Telefoonnummer */
    readonly telefoon: string | null;
    /** KVK-nummer */
    kvknummer: string | null;
}

/** Resultaat van een gevonden taxatiebureau */
export interface TaxatieNwwiTaxatiebureauOutput {
    /** Identificatie van het taxatiebedrijf */
    readonly taxatiebureauId: string | null;
    /** Naam van het taxatiebedrijf */
    readonly bedrijfsnaam: string | null;
    /** Straatnaam taxatiebedrijf */
    readonly straat: string | null;
    /** Huisnummer taxatiebedrijf */
    readonly huisnummer: number | null;
    /** Huisnummertoevoeging taxatiebedrijf */
    readonly toevoeging: string | null;
    /** Postcode taxatiebedrijf */
    readonly postcode: string | null;
    /** Vestigingsplaats taxatiebedrijf */
    readonly plaats: string | null;
    /** Telefoonnummer taxatiebedrijf */
    readonly telefoonnummer: string | null;
    /** Emailadres van het taxatiebedrijf */
    readonly emailadres: string | null;
    /** Branche van het taxatiebdrijf */
    readonly branche: string | null;
    /** Afstand in km tussen taxatiebedrijf en te taxeren object */
    readonly afstand: string | null;
}

/** Resultaat van de opvraging van taxatiebureaus */
export interface TaxatieNwwiTaxatiebureausOutput {
    /** De gevonden taxatiebureaus */
    readonly taxatiebureaus: TaxatieNwwiTaxatiebureauOutput[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat gegevens van Object. */
export interface TaxatieObject {
    adresPand: Adres;
    /** Aankoopprijs */
    aankoopprijsBedrag: number | null;
    /** Indicatie wel/geen nieuwbouw */
    nieuwbouw: boolean | null;
    /** Indentificatie bouwplan */
    bouwplan: string | null;
    /** Het bouwnummer */
    bouwnummer: string | null;
    gebruikMomenteel: TaxatieGebruikOptions | null;
    gebruikToekomst: TaxatieToekomstigGebruikOptions | null;
    /** Toelichting toekomstig gebruik van het pand bij keuze 'Anders' */
    gebruikToekomstAnders: string | null;
    /** Wel/Geen huurovereenkomst */
    huurovereenkomst: boolean | null;
    opdrachtgever: TaxatieOpdrachtgeverOptions | null;
}

export interface TaxatieObjectReadOnly {
    readonly straat: string | null;
    readonly huisnummer: number | null;
    readonly toevoeging: string | null;
    readonly postcode: string | null;
    readonly plaats: string | null;
    readonly nieuwbouw: boolean | null;
    readonly bouwplan: string | null;
    readonly bouwnummer: string | null;
    readonly aankoopprijs: number | null;
}

/** TaxatieOpdrachtgeverOptions Nvt = 1, DeHuidigeEigenaar = 2, DeHuidigeEigenaarEnVerhuurderEnBewoner = 3, BewonerEnKoperVoorEigenBewoning = 4, KoperVoorEigenBewoning = 5, Anders = 6 */
export enum TaxatieOpdrachtgeverOptions {
    Nvt = "Nvt",
    DeHuidigeEigenaar = "DeHuidigeEigenaar",
    DeHuidigeEigenaarEnVerhuurderEnBewoner = "DeHuidigeEigenaarEnVerhuurderEnBewoner",
    BewonerEnKoperVoorEigenBewoning = "BewonerEnKoperVoorEigenBewoning",
    KoperVoorEigenBewoning = "KoperVoorEigenBewoning",
    Anders = "Anders",
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Aanvraag/Taxatie. */
export interface TaxatieOutput {
    /** Lijst met de inhoud van het Adviesbox-form Aanvraag/Taxatie per adviesdossier. */
    taxaties: { [key: string]: Taxatie; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Gegevens van een opdrachtgever of partner */
export interface TaxatiePersoon {
    /** Achternaam */
    achternaam: string | null;
    /** Voorvoegsel */
    voorvoegsel: string | null;
    /** Voorletters */
    voorletters: string | null;
    /** Roepnaam */
    roepnaam: string | null;
    geslacht: GeslachtOpties;
    /** Geboortedatum */
    geboortedatum: string | null;
    /** Telefoonnummer prive */
    telefoonPrive: string | null;
    /** E-mailadres */
    email: string | null;
    /** Geboorteland (code) */
    geboortelandCode: string | null;
    /** Telefoonnummer werk */
    telefoonWerk: string | null;
    /** Telefoonnummer mobiel */
    telefoonMobiel: string | null;
    /** Geboortevoornamen */
    voornamen: string | null;
    /** Iban rekeningnummer */
    iban: string | null;
    adres: Adres | null;
}

/** TaxatieSoortAanvraagOptions Oversluiting = 1, AanVerkoopBeslissing = 2, BouwkundigeKeuring = 3, Combinatie = 4, Anders = 5 */
export enum TaxatieSoortAanvraagOptions {
    Oversluiting = "Oversluiting",
    AanVerkoopBeslissing = "AanVerkoopBeslissing",
    BouwkundigeKeuring = "BouwkundigeKeuring",
    Combinatie = "Combinatie",
    Anders = "Anders",
}

/** Uitvoer voor een Taxatheek aanvraag */
export interface TaxatieTaxatheekAanvraagOutput {
    /** Opdrachtnummer behorende bij de aanvraag */
    readonly opdrachtNummer: string | null;
}

/** TaxatieTenBehoevenVanOptions Aankoop = 0, Verkoop = 1, NhgFinanciering = 2, Anders = 3 */
export enum TaxatieTenBehoevenVanOptions {
    Aankoop = "Aankoop",
    Verkoop = "Verkoop",
    NhgFinanciering = "NhgFinanciering",
    Anders = "Anders",
}

/** TaxatieToekomstigGebruikOptions BenEigenaarEnBlijfInWoning = 1, BenEigenaarEnBlijfWoningVerhuren = 2, BenEigenaarEnWilWoningVerhuren = 3, WoontInWoningEnWilWoningKopen = 4, WilWoningKopenVoorWonen = 5, WilWoningKopenVoorVerhuren = 6, Anders = 7 */
export enum TaxatieToekomstigGebruikOptions {
    BenEigenaarEnBlijfInWoning = "BenEigenaarEnBlijfInWoning",
    BenEigenaarEnBlijfWoningVerhuren = "BenEigenaarEnBlijfWoningVerhuren",
    BenEigenaarEnWilWoningVerhuren = "BenEigenaarEnWilWoningVerhuren",
    WoontInWoningEnWilWoningKopen = "WoontInWoningEnWilWoningKopen",
    WilWoningKopenVoorWonen = "WilWoningKopenVoorWonen",
    WilWoningKopenVoorVerhuren = "WilWoningKopenVoorVerhuren",
    Anders = "Anders",
}

/** Regel met verbouwing specs. */
export interface TaxatieVerbouwingSpecificatie {
    /** De unieke identificatie van de verbouwing */
    verbouwingId: string | null;
    /** Volgnummer van de verbouwing */
    volgnummer: number;
    /** Omschrijving werkzaamheid */
    werkzaamheid: string | null;
    /** Bedrag voor deze werkzaamheid */
    bedrag: number | null;
    /** Of de verbouwing wordt uitgevoerd in eigen beheer */
    eigenBeheer: boolean | null;
    verbouwingType: TaxatieVerbouwingTypeOptions | null;
}

/** TaxatieVerbouwingTypeOptions Nieuw = 1, Bouwkundig = 2 */
export enum TaxatieVerbouwingTypeOptions {
    Nieuw = "Nieuw",
    Bouwkundig = "Bouwkundig",
}

/** Bevat gegevens van het Taxatiebureau. */
export interface Taxatiebureau {
    /** De code van de maatschappij uit de Producten Web API */
    maatschappijCode: string | null;
    /** De productcode van het taxatieproduct uit de Producten Web API */
    productCode: number | null;
    /** De productnaam van het taxatieproduct uit de Producten Web API */
    readonly taxatieProductNaam: string | null;
    soortAanvraag: TaxatieSoortAanvraagOptions | null;
    /** Indien anders als soort aanvraag dan hier "te weten" invullen */
    andersTeWeten: string | null;
    /** Het agentnummer */
    agentnummer: string | null;
}

/** Gegevens van een te beeindigen leningdeel. */
export interface TeBeeindigenLeningdeel {
    /** Unieke identificatie van de boeterente die bij dit te beeindigen leningdeel betrokken is */
    boeterenteId: string;
    /** Unieke identificatie van het leningdeel in de huidige situatie waarop de boeterente betrekking heeft */
    leningdeelId: string;
    /** Omschrijving maatschappij */
    readonly maatschappijOmschrijving: string | null;
    aflossingsvorm: AflossingsVormType | null;
    boeterenteBerekeningswijze: BoeterenteBerekeningswijzeOpties | null;
    /** Bedrag van de oorspronkelijke hoofdsom van het leningdeel */
    readonly oorspronkelijkeHoofdsomBedrag: number | null;
    /** Het bedrag van het leningdeel dat nog resteert */
    readonly restantHoofdsomBedrag: number | null;
    /** Het aantal maanden looptijd dat nog resteert in dit leningdeel */
    readonly restantLooptijdInMaanden: number | null;
    /** Datum einde rentevastperiode */
    readonly rentevastperiodeEinddatum: string | null;
    /** Datum van de boeterente */
    boeterenteDatum: string | null;
    /** Resterende periode weergeven (true) of aanpasbaar maken (false) */
    resterendePeriodeWeergeven: boolean | null;
    /** Het aantal volledige jaren dat resteert */
    resterendePeriodeJaren: number | null;
    /** Het aantal maanden dat resteert in het laatste, niet volledige jaar */
    resterendePeriodeMaanden: number | null;
    /** Percentage boetevrij */
    boetevrijPercentage: number | null;
    /** Huidig rentepercentage */
    huidigRentePercentage: number | null;
    /** Nieuw rentepercentage. */
    nieuwRentePercentage: number | null;
    /** Boeterentebedrag */
    boeterentebedrag: number | null;
    /** Totaal opgebouwde waarde */
    opgebouwdeWaarde: number | null;
}

/** Bevat gegevens van de toetsinkomenVerklaring van de aanvrager (klant). */
export interface ToetsinkomenVerklaring {
    /** Inkomensverklaring van aanvrager */
    inkomensverklaring: string | null;
    /** Toetsinkomen van aanvrager */
    toetsInkomen: number | null;
}

/** ToetsrenteBerekeningOptions SpecificatieToetsrente = 0, GewensteRentevastperiode = 1 */
export enum ToetsrenteBerekeningOptions {
    SpecificatieToetsrente = "SpecificatieToetsrente",
    GewensteRentevastperiode = "GewensteRentevastperiode",
}

export interface TweedeWoningNietMogelijkOutput {
    success: boolean | null;
}

/** Een uitbetaling gedurende de bouw */
export interface Uitbetaling {
    /** Maand van de uitbetaling */
    maand: number;
    /** Percentage van het bouwdepot-bedrag in de gegeven maand */
    percentage: number | null;
}

export interface UitkerendeFase {
    belastingBox: BelastingBoxOptions | null;
    soortLijfrenteUitkering: SoortLijfrenteUitkeringOptions | null;
    duurUitkeringInMaanden: number | null;
    duurUitkeringHoogInMaanden: number | null;
    hooglaagVerhouding: number | null;
    lijfrenteTariefPercentage: number | null;
    overgangOp2eVerzekerde: boolean | null;
    overgangOp2eVerzekerdePercentage: number | null;
    lijfrenteUitkeringBedrag: number | null;
    termijn: BetalingsTermijnType | null;
}

/** UitkeringAoSoort Geen = 0, Volledig = 1, ProRata = 2 */
export enum UitkeringAoSoort {
    Geen = "Geen",
    Volledig = "Volledig",
    ProRata = "ProRata",
}

/** UitkeringBijOverlijdenSoort Geen = 0, MaandNaOverlijden = 1, JongsteKind18 = 2 */
export enum UitkeringBijOverlijdenSoort {
    Geen = "Geen",
    MaandNaOverlijden = "MaandNaOverlijden",
    JongsteKind18 = "JongsteKind18",
}

/** UitslagOptions Wit = 0, Groen = 1, Oranje = 2, Rood = 3 */
export enum UitslagOptions {
    Wit = "Wit",
    Groen = "Groen",
    Oranje = "Oranje",
    Rood = "Rood",
}

/** Gegevens van een uitsluiting */
export interface Uitsluiting {
    /** Unieke identificatie van een uitsluiting */
    uitsluitingId: string | null;
    /** Volgnummer van de uitsluiting binnen de uitsluitingen van een klant */
    volgnummer: number;
    /** Code veld. Maatschappij */
    maatschappijCode: string | null;
    /** Omschrijving maatschappij */
    maatschappijOmschrijving: string | null;
    /** Datum uitsluiting */
    uitsluitingsdatum: string | null;
    /** Omschrijving reden */
    reden: string | null;
}

export interface ValidationResultModel {
    code: string | null;
    target: string | null;
    message: string | null;
}

export interface ValidationResultsModel {
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** VerblijfsVergunningType Geen = 0, Onbekend = 1, OnbepaaldeTijd = 2, BepaaldeTijd = 3, BepaaldeTijdAsiel_DocumentIII_ = 4, OnbepaaldeTijdAsiel_DocumentIV_ = 5, BepaaldeTijdNietTijdelijkVerblijfsdoel = 6 */
export enum VerblijfsVergunningType {
    Geen = "Geen",
    Onbekend = "Onbekend",
    OnbepaaldeTijd = "OnbepaaldeTijd",
    BepaaldeTijd = "BepaaldeTijd",
    BepaaldeTijdAsiel_DocumentIII_ = "BepaaldeTijdAsiel_DocumentIII_",
    OnbepaaldeTijdAsiel_DocumentIV_ = "OnbepaaldeTijdAsiel_DocumentIV_",
    BepaaldeTijdNietTijdelijkVerblijfsdoel = "BepaaldeTijdNietTijdelijkVerblijfsdoel",
}

/** Bevat de gegevens van de vergoedingen t.b.v het Vergoedingenoverzicht. */
export interface Vergoedingen {
    /** Ingangsdatum (of: 'Passeerdatum' wanneer er een hypotheek geadviseerd wordt) */
    ingangsdatum: string;
    hypotheekNorm: TarievenNorm | null;
    /** Vaste kosten die de adviseur in rekening brengt voor het uitbrengen van het advies */
    advieskostenBedrag: number | null;
    /** Indicatie dat de advieskosten van de bijbehorende instelling moet worden overgenomen */
    advieskostenOvernemen: boolean | null;
    /** Aantal uur advieswerk dat voor het uitbrengen van het advies in rekening moet worden gebracht */
    advieskostenAantalUur: number | null;
    /** Vaste kosten die de adviseur in rekening brengt voor het bemiddelen van de geldlening */
    bemiddelingsvergoedingGeldleningBedrag: number | null;
    /** Indicatie dat de bemiddelingsvergoeding voor de geldlening van de bijbehorende instelling moet worden overgenomen */
    bemiddelingsvergoedingGeldleningOvernemen: boolean | null;
    /** Aantal uur dat in rekening moet worden gebracht voor bemiddelingsvergoeding voor de geldlening */
    bemiddelingsvergoedingGeldleningAantalUur: number | null;
    /** Overige vaste bemiddelingsvergoeding die de adviseur in rekening brengt voor het adviseren */
    overigeBemiddelingsvergoedingBedrag: number | null;
    /** Indicatie dat de overige bemiddelingsvergoeding van de bijbehorende instelling moet worden overgenomen */
    overigeBemiddelingsvergoedingOvernemen: boolean | null;
    /** Aantal uur advieswerk dat voor het overig advieswerk in rekening moet worden gebracht */
    overigeBemiddelingsvergoedingAantalUur: number | null;
    /** Vaste kosten die de adviseur in rekening brengt voor het beheer van het dossier t.b.v. de geldlening */
    dossiervergoedingBedrag: number | null;
    /** Indicatie dat de dossiervergoeding van de bijbehorende instelling moet worden overgenomen */
    dossiervergoedingOvernemen: boolean | null;
}

/** Bevat de inhoud van het Adviesbox-form Vergoedingenoverzicht. */
export interface Vergoedingenoverzicht {
    vergoedingen: Vergoedingen | null;
    /** Bevat de gegevens van de huidige producten */
    huidigeProducten: VergoedingenoverzichtProduct[] | null;
    /** Bevat de kenmerken van de huidige producten t.b.v. pop-up 'Huidige producten' van het Vergoedingenoverzicht */
    readonly huidigeProductenKenmerken: VergoedingenoverzichtProductKenmerken[] | null;
    financiering: FinancieringOptions | null;
}

/** Bevat de gegevens van een huidig product t.b.v het Vergoedingenoverzicht. */
export interface VergoedingenoverzichtProduct {
    /** Unieke identificatie van het product */
    productId: string;
    /** Productnaam */
    readonly productnaam: string | null;
    /** Naam van de maatschappij */
    readonly maatschappijNaam: string | null;
    /** Omschrijving */
    readonly omschrijving: string | null;
    productsoort: SoortProductOptions;
    /** Indicatie dat het product doorloopt in de nieuwe situatie */
    meenemen: boolean;
    /** Indicatie dat het product premievrij doorloopt in de nieuwe situatie */
    premievrijMaken: boolean | null;
    /** Indicatie dat 'PremievrijMaken' mogelijk is voor het product */
    premievrijMakenMogelijk: boolean;
    /** Indicatie dat de waarde van de dekking in de financiering ingebracht moet worden */
    inFinanciering: boolean | null;
    /** Indicatie dat het saldo van het krediet in de financiering ingebracht moet worden */
    uitFinanciering: boolean | null;
    /** Indien het product vanaf de (aanvangdatum + looptijd) voorbij de huidige datum is. */
    eindeLooptijdDatum: string | null;
}

/** Bevat de kenmerken van een huidig product t.b.v. pop-up 'Huidige producten' van het Vergoedingenoverzicht. */
export interface VergoedingenoverzichtProductKenmerken {
    /** Productnaam */
    productnaam: string | null;
    /** Indicatie dat het product door de adviseur zelf is bemiddeld */
    uwBemiddeling: boolean | null;
    /** Ingangsdatum van het product */
    ingangsdatum: string | null;
    /** Looptijd van het product in maanden */
    looptijdInMaanden: number | null;
    /** Hoofdsom van het product */
    hoofdsomBedrag: number | null;
    /** Opbouw van het product */
    opbouwBedrag: number | null;
    /** Dekking 1 */
    dekking1Bedrag: number | null;
    /** Dekking 2 */
    dekking2Bedrag: number | null;
    /** Premie */
    premieBedrag: number | null;
    betalingstermijn: BetalingsTermijnType | null;
    /** Rentebedrag (per maand) */
    renteBedrag: number | null;
    /** Rentepercentage */
    rentePercentage: number | null;
    /** Aantal maanden rentevastperiode */
    rentevastAantalMaanden: number | null;
    /** Aantal maanden rentebedenktijd */
    rentebedenktijdInMaanden: number | null;
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Vergoedingenoverzicht. */
export interface VergoedingenoverzichtenOutput {
    /** Lijst met de inhoud van het scherm Vergoedingenoverzicht per voorstel (analyse). */
    vergoedingenoverzichten: { [key: string]: Vergoedingenoverzicht; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Verkoopstatus Geen = 0, BlijftInBezit = 1, IsVerkocht = 2, WordtVerkocht = 3 */
export enum Verkoopstatus {
    Geen = "Geen",
    BlijftInBezit = "BlijftInBezit",
    IsVerkocht = "IsVerkocht",
    WordtVerkocht = "WordtVerkocht",
}

/** Bevat de gegevens van Adviesbox Form Vermogen. */
export interface Vermogen {
    /** De producten op het scherm */
    producten: VermogenProduct[];
    aanvrager1: KlantnaamReadOnly | null;
    aanvrager2: KlantnaamReadOnly | null;
    /** Mogelijke keuzes indien er sprake is van fiscale voorzetting */
    fiscaleVoortzettingKeuzes: FiscaleVoortzettingKeuze[] | null;
    /** De af te lossen leningdelen van het voorstel. */
    readonly leningdelen: VermogenLeningdeelReadOnly[] | null;
    /** De af te lossen kredieten van het voorstel. */
    readonly kredieten: KredietReadOnly[] | null;
    /** De naam van de geldverstrekker die in het Form Hypotheek geselecteerd is. */
    readonly geldverstrekkerNaam: string | null;
    /** Ingangsdatum van het voorstel (of: 'Passeerdatum' wanneer er een hypotheek geadviseerd wordt) */
    readonly ingangsdatumVoorstel: string | null;
}

/** Invoer voor een opnameberekening van de generieke vermogensrekening. */
export interface VermogenBerekeningInput {
    vermogenProduct: VermogenProduct;
}

/** Het resultaat van de vermogen-berekening */
export interface VermogenBerekeningOutput {
    resultaat: VermogenBerekeningResultaat | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de berekende resultaten */
export interface VermogenBerekeningResultaat {
    /** De berekende inleg van de vermogensrekening. */
    inleg: number | null;
    /** Het deel van de inleg dat nodig is om het garantiekapitaal op te bouwen. */
    inlegGarantiedeel: number | null;
    /** Waardeopbouw per jaar */
    readonly waardeopbouwJaren: WaardeopbouwInJaar[] | null;
    /** De berekende waardeopbouw per maand */
    readonly waardeopbouwMaanden: WaardeopbouwInMaand[] | null;
}

/** Gegevens van 'Depot'. */
export interface VermogenDepot {
    soortDepot: SoortDepotOptions;
    /** Bestedingsdoel */
    bestedingsdoel: string | null;
    /** Aankoopkosten */
    aankoopkostenPercentage: number | null;
    /** Verkoopkosten */
    verkoopkostenPercentage: number | null;
    /** Beheerkosten */
    beheerkostenPercentage: number | null;
}

/** De gegevens van 'Extra inleg' voor een bepaald jaar. */
export interface VermogenExtraInlegInJaar {
    jaar: number;
    bedrag: number;
}

/** De gegevens van 'Extra opname' voor een bepaald jaar. */
export interface VermogenExtraOpnameInJaar {
    /** Jaar van de extra opname */
    jaar: number;
    /** Opname */
    opnameBedrag: number;
}

/** Bevat gegevens van de fiscale regeling. */
export interface VermogenFiscaleRegeling {
    /** Polisnummer */
    polisnummer: string | null;
    /** Geeft aan of er sprake is van een lijfrenteclausule */
    lijfrenteclausule: boolean | null;
    kapitaalopbouw: KapitaalopbouwOptions | null;
    productId: string | null;
    fiscaleVoortzetting: FiscaleVoortzettingOptions | null;
    originelePolisnummer: string | null;
    externeMaatschappijCode: string | null;
    externeMaatschappijOmschrijving: string | null;
    lijfrenteclausuleOrigineel: boolean | null;
    fiscaleTypering: FiscaleTyperingOptions | null;
    garantieverzekering: boolean | null;
    fiscaalRegime: FiscaalRegimeOptions | null;
    oorspronkelijkeIngangsdatum: string | null;
    ingangsdatumBox1: string | null;
    einddatum: string | null;
    doelkapitaalBedrag: number | null;
    laagstePremieooitBedrag: number | null;
    hoogstePremieOoitBedrag: number | null;
    huidigeJaarPremieBedrag: number | null;
    premieLopendJaarBedrag: number | null;
    eerdereUitkeringenBedrag: number | null;
    ingebrachteWaardeBedrag: number | null;
}

/** Gegevens van 'Inleggegevens'. */
export interface VermogenInleggegevens {
    /** Het aantal maanden dat inleg betaald moet worden */
    duurInMaanden: number | null;
    /** Het aantal maanden dat inleg betaald moet worden in de hooglaag-constructie */
    duurHooglaagInMaanden: number | null;
    stortingstermijn: BetalingsTermijnType | null;
    /** PremieAftrekBaarBedrag */
    premieAftrekbaarBedrag: number | null;
    /** Bedrag voor de (lage) inleg */
    inlegBedrag: number | null;
    /** Bedrag voor de hoge inleg */
    hogeInlegBedrag: number | null;
    /** Bedrag voor de eerste inleg */
    eersteInlegBedrag: number | null;
    /** Extra inleg per jaar */
    extraInlegJaren: VermogenExtraInlegInJaar[] | null;
}

/** Gegevens van 'Kapitaalopbouw'. */
export interface VermogenKapitaalopbouw {
    soortRekening: SoortVermogensrekeningOptions | null;
    soortBerekening: SoortBerekeningOptions | null;
    beleggersprofiel: BeleggersprofielOptions | null;
    /** Doelkapitaal */
    doelkapitaalBedrag: number | null;
    /** Rendement doelkapitaal */
    doelrendementPercentage: number | null;
    /** Voorbeeldkapitaal */
    voorbeeldkapitaalBedrag: number | null;
    /** Rendement voorbeeldkapitaal */
    voorbeeldrendementPercentage: number | null;
    /** Garantiekapitaal / waarvan gegarandeerd */
    garantiekapitaalBedrag: number | null;
    /** Rendement garantiekapitaal / waarvan gegarandeerd */
    garantierendementPercentage: number | null;
}

/** De af te lossen leningdelen van het voorstel. */
export interface VermogenLeningdeelReadOnly {
    /** Doelkapitaal bedrag */
    readonly doelkapitaalBedrag: number | null;
    /** Percentage doelkapitaal */
    readonly doelkapitaalPercentage: number | null;
    leningdeelId: string;
    doorlopend: boolean;
    readonly productnaam: string | null;
    readonly maatschappijCode: string | null;
    productcode: number;
    aanvangsdatum: string;
    looptijdInMaanden: number;
    volgnummer: number;
    leningdeelBedrag: number | null;
}

/** Gegevens van 'Onttrekking(en)'. */
export interface VermogenOnttrekkingen {
    /** Begindatum */
    begindatum: string | null;
    /** Het aantal maanden dat onttrekking gedaan moet worden */
    duurInMaanden: number | null;
    onttrekkingstermijn: BetalingsTermijnType | null;
    /** Bedrag voor de periodieke onttrekking */
    onttrekkingBedrag: number | null;
    /** Extra opname per jaar */
    extraOpnameJaren: VermogenExtraOpnameInJaar[] | null;
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Vermogen (zowel huidige situatie als voorstel). */
export interface VermogenOutput {
    /** Lijst met Vermogensproducten per adviesdossier (huidige situatie) of voorstel. */
    vermogens: { [key: string]: Vermogen; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Gegevens van een Vermogen-polis. */
export interface VermogenPolis {
    productnummer: string | null;
    maatschappijCode: string | null;
    maatschappijOmschrijving: string | null;
    maatschappijCodeHdn: string | null;
    productnaam: string | null;
    productcode: number;
    ingangsdatum: string;
    looptijdInMaanden: number | null;
    uwBemiddeling: boolean;
}

/** Bevat de gegevens van het Vermogen-product. */
export interface VermogenProduct {
    soortProduct: SoortVermogenProductOptions;
    /** Geeft aan of het om een doorlopend product gaat */
    readonly doorlopend: boolean | null;
    polis: VermogenPolis;
    /** Unieke identificaties van de klanten die als contractant geselecteerd zijn */
    contractantKlantIds: string[];
    depot: VermogenDepot | null;
    productwaarde: VermogenProductwaarde | null;
    inleggegevens: VermogenInleggegevens | null;
    kapitaalopbouw: VermogenKapitaalopbouw | null;
    onttrekkingen: VermogenOnttrekkingen | null;
    fiscaleRegeling: VermogenFiscaleRegeling | null;
    verpanding: VermogenVerpanding | null;
    /** Indicatie dat indien het doorlopende product gewijzigd is, deze opnieuw overgenomen moet worden naar de voorstellen */
    wijzigingenInDoorlopendeProductenOvernemen: boolean;
    productId: string | null;
    meenemen: boolean;
}

/** Gegevens van 'Productwaarde' of 'Depotwaarde'. */
export interface VermogenProductwaarde {
    /** Reeds opgebouwd */
    reedsOpgebouwdBedrag: number | null;
    /** Reeds opgebouwd per datum */
    reedsOpgebouwdDatum: string | null;
    /** Afkoopwaarde */
    afkoopwaardeBedrag: number | null;
    /** Afkoopwaarde per datum */
    afkoopwaardeDatum: string | null;
    /** Waardeopbouw (na x jaar) */
    readonly waardeopbouwBedrag: number | null;
    /** Waardeopbouw per jaar */
    readonly waardeopbouwJaren: WaardeopbouwInJaar[] | null;
    /** De berekende waardeopbouw per maand */
    waardeopbouwMaanden: WaardeopbouwInMaand[] | null;
}

/** De verpanding van een Vermogensproduct. */
export interface VermogenVerpanding {
    uitkerendeFase: UitkerendeFase | null;
    verpandAanGeldverstrekker: boolean | null;
    bedoeldVoorAflossing: boolean | null;
    aflosproducten: Aflosproduct[] | null;
}

export interface Verpanding {
    verpandAanGeldverstrekker: boolean | null;
    bedoeldVoorAflossing: boolean | null;
    aflosproducten: Aflosproduct[] | null;
}

export interface VersionInfo {
    naam: string | null;
    versie: string | null;
    auteur: string | null;
    copyright: string | null;
    opstartDatumTijd: string | null;
}

/** Verzekerd bedrag van een jaar */
export interface VerzekerdBedrag {
    /** Het jaar waarin het verzekerd bedrag van toepassing is */
    readonly jaar: number | null;
    /** Het jaartal waarin het verzekerd bedrag van toepassing is */
    readonly jaartal: number | null;
    /** Het bedrag dat verzekerd is gedurende het jaar */
    readonly bedrag: number | null;
}

/** Verzekeringsmotief Geen = 0, Hypotheek = 1, GerichteLijfrente = 2, NabestaandenVoorziening = 3, FinancieringOfKredietVerstrekking = 4, SuccessieAfdekking = 5, CompagnonVerzekering = 6, KeymanVerzekering = 7 */
export enum Verzekeringsmotief {
    Geen = "Geen",
    Hypotheek = "Hypotheek",
    GerichteLijfrente = "GerichteLijfrente",
    NabestaandenVoorziening = "NabestaandenVoorziening",
    FinancieringOfKredietVerstrekking = "FinancieringOfKredietVerstrekking",
    SuccessieAfdekking = "SuccessieAfdekking",
    CompagnonVerzekering = "CompagnonVerzekering",
    KeymanVerzekering = "KeymanVerzekering",
}

/** Model voor het bijwerken van de naam van een voorstel. */
export interface VoorstelNaam {
    /** De nieuwe naam van het voorstel */
    naam: string | null;
}

export interface WaardeopbouwInJaar {
    jaar: number;
    beginwaardeBedrag: number;
    stortingenBedrag: number;
    onttrekkingenBedrag: number;
    eindwaardeBedrag: number;
}

export interface WaardeopbouwInMaand {
    maand: number;
    eindwaardeBedrag: number;
}

/** Gegevens van een weigering */
export interface Weigering {
    /** Unieke identificatie van een weigering */
    weigeringId: string | null;
    /** Volgnummer van de weigering binnen de weigeringen van een klant */
    volgnummer: number;
    /** Code veld. Maatschappij */
    maatschappijCode: string | null;
    /** Omschrijving maatschappij */
    maatschappijOmschrijving: string | null;
    /** Datum weigering */
    weigeringDatum: string | null;
    /** Omschrijving reden weigering */
    reden: string | null;
}

/** WijzeVanTerugbetalingType Geen = 0, VolledigEigenMiddelen = 1, VrijwilligeVerkoopOnderpand = 2, BlijvenOfOpnieuwLenen = 3 */
export enum WijzeVanTerugbetalingType {
    Geen = "Geen",
    VolledigEigenMiddelen = "VolledigEigenMiddelen",
    VrijwilligeVerkoopOnderpand = "VrijwilligeVerkoopOnderpand",
    BlijvenOfOpnieuwLenen = "BlijvenOfOpnieuwLenen",
}

/** Bevat de input voor het bepalen van de hypotheekvormen bij 'Wijzig geldverstrekker met behoud van leningdelen'. */
export interface WijzigGeldverstrekkerInput {
    /** Code van de nieuwe geldverstrekker. */
    geldverstrekkerCode: string | null;
    /** Code van het nieuwe hypotheeklabel binnen de geldverstrekker uit de Producten API */
    hypotheeklabelCode: number;
    /** Lijst met leningdelen */
    leningdelen: WijzigGeldverstrekkerInputLeningdeel[] | null;
}

/** Gegevens van een leningdeel. */
export interface WijzigGeldverstrekkerInputLeningdeel {
    /** Volgnummer van het leningdeel binnen de leningdelen van de hypotheek */
    volgnummer: number;
    aflossingsvorm: AflossingsVormType;
}

/** De uitvoer van 'Wijzig geldverstrekker met behoud van leningdelen'. */
export interface WijzigGeldverstrekkerOutput {
    resultaat: WijzigGeldverstrekkerResultaat | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de inhoud van een gegenereerd leningdeel. */
export interface WijzigGeldverstrekkerOutputLeningdeel {
    /** Volgnummer van het leningdeel binnen de leningdelen van de hypotheek */
    volgnummer: number;
    hypotheekvorm: Hypotheekvorm | null;
    /** Bevat de hypotheekvormen van het gekozen hypotheeklabel die overeenkomen met de hypotheekvorm van het huidige leningdeel */
    readonly matchHypotheekvormen: Hypotheekvorm[] | null;
    /** Bevat de hypotheekvormen van het gekozen hypotheeklabel die bijna overeenkomen met de hypotheekvorm van het huidige leningdeel */
    readonly nearMatchHypotheekvormen: Hypotheekvorm[] | null;
}

/** Bevat het gegenereerde resultaat van 'Wijzig geldverstrekker met behoud van leningdelen'. */
export interface WijzigGeldverstrekkerResultaat {
    /** Lijst met gegenereerde leningdelen */
    readonly leningdelen: WijzigGeldverstrekkerOutputLeningdeel[] | null;
}

/** Bevat gegevens van het Adviesbox-form Woning. */
export interface Woning {
    financiering: FinancieringOptions | null;
    /** Geeft aan van welke huidige woning de hypotheek gewijzigd moet worden. */
    hypotheekOpWoning: string | null;
    /** Huidige woningen in eigendom (voor situaties waar geen sprake is van aankoop) */
    huidigeWoningen: HuidigeWoning[] | null;
    /** Bevat gegevens van te verkopen woningen */
    teVerkopenWoningen: WoningVerkoop[] | null;
    aanTeKopenWoning: WoningAankoop | null;
}

/** Bevat gegevens van een aan te kopen woning van het Adviesbox-form Woning. */
export interface WoningAankoop {
    pand: WoningPand | null;
    /** Indicatie dat het adres gelijk is het woonadres van de (1e) klant */
    gelijkAanWoonadres: boolean | null;
    adres: Adres | null;
    adresVan1eKlant: AdresReadOnly | null;
}

/** Extra gegevens van een woning in eigendom */
export interface WoningInEigendom {
    /** Eigendomsverhouding aanvrager 1 */
    eigendom1Percentage: number | null;
    /** Eigendomsverhouding aanvrager 2 */
    eigendom2Percentage: number | null;
    gebruikPand: GebruikPandSoort;
    /** Bedrag marktwaarde */
    marktwaardeBedrag: number | null;
    /** Bedrag WOZ-waarde */
    wozWaarde: number | null;
    /** Bedrag eigenwoningforfait */
    eigenWoningForfaitBedrag: number | null;
    /** Indicatie dat het eigenwoningforfait berekend is/moet worden */
    eigenWoningForfaitOvernemen: boolean | null;
    huidigPand: HuidigPand | null;
    /** Geeft aan of er een hypotheek op de woning rust */
    heeftHypotheekOpWoning: boolean | null;
    hypotheekOpWoning: HypotheekOpWoning | null;
    erfpachtOpWoning: ErfpachtOpWoning | null;
}

/** Gegevens van een pand */
export interface WoningPand {
    /** Referentie naar pand in de huidige situatie */
    huidigePandId: string | null;
    /** Indicatieveld. Eigen bewoning onderpand */
    eigenBewoning: boolean | null;
    /** Indicatieveld. Is er sprake van erfpacht? */
    erfpacht: boolean | null;
    /** Indicatieveld. Is de erfpacht afgekocht? */
    erfpachtAfgekocht: boolean | null;
    /** Indicatieveld. Is er sprake van eeuwigdurende erfpacht? */
    erfpachtEeuwigdurend: boolean | null;
    /** Datum einde erfpacht */
    erfpachtEinddatum: string | null;
    /** Bedrag jaarlijkse canon */
    erfpachtBedrag: number | null;
    /** Bouwjaar */
    bouwjaar: number | null;
    /** Indicatieveld. Is er sprake van appartementsrecht? */
    appartement: boolean | null;
    /** Servicekosten */
    servicekosten: number | null;
    /** Bedrag WOZ-waarde */
    wozWaarde: number | null;
    /** Bedrag eigenwoningforfait */
    eigenWoningForfaitBedrag: number | null;
    /** Bedrag getaxeerde marktwaarde */
    taxatieBedrag: number | null;
    /** Taxatiedatum */
    taxatiedatum: string | null;
    /** Indicatieveld. Is er sprake van zelfbouw? */
    zelfbouw: boolean | null;
    /** Bouwplan */
    bouwplan: string | null;
    /** Opleveringsdatum */
    opleverdatum: string | null;
    /** Bedrag marktwaarde na verbouw */
    marktwaardeNaVerbouwingBedrag: number | null;
    /** Indicatieveld. Is het pand bedoeld voor verhuur? */
    bedoeldVoorVerhuur: boolean | null;
    /** Indicatieveld. Is er sprake van een gedeeld perceel? */
    gedeeld: boolean | null;
    /** Bouwnummer */
    bouwnummer: string | null;
    /** Staat van onderhoud volgens de HDN keuzelijst OnderhoudsToestandType */
    staatOnderhoud: number | null;
    /** Aantal maanden duur van de bouw */
    duurBouwInMaanden: number | null;
    /** Eigendomsverhouding aanvrager 1 */
    eigendom1Percentage: number | null;
    /** Eigendomsverhouding aanvrager 2 */
    eigendom2Percentage: number | null;
    gebruikPand: GebruikPandSoort | null;
    /** Geeft aan dat op het object een voorwaarde bij verkoop van toepassing is */
    verkoopOnderVoorwaarden: boolean | null;
    /** Geeft aan welke voorwaarde bij verkoop van toepassing is (indien Zkn_In_VerkoopOnderVoorwaarden = True) */
    verkoopOnderVoorwaardenConstructie: number | null;
    /** Omschrijving constructie verkoop onder voorwaarden */
    verkoopOnderVoorwaardenConstructieOmschrijving: string | null;
    /** Wanneer de erfpacht- of kortingsconstructie nog niet is opgenomen in de waardelijst VerkoopOnderVoorwaardenConstructieType, kan hier 
           worden aangegeven om wat voor type constructie het gaat, zodat er rekening mee gehouden kan worden in de volledigheidstoets van NHG. */
    soortConstructieAnders: number | null;
    /** Met het Bag-ID kan verschillende brondata worden geraadpleegd zoals, EP-online, KadastraleKaart, WOZ-waardeloket. */
    bagId: string | null;
    /** Soort taxatie / bron waardebepaling */
    bronwaardebepaling: number | null;
    /** Geeft de bouwaard van het object weer volgens de HDN keuzelijst BouwaardType */
    bouwaard: number | null;
    /** Geeft de energie (label) klasse in welke de woning valt volgens de HDN keuzelijst EnergieKlasseType */
    energieklasse: number | null;
    /** Bedrag marktwaarde */
    marktwaardeBedrag: number | null;
    /** Indicatie dat de marktwaarde automatisch bepaald is (True) of door de gebruiker overruled (False) */
    marktwaardeOvernemen: boolean | null;
    /** Afbouwgarantie */
    afbouwgarantie: boolean | null;
    /** Eigen foto uploaden (true) of Google foto gebruiken (false) */
    eigenFoto: boolean | null;
    /** Locatie van de foto van de woning op disk */
    locatieFoto: string | null;
    /** Taxatie aanwezig */
    taxatieAanwezig: boolean | null;
    verkoopstatus: Verkoopstatus | null;
    /** Bedrag verkoopopbrengst */
    verkoopopbrengstBedrag: number | null;
    /** Datum verkocht per */
    verkoopdatum: string | null;
    /** Bedrag verkoopkosten */
    verkoopkostenBedrag: number | null;
    /** Indicatieveld. Moeten de verkoopkosten worden berekend? */
    verkoopkostenOvernemen: boolean | null;
    /** Code veld. Type woning volgens de HDN keuzelijst CodeObjectType. */
    typePand: number | null;
    /** Code van het gebruiksdoel van het betreffende object volgens de HDN keuzelijst ObjectSoortType */
    objectSoort: number | null;
    /** Code van het bijzondere gebruiksdoel van het betreffende object volgens de HDN keuzelijst BijzObjectSoortType */
    bijzonderObjectSoort: number | null;
    /** Indicatie dat er een garage aanwezig is */
    heeftGarage: boolean | null;
    /** Indicatie dat het object wordt gebruikt voor recreatieve bewoning */
    recreatieveBewoning: boolean | null;
    /** Kadastrale sectie */
    kadasterSectie: string | null;
    /** Kadastraal nummer */
    kadasterNummer: string | null;
    /** Kadastrale gemeente */
    kadasterGemeente: string | null;
    /** Oppervlakte in vierkante meters van de grond waar het onderpand op staat */
    kavelGrootteInM2: number | null;
    /** Indicatie veld. Bestaat er een hypotheek op de woning */
    hypotheekOpPand: boolean | null;
    /** Oorspronkelijke hypotheek op het pand */
    oorspronkelijkHypotheekbedrag: number | null;
    /** Datum ontbindende voorwaarden */
    ontbindendeVoorwaardenDatum: string | null;
    /** Datum bankgarantie */
    bankgarantieDatum: string | null;
    /** Indicatie dat er sprake is van particuliere erfpacht */
    erfpachtParticulier: boolean | null;
    /** Geeft aan op welke datum de energie (label) klasse is afgegeven */
    energieklasseDatum: string | null;
}

/** Bevat gegevens van een te verkopen woning van het Adviesbox-form Woning. */
export interface WoningVerkoop {
    /** Unieke identificatie van het te verkopen pand */
    pandId: string;
    /** Volgnummer van de woning/het pand op het scherm */
    readonly volgnummer: number | null;
    gebruikPand: GebruikPandSoort | null;
    gebruikPandVoorstel: GebruikPandSoort | null;
    /** Bedrag marktwaarde */
    marktwaardeBedrag: number | null;
    verkoopstatus: Verkoopstatus | null;
    /** Datum verkocht per */
    verkoopdatum: string | null;
    /** Datum ontbindende voorwaarden */
    ontbindendeVoorwaardenDatum: string | null;
    /** Bedrag verkoopopbrengst */
    verkoopopbrengstBedrag: number | null;
    /** Bedrag verkoopkosten */
    verkoopkostenBedrag: number | null;
    /** Indicatie dat de verkoopkosten worden berekend */
    verkoopkostenOvernemen: boolean | null;
    /** Geeft aan dat op het object een voorwaarde bij verkoop van toepassing is */
    verkoopOnderVoorwaarden: boolean | null;
    /** Geeft aan welke voorwaarde bij verkoop van toepassing is */
    verkoopOnderVoorwaardenConstructie: number | null;
    /** Omschrijving constructie verkoop onder voorwaarden */
    verkoopOnderVoorwaardenConstructieOmschrijving: string | null;
    /** Wanneer de erfpacht- of kortingsconstructie nog niet is opgenomen in de waardelijst VerkoopOnderVoorwaardenConstructieType, kan hier 
           worden aangegeven om wat voor type constructie het gaat, zodat er rekening mee gehouden kan worden in de volledigheidstoets van NHG. */
    soortConstructieAnders: number | null;
    /** Met het Bag-ID kan verschillende brondata worden geraadpleegd zoals, EP-online, KadastraleKaart, WOZ-waardeloket. */
    bagId: string | null;
    /** Soort taxatie / bron waardebepaling */
    bronwaardebepaling: number | null;
    adres: AdresReadOnly | null;
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Woning. */
export interface WoningenOutput {
    /** Lijst met de inhoud van het scherm Woning per adviesdossier. */
    woningen: { [key: string]: Woning; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat gegevens van het Adviesbox-form Woonsituatie. */
export interface Woonsituatie {
    /** Bevat huidige woonsituaties */
    huidigeWoonsituaties: HuidigeWoonsituatie[] | null;
    /** Geeft aan of het advies met een mede-aanvrager betreft */
    adviesMetMedeaanvrager: boolean;
    adresVan1eKlant: AdresReadOnly | null;
    adresVan2eKlant: AdresReadOnly | null;
    aanvrager1: KlantnaamReadOnly | null;
    aanvrager2: KlantnaamReadOnly | null;
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Woonsituatie. */
export interface WoonsituatieOutput {
    /** Lijst met de inhoud van het scherm Woonsituatie per adviesdossier. */
    woonsituaties: { [key: string]: Woonsituatie; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat renteaftrek-gegevens t.b.v. het scherm Woonsituatie. */
export interface WoonsituatieRenteaftrek {
    /** Unieke identificatie van een renteaftrek */
    renteaftrekId: string | null;
    /** Volgnummer van een renteaftrek in het bovenliggende object */
    volgnummer: number;
    /** Bedrag */
    bedrag: number | null;
    /** Datum aanvang renteaftrek */
    aanvangsdatum: string | null;
    /** Datum einde renteaftrek */
    einddatum: string | null;
}

/** Woonsituatiesoort Geen = 0, Eigendom = 1, Huur = 2, Inwonend = 3 */
export enum Woonsituatiesoort {
    Geen = "Geen",
    Eigendom = "Eigendom",
    Huur = "Huur",
    Inwonend = "Inwonend",
}

/** Ww-dekking */
export interface WwDekkingBedragen {
    /** Het verzekerd maandbedrag */
    readonly verzekerdMaandBedrag: number | null;
}

/** Model voor het zoeken van advies- en bemiddelingdossiers */
export interface ZoekDossierInput {
    /** Input voor het zoeken op naam, achternaam en/of tussenvoegsel */
    zoekNaamInput: string | null;
    /** Specifieke vestiging waarop gezocht wordt óf alle vestigingen als deze null is */
    zoekVestigingId: string | null;
    /** Pagina nummer dat getoond moet worden */
    paginaNummer: number;
    /** Aantal zoekresultaten dat getoond moet worden per pagina */
    aantalResultatenPerPagina: number;
    /** Waarde voor het filteren op geboortedatum */
    geboorteDatum: string | null;
    /** Waarde voor het filteren op postcode */
    postcode: string | null;
    /** Waarde voor het filteren op woonplaats */
    woonplaats: string | null;
    /** Als er enkel op de dossiers van de adviseur gezocht moet worden, dient deze gevuld te zijn */
    doorzoekAlleAdviezen: boolean;
    zoekResultaatSorteerOptions: ZoekResultaatSorteerOptions;
    /** Naamdelen van de zoekinput */
    readonly naamDelen: string[] | null;
}

/** ZoekResultaatSorteerOptions AchternaamOplopend = 0, AchternaamAflopend = 1, GeboorteDatumOplopend = 2, GeboorteDatumAflopend = 3, PostcodeOplopend = 4, PostcodeAflopend = 5, WoonplaatsOplopend = 6, WoonplaatsAflopend = 7 */
export enum ZoekResultaatSorteerOptions {
    AchternaamOplopend = "AchternaamOplopend",
    AchternaamAflopend = "AchternaamAflopend",
    GeboorteDatumOplopend = "GeboorteDatumOplopend",
    GeboorteDatumAflopend = "GeboorteDatumAflopend",
    PostcodeOplopend = "PostcodeOplopend",
    PostcodeAflopend = "PostcodeAflopend",
    WoonplaatsOplopend = "WoonplaatsOplopend",
    WoonplaatsAflopend = "WoonplaatsAflopend",
}

/** Een regel uit het resultaat van het zoeken naar adviesdossiers. */
export interface ZoekenAdviesdossier {
    /** Unieke identificatie van een gevonden adviesdossier. */
    adviesdossierId: string;
    /** Datum dat het adviesdossier voor het laatst bewerkt is. */
    readonly laatstBewerktDatum: string | null;
    /** Tijd dat het adviesdossier voor het laatst bewerkt is. */
    laatstBewerktTijd: string | null;
    aanleiding: FinancieringOptions | null;
    /** Korte omschrijving van het adviesdossier. */
    readonly omschrijving: string | null;
    status: Dossierstatus;
    /** De ids van de adviseurs gekoppeld aan dit adviesdossier */
    adviseurIds: string[] | null;
}

/** Een regel uit het resultaat van het zoeken naar adviesdossiers, inclusief gegevens van de aanvrager(s). */
export interface ZoekenAdviesdossierMetKlantInfo {
    aanvrager1: KlantnaamReadOnly | null;
    aanvrager2: KlantnaamReadOnly | null;
    /** Unieke identificatie van een gevonden adviesdossier. */
    adviesdossierId: string;
    /** Datum dat het adviesdossier voor het laatst bewerkt is. */
    readonly laatstBewerktDatum: string | null;
    /** Tijd dat het adviesdossier voor het laatst bewerkt is. */
    laatstBewerktTijd: string | null;
    aanleiding: FinancieringOptions | null;
    /** Korte omschrijving van het adviesdossier. */
    readonly omschrijving: string | null;
    status: Dossierstatus;
    /** De ids van de adviseurs gekoppeld aan dit adviesdossier */
    adviseurIds: string[] | null;
}

/** Een regel uit het resultaat van een zoekopdracht. */
export interface Zoekresultaat {
    /** De unieke identificatie van het klantdossier waar dit zoekresultaat onder valt. */
    klantdossierId: string;
    /** Het recentste moment dat een adviedossier van deze klant(en) geopend is. */
    readonly laatstGeopendDatum: string | null;
    /** Tijd dat het adviesdossier voor het laatst geopend is. */
    readonly laatstGeopendTijd: string | null;
    /** De gebruikersnaam van de persoon die het adviesdossier het laatst geopend heeft. */
    readonly laatstGeopendDoor: string | null;
    aanvrager1: KlantnaamReadOnly | null;
    aanvrager2: KlantnaamReadOnly | null;
    adviseur: ZoekresultaatAdviseur | null;
    /** De naam van de vestiging waar de klant staat ingeschreven. */
    readonly naamVestiging: string | null;
    /** Het guid van de vestiging waar de klant staat ingeschreven. */
    vestigingId: string;
    /** De postcode van het woonadres van aanvrager 1 */
    readonly postcode: string | null;
    /** De woonplaats van aanvrager 1 */
    readonly woonplaats: string | null;
    /** De adviesdossiers van deze klanten. */
    readonly adviesdossiers: ZoekenAdviesdossier[] | null;
}

/** Gegevens van de adviseur, benodigd om weer te geven in het zoekresultaat. */
export interface ZoekresultaatAdviseur {
    /** Unieke identificatie van de Adviseur */
    adviseurId: string;
    /** Achternaam */
    readonly achternaam: string | null;
    /** Voorvoegsel */
    readonly voorvoegsel: string | null;
    /** Voorletters */
    readonly voorletters: string | null;
    /** Roepnaam */
    readonly voornamen: string | null;
    geslacht: GeslachtOpties;
}

/** Het resultaat van een zoekopdracht. */
export interface ZoekresultaatOutput {
    /** De gevonden resultaten. */
    readonly zoekresultaten: Zoekresultaat[] | null;
    /** Totaal aantal gevonden resultaten. */
    totalNumberOfResults: number;
    /** Totaal aantal gevonden resultaten. */
    totalNumberOfPages: number;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Onderdeel van het dashboard dat gewenst is */
export enum Onderdeel {
    HypotheekAcceptatie = "HypotheekAcceptatie",
    Snelinzicht = "Snelinzicht",
    Overlijden = "Overlijden",
    Arbeidsongeschiktheid = "Arbeidsongeschiktheid",
    Werkloosheid = "Werkloosheid",
    Pensioen = "Pensioen",
    VerantwoordeWoonlasten = "VerantwoordeWoonlasten",
    Aflossingsvorm = "Aflossingsvorm",
    Rentevastperiode = "Rentevastperiode",
    OpbouwDoelvermogen = "OpbouwDoelvermogen",
}

/** Onderdeel van het dashboard waarvan de gegevens opgeslagen moeten worden */
export enum Onderdeel2 {
    HypotheekAcceptatie = "HypotheekAcceptatie",
    Snelinzicht = "Snelinzicht",
    Overlijden = "Overlijden",
    Arbeidsongeschiktheid = "Arbeidsongeschiktheid",
    Werkloosheid = "Werkloosheid",
    Pensioen = "Pensioen",
    VerantwoordeWoonlasten = "VerantwoordeWoonlasten",
    Aflossingsvorm = "Aflossingsvorm",
    Rentevastperiode = "Rentevastperiode",
    OpbouwDoelvermogen = "OpbouwDoelvermogen",
}

/** Onderdeel van het dashboard dat gewenst is */
export enum Onderdeel3 {
    HypotheekAcceptatie = "HypotheekAcceptatie",
    Snelinzicht = "Snelinzicht",
    Overlijden = "Overlijden",
    Arbeidsongeschiktheid = "Arbeidsongeschiktheid",
    Werkloosheid = "Werkloosheid",
    Pensioen = "Pensioen",
    VerantwoordeWoonlasten = "VerantwoordeWoonlasten",
    Aflossingsvorm = "Aflossingsvorm",
    Rentevastperiode = "Rentevastperiode",
    OpbouwDoelvermogen = "OpbouwDoelvermogen",
}

/** InkomenPeriode Geen = 0, PerJaar = 1, PerMaand = 12, Per4Weken = 13, PerWeek = 52 */
export enum InkomenPeriodeCode {
    Geen = "Geen",
    PerJaar = "PerJaar",
    PerMaand = "PerMaand",
    Per4Weken = "Per4Weken",
    PerWeek = "PerWeek",
}

/** InkomenPeriode Geen = 0, PerJaar = 1, PerMaand = 12, Per4Weken = 13, PerWeek = 52 */
export enum InkomenPeriodeCode2 {
    Geen = "Geen",
    PerJaar = "PerJaar",
    PerMaand = "PerMaand",
    Per4Weken = "Per4Weken",
    PerWeek = "PerWeek",
}

/** Het klantprofiel-onderwerp */
export enum Onderwerp {
    AlgemeenDoelstelling = "AlgemeenDoelstelling",
    AlgemeenToekomstperspectief = "AlgemeenToekomstperspectief",
    AlgemeenRisicoEnKennis = "AlgemeenRisicoEnKennis",
    HypotheekAlgemeen = "HypotheekAlgemeen",
    HypotheekVerduurzaming = "HypotheekVerduurzaming",
    HypotheekVerantwoordeWoonlasten = "HypotheekVerantwoordeWoonlasten",
    HypotheekEigenGeld = "HypotheekEigenGeld",
    HypotheekDubbeleWoonlasten = "HypotheekDubbeleWoonlasten",
    HypotheekFiscaal = "HypotheekFiscaal",
    HypotheekHypotheekvorm = "HypotheekHypotheekvorm",
    HypotheekRentevastperiode = "HypotheekRentevastperiode",
    HypotheekGeldverstrekker = "HypotheekGeldverstrekker",
    RisicosOverlijden = "RisicosOverlijden",
    RisicosArbeidsongeschiktheid = "RisicosArbeidsongeschiktheid",
    RisicosWerkloosheid = "RisicosWerkloosheid",
    RisicosPensioen = "RisicosPensioen",
    VermogensopbouwOpbouwDoelvermogen = "VermogensopbouwOpbouwDoelvermogen",
    VermogensopbouwRisicoprofiel = "VermogensopbouwRisicoprofiel",
}

/** Het klantprofiel-onderwerp */
export enum Onderwerp2 {
    AlgemeenDoelstelling = "AlgemeenDoelstelling",
    AlgemeenToekomstperspectief = "AlgemeenToekomstperspectief",
    AlgemeenRisicoEnKennis = "AlgemeenRisicoEnKennis",
    HypotheekAlgemeen = "HypotheekAlgemeen",
    HypotheekVerduurzaming = "HypotheekVerduurzaming",
    HypotheekVerantwoordeWoonlasten = "HypotheekVerantwoordeWoonlasten",
    HypotheekEigenGeld = "HypotheekEigenGeld",
    HypotheekDubbeleWoonlasten = "HypotheekDubbeleWoonlasten",
    HypotheekFiscaal = "HypotheekFiscaal",
    HypotheekHypotheekvorm = "HypotheekHypotheekvorm",
    HypotheekRentevastperiode = "HypotheekRentevastperiode",
    HypotheekGeldverstrekker = "HypotheekGeldverstrekker",
    RisicosOverlijden = "RisicosOverlijden",
    RisicosArbeidsongeschiktheid = "RisicosArbeidsongeschiktheid",
    RisicosWerkloosheid = "RisicosWerkloosheid",
    RisicosPensioen = "RisicosPensioen",
    VermogensopbouwOpbouwDoelvermogen = "VermogensopbouwOpbouwDoelvermogen",
    VermogensopbouwRisicoprofiel = "VermogensopbouwRisicoprofiel",
}

/** Het soort onderwerp */
export enum Onderwerpsoort {
    Geen = "Geen",
    Algemeen = "Algemeen",
    Rentevastperiode = "Rentevastperiode",
    FiscaleAftrek = "FiscaleAftrek",
    InbrengEigenGeld = "InbrengEigenGeld",
    OversluitenHypotheek = "OversluitenHypotheek",
    VerantwoordeWoonlasten = "VerantwoordeWoonlasten",
    Box3Consumptief = "Box3Consumptief",
    AfdekkenOverlijdensrisico = "AfdekkenOverlijdensrisico",
    AfdekkenAOWW = "AfdekkenAOWW",
    Pensioenvoorziening = "Pensioenvoorziening",
    HoogteOpbouwDoelvermogen = "HoogteOpbouwDoelvermogen",
    WijzeOpbouwDoelvermogen = "WijzeOpbouwDoelvermogen",
    Beleggingsproduct = "Beleggingsproduct",
    Beleggingsprofiel = "Beleggingsprofiel",
    Fondskeuze = "Fondskeuze",
    OversluitenBeleggingspolis = "OversluitenBeleggingspolis",
    AfdekkenWW = "AfdekkenWW",
    Kredieten = "Kredieten",
    DubbeleWoonlasten = "DubbeleWoonlasten",
    EerderStoppen = "EerderStoppen",
    Geldverstrekker = "Geldverstrekker",
    HypotheekAflossen = "HypotheekAflossen",
    Schade = "Schade",
    Risicoprofiel = "Risicoprofiel",
    Nazorg = "Nazorg",
    Energie = "Energie",
    Telecom = "Telecom",
    Uitvaart = "Uitvaart",
    Verduurzaming = "Verduurzaming",
    Alles = "Alles",
}

/** Het soort onderwerp */
export enum Onderwerpsoort2 {
    Geen = "Geen",
    Algemeen = "Algemeen",
    Rentevastperiode = "Rentevastperiode",
    FiscaleAftrek = "FiscaleAftrek",
    InbrengEigenGeld = "InbrengEigenGeld",
    OversluitenHypotheek = "OversluitenHypotheek",
    VerantwoordeWoonlasten = "VerantwoordeWoonlasten",
    Box3Consumptief = "Box3Consumptief",
    AfdekkenOverlijdensrisico = "AfdekkenOverlijdensrisico",
    AfdekkenAOWW = "AfdekkenAOWW",
    Pensioenvoorziening = "Pensioenvoorziening",
    HoogteOpbouwDoelvermogen = "HoogteOpbouwDoelvermogen",
    WijzeOpbouwDoelvermogen = "WijzeOpbouwDoelvermogen",
    Beleggingsproduct = "Beleggingsproduct",
    Beleggingsprofiel = "Beleggingsprofiel",
    Fondskeuze = "Fondskeuze",
    OversluitenBeleggingspolis = "OversluitenBeleggingspolis",
    AfdekkenWW = "AfdekkenWW",
    Kredieten = "Kredieten",
    DubbeleWoonlasten = "DubbeleWoonlasten",
    EerderStoppen = "EerderStoppen",
    Geldverstrekker = "Geldverstrekker",
    HypotheekAflossen = "HypotheekAflossen",
    Schade = "Schade",
    Risicoprofiel = "Risicoprofiel",
    Nazorg = "Nazorg",
    Energie = "Energie",
    Telecom = "Telecom",
    Uitvaart = "Uitvaart",
    Verduurzaming = "Verduurzaming",
    Alles = "Alles",
}

/** Taxatiedoel (niet alle doelen zijn toegestaan bij NWWI) */
export enum Taxatiedoel {
    HypothecaireFinancieringMetNhg = "HypothecaireFinancieringMetNhg",
    HypothecaireFinancieringZonderNhg = "HypothecaireFinancieringZonderNhg",
    InzichtWaardeTenBehoeveBeslissing = "InzichtWaardeTenBehoeveBeslissing",
    AanvraagHypothecaireGeldlening = "AanvraagHypothecaireGeldlening",
    AankoopBeslissing = "AankoopBeslissing",
    AanvraagOverbruggingsfinanciering = "AanvraagOverbruggingsfinanciering",
    BijzonderBeheer = "BijzonderBeheer",
    BoedelSplitsing = "BoedelSplitsing",
    BrabantseVerkoopgarantie = "BrabantseVerkoopgarantie",
    Hertaxatie = "Hertaxatie",
    MinnelijkeWaardering = "MinnelijkeWaardering",
    OntpandingVerzekeringspolis = "OntpandingVerzekeringspolis",
    Uitwinning = "Uitwinning",
    VerkoopBeslissing = "VerkoopBeslissing",
    VerkrijgenFinanciering = "VerkrijgenFinanciering",
    VerkrijgenFinancieringMetNhg = "VerkrijgenFinancieringMetNhg",
    VerkrijgenInzichtWaardeAankoopbeslissing = "VerkrijgenInzichtWaardeAankoopbeslissing",
    VerkrijgenInzichtWaardeVerkoopbeslissing = "VerkrijgenInzichtWaardeVerkoopbeslissing",
    VerkrijgenInzichtTenBehoeveVanExecutorialeVerkoop = "VerkrijgenInzichtTenBehoeveVanExecutorialeVerkoop",
    WoningFinancieringMetValidatie = "WoningFinancieringMetValidatie",
    WoningFinancieringNwwi = "WoningFinancieringNwwi",
    BepalenPrijsBijVerkoop = "BepalenPrijsBijVerkoop",
    BepalenPrijsBijAankoop = "BepalenPrijsBijAankoop",
    BepalenPrijsBijTerugkoop = "BepalenPrijsBijTerugkoop",
    GedwongenVerkoop = "GedwongenVerkoop",
    Anders = "Anders",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}